import { ɵɵdefineInjectable, Injectable, Component, Input, EventEmitter, Output, Pipe, ɵɵinject, ViewChild, forwardRef, HostBinding, ElementRef, SimpleChange, Directive, Host, Optional, Self, ChangeDetectorRef, ViewContainerRef, ComponentFactoryResolver, TemplateRef, NgModule } from '@angular/core';
import { ReplaySubject, BehaviorSubject, throwError, Subject, combineLatest, forkJoin, Subscription, Observable } from 'rxjs';
import { BrowserModule } from '@angular/platform-browser';
import { NavigationEnd, Router, ActivatedRoute, RouterModule } from '@angular/router';
import { TranslateService, TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { getLocaleId, getLocaleDateTimeFormat, FormatWidth, getLocaleTimeFormat, getLocaleDateFormat, getLocaleNumberSymbol, NumberSymbol, FormStyle, getLocaleEraNames, getLocaleExtraDayPeriodRules, getLocaleExtraDayPeriods, getLocaleDayPeriods, getLocaleDayNames, getLocaleMonthNames, TranslationWidth, DatePipe, formatDate as formatDate$1 } from '@angular/common';
import { NgbDate, NgbCalendar, NgbDateParserFormatter, NgbPopoverConfig, ModalDismissReasons, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import * as moment from 'moment';
import { NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';
import { HttpParams, HttpClient, HttpRequest, HttpEventType, HttpClientModule, HttpHeaders } from '@angular/common/http';
import { v4 } from 'uuid';
import { share, debounceTime, take, filter, startWith, map } from 'rxjs/operators';
import { OAuthService } from 'angular-oauth2-oidc';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@ngx-translate/core';
import * as ɵngcc3 from '@angular/router';
import * as ɵngcc4 from '@ng-bootstrap/ng-bootstrap';
import * as ɵngcc5 from '@angular/forms';
import * as ɵngcc6 from '@angular/common/http';
import * as ɵngcc7 from '@ng-select/ng-select';
import * as ɵngcc8 from 'angular-oauth2-oidc';

function AlertComponent_ng_template_0_button_0_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 5);
    ɵngcc0.ɵɵlistener("click", function AlertComponent_ng_template_0_button_0_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(2); return ctx_r5.dismiss(); });
    ɵngcc0.ɵɵelementStart(1, "span", 6);
    ɵngcc0.ɵɵtext(2, "\u00D7");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function AlertComponent_ng_template_0_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 7);
    ɵngcc0.ɵɵlistener("click", function AlertComponent_ng_template_0_button_2_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ctx_r7.dismiss(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 1, "dialogue.close"), " ");
} }
function AlertComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, AlertComponent_ng_template_0_button_0_Template, 3, 0, "button", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵtemplate(2, AlertComponent_ng_template_0_button_2_Template, 3, 3, "button", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.canClose() && ctx_r1.closeStyle === "cross");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.canClose() && ctx_r1.closeStyle === "button");
} }
function AlertComponent_div_2_h4_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function AlertComponent_div_2_h4_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h4", 11);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵtemplate(2, AlertComponent_div_2_h4_1_ng_container_2_Template, 1, 0, "ng-container", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(2);
    const _r0 = ɵngcc0.ɵɵreference(1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r9.alert.title, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r0);
} }
function AlertComponent_div_2_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r10.alert.message);
} }
function AlertComponent_div_2_span_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function AlertComponent_div_2_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtemplate(1, AlertComponent_div_2_span_3_ng_container_1_Template, 1, 0, "ng-container", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext(2);
    const _r0 = ɵngcc0.ɵɵreference(1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r0);
} }
const _c0 = function (a0) { return { "alert-dismissible": a0 }; };
function AlertComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵtemplate(1, AlertComponent_div_2_h4_1_Template, 3, 2, "h4", 9);
    ɵngcc0.ɵɵtemplate(2, AlertComponent_div_2_span_2_Template, 2, 1, "span", 10);
    ɵngcc0.ɵɵtemplate(3, AlertComponent_div_2_span_3_Template, 2, 1, "span", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("alert ", ctx_r2.alert.type, "");
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(7, _c0, ctx_r2.closeStyle === "cross"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.hasTitle());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.hasMessage());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r2.hasTitle());
} }
function AlertsComponent_div_0_ws_alert_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "ws-alert", 3);
} if (rf & 2) {
    const item_r2 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("alert", item_r2)("closeStyle", ctx_r1.closeStyle);
} }
function AlertsComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵtemplate(1, AlertsComponent_div_0_ws_alert_1_Template, 1, 2, "ws-alert", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.getMyAlertList());
} }
function PuppeteerBannerComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate4(" ", ctx_r0.currentUser.puppeteer.first_name, " ", ctx_r0.currentUser.puppeteer.last_name, " logged in as ", ctx_r0.currentUser.first_name, " ", ctx_r0.currentUser.last_name, "\n");
} }
function BreadcrumbsComponent_nav_0_li_2_a_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 8);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵpropertyInterpolate("href", ctx_r4.homeItemRoute, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r4.homeItemText);
} }
function BreadcrumbsComponent_nav_0_li_2_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r5.homeItemText);
} }
function BreadcrumbsComponent_nav_0_li_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 5);
    ɵngcc0.ɵɵtemplate(1, BreadcrumbsComponent_nav_0_li_2_a_1_Template, 2, 2, "a", 6);
    ɵngcc0.ɵɵtemplate(2, BreadcrumbsComponent_nav_0_li_2_span_2_Template, 2, 1, "span", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.service.linkHomeItem);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r1.service.linkHomeItem);
} }
function BreadcrumbsComponent_nav_0_li_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 5);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.homeItemText, " ");
} }
const _c1 = function (a0, a1) { return [a0, a1]; };
function BreadcrumbsComponent_nav_0_li_4_a_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const breadcrumb_r6 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("routerLink", ɵngcc0.ɵɵpureFunction2(2, _c1, breadcrumb_r6.url, breadcrumb_r6.params));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", breadcrumb_r6.label, " ");
} }
function BreadcrumbsComponent_nav_0_li_4_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const breadcrumb_r6 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", breadcrumb_r6.label, " ");
} }
function BreadcrumbsComponent_nav_0_li_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵtemplate(1, BreadcrumbsComponent_nav_0_li_4_a_1_Template, 2, 5, "a", 9);
    ɵngcc0.ɵɵtemplate(2, BreadcrumbsComponent_nav_0_li_4_span_2_Template, 2, 1, "span", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const last_r7 = ctx.last;
    ɵngcc0.ɵɵclassMapInterpolate1("breadcrumb-item ", last_r7 ? "active" : "", "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !last_r7);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", last_r7);
} }
function BreadcrumbsComponent_nav_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "nav", 1);
    ɵngcc0.ɵɵelementStart(1, "ol", 2);
    ɵngcc0.ɵɵtemplate(2, BreadcrumbsComponent_nav_0_li_2_Template, 3, 2, "li", 3);
    ɵngcc0.ɵɵtemplate(3, BreadcrumbsComponent_nav_0_li_3_Template, 2, 1, "li", 3);
    ɵngcc0.ɵɵtemplate(4, BreadcrumbsComponent_nav_0_li_4_Template, 3, 5, "li", 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.service.showHomeItem && !ctx_r0.isAtHome);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.showHomeItem && ctx_r0.isAtHome);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.breadcrumbs);
} }
function HeaderComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 7);
    ɵngcc0.ɵɵelement(1, "ws-wordmark");
    ɵngcc0.ɵɵelementStart(2, "span", 8);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.appName);
} }
const _c2 = function (a0) { return [a0]; };
function HeaderComponent_ng_template_2_li_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵelementStart(1, "a", 15);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r12 = ctx.$implicit;
    const ctx_r9 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassMapInterpolate2("nav-item ", ctx_r9.isRouteActive(item_r12) ? "active" : "", " ", item_r12.subMenuItems ? "has-subnav" : "", "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("routerLink", item_r12.params ? ɵngcc0.ɵɵpureFunction2(6, _c1, item_r12.url, item_r12.params) : ɵngcc0.ɵɵpureFunction1(9, _c2, item_r12.url));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r12.label, " ");
} }
function HeaderComponent_ng_template_2_div_6_a_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 23);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r14 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("routerLink", item_r14.params ? ɵngcc0.ɵɵpureFunction2(2, _c1, item_r14.url, item_r14.params) : ɵngcc0.ɵɵpureFunction1(5, _c2, item_r14.url));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(item_r14.label);
} }
function HeaderComponent_ng_template_2_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 16);
    ɵngcc0.ɵɵelementStart(1, "button", 17);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 18);
    ɵngcc0.ɵɵelementStart(4, "a", 19);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(6, "div", 20);
    ɵngcc0.ɵɵtemplate(7, HeaderComponent_ng_template_2_div_6_a_7_Template, 2, 7, "a", 21);
    ɵngcc0.ɵɵpipe(8, "wsMenuAccessFilter");
    ɵngcc0.ɵɵelementStart(9, "a", 22);
    ɵngcc0.ɵɵlistener("click", function HeaderComponent_ng_template_2_div_6_Template_a_click_9_listener() { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r15 = ɵngcc0.ɵɵnextContext(2); ctx_r15.logout(); return false; });
    ɵngcc0.ɵɵtext(10);
    ɵngcc0.ɵɵpipe(11, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r10.getInitials(), " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate2("", ctx_r10.currentUser.first_name, " ", ctx_r10.currentUser.last_name, "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind3(8, 5, ctx_r10.dropDownMenuItems, ctx_r10.isLoggedIn, ctx_r10.userRoles()));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(11, 9, "auth.logout"));
} }
function HeaderComponent_ng_template_2_a_7_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 24);
    ɵngcc0.ɵɵlistener("click", function HeaderComponent_ng_template_2_a_7_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r17 = ɵngcc0.ɵɵnextContext(2); ctx_r17.login(); return false; });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "auth.login"));
} }
function HeaderComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "button", 9);
    ɵngcc0.ɵɵtext(1, " Menu ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "div", 10);
    ɵngcc0.ɵɵelementStart(3, "ul", 11);
    ɵngcc0.ɵɵtemplate(4, HeaderComponent_ng_template_2_li_4_Template, 3, 11, "li", 12);
    ɵngcc0.ɵɵpipe(5, "wsMenuAccessFilter");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, HeaderComponent_ng_template_2_div_6_Template, 12, 11, "div", 13);
    ɵngcc0.ɵɵtemplate(7, HeaderComponent_ng_template_2_a_7_Template, 3, 3, "a", 14);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind3(5, 3, ctx_r3.menuItems, ctx_r3.isLoggedIn, ctx_r3.userRoles()));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.showMenu());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.showLoginButton());
} }
function HeaderComponent_ng_template_4_li_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵelementStart(1, "a", 15);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r20 = ctx.$implicit;
    const ctx_r19 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassMapInterpolate1("nav-item ", ctx_r19.isRouteActive(item_r20) ? "active" : "", "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("routerLink", item_r20.params ? ɵngcc0.ɵɵpureFunction2(5, _c1, item_r20.url, item_r20.params) : ɵngcc0.ɵɵpureFunction1(8, _c2, item_r20.url));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r20.label, " ");
} }
function HeaderComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 25);
    ɵngcc0.ɵɵelementStart(1, "ul", 11);
    ɵngcc0.ɵɵtemplate(2, HeaderComponent_ng_template_4_li_2_Template, 3, 10, "li", 12);
    ɵngcc0.ɵɵpipe(3, "wsMenuAccessFilter");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind3(3, 1, ctx_r5.getSubMenuItems(ctx_r5.getActiveParentMenu()), ctx_r5.isLoggedIn, ctx_r5.userRoles()));
} }
function HeaderComponent_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function HeaderComponent_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function HeaderComponent_nav_10_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function HeaderComponent_nav_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "nav", 26);
    ɵngcc0.ɵɵelementStart(1, "div", 4);
    ɵngcc0.ɵɵtemplate(2, HeaderComponent_nav_10_ng_container_2_Template, 1, 0, "ng-container", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext();
    const _r4 = ɵngcc0.ɵɵreference(5);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r8.subMenuTemplate ? ctx_r8.subMenuTemplate : _r4);
} }
const _c3 = ["#col1DefaultTemplate"];
const _c4 = ["#col6DefaultTemplate"];
const _c5 = ["#colDefaultTemplate"];
function FooterComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h1");
    ɵngcc0.ɵɵelementStart(1, "a", 16);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "ul");
    ɵngcc0.ɵɵelementStart(5, "li");
    ɵngcc0.ɵɵelementStart(6, "a", 17);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵpipe(8, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "li");
    ɵngcc0.ɵɵelementStart(10, "a", 18);
    ɵngcc0.ɵɵtext(11);
    ɵngcc0.ɵɵpipe(12, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "li");
    ɵngcc0.ɵɵelementStart(14, "a", 19);
    ɵngcc0.ɵɵtext(15);
    ɵngcc0.ɵɵpipe(16, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(17, "li");
    ɵngcc0.ɵɵelementStart(18, "a", 20);
    ɵngcc0.ɵɵtext(19);
    ɵngcc0.ɵɵpipe(20, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(21, "li");
    ɵngcc0.ɵɵelementStart(22, "a", 21);
    ɵngcc0.ɵɵtext(23);
    ɵngcc0.ɵɵpipe(24, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(25, "li");
    ɵngcc0.ɵɵelementStart(26, "a", 22);
    ɵngcc0.ɵɵtext(27);
    ɵngcc0.ɵɵpipe(28, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 7, "footer.links.my.worldskills"));
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(8, 9, "footer.links.wiw"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(12, 11, "footer.links.glossary"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(16, 13, "footer.links.registrations"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(20, 15, "footer.links.forums"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(24, 17, "footer.links.infrastructure.lists"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(28, 19, "footer.links.skill.management"));
} }
function FooterComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 23);
    ɵngcc0.ɵɵelementStart(1, "a", 24);
    ɵngcc0.ɵɵelement(2, "ws-logo", 25);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function FooterComponent_ng_template_4_Template(rf, ctx) { }
function FooterComponent_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function FooterComponent_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function FooterComponent_ng_container_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function FooterComponent_ng_container_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function FooterComponent_ng_container_18_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function FooterComponent_ng_container_20_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function FooterComponent_div_41_a_6_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 32);
    ɵngcc0.ɵɵlistener("click", function FooterComponent_div_41_a_6_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r16); const language_r14 = ctx.$implicit; const ctx_r15 = ɵngcc0.ɵɵnextContext(2); ctx_r15.changeLanguage(language_r14); return false; });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const language_r14 = ctx.$implicit;
    const ctx_r13 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassProp("active", ctx_r13.isLanguageSelected(language_r14));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", language_r14.name, " ");
} }
function FooterComponent_div_41_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 26);
    ɵngcc0.ɵɵelementStart(1, "div", 27);
    ɵngcc0.ɵɵelementStart(2, "button", 28);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 29);
    ɵngcc0.ɵɵtemplate(6, FooterComponent_div_41_a_6_Template, 2, 3, "a", 30);
    ɵngcc0.ɵɵelement(7, "div", 31);
    ɵngcc0.ɵɵelementStart(8, "a", 32);
    ɵngcc0.ɵɵlistener("click", function FooterComponent_div_41_Template_a_click_8_listener($event) { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r17 = ɵngcc0.ɵɵnextContext(); $event.preventDefault(); return ctx_r17.languagePrompt(); });
    ɵngcc0.ɵɵtext(9);
    ɵngcc0.ɵɵpipe(10, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(4, 3, "footer.translation.language"), " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r12.getLanguages());
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(10, 5, "footer.translation.missing"), " ");
} }
function DateRangeComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 15);
    ɵngcc0.ɵɵlistener("mouseenter", function DateRangeComponent_ng_template_5_Template_span_mouseenter_0_listener() { ɵngcc0.ɵɵrestoreView(_r8); const date_r5 = ctx.$implicit; const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.hoveredDate = date_r5; })("mouseleave", function DateRangeComponent_ng_template_5_Template_span_mouseleave_0_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.hoveredDate = null; });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const date_r5 = ctx.$implicit;
    const focused_r6 = ctx.focused;
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("focused", focused_r6)("range", ctx_r2.isRange(date_r5))("faded", ctx_r2.isHovered(date_r5) || ctx_r2.isInside(date_r5));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", date_r5.day, " ");
} }
const _c6 = ["popOver"];
function DatetimePickerComponent_ng_template_7_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "ngb-datepicker", 9, 10);
    ɵngcc0.ɵɵlistener("ngModelChange", function DatetimePickerComponent_ng_template_7_div_1_Template_ngb_datepicker_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(2); return ctx_r8.onDateChange($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "button", 11);
    ɵngcc0.ɵɵlistener("click", function DatetimePickerComponent_ng_template_7_div_1_Template_button_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r10 = ɵngcc0.ɵɵnextContext(2); return ctx_r10.toggleDateTimeState(); });
    ɵngcc0.ɵɵelement(4, "i", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "button", 13);
    ɵngcc0.ɵɵlistener("click", function DatetimePickerComponent_ng_template_7_div_1_Template_button_click_5_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ctx_r11.onAccept(); });
    ɵngcc0.ɵɵelement(6, "i", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    const _r3 = ɵngcc0.ɵɵreference(10);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r5.value)("minDate", ctx_r5.minDate)("maxDate", ctx_r5.maxDate);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("disabled", !(ctx_r5.value == null ? null : ctx_r5.value.day))("ngbPopover", _r3);
} }
function DatetimePickerComponent_ng_template_7_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "button", 13);
    ɵngcc0.ɵɵlistener("click", function DatetimePickerComponent_ng_template_7_div_2_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(2); return ctx_r13.toggleDateTimeState(); });
    ɵngcc0.ɵɵelement(2, "i", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "button", 13);
    ɵngcc0.ɵɵlistener("click", function DatetimePickerComponent_ng_template_7_div_2_Template_button_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r15 = ɵngcc0.ɵɵnextContext(2); return ctx_r15.onAccept(); });
    ɵngcc0.ɵɵelement(4, "i", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 15);
    ɵngcc0.ɵɵelementStart(6, "ngb-timepicker", 16, 17);
    ɵngcc0.ɵɵlistener("ngModelChange", function DatetimePickerComponent_ng_template_7_div_2_Template_ngb_timepicker_ngModelChange_6_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r16 = ɵngcc0.ɵɵnextContext(2); return ctx_r16.onTimeChange($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r6.value)("seconds", ctx_r6.seconds)("hourStep", ctx_r6.hourStep)("minuteStep", ctx_r6.minuteStep)("secondStep", ctx_r6.secondStep);
} }
function DatetimePickerComponent_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, DatetimePickerComponent_ng_template_7_div_1_Template, 7, 5, "div", 8);
    ɵngcc0.ɵɵtemplate(2, DatetimePickerComponent_ng_template_7_div_2_Template, 8, 5, "div", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r2.showTimePickerToggle);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.showTimePickerToggle);
} }
function DatetimePickerComponent_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0, " timepicker here!\n");
} }
function PollResultComponent_div_0_p_1_li_10_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1, "\u00A0");
    ɵngcc0.ɵɵelementEnd();
} }
function PollResultComponent_div_0_p_1_li_10_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 11);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const track_r4 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r6 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r6.getVoteIndex(track_r4));
} }
function PollResultComponent_div_0_p_1_li_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 6);
    ɵngcc0.ɵɵelementStart(1, "div", 7);
    ɵngcc0.ɵɵelementStart(2, "span", 8);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, PollResultComponent_div_0_p_1_li_10_span_4_Template, 2, 0, "span", 9);
    ɵngcc0.ɵɵtemplate(5, PollResultComponent_div_0_p_1_li_10_span_5_Template, 2, 1, "span", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const track_r4 = ctx.$implicit;
    const ctx_r3 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("ngbPopover", ctx_r3.getVoterHover(track_r4));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.getVoter(track_r4));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.showVoteIndex);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.showVoteIndex);
} }
function PollResultComponent_div_0_p_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p");
    ɵngcc0.ɵɵelementStart(1, "strong");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "br");
    ɵngcc0.ɵɵelementStart(4, "ngb-progressbar", 3);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "translate");
    ɵngcc0.ɵɵpipe(7, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "span");
    ɵngcc0.ɵɵelementStart(9, "ul", 4);
    ɵngcc0.ɵɵtemplate(10, PollResultComponent_div_0_p_1_li_10_Template, 6, 4, "li", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r2 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(option_r2.text.text);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵpropertyInterpolate2("ngbPopover", "", ctx_r1.countPoints(option_r2), " points, ", ctx_r1.countVotes(option_r2), " votes");
    ɵngcc0.ɵɵproperty("showValue", false)("value", ctx_r1.countPoints(option_r2))("max", ctx_r1.max);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate4(" ", ctx_r1.countPoints(option_r2), " ", ɵngcc0.ɵɵpipeBind1(6, 11, "polls.points"), ", ", ctx_r1.countVotes(option_r2), " ", ɵngcc0.ɵɵpipeBind1(7, 13, "polls.votes"), "");
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.getPeople(option_r2));
} }
function PollResultComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵtemplate(1, PollResultComponent_div_0_p_1_Template, 11, 15, "p", 2);
    ɵngcc0.ɵɵpipe(2, "wsSort");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind3(2, 1, ctx_r0.poll.options, "asc", "id"));
} }
const _c7 = function (a0) { return { active: a0 }; };
function StandardPollComponent_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "label", 4);
    ɵngcc0.ɵɵelementStart(3, "input", 5);
    ɵngcc0.ɵɵlistener("ngModelChange", function StandardPollComponent_li_1_Template_input_ngModelChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.selection.optionId = $event; })("click", function StandardPollComponent_li_1_Template_input_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r3); const option_r1 = ctx.$implicit; const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.onOptionSelect(option_r1); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(6, _c7, ctx_r0.voted.hasVoted && ctx_r0.isSelected(option_r1)));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("disabled", ctx_r0.voted.hasVoted)("checked", ctx_r0.isSelected(option_r1))("value", option_r1.id)("ngModel", ctx_r0.selection.optionId);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", option_r1.text.text, " ");
} }
function WeightedPollComponent_li_1_option_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 6);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r3 = ctx.$implicit;
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("value", option_r3.id);
    ɵngcc0.ɵɵproperty("disabled", ctx_r2.isSelected(option_r3.id));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(option_r3.text.text);
} }
function WeightedPollComponent_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 2);
    ɵngcc0.ɵɵelementStart(1, "select", 3);
    ɵngcc0.ɵɵlistener("ngModelChange", function WeightedPollComponent_li_1_Template_select_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const num_r1 = ctx.$implicit; const ctx_r4 = ɵngcc0.ɵɵnextContext(); return (ctx_r4.models[num_r1] = $event); })("change", function WeightedPollComponent_li_1_Template_select_change_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const num_r1 = ctx.$implicit; const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.change($event, num_r1); });
    ɵngcc0.ɵɵelementStart(2, "option", 4);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵpipe(5, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, WeightedPollComponent_li_1_option_6_Template, 2, 3, "option", 5);
    ɵngcc0.ɵɵpipe(7, "wsSort");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const num_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.models[num_r1])("disabled", ctx_r0.voted.hasVoted);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate4("", ctx_r0.numberToWord(num_r1 + 1), " ", ɵngcc0.ɵɵpipeBind1(4, 7, "polls.selection"), " (", ctx_r0.calcPointsForItem(num_r1), " ", ɵngcc0.ɵɵpipeBind1(5, 9, "polls.points"), ")");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind3(7, 11, ctx_r0.poll.options, "asc", ctx_r0.id));
} }
function VoteControlComponent_ng_template_0_Template(rf, ctx) { }
function VoteControlComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
    ɵngcc0.ɵɵelement(1, "br");
    ɵngcc0.ɵɵelementStart(2, "small", 9);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r3.poll.title.text, " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate3("", ɵngcc0.ɵɵpipeBind1(4, 4, "polls.created.by"), ": ", ctx_r3.poll.createdBy.firstName, " ", ctx_r3.poll.createdBy.lastName, "");
} }
function VoteControlComponent_ng_template_4_span_6_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "date");
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵpipe(4, "date");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate3(" ", ɵngcc0.ɵɵpipeBind2(2, 3, ctx_r19.poll.start, ctx_r19.dateFormat), " ", ɵngcc0.ɵɵpipeBind1(3, 6, "polls.to"), " ", ɵngcc0.ɵɵpipeBind2(4, 8, ctx_r19.poll.expiry, ctx_r19.dateFormat), " ");
} }
function VoteControlComponent_ng_template_4_span_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtemplate(1, VoteControlComponent_ng_template_4_span_6_span_1_Template, 5, 11, "span", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r17.poll.start);
} }
function VoteControlComponent_ng_template_4_span_7_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 12);
    ɵngcc0.ɵɵpipe(1, "date");
    ɵngcc0.ɵɵpipe(2, "date");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "date");
    ɵngcc0.ɵɵpipe(5, "date");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r20 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵpropertyInterpolate2("ngbPopover", "", ɵngcc0.ɵɵpipeBind2(1, 4, ctx_r20.poll.start, ctx_r20.dateFormat), " to ", ɵngcc0.ɵɵpipeBind2(2, 7, ctx_r20.poll.expiry, ctx_r20.dateFormat), "");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate2(" ", ɵngcc0.ɵɵpipeBind2(4, 10, ctx_r20.poll.start, "d"), "-", ɵngcc0.ɵɵpipeBind2(5, 13, ctx_r20.poll.expiry, ctx_r20.dateFormat), " ");
} }
function VoteControlComponent_ng_template_4_span_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtemplate(1, VoteControlComponent_ng_template_4_span_7_span_1_Template, 6, 16, "span", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r18.poll.start);
} }
function VoteControlComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "small", 9);
    ɵngcc0.ɵɵelementStart(1, "strong");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(5, "\u00A0|\u00A0 ");
    ɵngcc0.ɵɵtemplate(6, VoteControlComponent_ng_template_4_span_6_Template, 2, 1, "span", 10);
    ɵngcc0.ɵɵtemplate(7, VoteControlComponent_ng_template_4_span_7_Template, 2, 1, "span", 10);
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(3, 4, "polls.status"), ":");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r5.state, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r5.useDateRange());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.useDateRange());
} }
function VoteControlComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r7.poll.question.text, "\n");
} }
function VoteControlComponent_ng_template_8_div_0_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "strong");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 1, "polls.messages.abstained"));
} }
function VoteControlComponent_ng_template_8_div_0_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "strong");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 1, "polls.messages.anon"));
} }
function VoteControlComponent_ng_template_8_div_0_div_6_li_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const entry_r27 = ctx.$implicit;
    const ctx_r26 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r26.getVoteText(entry_r27), " ");
} }
function VoteControlComponent_ng_template_8_div_0_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "strong");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "ol");
    ɵngcc0.ɵɵtemplate(5, VoteControlComponent_ng_template_8_div_0_div_6_li_5_Template, 2, 1, "li", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r25 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 2, "polls.messages.choices"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r25.voted.votes);
} }
function VoteControlComponent_ng_template_8_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "em");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, VoteControlComponent_ng_template_8_div_0_div_4_Template, 4, 3, "div", 10);
    ɵngcc0.ɵɵtemplate(5, VoteControlComponent_ng_template_8_div_0_div_5_Template, 4, 3, "div", 10);
    ɵngcc0.ɵɵtemplate(6, VoteControlComponent_ng_template_8_div_0_div_6_Template, 6, 4, "div", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 4, "polls.messages.voted"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r21.voted.abstained);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r21.voted.anonymous);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r21.voted.abstained && !ctx_r21.voted.anonymous);
} }
function VoteControlComponent_ng_template_8_div_1_ws_standard_poll_1_Template(rf, ctx) { if (rf & 1) {
    const _r32 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ws-standard-poll", 15);
    ɵngcc0.ɵɵlistener("optionSelected", function VoteControlComponent_ng_template_8_div_1_ws_standard_poll_1_Template_ws_standard_poll_optionSelected_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r32); const ctx_r31 = ɵngcc0.ɵɵnextContext(3); return ctx_r31.selected($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r28 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("poll", ctx_r28.poll)("voted", ctx_r28.voted)("initialSelection", ctx_r28.selection)("optionHandler", ctx_r28.optionHandler);
} }
function VoteControlComponent_ng_template_8_div_1_ws_weighted_poll_2_Template(rf, ctx) { if (rf & 1) {
    const _r34 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ws-weighted-poll", 15);
    ɵngcc0.ɵɵlistener("optionSelected", function VoteControlComponent_ng_template_8_div_1_ws_weighted_poll_2_Template_ws_weighted_poll_optionSelected_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r34); const ctx_r33 = ɵngcc0.ɵɵnextContext(3); return ctx_r33.selected($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r29 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("poll", ctx_r29.poll)("voted", ctx_r29.voted)("initialSelection", ctx_r29.selection)("optionHandler", ctx_r29.optionHandler);
} }
function VoteControlComponent_ng_template_8_div_1_ws_multiselect_poll_3_Template(rf, ctx) { if (rf & 1) {
    const _r36 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ws-multiselect-poll", 15);
    ɵngcc0.ɵɵlistener("optionSelected", function VoteControlComponent_ng_template_8_div_1_ws_multiselect_poll_3_Template_ws_multiselect_poll_optionSelected_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r36); const ctx_r35 = ɵngcc0.ɵɵnextContext(3); return ctx_r35.selected($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r30 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("poll", ctx_r30.poll)("voted", ctx_r30.voted)("initialSelection", ctx_r30.selection)("optionHandler", ctx_r30.optionHandler);
} }
function VoteControlComponent_ng_template_8_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, VoteControlComponent_ng_template_8_div_1_ws_standard_poll_1_Template, 1, 4, "ws-standard-poll", 14);
    ɵngcc0.ɵɵtemplate(2, VoteControlComponent_ng_template_8_div_1_ws_weighted_poll_2_Template, 1, 4, "ws-weighted-poll", 14);
    ɵngcc0.ɵɵtemplate(3, VoteControlComponent_ng_template_8_div_1_ws_multiselect_poll_3_Template, 1, 4, "ws-multiselect-poll", 14);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r22.poll.type === "standard");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r22.poll.type === "weighted");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r22.poll.type === "multiselect");
} }
function VoteControlComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, VoteControlComponent_ng_template_8_div_0_Template, 7, 6, "div", 10);
    ɵngcc0.ɵɵtemplate(1, VoteControlComponent_ng_template_8_div_1_Template, 4, 3, "div", 10);
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r9.voted.hasVoted);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r9.voted.hasVoted);
} }
function VoteControlComponent_ng_template_10_ws_poll_result_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "ws-poll-result", 17);
} if (rf & 2) {
    const ctx_r37 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("poll", ctx_r37.poll)("results", ctx_r37.results)("tracks", ctx_r37.tracks);
} }
function VoteControlComponent_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, VoteControlComponent_ng_template_10_ws_poll_result_0_Template, 1, 3, "ws-poll-result", 16);
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r11.results);
} }
function VoteControlComponent_ng_template_12_button_0_Template(rf, ctx) { if (rf & 1) {
    const _r44 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 21);
    ɵngcc0.ɵɵlistener("click", function VoteControlComponent_ng_template_12_button_0_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r44); const ctx_r43 = ɵngcc0.ɵɵnextContext(2); ctx_r43.vote(); return false; });
    ɵngcc0.ɵɵelement(1, "i", 22);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r38 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("disabled", ctx_r38.hasVotesSelected());
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("\u00A0 ", ɵngcc0.ɵɵpipeBind1(3, 2, "polls.buttons.vote"), "");
} }
function VoteControlComponent_ng_template_12_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r46 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 23);
    ɵngcc0.ɵɵlistener("click", function VoteControlComponent_ng_template_12_button_2_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r46); const ctx_r45 = ɵngcc0.ɵɵnextContext(2); ctx_r45.abstain(); return false; });
    ɵngcc0.ɵɵelement(1, "i", 24);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("\u00A0 ", ɵngcc0.ɵɵpipeBind1(3, 1, "polls.buttons.abstain"), "");
} }
function VoteControlComponent_ng_template_12_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r48 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 23);
    ɵngcc0.ɵɵlistener("click", function VoteControlComponent_ng_template_12_button_4_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r48); const ctx_r47 = ɵngcc0.ɵɵnextContext(2); ctx_r47.unvote(); return false; });
    ɵngcc0.ɵɵelement(1, "i", 25);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("\u00A0 ", ɵngcc0.ɵɵpipeBind1(3, 1, "polls.buttons.clear.vote"), "");
} }
function VoteControlComponent_ng_template_12_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r50 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 26);
    ɵngcc0.ɵɵlistener("click", function VoteControlComponent_ng_template_12_button_6_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r50); const ctx_r49 = ɵngcc0.ɵɵnextContext(2); ctx_r49.changeView("result"); return false; });
    ɵngcc0.ɵɵelement(1, "i", 27);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("\u00A0 ", ɵngcc0.ɵɵpipeBind1(3, 1, "polls.buttons.view.results"), "");
} }
function VoteControlComponent_ng_template_12_button_8_Template(rf, ctx) { if (rf & 1) {
    const _r52 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 26);
    ɵngcc0.ɵɵlistener("click", function VoteControlComponent_ng_template_12_button_8_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r52); const ctx_r51 = ɵngcc0.ɵɵnextContext(2); ctx_r51.changeView("question"); return false; });
    ɵngcc0.ɵɵelement(1, "i", 28);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("\u00A0 ", ɵngcc0.ɵɵpipeBind1(3, 1, "polls.buttons.view.choices"), "");
} }
function VoteControlComponent_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, VoteControlComponent_ng_template_12_button_0_Template, 4, 4, "button", 18);
    ɵngcc0.ɵɵtext(1, "\u00A0 ");
    ɵngcc0.ɵɵtemplate(2, VoteControlComponent_ng_template_12_button_2_Template, 4, 3, "button", 19);
    ɵngcc0.ɵɵtext(3, "\u00A0 ");
    ɵngcc0.ɵɵtemplate(4, VoteControlComponent_ng_template_12_button_4_Template, 4, 3, "button", 19);
    ɵngcc0.ɵɵtext(5, "\u00A0 ");
    ɵngcc0.ɵɵtemplate(6, VoteControlComponent_ng_template_12_button_6_Template, 4, 3, "button", 20);
    ɵngcc0.ɵɵtext(7, "\u00A0 ");
    ɵngcc0.ɵɵtemplate(8, VoteControlComponent_ng_template_12_button_8_Template, 4, 3, "button", 20);
    ɵngcc0.ɵɵtext(9, "\u00A0\n");
} if (rf & 2) {
    const ctx_r13 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r13.showVoteButton());
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r13.showAbstainButton());
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r13.showClearVoteButton());
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r13.viewResultsState() && ctx_r13.state === "running");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r13.view === "result" && ctx_r13.state === "running");
} }
function VoteControlComponent_ng_template_14_a_4_Template(rf, ctx) { if (rf & 1) {
    const _r59 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 33);
    ɵngcc0.ɵɵlistener("click", function VoteControlComponent_ng_template_14_a_4_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r59); const ctx_r58 = ɵngcc0.ɵɵnextContext(2); ctx_r58.export(); return false; });
    ɵngcc0.ɵɵelement(1, "i", 34);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("\u00A0", ɵngcc0.ɵɵpipeBind1(3, 1, "polls.buttons.export.results"), " ");
} }
function VoteControlComponent_ng_template_14_a_5_Template(rf, ctx) { if (rf & 1) {
    const _r61 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 33);
    ɵngcc0.ɵɵlistener("click", function VoteControlComponent_ng_template_14_a_5_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r61); const ctx_r60 = ɵngcc0.ɵɵnextContext(2); ctx_r60.resetClick(ctx_r60.poll); return false; });
    ɵngcc0.ɵɵelement(1, "i", 35);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("\u00A0", ɵngcc0.ɵɵpipeBind1(3, 1, "polls.buttons.reset"), " ");
} }
function VoteControlComponent_ng_template_14_a_6_Template(rf, ctx) { if (rf & 1) {
    const _r63 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 33);
    ɵngcc0.ɵɵlistener("click", function VoteControlComponent_ng_template_14_a_6_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r63); const ctx_r62 = ɵngcc0.ɵɵnextContext(2); ctx_r62.extendClick(ctx_r62.poll); return false; });
    ɵngcc0.ɵɵelement(1, "i", 36);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("\u00A0", ɵngcc0.ɵɵpipeBind1(3, 1, "polls.buttons.extend"), " ");
} }
function VoteControlComponent_ng_template_14_a_7_Template(rf, ctx) { if (rf & 1) {
    const _r65 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 33);
    ɵngcc0.ɵɵlistener("click", function VoteControlComponent_ng_template_14_a_7_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r65); const ctx_r64 = ɵngcc0.ɵɵnextContext(2); ctx_r64.editClick(ctx_r64.poll); return false; });
    ɵngcc0.ɵɵelement(1, "i", 37);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("\u00A0", ɵngcc0.ɵɵpipeBind1(3, 1, "polls.buttons.edit"), " ");
} }
function VoteControlComponent_ng_template_14_a_8_Template(rf, ctx) { if (rf & 1) {
    const _r67 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 33);
    ɵngcc0.ɵɵlistener("click", function VoteControlComponent_ng_template_14_a_8_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r67); const ctx_r66 = ɵngcc0.ɵɵnextContext(2); ctx_r66.deleteClick(ctx_r66.poll); return false; });
    ɵngcc0.ɵɵelement(1, "i", 38);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("\u00A0", ɵngcc0.ɵɵpipeBind1(3, 1, "polls.buttons.delete"), " ");
} }
function VoteControlComponent_ng_template_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 29);
    ɵngcc0.ɵɵelementStart(1, "button", 30);
    ɵngcc0.ɵɵtext(2, " Manage ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 31);
    ɵngcc0.ɵɵtemplate(4, VoteControlComponent_ng_template_14_a_4_Template, 4, 3, "a", 32);
    ɵngcc0.ɵɵtemplate(5, VoteControlComponent_ng_template_14_a_5_Template, 4, 3, "a", 32);
    ɵngcc0.ɵɵtemplate(6, VoteControlComponent_ng_template_14_a_6_Template, 4, 3, "a", 32);
    ɵngcc0.ɵɵtemplate(7, VoteControlComponent_ng_template_14_a_7_Template, 4, 3, "a", 32);
    ɵngcc0.ɵɵtemplate(8, VoteControlComponent_ng_template_14_a_8_Template, 4, 3, "a", 32);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r15.view === "result" && ctx_r15.showExportButton);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r15.showResetButton);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r15.showExtendButton);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r15.showEditButton);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r15.showDeleteButton);
} }
function VoteControlComponent_div_16_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function VoteControlComponent_div_16_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function VoteControlComponent_div_16_div_6_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function VoteControlComponent_div_16_div_6_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function VoteControlComponent_div_16_div_6_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function VoteControlComponent_div_16_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 48);
    ɵngcc0.ɵɵtemplate(1, VoteControlComponent_div_16_div_6_ng_container_1_Template, 1, 0, "ng-container", 41);
    ɵngcc0.ɵɵtemplate(2, VoteControlComponent_div_16_div_6_ng_container_2_Template, 1, 0, "ng-container", 41);
    ɵngcc0.ɵɵtemplate(3, VoteControlComponent_div_16_div_6_ng_container_3_Template, 1, 0, "ng-container", 41);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r70 = ɵngcc0.ɵɵnextContext(2);
    const _r0 = ɵngcc0.ɵɵreference(1);
    const _r8 = ɵngcc0.ɵɵreference(9);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r70.beforeOptionsTemplate ? ctx_r70.beforeOptionsTemplate : _r0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r70.optionsTemplate ? ctx_r70.optionsTemplate : _r8);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r70.afterOptionsTemplate ? ctx_r70.afterOptionsTemplate : _r0);
} }
function VoteControlComponent_div_16_div_7_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function VoteControlComponent_div_16_div_7_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function VoteControlComponent_div_16_div_7_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function VoteControlComponent_div_16_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 48);
    ɵngcc0.ɵɵtemplate(1, VoteControlComponent_div_16_div_7_ng_container_1_Template, 1, 0, "ng-container", 41);
    ɵngcc0.ɵɵtemplate(2, VoteControlComponent_div_16_div_7_ng_container_2_Template, 1, 0, "ng-container", 41);
    ɵngcc0.ɵɵtemplate(3, VoteControlComponent_div_16_div_7_ng_container_3_Template, 1, 0, "ng-container", 41);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r71 = ɵngcc0.ɵɵnextContext(2);
    const _r0 = ɵngcc0.ɵɵreference(1);
    const _r10 = ɵngcc0.ɵɵreference(11);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r71.beforeResultTemplate ? ctx_r71.beforeResultTemplate : _r0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r71.resultTemplate ? ctx_r71.resultTemplate : _r10);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r71.afterResultTemplate ? ctx_r71.afterResultTemplate : _r0);
} }
function VoteControlComponent_div_16_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function VoteControlComponent_div_16_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function VoteControlComponent_div_16_ng_container_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function VoteControlComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 39);
    ɵngcc0.ɵɵelementStart(1, "div", 40);
    ɵngcc0.ɵɵtemplate(2, VoteControlComponent_div_16_ng_container_2_Template, 1, 0, "ng-container", 41);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 42);
    ɵngcc0.ɵɵelementStart(4, "div", 43);
    ɵngcc0.ɵɵtemplate(5, VoteControlComponent_div_16_ng_container_5_Template, 1, 0, "ng-container", 41);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, VoteControlComponent_div_16_div_6_Template, 4, 3, "div", 44);
    ɵngcc0.ɵɵtemplate(7, VoteControlComponent_div_16_div_7_Template, 4, 3, "div", 44);
    ɵngcc0.ɵɵelement(8, "hr");
    ɵngcc0.ɵɵelementStart(9, "div", 45);
    ɵngcc0.ɵɵtemplate(10, VoteControlComponent_div_16_ng_container_10_Template, 1, 0, "ng-container", 41);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "div", 46);
    ɵngcc0.ɵɵtemplate(12, VoteControlComponent_div_16_ng_container_12_Template, 1, 0, "ng-container", 41);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "div", 47);
    ɵngcc0.ɵɵtemplate(14, VoteControlComponent_div_16_ng_container_14_Template, 1, 0, "ng-container", 41);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = ɵngcc0.ɵɵnextContext();
    const _r2 = ɵngcc0.ɵɵreference(3);
    const _r6 = ɵngcc0.ɵɵreference(7);
    const _r12 = ɵngcc0.ɵɵreference(13);
    const _r14 = ɵngcc0.ɵɵreference(15);
    const _r4 = ɵngcc0.ɵɵreference(5);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r16.titleTemplate ? ctx_r16.titleTemplate : _r2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r16.questionTemplate ? ctx_r16.questionTemplate : _r6);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r16.view === "question");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r16.view === "result");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r16.controlBarLeftTemplate ? ctx_r16.controlBarLeftTemplate : _r12);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r16.controlBarRightTemplate ? ctx_r16.controlBarRightTemplate : _r14);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r16.footerTemplate ? ctx_r16.footerTemplate : _r4);
} }
function MultiselectPollComponent_li_1_option_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 6);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r3 = ctx.$implicit;
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("value", option_r3.id);
    ɵngcc0.ɵɵproperty("disabled", ctx_r2.isSelected(option_r3.id));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", option_r3.text.text, " ");
} }
function MultiselectPollComponent_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 2);
    ɵngcc0.ɵɵelementStart(1, "select", 3);
    ɵngcc0.ɵɵlistener("ngModelChange", function MultiselectPollComponent_li_1_Template_select_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const num_r1 = ctx.$implicit; const ctx_r4 = ɵngcc0.ɵɵnextContext(); return (ctx_r4.models[num_r1] = $event); })("change", function MultiselectPollComponent_li_1_Template_select_change_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const num_r1 = ctx.$implicit; const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.change($event, num_r1); });
    ɵngcc0.ɵɵelementStart(2, "option", 4);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, MultiselectPollComponent_li_1_option_4_Template, 2, 3, "option", 5);
    ɵngcc0.ɵɵpipe(5, "wsSort");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const num_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.models[num_r1])("disabled", ctx_r0.voted.hasVoted);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("", ctx_r0.numberToWord(num_r1 + 1), " selection (1 point)");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind3(5, 4, ctx_r0.poll.options, "asc", ctx_r0.id));
} }
const _c8 = ["ngSelectComponent"];
const _c9 = ["wrapperControl"];
const _c10 = ["expandControl"];
const _c11 = ["expandAllControl"];
const _c12 = ["collapseControl"];
const _c13 = ["collapseAllControl"];
const _c14 = ["separatorControl"];
const _c15 = ["showingControl"];
function EntityTreeSelectComponent_ng_template_0_ng_template_1_Template(rf, ctx) { }
function EntityTreeSelectComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 12);
    ɵngcc0.ɵɵtemplate(1, EntityTreeSelectComponent_ng_template_0_ng_template_1_Template, 0, 0, "ng-template", 13);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const template_r20 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", template_r20);
} }
function EntityTreeSelectComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r25 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 14);
    ɵngcc0.ɵɵlistener("click", function EntityTreeSelectComponent_ng_template_2_Template_button_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r25); const click_r23 = ctx.click; $event.preventDefault(); return click_r23(); });
    ɵngcc0.ɵɵtext(1, "Expand");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const enabled_r22 = ctx.enabled;
    ɵngcc0.ɵɵproperty("disabled", !enabled_r22);
} }
function EntityTreeSelectComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "button", 15);
    ɵngcc0.ɵɵlistener("click", function EntityTreeSelectComponent_ng_template_4_Template_button_click_0_listener() { const click_r26 = ctx.click; return click_r26(); });
    ɵngcc0.ɵɵtext(1, "Expand all");
    ɵngcc0.ɵɵelementEnd();
} }
function EntityTreeSelectComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "button", 14);
    ɵngcc0.ɵɵlistener("click", function EntityTreeSelectComponent_ng_template_6_Template_button_click_0_listener() { const click_r29 = ctx.click; return click_r29(); });
    ɵngcc0.ɵɵtext(1, "Collapse");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const enabled_r28 = ctx.enabled;
    ɵngcc0.ɵɵproperty("disabled", !enabled_r28);
} }
function EntityTreeSelectComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    const _r33 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 15);
    ɵngcc0.ɵɵlistener("click", function EntityTreeSelectComponent_ng_template_8_Template_button_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r33); const click_r31 = ctx.click; $event.preventDefault(); return click_r31(); });
    ɵngcc0.ɵɵtext(1, "Collapse all");
    ɵngcc0.ɵɵelementEnd();
} }
function EntityTreeSelectComponent_ng_template_10_Template(rf, ctx) { }
function EntityTreeSelectComponent_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
} if (rf & 2) {
    const showing_r34 = ctx.showing;
    const total_r35 = ctx.total;
    ɵngcc0.ɵɵtextInterpolate2(" Showing ", showing_r34, " of ", total_r35, "\n");
} }
function EntityTreeSelectComponent_ng_template_14_ng_template_0_Template(rf, ctx) { }
function EntityTreeSelectComponent_ng_template_14_ng_template_1_Template(rf, ctx) { }
function EntityTreeSelectComponent_ng_template_14_ng_template_2_Template(rf, ctx) { }
function EntityTreeSelectComponent_ng_template_14_ng_template_3_Template(rf, ctx) { }
function EntityTreeSelectComponent_ng_template_14_ng_template_4_Template(rf, ctx) { }
function EntityTreeSelectComponent_ng_template_14_ng_template_5_Template(rf, ctx) { }
function EntityTreeSelectComponent_ng_template_14_ng_template_6_Template(rf, ctx) { }
const _c16 = function (a0, a1) { return { enabled: a0, click: a1 }; };
const _c17 = function (a0) { return { click: a0 }; };
function EntityTreeSelectComponent_ng_template_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, EntityTreeSelectComponent_ng_template_14_ng_template_0_Template, 0, 0, "ng-template", 16);
    ɵngcc0.ɵɵtemplate(1, EntityTreeSelectComponent_ng_template_14_ng_template_1_Template, 0, 0, "ng-template", 13);
    ɵngcc0.ɵɵtemplate(2, EntityTreeSelectComponent_ng_template_14_ng_template_2_Template, 0, 0, "ng-template", 16);
    ɵngcc0.ɵɵtemplate(3, EntityTreeSelectComponent_ng_template_14_ng_template_3_Template, 0, 0, "ng-template", 13);
    ɵngcc0.ɵɵtemplate(4, EntityTreeSelectComponent_ng_template_14_ng_template_4_Template, 0, 0, "ng-template", 16);
    ɵngcc0.ɵɵtemplate(5, EntityTreeSelectComponent_ng_template_14_ng_template_5_Template, 0, 0, "ng-template", 13);
    ɵngcc0.ɵɵtemplate(6, EntityTreeSelectComponent_ng_template_14_ng_template_6_Template, 0, 0, "ng-template", 16);
} if (rf & 2) {
    const ctx_r15 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r15.controls.collapse)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(11, _c16, ctx_r15.currentMarkedEntity && ctx_r15.isExpandable(ctx_r15.currentMarkedEntity) && ctx_r15.isExpanded(ctx_r15.currentMarkedEntity), ctx_r15.collapseFn(ctx_r15.currentMarkedEntity)));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r15.controls.separator);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r15.controls.expand)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(14, _c16, ctx_r15.currentMarkedEntity && ctx_r15.isExpandable(ctx_r15.currentMarkedEntity) && ctx_r15.isCollapsed(ctx_r15.currentMarkedEntity), ctx_r15.expandFn(ctx_r15.currentMarkedEntity)));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r15.controls.separator);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r15.controls.collapseAll)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(17, _c17, ctx_r15.collapseAllFn()));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r15.controls.separator);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r15.controls.expandAll)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(19, _c17, ctx_r15.expandAllFn()));
} }
function EntityTreeSelectComponent_ng_template_18_ng_container_0_ng_template_1_ng_template_2_Template(rf, ctx) { }
function EntityTreeSelectComponent_ng_template_18_ng_container_0_ng_template_1_ng_template_4_Template(rf, ctx) { }
const _c18 = function (a0, a1) { return { showing: a0, total: a1 }; };
const _c19 = function (a0) { return { $implicit: a0 }; };
function EntityTreeSelectComponent_ng_template_18_ng_container_0_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 25);
    ɵngcc0.ɵɵelementStart(1, "div");
    ɵngcc0.ɵɵtemplate(2, EntityTreeSelectComponent_ng_template_18_ng_container_0_ng_template_1_ng_template_2_Template, 0, 0, "ng-template", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div");
    ɵngcc0.ɵɵtemplate(4, EntityTreeSelectComponent_ng_template_18_ng_container_0_ng_template_1_ng_template_4_Template, 0, 0, "ng-template", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r49 = ɵngcc0.ɵɵnextContext(3);
    const _r14 = ɵngcc0.ɵɵreference(15);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r49.controls.showing)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(4, _c18, ctx_r49.filtered, ctx_r49.total));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r49.controls.wrapper)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(7, _c19, _r14));
} }
function EntityTreeSelectComponent_ng_template_18_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, EntityTreeSelectComponent_ng_template_18_ng_container_0_ng_template_1_Template, 5, 9, "ng-template", 24);
    ɵngcc0.ɵɵelementContainerEnd();
} }
function EntityTreeSelectComponent_ng_template_18_ng_template_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r57 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "span", 26);
    ɵngcc0.ɵɵlistener("click", function EntityTreeSelectComponent_ng_template_18_ng_template_1_ng_container_2_Template_span_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r57); const ctx_r56 = ɵngcc0.ɵɵnextContext(); const entity_r52 = ctx_r56.item; const clear_r53 = ctx_r56.clear; return clear_r53(entity_r52); });
    ɵngcc0.ɵɵtext(2, "\u00D7");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} }
function EntityTreeSelectComponent_ng_template_18_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(2, EntityTreeSelectComponent_ng_template_18_ng_template_1_ng_container_2_Template, 3, 0, "ng-container", 17);
} if (rf & 2) {
    const entity_r52 = ctx.item;
    const ctx_r47 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassMap(ctx_r47.multiple ? "px-2" : "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r47.showFullPath ? entity_r52.fullPathName : entity_r52.name.text);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r47.multiple);
} }
function EntityTreeSelectComponent_ng_template_18_ng_container_9_ng_template_1_Template(rf, ctx) { }
const _c20 = function (a0, a1) { return { $implicit: a0, depth: a1 }; };
function EntityTreeSelectComponent_ng_template_18_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, EntityTreeSelectComponent_ng_template_18_ng_container_9_ng_template_1_Template, 0, 0, "ng-template", 16);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const child_r58 = ctx.$implicit;
    const depth_r44 = ɵngcc0.ɵɵnextContext().depth;
    ɵngcc0.ɵɵnextContext();
    const _r17 = ɵngcc0.ɵɵreference(19);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r17)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(2, _c20, child_r58, depth_r44 + 1));
} }
const _c21 = function (a1, a2, a3, a4, a5, a6, a7, a8, a9) { return { "item-wrapper": true, "level-0": a1, "level-1": a2, "level-2": a3, "level-3": a4, "level-4": a5, "level-5": a6, "level-6": a7, "expanded": a8, "collapsed": a9 }; };
function EntityTreeSelectComponent_ng_template_18_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, EntityTreeSelectComponent_ng_template_18_ng_container_0_Template, 2, 0, "ng-container", 17);
    ɵngcc0.ɵɵtemplate(1, EntityTreeSelectComponent_ng_template_18_ng_template_1_Template, 3, 5, "ng-template", 18);
    ɵngcc0.ɵɵelementStart(2, "ng-option", 19);
    ɵngcc0.ɵɵelementStart(3, "div", 20);
    ɵngcc0.ɵɵelementStart(4, "div", 21);
    ɵngcc0.ɵɵelementStart(5, "div", 22);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 23);
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(9, EntityTreeSelectComponent_ng_template_18_ng_container_9_Template, 2, 5, "ng-container", 11);
} if (rf & 2) {
    const entity_r43 = ctx.$implicit;
    const depth_r44 = ctx.depth;
    const ctx_r18 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r18.showControls && !!ctx_r18.treeEntities);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("value", entity_r43)("disabled", !entity_r43.selectable);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("id", ctx_r18.getDomIdentifier("entity-" + entity_r43.id))("ngClass", ɵngcc0.ɵɵpureFunctionV(9, _c21, [depth_r44 === 0, depth_r44 === 1, depth_r44 === 2, depth_r44 === 3, depth_r44 === 4, depth_r44 === 5, depth_r44 === 6, ctx_r18.isExpandable(entity_r43) && ctx_r18.isExpanded(entity_r43), ctx_r18.isExpandable(entity_r43) && ctx_r18.isCollapsed(entity_r43)]));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵattribute("data-entity-expander-id", ctx_r18.getDomIdentifier(entity_r43.id));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r18.isExpandable(entity_r43) && ctx_r18.isExpanded(entity_r43) ? "expanded" : ctx_r18.isExpandable(entity_r43) && ctx_r18.isCollapsed(entity_r43) ? "collapsed" : "", " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(entity_r43.name.text);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", entity_r43.children);
} }
function EntityTreeSelectComponent_ng_container_20_ng_template_1_Template(rf, ctx) { }
const _c22 = function (a0) { return { $implicit: a0, depth: 0 }; };
function EntityTreeSelectComponent_ng_container_20_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, EntityTreeSelectComponent_ng_container_20_ng_template_1_Template, 0, 0, "ng-template", 16);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const entity_r61 = ctx.$implicit;
    ɵngcc0.ɵɵnextContext();
    const _r17 = ɵngcc0.ɵɵreference(19);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r17)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c22, entity_r61));
} }
const _c23 = ["templateRef"];
function SelectAsyncHeaderComponent_ng_template_0_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.content);
} }
function SelectAsyncHeaderComponent_ng_template_0_ng_container_1_ng_template_1_Template(rf, ctx) { }
function SelectAsyncHeaderComponent_ng_template_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, SelectAsyncHeaderComponent_ng_template_0_ng_container_1_ng_template_1_Template, 0, 0, "ng-template", 2);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r3.content);
} }
function SelectAsyncHeaderComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, SelectAsyncHeaderComponent_ng_template_0_ng_container_0_Template, 2, 1, "ng-container", 1);
    ɵngcc0.ɵɵtemplate(1, SelectAsyncHeaderComponent_ng_template_0_ng_container_1_Template, 2, 1, "ng-container", 1);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.isString);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r1.isString);
} }
function AuthHeaderComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 5);
    ɵngcc0.ɵɵelement(1, "ws-wordmark");
    ɵngcc0.ɵɵelementStart(2, "span", 6);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.appName);
} }
function AuthHeaderComponent_ng_template_2_li_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵelementStart(1, "a", 13);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r9 = ctx.$implicit;
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassMapInterpolate1("nav-item ", ctx_r6.isRouteActive(item_r9.url) ? "active" : "", "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("routerLink", item_r9.params ? ɵngcc0.ɵɵpureFunction2(5, _c1, item_r9.url, item_r9.params) : ɵngcc0.ɵɵpureFunction1(8, _c2, item_r9.url));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r9.label, " ");
} }
function AuthHeaderComponent_ng_template_2_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵelementStart(1, "button", 15);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 16);
    ɵngcc0.ɵɵelementStart(4, "a", 17);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(6, "div", 18);
    ɵngcc0.ɵɵelementStart(7, "a", 19);
    ɵngcc0.ɵɵlistener("click", function AuthHeaderComponent_ng_template_2_div_6_Template_a_click_7_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(2); $event.preventDefault(); return ctx_r10.logout(); });
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵpipe(9, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r7.initials, " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate2("", ctx_r7.currentUser.first_name, " ", ctx_r7.currentUser.last_name, "");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(9, 4, "auth.logout"));
} }
function AuthHeaderComponent_ng_template_2_a_7_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 20);
    ɵngcc0.ɵɵlistener("click", function AuthHeaderComponent_ng_template_2_a_7_Template_a_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r12 = ɵngcc0.ɵɵnextContext(2); $event.preventDefault(); return ctx_r12.login(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "auth.login"));
} }
function AuthHeaderComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "button", 7);
    ɵngcc0.ɵɵtext(1, " Menu ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "div", 8);
    ɵngcc0.ɵɵelementStart(3, "ul", 9);
    ɵngcc0.ɵɵtemplate(4, AuthHeaderComponent_ng_template_2_li_4_Template, 3, 10, "li", 10);
    ɵngcc0.ɵɵpipe(5, "wsMenuAccessFilter");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, AuthHeaderComponent_ng_template_2_div_6_Template, 10, 6, "div", 11);
    ɵngcc0.ɵɵtemplate(7, AuthHeaderComponent_ng_template_2_a_7_Template, 3, 3, "a", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind3(5, 3, ctx_r3.menuItems, !!ctx_r3.currentUser, ctx_r3.userRoles));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.currentUser);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r3.currentUser);
} }
function AuthHeaderComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function AuthHeaderComponent_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function AuthFooterComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h1");
    ɵngcc0.ɵɵelementStart(1, "a", 17);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "ul");
    ɵngcc0.ɵɵelementStart(5, "li");
    ɵngcc0.ɵɵelementStart(6, "a", 18);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵpipe(8, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "li");
    ɵngcc0.ɵɵelementStart(10, "a", 19);
    ɵngcc0.ɵɵtext(11);
    ɵngcc0.ɵɵpipe(12, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "li");
    ɵngcc0.ɵɵelementStart(14, "a", 20);
    ɵngcc0.ɵɵtext(15);
    ɵngcc0.ɵɵpipe(16, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(17, "li");
    ɵngcc0.ɵɵelementStart(18, "a", 21);
    ɵngcc0.ɵɵtext(19);
    ɵngcc0.ɵɵpipe(20, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(21, "li");
    ɵngcc0.ɵɵelementStart(22, "a", 22);
    ɵngcc0.ɵɵtext(23);
    ɵngcc0.ɵɵpipe(24, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(25, "li");
    ɵngcc0.ɵɵelementStart(26, "a", 23);
    ɵngcc0.ɵɵtext(27);
    ɵngcc0.ɵɵpipe(28, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 7, "footer.links.my.worldskills"));
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(8, 9, "footer.links.wiw"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(12, 11, "footer.links.glossary"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(16, 13, "footer.links.registrations"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(20, 15, "footer.links.forums"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(24, 17, "footer.links.infrastructure.lists"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(28, 19, "footer.links.skill.management"));
} }
function AuthFooterComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 24);
    ɵngcc0.ɵɵelementStart(1, "a", 25);
    ɵngcc0.ɵɵelement(2, "ws-logo", 26);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function AuthFooterComponent_ng_template_4_Template(rf, ctx) { }
function AuthFooterComponent_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function AuthFooterComponent_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function AuthFooterComponent_ng_container_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function AuthFooterComponent_ng_container_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function AuthFooterComponent_ng_container_18_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function AuthFooterComponent_ng_container_20_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function AuthFooterComponent_li_40_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 11);
    ɵngcc0.ɵɵelementStart(1, "a", 27);
    ɵngcc0.ɵɵlistener("click", function AuthFooterComponent_li_40_Template_a_click_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r15 = ɵngcc0.ɵɵnextContext(); $event.preventDefault(); return ctx_r15.login(); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 1, "auth.login"));
} }
function AuthFooterComponent_li_41_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 11);
    ɵngcc0.ɵɵelementStart(1, "a", 27);
    ɵngcc0.ɵɵlistener("click", function AuthFooterComponent_li_41_Template_a_click_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r17 = ɵngcc0.ɵɵnextContext(); $event.preventDefault(); return ctx_r17.logout(); });
    ɵngcc0.ɵɵtext(2, "'auth.logout'");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function AuthFooterComponent_div_43_a_6_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 34);
    ɵngcc0.ɵɵlistener("click", function AuthFooterComponent_div_43_a_6_Template_a_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r22); const language_r20 = ctx.$implicit; const ctx_r21 = ɵngcc0.ɵɵnextContext(2); $event.preventDefault(); return ctx_r21.changeLanguage(language_r20); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const language_r20 = ctx.$implicit;
    const ctx_r19 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassProp("active", ctx_r19.isLanguageSelected(language_r20));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", language_r20.name, " ");
} }
function AuthFooterComponent_div_43_Template(rf, ctx) { if (rf & 1) {
    const _r24 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 28);
    ɵngcc0.ɵɵelementStart(1, "div", 29);
    ɵngcc0.ɵɵelementStart(2, "button", 30);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 31);
    ɵngcc0.ɵɵtemplate(6, AuthFooterComponent_div_43_a_6_Template, 2, 3, "a", 32);
    ɵngcc0.ɵɵelement(7, "div", 33);
    ɵngcc0.ɵɵelementStart(8, "a", 34);
    ɵngcc0.ɵɵlistener("click", function AuthFooterComponent_div_43_Template_a_click_8_listener($event) { ɵngcc0.ɵɵrestoreView(_r24); const ctx_r23 = ɵngcc0.ɵɵnextContext(); $event.preventDefault(); return ctx_r23.languagePrompt(); });
    ɵngcc0.ɵɵtext(9);
    ɵngcc0.ɵɵpipe(10, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(4, 3, "footer.translation.language"), " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r14.getLanguages());
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(10, 5, "footer.translation.missing"), " ");
} }
function ResourceThumbnailComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "a", 6);
    ɵngcc0.ɵɵtext(2, "Download");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("href", ctx_r0.resourceThumbnail.downloadLink, ɵngcc0.ɵɵsanitizeUrl);
} }
function ResourceThumbnailContainerComponent_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 7);
    ɵngcc0.ɵɵlistener("click", function ResourceThumbnailContainerComponent_button_6_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.downloadAllResourcesAsZipFile(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("disabled", ctx_r0.isZippingFiles);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.getDownloadAllBtnText, " ");
} }
function ResourceThumbnailContainerComponent_ws_resource_thumbnail_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "ws-resource-thumbnail", 8);
} if (rf & 2) {
    const thumbnail_r4 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("resourceThumbnail", thumbnail_r4);
} }
function I18nTextboxComponent_div_1_div_7_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const lang_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(lang_r2.text);
} }
function I18nTextboxComponent_div_1_div_7_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 16);
    ɵngcc0.ɵɵelementStart(1, "em");
    ɵngcc0.ɵɵtext(2, "(Empty)");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function I18nTextboxComponent_div_1_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵlistener("click", function I18nTextboxComponent_div_1_div_7_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const lang_r2 = ctx.$implicit; const ctx_r6 = ɵngcc0.ɵɵnextContext(2); return ctx_r6.selectLang(lang_r2); });
    ɵngcc0.ɵɵelementStart(1, "div", 10);
    ɵngcc0.ɵɵelementStart(2, "div", 11);
    ɵngcc0.ɵɵtemplate(3, I18nTextboxComponent_div_1_div_7_span_3_Template, 2, 1, "span", 12);
    ɵngcc0.ɵɵtemplate(4, I18nTextboxComponent_div_1_div_7_span_4_Template, 3, 0, "span", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 14);
    ɵngcc0.ɵɵelementStart(6, "div", 15);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const lang_r2 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("ngbPopover", lang_r2.text);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(5, _c7, lang_r2.lang_code === ctx_r1.currentCode));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", lang_r2.text);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !lang_r2.text);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.getLang(lang_r2.lang_code), " ");
} }
const _c24 = function (a0) { return { show: a0 }; };
function I18nTextboxComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "input", 3);
    ɵngcc0.ɵɵlistener("input", function I18nTextboxComponent_div_1_Template_input_input_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.textChanged($event.target.value); })("ngModelChange", function I18nTextboxComponent_div_1_Template_input_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.text = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "div", 4);
    ɵngcc0.ɵɵelementStart(3, "button", 5);
    ɵngcc0.ɵɵlistener("click", function I18nTextboxComponent_div_1_Template_button_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.show = !ctx_r11.show; });
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 6);
    ɵngcc0.ɵɵelementStart(6, "div", 7);
    ɵngcc0.ɵɵtemplate(7, I18nTextboxComponent_div_1_div_7_Template, 8, 7, "div", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.text);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("disabled", ctx_r0.disaableLangChange);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.getLang(ctx_r0.currentCode));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(5, _c24, ctx_r0.show));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.value);
} }
function I18nTextareaComponent_div_1_div_7_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const lang_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(lang_r2.text);
} }
function I18nTextareaComponent_div_1_div_7_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 16);
    ɵngcc0.ɵɵelementStart(1, "em");
    ɵngcc0.ɵɵtext(2, "(Empty)");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function I18nTextareaComponent_div_1_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵlistener("click", function I18nTextareaComponent_div_1_div_7_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const lang_r2 = ctx.$implicit; const ctx_r6 = ɵngcc0.ɵɵnextContext(2); return ctx_r6.selectLang(lang_r2); });
    ɵngcc0.ɵɵelementStart(1, "div", 10);
    ɵngcc0.ɵɵelementStart(2, "div", 11);
    ɵngcc0.ɵɵtemplate(3, I18nTextareaComponent_div_1_div_7_span_3_Template, 2, 1, "span", 12);
    ɵngcc0.ɵɵtemplate(4, I18nTextareaComponent_div_1_div_7_span_4_Template, 3, 0, "span", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 14);
    ɵngcc0.ɵɵelementStart(6, "div", 15);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const lang_r2 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("ngbPopover", lang_r2.text);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(5, _c7, lang_r2.lang_code === ctx_r1.currentCode));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", lang_r2.text);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !lang_r2.text);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.getLang(lang_r2.lang_code), " ");
} }
function I18nTextareaComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "textarea", 3);
    ɵngcc0.ɵɵlistener("input", function I18nTextareaComponent_div_1_Template_textarea_input_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.textChanged($event.target.value); })("ngModelChange", function I18nTextareaComponent_div_1_Template_textarea_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.text = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "div", 4);
    ɵngcc0.ɵɵelementStart(3, "button", 5);
    ɵngcc0.ɵɵlistener("click", function I18nTextareaComponent_div_1_Template_button_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.show = !ctx_r11.show; });
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 6);
    ɵngcc0.ɵɵelementStart(6, "div", 7);
    ɵngcc0.ɵɵtemplate(7, I18nTextareaComponent_div_1_div_7_Template, 8, 7, "div", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.text);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("disabled", ctx_r0.disaableLangChange);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.getLang(ctx_r0.currentCode));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(5, _c24, ctx_r0.show));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.value);
} }
function RelativeDateComponent_span_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.output);
} }
function RelativeDateComponent_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span");
} }
function RelativeDateComponent_span_2_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "dates.just_now"));
} }
function RelativeDateComponent_span_2_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "dates.minute_ago"));
} }
function RelativeDateComponent_span_2_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2("", ctx_r6.floor(ctx_r6.diff / 60), " ", ɵngcc0.ɵɵpipeBind1(2, 2, "dates.minutes_ago"), "");
} }
function RelativeDateComponent_span_2_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "dates.hour_ago"));
} }
function RelativeDateComponent_span_2_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2("", ctx_r8.floor(ctx_r8.diff / 3600), " ", ɵngcc0.ɵɵpipeBind1(2, 2, "dates.hours_ago"), "");
} }
function RelativeDateComponent_span_2_span_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "dates.yesterday"));
} }
function RelativeDateComponent_span_2_span_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2("", ctx_r10.daydiff, " ", ɵngcc0.ɵɵpipeBind1(2, 2, "dates.days_ago"), "");
} }
function RelativeDateComponent_span_2_span_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "dates.week_ago"));
} }
function RelativeDateComponent_span_2_span_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2("", ctx_r12.ceil(ctx_r12.daydiff / 7), " ", ɵngcc0.ɵɵpipeBind1(2, 2, "dates.weeks_ago"), "");
} }
function RelativeDateComponent_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtemplate(1, RelativeDateComponent_span_2_span_1_Template, 3, 3, "span", 0);
    ɵngcc0.ɵɵtemplate(2, RelativeDateComponent_span_2_span_2_Template, 3, 3, "span", 0);
    ɵngcc0.ɵɵtemplate(3, RelativeDateComponent_span_2_span_3_Template, 3, 4, "span", 0);
    ɵngcc0.ɵɵtemplate(4, RelativeDateComponent_span_2_span_4_Template, 3, 3, "span", 0);
    ɵngcc0.ɵɵtemplate(5, RelativeDateComponent_span_2_span_5_Template, 3, 4, "span", 0);
    ɵngcc0.ɵɵtemplate(6, RelativeDateComponent_span_2_span_6_Template, 3, 3, "span", 0);
    ɵngcc0.ɵɵtemplate(7, RelativeDateComponent_span_2_span_7_Template, 3, 4, "span", 0);
    ɵngcc0.ɵɵtemplate(8, RelativeDateComponent_span_2_span_8_Template, 3, 3, "span", 0);
    ɵngcc0.ɵɵtemplate(9, RelativeDateComponent_span_2_span_9_Template, 3, 4, "span", 0);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.diff < 60);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.diff > 60 && ctx_r2.diff < 120);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.diff > 120 && ctx_r2.diff < 3600);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.diff > 3600 && ctx_r2.diff < 7200);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.diff > 7200 && ctx_r2.diff < 86400);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.diff >= 86400 && ctx_r2.daydiff === 1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.diff > 86400 && ctx_r2.daydiff > 1 && ctx_r2.daydiff < 7);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.diff > 86400 && ctx_r2.daydiff === 7);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.diff > 86400 && ctx_r2.daydiff > 7 && ctx_r2.daydiff < 31);
} }
function RelativeDateComponent_span_3_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "dates.soon"));
} }
function RelativeDateComponent_span_3_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "dates.in_a_minute"));
} }
const _c25 = function (a0) { return { number: a0 }; };
function RelativeDateComponent_span_3_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(2, 1, "dates.in_n_minutes", ɵngcc0.ɵɵpureFunction1(4, _c25, ctx_r15.floor(ctx_r15.diff / 60))));
} }
function RelativeDateComponent_span_3_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "dates.in_an_hour"));
} }
function RelativeDateComponent_span_3_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(2, 1, "dates.in_n_hours", ɵngcc0.ɵɵpureFunction1(4, _c25, ctx_r17.floor(ctx_r17.diff / 3600))));
} }
function RelativeDateComponent_span_3_span_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "dates.tomorrow"));
} }
function RelativeDateComponent_span_3_span_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(2, 1, "dates.in_n_days", ɵngcc0.ɵɵpureFunction1(4, _c25, ctx_r19.daydiff)));
} }
function RelativeDateComponent_span_3_span_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "dates.in_a_week"));
} }
function RelativeDateComponent_span_3_span_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(2, 1, "dates.in_n_weeks", ɵngcc0.ɵɵpureFunction1(4, _c25, ctx_r21.ceil(ctx_r21.daydiff / 7))));
} }
function RelativeDateComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtemplate(1, RelativeDateComponent_span_3_span_1_Template, 3, 3, "span", 0);
    ɵngcc0.ɵɵtemplate(2, RelativeDateComponent_span_3_span_2_Template, 3, 3, "span", 0);
    ɵngcc0.ɵɵtemplate(3, RelativeDateComponent_span_3_span_3_Template, 3, 6, "span", 0);
    ɵngcc0.ɵɵtemplate(4, RelativeDateComponent_span_3_span_4_Template, 3, 3, "span", 0);
    ɵngcc0.ɵɵtemplate(5, RelativeDateComponent_span_3_span_5_Template, 3, 6, "span", 0);
    ɵngcc0.ɵɵtemplate(6, RelativeDateComponent_span_3_span_6_Template, 3, 3, "span", 0);
    ɵngcc0.ɵɵtemplate(7, RelativeDateComponent_span_3_span_7_Template, 3, 6, "span", 0);
    ɵngcc0.ɵɵtemplate(8, RelativeDateComponent_span_3_span_8_Template, 3, 3, "span", 0);
    ɵngcc0.ɵɵtemplate(9, RelativeDateComponent_span_3_span_9_Template, 3, 6, "span", 0);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.diff < 60);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.diff > 60 && ctx_r3.diff < 120);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.diff > 120 && ctx_r3.diff < 3600);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.diff > 3600 && ctx_r3.diff < 7200);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.diff > 7200 && ctx_r3.diff < 86400);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.diff >= 86400 && ctx_r3.daydiff === 1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.diff > 86400 && ctx_r3.daydiff > 1 && ctx_r3.daydiff < 7);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.diff > 86400 && ctx_r3.daydiff === 7);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.diff > 86400 && ctx_r3.daydiff > 7 && ctx_r3.daydiff < 31);
} }
function ToastComponent_ngb_toast_1_ng_template_1_ng_template_0_Template(rf, ctx) { }
function ToastComponent_ngb_toast_1_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, ToastComponent_ngb_toast_1_ng_template_1_ng_template_0_Template, 0, 0, "ng-template", 5);
} if (rf & 2) {
    const toast_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", toast_r1.textOrTpl);
} }
function ToastComponent_ngb_toast_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
} if (rf & 2) {
    const toast_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵtextInterpolate(toast_r1.textOrTpl);
} }
function ToastComponent_ngb_toast_1_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ngb-toast", 2);
    ɵngcc0.ɵɵlistener("hide", function ToastComponent_ngb_toast_1_Template_ngb_toast_hide_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); const toast_r1 = ctx.$implicit; const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.service.remove(toast_r1); });
    ɵngcc0.ɵɵtemplate(1, ToastComponent_ngb_toast_1_ng_template_1_Template, 1, 1, "ng-template", 3);
    ɵngcc0.ɵɵtemplate(2, ToastComponent_ngb_toast_1_ng_template_2_Template, 1, 1, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const toast_r1 = ctx.$implicit;
    const _r3 = ɵngcc0.ɵɵreference(3);
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMap(toast_r1.classname);
    ɵngcc0.ɵɵproperty("header", toast_r1.headertext)("autohide", toast_r1.autohide)("delay", toast_r1.delay || 5000);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.isTemplate(toast_r1))("ngIfElse", _r3);
} }
const _c26 = ["okmodal"];
const _c27 = ["okcancelmodal"];
const _c28 = ["yesmodal"];
const _c29 = ["yesnomodal"];
function ModalsComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵelementStart(1, "h4", 5);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "button", 6);
    ɵngcc0.ɵɵlistener("click", function ModalsComponent_ng_template_0_Template_button_click_3_listener() { const modal_r8 = ctx.$implicit; return modal_r8.dismiss("close"); });
    ɵngcc0.ɵɵelementStart(4, "span", 7);
    ɵngcc0.ɵɵtext(5, "\u00D7");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 8);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 9);
    ɵngcc0.ɵɵelementStart(9, "button", 10);
    ɵngcc0.ɵɵlistener("click", function ModalsComponent_ng_template_0_Template_button_click_9_listener() { const modal_r8 = ctx.$implicit; return modal_r8.close("ok"); });
    ɵngcc0.ɵɵtext(10);
    ɵngcc0.ɵɵpipe(11, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.okModalItem.title);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.okModalItem.body, " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(11, 3, "modals.ok"));
} }
function ModalsComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵelementStart(1, "h4", 5);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "button", 6);
    ɵngcc0.ɵɵlistener("click", function ModalsComponent_ng_template_2_Template_button_click_3_listener() { const modal_r11 = ctx.$implicit; return modal_r11.dismiss("close"); });
    ɵngcc0.ɵɵelementStart(4, "span", 7);
    ɵngcc0.ɵɵtext(5, "\u00D7");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 8);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 9);
    ɵngcc0.ɵɵelementStart(9, "button", 10);
    ɵngcc0.ɵɵlistener("click", function ModalsComponent_ng_template_2_Template_button_click_9_listener() { const modal_r11 = ctx.$implicit; return modal_r11.close("cancel"); });
    ɵngcc0.ɵɵtext(10);
    ɵngcc0.ɵɵpipe(11, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "button", 10);
    ɵngcc0.ɵɵlistener("click", function ModalsComponent_ng_template_2_Template_button_click_12_listener() { const modal_r11 = ctx.$implicit; return modal_r11.close("ok"); });
    ɵngcc0.ɵɵtext(13);
    ɵngcc0.ɵɵpipe(14, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.okCancelModalItem.title);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r3.okCancelModalItem.body, " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(11, 4, "modals.cancel"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(14, 6, "modals.ok"));
} }
function ModalsComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵelementStart(1, "h4", 5);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "button", 6);
    ɵngcc0.ɵɵlistener("click", function ModalsComponent_ng_template_4_Template_button_click_3_listener() { const modal_r15 = ctx.$implicit; return modal_r15.dismiss("close"); });
    ɵngcc0.ɵɵelementStart(4, "span", 7);
    ɵngcc0.ɵɵtext(5, "\u00D7");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 8);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 9);
    ɵngcc0.ɵɵelementStart(9, "button", 10);
    ɵngcc0.ɵɵlistener("click", function ModalsComponent_ng_template_4_Template_button_click_9_listener() { const modal_r15 = ctx.$implicit; return modal_r15.close("yes"); });
    ɵngcc0.ɵɵtext(10);
    ɵngcc0.ɵɵpipe(11, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r5.yesModalItem.title);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r5.yesModalItem.body, " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(11, 3, "modals.yes"));
} }
function ModalsComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵelementStart(1, "h4", 5);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "button", 6);
    ɵngcc0.ɵɵlistener("click", function ModalsComponent_ng_template_6_Template_button_click_3_listener() { const modal_r18 = ctx.$implicit; return modal_r18.dismiss("close"); });
    ɵngcc0.ɵɵelementStart(4, "span", 7);
    ɵngcc0.ɵɵtext(5, "\u00D7");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 8);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 9);
    ɵngcc0.ɵɵelementStart(9, "button", 10);
    ɵngcc0.ɵɵlistener("click", function ModalsComponent_ng_template_6_Template_button_click_9_listener() { const modal_r18 = ctx.$implicit; return modal_r18.close("yes"); });
    ɵngcc0.ɵɵtext(10);
    ɵngcc0.ɵɵpipe(11, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "button", 10);
    ɵngcc0.ɵɵlistener("click", function ModalsComponent_ng_template_6_Template_button_click_12_listener() { const modal_r18 = ctx.$implicit; return modal_r18.close("yes"); });
    ɵngcc0.ɵɵtext(13);
    ɵngcc0.ɵɵpipe(14, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r7.yesModalItem.title);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r7.yesModalItem.body, " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(11, 4, "modals.no"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(14, 6, "modals.yes"));
} }
class WorldskillsAngularLibService {
    constructor() {
        // default configuration
        this.defaultSupportEmailAddress = 'webmaster@worldskills.org';
        this.appConfigSubject = new ReplaySubject(1);
        this.httpConfigSubject = new ReplaySubject(1);
        this.serviceConfigSubject = new ReplaySubject(1);
        this.authConfigSubject = new ReplaySubject(1);
        this.appConfigSubject.next({ notAuthorizedRoute: ['/not-authorized'] });
    }
}
WorldskillsAngularLibService.ɵfac = function WorldskillsAngularLibService_Factory(t) { return new (t || WorldskillsAngularLibService)(); };
WorldskillsAngularLibService.ɵprov = ɵɵdefineInjectable({ factory: function WorldskillsAngularLibService_Factory() { return new WorldskillsAngularLibService(); }, token: WorldskillsAngularLibService, providedIn: "root" });
WorldskillsAngularLibService.ctorParameters = () => [];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(WorldskillsAngularLibService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class WorldskillsAngularLibComponent {
    constructor() { }
    ngOnInit() {
    }
}
WorldskillsAngularLibComponent.ɵfac = function WorldskillsAngularLibComponent_Factory(t) { return new (t || WorldskillsAngularLibComponent)(); };
WorldskillsAngularLibComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: WorldskillsAngularLibComponent, selectors: [["ws-worldskills-angular-lib"]], decls: 2, vars: 0, template: function WorldskillsAngularLibComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p");
        ɵngcc0.ɵɵtext(1, " worldskills-angular-lib works! ");
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2 });
WorldskillsAngularLibComponent.ctorParameters = () => [];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(WorldskillsAngularLibComponent, [{
        type: Component,
        args: [{
                selector: 'ws-worldskills-angular-lib',
                template: `
    <p>
      worldskills-angular-lib works!
    </p>
  `
            }]
    }], function () { return []; }, null); })();

class AlertService {
    constructor() {
        this.alerts = [];
    }
    remove(id) {
        const index = this.alerts.findIndex(item => item.id === id);
        if (index !== -1) {
            this.alerts.splice(index, 1);
        }
    }
    setAlert(id, type, title, message, closable, wsAlertComponentId) {
        title = title || '';
        message = message || '';
        closable = closable || false;
        wsAlertComponentId = wsAlertComponentId || '';
        this.alerts.push({
            id, type, title, message, closable, wsAlertComponentId
        });
    }
}
AlertService.ɵfac = function AlertService_Factory(t) { return new (t || AlertService)(); };
AlertService.ɵprov = ɵɵdefineInjectable({ factory: function AlertService_Factory() { return new AlertService(); }, token: AlertService, providedIn: "root" });
AlertService.ctorParameters = () => [];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AlertService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class AlertComponent {
    constructor(alertService) {
        this.alertService = alertService;
        this.closeStyle = 'cross'; // cross | button
    }
    // tslint:disable-next-line:typedef
    ngOnInit() {
    }
    // tslint:disable-next-line:typedef use-lifecycle-interface
    ngOnChanges() {
    }
    hasMessage() {
        return this.alert.message && this.alert.message.length > 0;
    }
    hasTitle() {
        return this.alert.title && this.alert.title.length > 0;
    }
    canClose() {
        return this.alert.closable;
    }
    dismiss() {
        this.alertService.remove(this.alert.id);
    }
}
AlertComponent.ɵfac = function AlertComponent_Factory(t) { return new (t || AlertComponent)(ɵngcc0.ɵɵdirectiveInject(AlertService)); };
AlertComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AlertComponent, selectors: [["ws-alert"]], inputs: { closeStyle: "closeStyle", alert: "alert" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 3, vars: 1, consts: [["buttonTemplate", ""], ["role", "alert", 3, "class", "ngClass", 4, "ngIf"], ["type", "button", "class", "close", "data-dismiss", "alert", "aria-label", "Close", 3, "click", 4, "ngIf"], [1, "pull-right"], ["type", "button", "class", "btn btn-sm btn-danger", "data-dismiss", "alert", "aria-label", "Close", 3, "click", 4, "ngIf"], ["type", "button", "data-dismiss", "alert", "aria-label", "Close", 1, "close", 3, "click"], ["aria-hidden", "true"], ["type", "button", "data-dismiss", "alert", "aria-label", "Close", 1, "btn", "btn-sm", "btn-danger", 3, "click"], ["role", "alert", 3, "ngClass"], ["class", "alert-heading", 4, "ngIf"], [4, "ngIf"], [1, "alert-heading"], [4, "ngTemplateOutlet"]], template: function AlertComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, AlertComponent_ng_template_0_Template, 3, 2, "ng-template", null, 0, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(2, AlertComponent_div_2_Template, 4, 9, "div", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.alert);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgClass, ɵngcc1.NgTemplateOutlet], pipes: [ɵngcc2.TranslatePipe], styles: [""] });
AlertComponent.ctorParameters = () => [
    { type: AlertService }
];
AlertComponent.propDecorators = {
    alert: [{ type: Input }],
    closeStyle: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AlertComponent, [{
        type: Component,
        args: [{
                selector: 'ws-alert',
                template: "<ng-template #buttonTemplate>\n  <button *ngIf=\"canClose() && closeStyle === 'cross'\" (click)=\"dismiss()\" type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-label=\"Close\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n  <div class=\"pull-right\">\n    <button *ngIf=\"canClose() && closeStyle === 'button'\" (click)=\"dismiss()\" type=\"button\" class=\"btn btn-sm btn-danger\" data-dismiss=\"alert\" aria-label=\"Close\">\n      {{ 'dialogue.close' | translate }}\n    </button>\n  </div>\n</ng-template>\n\n<div *ngIf=\"alert\" class=\"alert {{ alert.type }}\" [ngClass]=\"{ 'alert-dismissible': closeStyle === 'cross'}\" role=\"alert\">\n  <h4 *ngIf=\"hasTitle()\" class=\"alert-heading\">\n    {{ alert.title }}\n    <ng-container *ngTemplateOutlet=\"buttonTemplate\"></ng-container>\n  </h4>\n  <span *ngIf=\"hasMessage()\">{{ alert.message }}</span>\n  <span *ngIf=\"!hasTitle()\">\n    <ng-container *ngTemplateOutlet=\"buttonTemplate\"></ng-container>\n  </span>\n</div>\n",
                styles: [""]
            }]
    }], function () { return [{ type: AlertService }]; }, { closeStyle: [{
            type: Input
        }], alert: [{
            type: Input
        }] }); })();

class AlertsComponent {
    constructor(alertService) {
        this.alertService = alertService;
        this.wsAlertComponentId = '';
        this.closeStyle = 'cross'; // cross | button
    }
    // tslint:disable-next-line:typedef
    ngOnInit() {
    }
    get hasAlerts() {
        return this.alertService.alerts.length > 0;
    }
    getMyAlertList() {
        return this.alertService.alerts.filter(a => a.wsAlertComponentId === '' ? true : a.wsAlertComponentId === this.wsAlertComponentId);
    }
}
AlertsComponent.ɵfac = function AlertsComponent_Factory(t) { return new (t || AlertsComponent)(ɵngcc0.ɵɵdirectiveInject(AlertService)); };
AlertsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AlertsComponent, selectors: [["ws-alerts"]], inputs: { wsAlertComponentId: "wsAlertComponentId", closeStyle: "closeStyle" }, decls: 1, vars: 1, consts: [["class", "alerts", 4, "ngIf"], [1, "alerts"], [3, "alert", "closeStyle", 4, "ngFor", "ngForOf"], [3, "alert", "closeStyle"]], template: function AlertsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, AlertsComponent_div_0_Template, 2, 1, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasAlerts);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgForOf, AlertComponent], styles: [""] });
AlertsComponent.ctorParameters = () => [
    { type: AlertService }
];
AlertsComponent.propDecorators = {
    wsAlertComponentId: [{ type: Input }],
    closeStyle: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AlertsComponent, [{
        type: Component,
        args: [{
                selector: 'ws-alerts',
                template: "<div *ngIf=\"hasAlerts\" class=\"alerts\">\n  <ws-alert *ngFor=\"let item of getMyAlertList()\" [alert]=\"item\" [closeStyle]=\"closeStyle\"></ws-alert>\n</div>\n",
                styles: [""]
            }]
    }], function () { return [{ type: AlertService }]; }, { wsAlertComponentId: [{
            type: Input
        }], closeStyle: [{
            type: Input
        }] }); })();

class PuppeteerBannerComponent {
    constructor() { }
    ngOnInit() {
    }
}
PuppeteerBannerComponent.ɵfac = function PuppeteerBannerComponent_Factory(t) { return new (t || PuppeteerBannerComponent)(); };
PuppeteerBannerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: PuppeteerBannerComponent, selectors: [["ws-puppeteer-banner"]], inputs: { currentUser: "currentUser" }, decls: 1, vars: 1, consts: [["style", "background-color: #D51067; padding: 10px 20px; color: #fff; text-align: center;", 4, "ngIf"], [2, "background-color", "#D51067", "padding", "10px 20px", "color", "#fff", "text-align", "center"]], template: function PuppeteerBannerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, PuppeteerBannerComponent_div_0_Template, 2, 4, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.currentUser && ctx.currentUser.puppeteer);
    } }, directives: [ɵngcc1.NgIf], styles: [""] });
PuppeteerBannerComponent.ctorParameters = () => [];
PuppeteerBannerComponent.propDecorators = {
    currentUser: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PuppeteerBannerComponent, [{
        type: Component,
        args: [{
                selector: 'ws-puppeteer-banner',
                template: "<div style=\"background-color: #D51067; padding: 10px 20px; color: #fff; text-align: center;\"\n  *ngIf=\"currentUser && currentUser.puppeteer\">\n  {{currentUser.puppeteer.first_name}} {{currentUser.puppeteer.last_name}} logged in as {{currentUser.first_name}}\n  {{currentUser.last_name}}\n</div>\n",
                styles: [""]
            }]
    }], function () { return []; }, { currentUser: [{
            type: Input
        }] }); })();

class StagingBannerComponent {
    constructor() {
        this.message = 'This is the staging environment. Changes in this environment might get overwritten.';
    }
    ngOnInit() {
    }
}
StagingBannerComponent.ɵfac = function StagingBannerComponent_Factory(t) { return new (t || StagingBannerComponent)(); };
StagingBannerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: StagingBannerComponent, selectors: [["ws-staging-banner"]], inputs: { message: "message" }, decls: 2, vars: 1, consts: [[2, "background-color", "#ff6c0d", "padding", "10px 20px", "color", "#fff", "text-align", "center"]], template: function StagingBannerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.message);
    } }, styles: [""] });
StagingBannerComponent.ctorParameters = () => [];
StagingBannerComponent.propDecorators = {
    message: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(StagingBannerComponent, [{
        type: Component,
        args: [{
                selector: 'ws-staging-banner',
                template: "<div style=\"background-color: #ff6c0d; padding: 10px 20px; color: #fff; text-align: center;\">{{message}}</div>\n",
                styles: [""]
            }]
    }], function () { return []; }, { message: [{
            type: Input
        }] }); })();

class GenericUtil {
    static isNullOrUndefined(obj) {
        return obj === undefined || obj === null;
    }
    static getValueOrDefault(value, defaultValue) {
        return GenericUtil.isNullOrUndefined(value) ? defaultValue : value;
    }
}

class BreadcrumbsService {
    constructor() {
        this.showHomeItem = true;
        this.linkHomeItem = true;
        this.breadcrumbs = [];
        this.replacements = [];
        this.breadcrumbsSubject = new BehaviorSubject([]);
    }
    build(route, url = '', first = true) {
        if (first) {
            this.breadcrumbs = [];
        }
        if (route.outlet === this.targetOutlet) {
            const path = route.snapshot.url.map(segment => segment.path).join('/');
            url = `${url}/${path}`;
            this.isAtHome = GenericUtil.isNullOrUndefined(this.homeItemRoute) ? false : path === this.homeItemRoute.replace('/', '');
            if (route.snapshot.data.hasOwnProperty('breadcrumb')) {
                let key;
                let label;
                if (typeof route.snapshot.data.breadcrumb === 'string') {
                    key = label = route.snapshot.data.breadcrumb;
                }
                else {
                    key = route.snapshot.data.breadcrumb.key;
                    label = route.snapshot.data.breadcrumb.label;
                }
                const breadcrumb = {
                    key,
                    label,
                    params: route.snapshot.params,
                    url
                };
                // handle key replacements before breadcrumbs are initialized
                const replacementIndex = this.replacements.findIndex(r => r.key === breadcrumb.key);
                if (replacementIndex !== -1) {
                    breadcrumb.label = this.replacements[replacementIndex].value;
                }
                this.breadcrumbs.push(breadcrumb);
                this.breadcrumbsSubject.next(this.breadcrumbs);
            }
            // nothing to do
            if (route.children.length === 0) {
                return;
            }
            route.children.forEach(child => {
                this.build(child, url, false);
            });
        }
    }
    createOrUpdateReplacement(key, value) {
        let index = this.replacements.findIndex(x => x.key === key);
        if (index === -1) {
            const replacement = { key, value };
            this.replacements.push(replacement);
            index = this.replacements.findIndex(x => x.key === key);
        }
        else {
            this.replacements[index].value = value;
        }
        return index;
    }
    replaceLabel(key, value) {
        const replacementIndex = this.createOrUpdateReplacement(key, value);
        if (GenericUtil.isNullOrUndefined(this.breadcrumbs)) {
            return;
        }
        if (this.breadcrumbs.length === 0) {
            return;
        }
        this.breadcrumbs.forEach((b, i) => {
            if (b.key === key) {
                this.breadcrumbs[i].label = value;
            }
        });
        this.breadcrumbsSubject.next(this.breadcrumbs);
    }
    // this method should only be used after the breadcrumb is initialized
    remove(key) {
        const index = this.breadcrumbs.findIndex(x => x.key === key);
        if (index !== -1) {
            this.breadcrumbs.splice(index, 1);
            this.breadcrumbsSubject.next(this.breadcrumbs);
        }
    }
    // this method should only be used after the breadcrumb is initialized
    add(breadcrumb) {
        const index = this.breadcrumbs.findIndex(x => x.key === breadcrumb.key);
        if (index !== -1) {
            throwError(`key "${breadcrumb.key}" already exists`);
            return;
        }
        this.breadcrumbs.push(breadcrumb);
        this.breadcrumbsSubject.next(this.breadcrumbs);
    }
}
BreadcrumbsService.ɵfac = function BreadcrumbsService_Factory(t) { return new (t || BreadcrumbsService)(); };
BreadcrumbsService.ɵprov = ɵɵdefineInjectable({ factory: function BreadcrumbsService_Factory() { return new BreadcrumbsService(); }, token: BreadcrumbsService, providedIn: "root" });
BreadcrumbsService.ctorParameters = () => [];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BreadcrumbsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class ArrayUtil {
    // since array concat doesn't trigger UI updates
    static pushMany(first, second) {
        second.forEach(item => first.push(item));
        return first;
    }
    static dedupePrimitive(arr) {
        const clean = [];
        arr.forEach(item => {
            if (clean.indexOf(item) === -1) {
                clean.push(item);
            }
        });
        return clean;
    }
    static isArray(obj) {
        return Array.isArray(obj);
    }
    static flatten(entities) {
        const result = entities.reduce((acc, entity) => entity.children ? [...acc, entity, ...entity.children] : [...acc, entity], []);
        return result;
    }
}

class BreadcrumbsComponent {
    constructor(service, router, route) {
        this.service = service;
        this.router = router;
        this.route = route;
    }
    // tslint:disable-next-line:typedef
    ngOnInit() {
        // listen for dev changes to the breadcrumbs
        this.replacementSubscription = this.service.breadcrumbsSubject.subscribe(next => {
            this.breadcrumbs = [];
            ArrayUtil.pushMany(this.breadcrumbs, next);
        });
        // init
        this.isAtHome = false;
        this.service.homeItemRoute = this.homeItemRoute;
        this.service.targetOutlet = 'primary';
        this.service.build(this.route.root);
        if (!GenericUtil.isNullOrUndefined(this.showHomeItem)) {
            this.service.showHomeItem = true;
        }
        // rebuild on nav change
        this.rebuildSubscription = this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.service.build(this.route.root);
                this.isAtHome = this.service.isAtHome;
            }
        });
    }
    // tslint:disable-next-line:use-lifecycle-interface typedef
    ngOnChanges() {
        if (!GenericUtil.isNullOrUndefined(this.showHomeItem)) {
            this.service.showHomeItem = true;
        }
        else {
            this.service.showHomeItem = this.showHomeItem;
        }
    }
    // tslint:disable-next-line:use-lifecycle-interface typedef
    ngOnDestroy() {
        if (this.replacementSubscription) {
            this.replacementSubscription.unsubscribe();
        }
        if (this.rebuildSubscription) {
            this.rebuildSubscription.unsubscribe();
        }
    }
}
BreadcrumbsComponent.ɵfac = function BreadcrumbsComponent_Factory(t) { return new (t || BreadcrumbsComponent)(ɵngcc0.ɵɵdirectiveInject(BreadcrumbsService), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.Router), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.ActivatedRoute)); };
BreadcrumbsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BreadcrumbsComponent, selectors: [["ws-breadcrumbs"]], inputs: { showHomeItem: "showHomeItem", homeItemRoute: "homeItemRoute", homeItemText: "homeItemText" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["aria-label", "breadcrumb", 4, "ngIf"], ["aria-label", "breadcrumb"], [1, "breadcrumb"], ["class", "breadcrumb-item", 4, "ngIf"], [3, "class", 4, "ngFor", "ngForOf"], [1, "breadcrumb-item"], [3, "href", 4, "ngIf"], [4, "ngIf"], [3, "href"], [3, "routerLink", 4, "ngIf"], [3, "routerLink"]], template: function BreadcrumbsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, BreadcrumbsComponent_nav_0_Template, 5, 3, "nav", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.breadcrumbs);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgForOf, ɵngcc3.RouterLinkWithHref], styles: [""] });
BreadcrumbsComponent.ctorParameters = () => [
    { type: BreadcrumbsService },
    { type: Router },
    { type: ActivatedRoute }
];
BreadcrumbsComponent.propDecorators = {
    showHomeItem: [{ type: Input }],
    homeItemRoute: [{ type: Input }],
    homeItemText: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BreadcrumbsComponent, [{
        type: Component,
        args: [{
                selector: 'ws-breadcrumbs',
                template: "<nav aria-label=\"breadcrumb\" *ngIf=\"breadcrumbs\">\n  <ol class=\"breadcrumb\">\n    <li class=\"breadcrumb-item\" *ngIf=\"service.showHomeItem && !isAtHome\">\n      <a *ngIf=\"service.linkHomeItem\" href=\"{{ homeItemRoute }}\">{{ homeItemText }}</a>\n      <span *ngIf=\"!service.linkHomeItem\">{{ homeItemText }}</span>\n    </li>\n    <li class=\"breadcrumb-item\" *ngIf=\"showHomeItem && isAtHome\">\n      {{ homeItemText }}\n    </li>\n    <li class=\"breadcrumb-item {{ last ? 'active' : '' }}\"\n      *ngFor=\"let breadcrumb of breadcrumbs; let last = last;\">\n      <a *ngIf=\"!last\" [routerLink]=\"[breadcrumb.url, breadcrumb.params]\">\n        {{ breadcrumb.label }}\n      </a>\n      <span *ngIf=\"last\">\n        {{ breadcrumb.label }}\n      </span>\n    </li>\n  </ol>\n</nav>\n",
                styles: [""]
            }]
    }], function () { return [{ type: BreadcrumbsService }, { type: ɵngcc3.Router }, { type: ɵngcc3.ActivatedRoute }]; }, { showHomeItem: [{
            type: Input
        }], homeItemRoute: [{
            type: Input
        }], homeItemText: [{
            type: Input
        }] }); })();

class HeaderComponent {
    constructor(router, route) {
        this.router = router;
        this.route = route;
        this.logoutClick = new EventEmitter();
        this.loginClick = new EventEmitter();
        this.appName = 'Application';
        this.isLoggedIn = false;
        this.showLoginAndLogoutButtons = false;
        this.menuItems = [];
        this.dropDownMenuItems = [];
        this.currentUser = null;
    }
    // tslint:disable-next-line:use-life-cycle-interface typedef
    ngOnInit() {
    }
    // tslint:disable-next-line:use-lifecycle-interface typedef
    ngOnChanges() {
    }
    userRoles() {
        if (this.currentUser === undefined || this.currentUser === null) {
            return [];
        }
        if (this.currentUser.roles === undefined || this.currentUser.roles === null) {
            return [];
        }
        return this.currentUser.roles.map(item => {
            return item.name;
        });
    }
    isRouteActive(item) {
        var _a;
        return item.url === this.router.url || ((_a = item === null || item === void 0 ? void 0 : item.subMenuItems) === null || _a === void 0 ? void 0 : _a.some(subItem => subItem.url === this.router.url));
    }
    getActiveParentMenu() {
        let parent = this.menuItems.find(item => item.url === this.router.url);
        if (GenericUtil.isNullOrUndefined(parent)) {
            // get the parent of the active child item.
            const parents = this.menuItems.filter(item => !GenericUtil.isNullOrUndefined(item.subMenuItems));
            parents.forEach(item => {
                if (GenericUtil.isNullOrUndefined(parent)) {
                    const match = item.subMenuItems.find(subItem => subItem.url === this.router.url);
                    if (!GenericUtil.isNullOrUndefined(match)) {
                        parent = item;
                    }
                }
            });
        }
        return parent;
    }
    hasSubMenuItems(item) {
        if (GenericUtil.isNullOrUndefined(item)) {
            return false;
        }
        return !GenericUtil.isNullOrUndefined(item.subMenuItems);
    }
    getSubMenuItems(item) {
        if (GenericUtil.isNullOrUndefined(item)) {
            return [];
        }
        if (GenericUtil.isNullOrUndefined(item.subMenuItems)) {
            return [];
        }
        return item.subMenuItems;
    }
    login() {
        this.loginClick.emit();
    }
    logout() {
        this.logoutClick.emit();
    }
    getInitials() {
        let s = '';
        if (this.currentUser) {
            if (this.currentUser.first_name) {
                s = this.currentUser.first_name.substr(0, 1);
            }
            if (this.currentUser.last_name) {
                s += this.currentUser.last_name.substr(0, 1);
            }
        }
        return s.toUpperCase();
    }
    showMenu() {
        return this.showLoginAndLogoutButtons ? this.isLoggedIn || !GenericUtil.isNullOrUndefined(this.currentUser) : false;
    }
    showLoginButton() {
        return this.showLoginAndLogoutButtons ? !this.isLoggedIn || GenericUtil.isNullOrUndefined(this.currentUser) : false;
    }
}
HeaderComponent.ɵfac = function HeaderComponent_Factory(t) { return new (t || HeaderComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.Router), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.ActivatedRoute)); };
HeaderComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: HeaderComponent, selectors: [["ws-header"]], inputs: { appName: "appName", isLoggedIn: "isLoggedIn", showLoginAndLogoutButtons: "showLoginAndLogoutButtons", menuItems: "menuItems", dropDownMenuItems: "dropDownMenuItems", currentUser: "currentUser", linkTitle: "linkTitle", appNameTemplate: "appNameTemplate", menuTemplate: "menuTemplate", subMenuTemplate: "subMenuTemplate" }, outputs: { logoutClick: "logoutClick", loginClick: "loginClick" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 11, vars: 3, consts: [["appNameDefaultTemplate", ""], ["menuDefaultTemplate", ""], ["subMenuDefaultTemplate", ""], [1, "navbar", "navbar-expand-md", "ws-navbar-main", "ws-navbar-stripe", "wsmember-navbar-main", "wsmember-bg-pink"], [1, "container"], [4, "ngTemplateOutlet"], ["class", "navbar navbar-expand-md ws-navbar-sub", 4, "ngIf"], ["href", "#", 1, "navbar-brand"], [1, "ml-1", "text-white"], ["type", "button", "data-toggle", "collapse", "data-target", "#navbarSupportedContent", "aria-controls", "navbarSupportedContent", "aria-expanded", "false", "aria-label", "Toggle navigation", 1, "navbar-toggler", "collapsed"], ["id", "navbarSupportedContent", 1, "collapse", "navbar-collapse"], [1, "navbar-nav", "ml-auto"], [3, "class", 4, "ngFor", "ngForOf"], ["class", "dropdown ml-2", 4, "ngIf"], ["class", "btn btn-light btn-sm ml-2 wsi-login", 3, "click", 4, "ngIf"], [1, "nav-link", 3, "routerLink"], [1, "dropdown", "ml-2"], ["type", "button", "data-toggle", "dropdown", 1, "btn", "btn-white", "rounded-pill"], [1, "dropdown-menu", "dropdown-menu-right"], ["href", "#", "tabindex", "-1", 1, "dropdown-item", "disabled"], [1, "dropdown-divider"], ["class", "dropdown-item", 3, "routerLink", 4, "ngFor", "ngForOf"], ["href", "#", 1, "dropdown-item", 3, "click"], [1, "dropdown-item", 3, "routerLink"], [1, "btn", "btn-light", "btn-sm", "ml-2", "wsi-login", 3, "click"], [1, "collapse", "navbar-collapse"], [1, "navbar", "navbar-expand-md", "ws-navbar-sub"]], template: function HeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, HeaderComponent_ng_template_0_Template, 4, 1, "ng-template", null, 0, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(2, HeaderComponent_ng_template_2_Template, 8, 7, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(4, HeaderComponent_ng_template_4_Template, 4, 5, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementStart(6, "nav", 3);
        ɵngcc0.ɵɵelementStart(7, "div", 4);
        ɵngcc0.ɵɵtemplate(8, HeaderComponent_ng_container_8_Template, 1, 0, "ng-container", 5);
        ɵngcc0.ɵɵtemplate(9, HeaderComponent_ng_container_9_Template, 1, 0, "ng-container", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(10, HeaderComponent_nav_10_Template, 3, 1, "nav", 6);
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(1);
        const _r2 = ɵngcc0.ɵɵreference(3);
        ɵngcc0.ɵɵadvance(8);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.appNameTemplate ? ctx.appNameTemplate : _r0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.menuTemplate ? ctx.menuTemplate : _r2);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasSubMenuItems(ctx.getActiveParentMenu()));
    } }, directives: function () { return [ɵngcc4.NgbNavbar, ɵngcc1.NgTemplateOutlet, ɵngcc1.NgIf, WordmarkComponent, ɵngcc1.NgForOf, ɵngcc3.RouterLinkWithHref]; }, pipes: function () { return [MenuAccessPipe, ɵngcc2.TranslatePipe]; }, styles: [".has-subnav.active[_ngcontent-%COMP%]{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='15px' height='8px' viewBox='0 0 15 8' version='1.1'%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cpolygon id='Triangle' fill='%230E779F' fill-rule='nonzero' points='7.5 0 15 8 0 8'%3E%3C/polygon%3E%3C/g%3E%3C/svg%3E\");background-position:50% bottom;background-repeat:no-repeat;margin-bottom:-13px}"] });
HeaderComponent.ctorParameters = () => [
    { type: Router },
    { type: ActivatedRoute }
];
HeaderComponent.propDecorators = {
    appName: [{ type: Input }],
    isLoggedIn: [{ type: Input }],
    showLoginAndLogoutButtons: [{ type: Input }],
    menuItems: [{ type: Input }],
    dropDownMenuItems: [{ type: Input }],
    currentUser: [{ type: Input }],
    linkTitle: [{ type: Input }],
    appNameTemplate: [{ type: Input }],
    menuTemplate: [{ type: Input }],
    subMenuTemplate: [{ type: Input }],
    logoutClick: [{ type: Output }],
    loginClick: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(HeaderComponent, [{
        type: Component,
        args: [{
                selector: 'ws-header',
                template: "<ng-template #appNameDefaultTemplate>\n    <a class=\"navbar-brand\" href=\"#\">\n        <ws-wordmark></ws-wordmark>\n        <span class=\"ml-1 text-white\">{{ appName }}</span>\n    </a>\n</ng-template>\n\n<ng-template #menuDefaultTemplate>\n    <button class=\"navbar-toggler collapsed\" type=\"button\" data-toggle=\"collapse\" data-target=\"#navbarSupportedContent\"\n            aria-controls=\"navbarSupportedContent\" aria-expanded=\"false\" aria-label=\"Toggle navigation\">\n        Menu\n    </button>\n    <div class=\"collapse navbar-collapse\" id=\"navbarSupportedContent\">\n        <ul class=\"navbar-nav ml-auto\">\n            <li class=\"nav-item {{ isRouteActive(item) ? 'active' : '' }} {{ item.subMenuItems ? 'has-subnav' : ''}}\"\n                *ngFor=\"let item of menuItems | wsMenuAccessFilter: isLoggedIn: userRoles()\">\n                <a class=\"nav-link\" [routerLink]=\"item.params ? [item.url, item.params] : [item.url]\">\n                    {{ item.label }}\n                </a>\n            </li>\n        </ul>\n\n        <div class=\"dropdown ml-2\" *ngIf=\"showMenu()\">\n            <button class=\"btn btn-white rounded-pill\" type=\"button\" data-toggle=\"dropdown\">\n                {{ getInitials() }}\n            </button>\n            <div class=\"dropdown-menu dropdown-menu-right\">\n                <a class=\"dropdown-item disabled\" href=\"#\" tabindex=\"-1\">{{ currentUser.first_name }}\n                    {{ currentUser.last_name }}</a>\n                <div class=\"dropdown-divider\"></div>\n                <a *ngFor=\"let item of dropDownMenuItems | wsMenuAccessFilter: isLoggedIn: userRoles()\" class=\"dropdown-item\" [routerLink]=\"item.params ? [item.url, item.params] : [item.url]\">{{ item.label }}</a>\n                <a class=\"dropdown-item\" href=\"#\" (click)=\"logout(); false;\">{{ 'auth.logout' | translate }}</a>\n            </div>\n        </div>\n        <a class=\"btn btn-light btn-sm ml-2 wsi-login\" (click)=\"login(); false;\"\n           *ngIf=\"showLoginButton()\">{{ 'auth.login' | translate }}</a>\n    </div>\n</ng-template>\n\n\n<ng-template #subMenuDefaultTemplate>\n    <div class=\"collapse navbar-collapse\">\n        <ul class=\"navbar-nav ml-auto\">\n            <li class=\"nav-item {{ isRouteActive(item) ? 'active' : '' }}\"\n                *ngFor=\"let item of getSubMenuItems(getActiveParentMenu()) | wsMenuAccessFilter: isLoggedIn: userRoles()\">\n                <a class=\"nav-link\" [routerLink]=\"item.params ? [item.url, item.params] : [item.url]\">\n                    {{ item.label }}\n                </a>\n            </li>\n        </ul>\n    </div>\n</ng-template>\n\n<nav class=\"navbar navbar-expand-md ws-navbar-main ws-navbar-stripe wsmember-navbar-main wsmember-bg-pink\">\n    <div class=\"container\">\n        <ng-container *ngTemplateOutlet=\"appNameTemplate ? appNameTemplate : appNameDefaultTemplate\"></ng-container>\n        <ng-container *ngTemplateOutlet=\"menuTemplate ? menuTemplate : menuDefaultTemplate\"></ng-container>\n    </div>\n</nav>\n\n<nav class=\"navbar navbar-expand-md ws-navbar-sub\" *ngIf=\"hasSubMenuItems(getActiveParentMenu())\">\n    <div class=\"container\">\n        <ng-container *ngTemplateOutlet=\"subMenuTemplate ? subMenuTemplate : subMenuDefaultTemplate\"></ng-container>\n    </div>\n</nav>",
                styles: [".has-subnav.active{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='15px' height='8px' viewBox='0 0 15 8' version='1.1'%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cpolygon id='Triangle' fill='%230E779F' fill-rule='nonzero' points='7.5 0 15 8 0 8'%3E%3C/polygon%3E%3C/g%3E%3C/svg%3E\");background-position:50% bottom;background-repeat:no-repeat;margin-bottom:-13px}"]
            }]
    }], function () { return [{ type: ɵngcc3.Router }, { type: ɵngcc3.ActivatedRoute }]; }, { logoutClick: [{
            type: Output
        }], loginClick: [{
            type: Output
        }], appName: [{
            type: Input
        }], isLoggedIn: [{
            type: Input
        }], showLoginAndLogoutButtons: [{
            type: Input
        }], menuItems: [{
            type: Input
        }], dropDownMenuItems: [{
            type: Input
        }], currentUser: [{
            type: Input
        }], linkTitle: [{
            type: Input
        }], appNameTemplate: [{
            type: Input
        }], menuTemplate: [{
            type: Input
        }], subMenuTemplate: [{
            type: Input
        }] }); })();

class LogoComponent {
    constructor() { }
    ngOnInit() {
    }
}
LogoComponent.ɵfac = function LogoComponent_Factory(t) { return new (t || LogoComponent)(); };
LogoComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: LogoComponent, selectors: [["ws-logo"]], decls: 22, vars: 0, consts: [["width", "110px", "height", "65px", "viewBox", "0 0 220 129", "version", "1.1", "xmlns", "http://www.w3.org/2000/svg", 0, "xmlns", "xlink", "http://www.w3.org/1999/xlink", 0, "xml", "space", "preserve", 0, "xmlns", "serif", "http://www.serif.com/", "aria-label", "WorldSkills", 2, "fill-rule", "evenodd", "clip-rule", "evenodd", "stroke-linejoin", "round", "stroke-miterlimit", "1.41421"], ["d", "M52.271,126.434c-5.36,0 -8.958,-4.395 -8.958,-10.942c0,-6.547 3.598,-10.944 8.958,-10.944c5.358,0 8.959,4.397 8.959,10.944c0,6.547 -3.601,10.942 -8.959,10.942Zm0,-24.453c-9.152,0 -12.397,7.276 -12.397,13.511c0,6.232 3.245,13.509 12.397,13.509c9.151,0 12.398,-7.277 12.398,-13.509c0,-6.235 -3.247,-13.511 -12.398,-13.511Z", 2, "fill", "#fff", "fill-rule", "nonzero"], ["d", "M70.618,106.725l0,-4.232l-2.916,0l0.003,25.798l3.122,0l0,-12.745l-0.006,-0.165c0.006,-4.753 1.352,-10.434 7.767,-10.434l0.975,0.046l0.012,-0.101l0.156,-3.009l-0.363,-0.002c-4.333,0 -7.269,1.636 -8.75,4.844Z", 2, "fill", "#fff", "fill-rule", "nonzero"], ["d", "M134.06,107.522c-2.152,-0.71 -3.726,-1.121 -6.297,-1.121c-1.89,0 -4.145,0.664 -4.145,2.905c0,4.18 12.225,1.53 12.225,11.001c0,6.117 -5.614,8.564 -11.333,8.564c-2.68,0 -5.407,-0.457 -7.977,-1.12l0.419,-5.607c2.203,1.069 4.512,1.733 6.924,1.733c1.788,0 4.62,-0.664 4.62,-3.209c0,-5.146 -12.226,-1.631 -12.226,-11.107c0,-5.653 5.09,-8.153 10.599,-8.153c3.306,0 5.46,0.512 7.662,0.97l-0.471,5.144Z", 2, "fill", "#fff", "fill-rule", "nonzero"], ["x", "166.803", "y", "102.052", "width", "7.034", "height", "26.24", 2, "fill", "#fff", "fill-rule", "nonzero"], ["d", "M217.817,107.522c-2.151,-0.71 -3.725,-1.121 -6.296,-1.121c-1.892,0 -4.146,0.664 -4.146,2.905c0,4.18 12.225,1.53 12.225,11.001c0,6.117 -5.613,8.564 -11.333,8.564c-2.678,0 -5.405,-0.457 -7.977,-1.12l0.42,-5.607c2.203,1.069 4.513,1.733 6.926,1.733c1.785,0 4.619,-0.664 4.619,-3.209c0,-5.146 -12.227,-1.631 -12.227,-11.107c0,-5.653 5.09,-8.153 10.602,-8.153c3.305,0 5.454,0.512 7.659,0.97l-0.472,5.144Z", 2, "fill", "#fff", "fill-rule", "nonzero"], ["d", "M153.067,113.813l9.962,-11.761l-8.292,0l-8.394,10.497l-0.106,0l0,-24.615l-7.032,2.148l0,38.21l7.032,0l0,-12.738l0.106,0l9.027,12.738l8.919,0l-11.222,-14.479Z", 2, "fill", "#fff", "fill-rule", "nonzero"], ["d", "M101.041,126.336c-7.234,0 -8.017,-7.653 -8.017,-10.943c0,-3.292 0.783,-10.944 8.017,-10.944c5.537,0 8.017,5.495 8.017,10.944c0,5.448 -2.48,10.943 -8.017,10.943Zm11.012,-36.962l-2.995,0.917l0,15.95c-0.652,-1.091 -3.088,-4.428 -8.543,-4.36c-9.031,0.114 -10.927,7.409 -10.927,13.512c0,8.332 4.187,13.511 10.929,13.511c4.014,0 6.73,-1.479 8.541,-4.613l0,4.001l3.121,0l0,-38.957l-0.126,0.039Z", 2, "fill", "#fff", "fill-rule", "nonzero"], ["d", "M85.984,89.376l-2.997,0.913l0,38.003l3.123,0l0,-38.957l-0.126,0.041Z", 2, "fill", "#fff", "fill-rule", "nonzero"], ["d", "M178.373,90.082l0,38.21l7.031,0l0,-40.359l-7.031,2.149Z", 2, "fill", "#fff", "fill-rule", "nonzero"], ["d", "M189.455,90.082l-0.004,0l0,38.21l7.034,0l0,-40.359l-7.03,2.149Z", 2, "fill", "#fff", "fill-rule", "nonzero"], ["d", "M174.384,92.257c0,-2.165 -1.756,-3.917 -3.917,-3.917c-2.161,0 -3.915,1.752 -3.915,3.917c0,2.163 1.754,3.917 3.915,3.917c2.161,0 3.917,-1.754 3.917,-3.917Z", 2, "fill", "#fff", "fill-rule", "nonzero"], ["d", "M3.352,102.493l-3.352,0l0.042,0.129c0.16,0.486 8.402,25.375 8.48,25.601l0.022,0.069l3.856,0c0,0 7.249,-22.333 7.292,-22.469l0.239,0c0.045,0.136 7.294,22.469 7.294,22.469l3.858,0l8.753,-25.799l-3.113,0c0,0 -7.354,22.334 -7.4,22.467l-0.238,0c-0.042,-0.134 -7.082,-22.467 -7.082,-22.467l-3.857,0c0,0 -7.407,22.334 -7.453,22.467l-0.237,0c-0.042,-0.137 -7.032,-22.467 -7.032,-22.467l-0.072,0Z", 2, "fill", "#fff", "fill-rule", "nonzero"], ["d", "M160.498,44.986c0,0 12.347,-2.186 16.389,-12.002c0,0 71.891,14.725 29.452,53.074c0,0 15.749,-14.828 6.953,-26.691c0,0 4.909,14.726 -14.316,24.645c0,0 41.695,-29.617 -38.478,-39.026Z", 2, "fill", "#fff", "fill-rule", "nonzero"], ["d", "M199.888,39.615c5.028,2.487 8.548,4.931 10.604,6.536c0.905,-25.738 -17.55,-40.127 -17.55,-40.127c-0.536,1.65 -2.147,3.49 -4.448,4.333c-2.301,0.844 -3.682,3.605 -3.682,3.605c9.019,7.501 13.351,16.659 15.076,25.653Z", 2, "fill", "#fff", "fill-rule", "nonzero"], ["d", "M174.979,34.807c1.089,-1.627 1.394,-2.744 1.394,-2.744c4.752,0.844 9.016,1.957 12.814,3.202c-7.877,-22.459 -22.526,-34.751 -22.526,-34.751c-0.409,1.177 -4.704,3.324 -7.619,4.603c-2.914,1.278 -2.147,6.698 -2.147,6.698c8.01,6.619 13.838,14.721 18.084,22.992Z", 2, "fill", "#fff", "fill-rule", "nonzero"], ["d", "M205.115,59.685c-0.991,11.081 -7.571,22.845 -7.571,22.845c4.646,-7.067 7.822,-13.702 9.875,-19.884c-0.576,-1.045 -1.354,-2.031 -2.304,-2.961Z", 2, "fill", "#fff", "fill-rule", "nonzero"], ["d", "M204.253,58.898c-1.084,-0.931 -2.337,-1.804 -3.726,-2.621c-1.154,11.922 -5.13,20.884 -5.13,20.884c2.3,-2.608 4.064,-6.826 4.064,-6.826c0.077,2.991 -2.378,8.897 -2.378,8.897c4.222,-6.783 6.242,-15.026 7.17,-20.334Z", 2, "fill", "#fff", "fill-rule", "nonzero"], ["d", "M179.302,82.112c-2.556,-1.377 -6.263,-2.842 -13.881,-8.742c5.766,4.341 15.394,7.115 15.394,7.115c-21.256,-10.789 -25.89,-20.57 -25.89,-20.57c-2.046,-0.066 -3.279,1.232 -4.089,1.677c-0.811,0.444 -3.021,0.406 -3.021,0.406c8.101,13.061 31.487,20.114 31.487,20.114Z", 2, "fill", "#fff", "fill-rule", "nonzero"], ["d", "M169.793,46.953c-7.062,-1.17 -12.249,-1.622 -12.249,-1.622c2.823,-0.709 5.225,-1.571 7.279,-2.509c-9.939,-7.239 -19.842,-9.021 -19.842,-9.021c0,0 -1.841,0.613 -2.097,3.682c-0.254,3.067 -2.607,3.477 -2.607,3.477c37.121,9.919 42.694,40.495 42.694,40.495c-2.531,-13.805 -7.9,-22.625 -7.9,-22.625c5.676,5.829 9.587,20.632 9.587,20.632c-1.259,-15.301 -7.604,-25.618 -14.865,-32.509Z", 2, "fill", "#fff", "fill-rule", "nonzero"], ["d", "M180.901,49.165c5.345,16.489 5.446,30.449 5.446,30.449c3.955,-7.668 2.914,-25.309 2.914,-25.309c3.681,7.209 3.221,26.844 3.221,26.844c1.888,-10.318 1.961,-19.753 0.878,-28.245c-3.92,-1.502 -8.228,-2.736 -12.459,-3.739Z", 2, "fill", "#fff", "fill-rule", "nonzero"]], template: function LogoComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(0, "svg", 0);
        ɵngcc0.ɵɵelementStart(1, "g");
        ɵngcc0.ɵɵelement(2, "path", 1);
        ɵngcc0.ɵɵelement(3, "path", 2);
        ɵngcc0.ɵɵelement(4, "path", 3);
        ɵngcc0.ɵɵelement(5, "rect", 4);
        ɵngcc0.ɵɵelement(6, "path", 5);
        ɵngcc0.ɵɵelement(7, "path", 6);
        ɵngcc0.ɵɵelement(8, "path", 7);
        ɵngcc0.ɵɵelement(9, "path", 8);
        ɵngcc0.ɵɵelement(10, "path", 9);
        ɵngcc0.ɵɵelement(11, "path", 10);
        ɵngcc0.ɵɵelement(12, "path", 11);
        ɵngcc0.ɵɵelement(13, "path", 12);
        ɵngcc0.ɵɵelement(14, "path", 13);
        ɵngcc0.ɵɵelement(15, "path", 14);
        ɵngcc0.ɵɵelement(16, "path", 15);
        ɵngcc0.ɵɵelement(17, "path", 16);
        ɵngcc0.ɵɵelement(18, "path", 17);
        ɵngcc0.ɵɵelement(19, "path", 18);
        ɵngcc0.ɵɵelement(20, "path", 19);
        ɵngcc0.ɵɵelement(21, "path", 20);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [""] });
LogoComponent.ctorParameters = () => [];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LogoComponent, [{
        type: Component,
        args: [{
                selector: 'ws-logo',
                template: "<svg width=\"110px\" height=\"65px\" viewBox=\"0 0 220 129\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xml:space=\"preserve\" xmlns:serif=\"http://www.serif.com/\" style=\"fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:1.41421;\" aria-label=\"WorldSkills\">\n  <g>\n      <path d=\"M52.271,126.434c-5.36,0 -8.958,-4.395 -8.958,-10.942c0,-6.547 3.598,-10.944 8.958,-10.944c5.358,0 8.959,4.397 8.959,10.944c0,6.547 -3.601,10.942 -8.959,10.942Zm0,-24.453c-9.152,0 -12.397,7.276 -12.397,13.511c0,6.232 3.245,13.509 12.397,13.509c9.151,0 12.398,-7.277 12.398,-13.509c0,-6.235 -3.247,-13.511 -12.398,-13.511Z\" style=\"fill:#fff;fill-rule:nonzero;\"/>\n      <path d=\"M70.618,106.725l0,-4.232l-2.916,0l0.003,25.798l3.122,0l0,-12.745l-0.006,-0.165c0.006,-4.753 1.352,-10.434 7.767,-10.434l0.975,0.046l0.012,-0.101l0.156,-3.009l-0.363,-0.002c-4.333,0 -7.269,1.636 -8.75,4.844Z\" style=\"fill:#fff;fill-rule:nonzero;\"/>\n      <path d=\"M134.06,107.522c-2.152,-0.71 -3.726,-1.121 -6.297,-1.121c-1.89,0 -4.145,0.664 -4.145,2.905c0,4.18 12.225,1.53 12.225,11.001c0,6.117 -5.614,8.564 -11.333,8.564c-2.68,0 -5.407,-0.457 -7.977,-1.12l0.419,-5.607c2.203,1.069 4.512,1.733 6.924,1.733c1.788,0 4.62,-0.664 4.62,-3.209c0,-5.146 -12.226,-1.631 -12.226,-11.107c0,-5.653 5.09,-8.153 10.599,-8.153c3.306,0 5.46,0.512 7.662,0.97l-0.471,5.144Z\" style=\"fill:#fff;fill-rule:nonzero;\"/>\n      <rect x=\"166.803\" y=\"102.052\" width=\"7.034\" height=\"26.24\" style=\"fill:#fff;fill-rule:nonzero;\"/>\n      <path d=\"M217.817,107.522c-2.151,-0.71 -3.725,-1.121 -6.296,-1.121c-1.892,0 -4.146,0.664 -4.146,2.905c0,4.18 12.225,1.53 12.225,11.001c0,6.117 -5.613,8.564 -11.333,8.564c-2.678,0 -5.405,-0.457 -7.977,-1.12l0.42,-5.607c2.203,1.069 4.513,1.733 6.926,1.733c1.785,0 4.619,-0.664 4.619,-3.209c0,-5.146 -12.227,-1.631 -12.227,-11.107c0,-5.653 5.09,-8.153 10.602,-8.153c3.305,0 5.454,0.512 7.659,0.97l-0.472,5.144Z\" style=\"fill:#fff;fill-rule:nonzero;\"/>\n      <path d=\"M153.067,113.813l9.962,-11.761l-8.292,0l-8.394,10.497l-0.106,0l0,-24.615l-7.032,2.148l0,38.21l7.032,0l0,-12.738l0.106,0l9.027,12.738l8.919,0l-11.222,-14.479Z\" style=\"fill:#fff;fill-rule:nonzero;\"/>\n      <path d=\"M101.041,126.336c-7.234,0 -8.017,-7.653 -8.017,-10.943c0,-3.292 0.783,-10.944 8.017,-10.944c5.537,0 8.017,5.495 8.017,10.944c0,5.448 -2.48,10.943 -8.017,10.943Zm11.012,-36.962l-2.995,0.917l0,15.95c-0.652,-1.091 -3.088,-4.428 -8.543,-4.36c-9.031,0.114 -10.927,7.409 -10.927,13.512c0,8.332 4.187,13.511 10.929,13.511c4.014,0 6.73,-1.479 8.541,-4.613l0,4.001l3.121,0l0,-38.957l-0.126,0.039Z\" style=\"fill:#fff;fill-rule:nonzero;\"/>\n      <path d=\"M85.984,89.376l-2.997,0.913l0,38.003l3.123,0l0,-38.957l-0.126,0.041Z\" style=\"fill:#fff;fill-rule:nonzero;\"/>\n      <path d=\"M178.373,90.082l0,38.21l7.031,0l0,-40.359l-7.031,2.149Z\" style=\"fill:#fff;fill-rule:nonzero;\"/>\n      <path d=\"M189.455,90.082l-0.004,0l0,38.21l7.034,0l0,-40.359l-7.03,2.149Z\" style=\"fill:#fff;fill-rule:nonzero;\"/>\n      <path d=\"M174.384,92.257c0,-2.165 -1.756,-3.917 -3.917,-3.917c-2.161,0 -3.915,1.752 -3.915,3.917c0,2.163 1.754,3.917 3.915,3.917c2.161,0 3.917,-1.754 3.917,-3.917Z\" style=\"fill:#fff;fill-rule:nonzero;\"/>\n      <path d=\"M3.352,102.493l-3.352,0l0.042,0.129c0.16,0.486 8.402,25.375 8.48,25.601l0.022,0.069l3.856,0c0,0 7.249,-22.333 7.292,-22.469l0.239,0c0.045,0.136 7.294,22.469 7.294,22.469l3.858,0l8.753,-25.799l-3.113,0c0,0 -7.354,22.334 -7.4,22.467l-0.238,0c-0.042,-0.134 -7.082,-22.467 -7.082,-22.467l-3.857,0c0,0 -7.407,22.334 -7.453,22.467l-0.237,0c-0.042,-0.137 -7.032,-22.467 -7.032,-22.467l-0.072,0Z\" style=\"fill:#fff;fill-rule:nonzero;\"/>\n      <path d=\"M160.498,44.986c0,0 12.347,-2.186 16.389,-12.002c0,0 71.891,14.725 29.452,53.074c0,0 15.749,-14.828 6.953,-26.691c0,0 4.909,14.726 -14.316,24.645c0,0 41.695,-29.617 -38.478,-39.026Z\" style=\"fill:#fff;fill-rule:nonzero;\"/>\n      <path d=\"M199.888,39.615c5.028,2.487 8.548,4.931 10.604,6.536c0.905,-25.738 -17.55,-40.127 -17.55,-40.127c-0.536,1.65 -2.147,3.49 -4.448,4.333c-2.301,0.844 -3.682,3.605 -3.682,3.605c9.019,7.501 13.351,16.659 15.076,25.653Z\" style=\"fill:#fff;fill-rule:nonzero;\"/>\n      <path d=\"M174.979,34.807c1.089,-1.627 1.394,-2.744 1.394,-2.744c4.752,0.844 9.016,1.957 12.814,3.202c-7.877,-22.459 -22.526,-34.751 -22.526,-34.751c-0.409,1.177 -4.704,3.324 -7.619,4.603c-2.914,1.278 -2.147,6.698 -2.147,6.698c8.01,6.619 13.838,14.721 18.084,22.992Z\" style=\"fill:#fff;fill-rule:nonzero;\"/>\n      <path d=\"M205.115,59.685c-0.991,11.081 -7.571,22.845 -7.571,22.845c4.646,-7.067 7.822,-13.702 9.875,-19.884c-0.576,-1.045 -1.354,-2.031 -2.304,-2.961Z\" style=\"fill:#fff;fill-rule:nonzero;\"/>\n      <path d=\"M204.253,58.898c-1.084,-0.931 -2.337,-1.804 -3.726,-2.621c-1.154,11.922 -5.13,20.884 -5.13,20.884c2.3,-2.608 4.064,-6.826 4.064,-6.826c0.077,2.991 -2.378,8.897 -2.378,8.897c4.222,-6.783 6.242,-15.026 7.17,-20.334Z\" style=\"fill:#fff;fill-rule:nonzero;\"/>\n      <path d=\"M179.302,82.112c-2.556,-1.377 -6.263,-2.842 -13.881,-8.742c5.766,4.341 15.394,7.115 15.394,7.115c-21.256,-10.789 -25.89,-20.57 -25.89,-20.57c-2.046,-0.066 -3.279,1.232 -4.089,1.677c-0.811,0.444 -3.021,0.406 -3.021,0.406c8.101,13.061 31.487,20.114 31.487,20.114Z\" style=\"fill:#fff;fill-rule:nonzero;\"/>\n      <path d=\"M169.793,46.953c-7.062,-1.17 -12.249,-1.622 -12.249,-1.622c2.823,-0.709 5.225,-1.571 7.279,-2.509c-9.939,-7.239 -19.842,-9.021 -19.842,-9.021c0,0 -1.841,0.613 -2.097,3.682c-0.254,3.067 -2.607,3.477 -2.607,3.477c37.121,9.919 42.694,40.495 42.694,40.495c-2.531,-13.805 -7.9,-22.625 -7.9,-22.625c5.676,5.829 9.587,20.632 9.587,20.632c-1.259,-15.301 -7.604,-25.618 -14.865,-32.509Z\" style=\"fill:#fff;fill-rule:nonzero;\"/>\n      <path d=\"M180.901,49.165c5.345,16.489 5.446,30.449 5.446,30.449c3.955,-7.668 2.914,-25.309 2.914,-25.309c3.681,7.209 3.221,26.844 3.221,26.844c1.888,-10.318 1.961,-19.753 0.878,-28.245c-3.92,-1.502 -8.228,-2.736 -12.459,-3.739Z\" style=\"fill:#fff;fill-rule:nonzero;\"/>\n  </g>\n</svg>\n",
                styles: [""]
            }]
    }], function () { return []; }, null); })();

class WordmarkComponent {
    constructor() { }
    ngOnInit() {
    }
}
WordmarkComponent.ɵfac = function WordmarkComponent_Factory(t) { return new (t || WordmarkComponent)(); };
WordmarkComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: WordmarkComponent, selectors: [["ws-wordmark"]], decls: 14, vars: 0, consts: [["width", "115px", "height", "22px", "viewBox", "0 0 220 42", "version", "1.1", "xmlns", "http://www.w3.org/2000/svg", 0, "xmlns", "xlink", "http://www.w3.org/1999/xlink", 0, "xml", "space", "preserve", 0, "xmlns", "serif", "http://www.serif.com/", "aria-label", "WorldSkills", 1, "d-inline-block", "align-baseline", 2, "fill-rule", "evenodd", "clip-rule", "evenodd", "stroke-linejoin", "round", "stroke-miterlimit", "1.41421"], ["d", "M52.271,39.434c-5.36,0 -8.958,-4.397 -8.958,-10.943c0,-6.546 3.598,-10.945 8.958,-10.945c5.358,0 8.959,4.399 8.959,10.945c0,6.546 -3.601,10.943 -8.959,10.943Zm0,-24.453c-9.152,0 -12.397,7.275 -12.397,13.51c0,6.233 3.245,13.509 12.397,13.509c9.151,0 12.398,-7.276 12.398,-13.509c0,-6.235 -3.247,-13.51 -12.398,-13.51Z", 2, "fill", "#fff", "fill-rule", "nonzero"], ["d", "M70.618,19.724l0,-4.232l-2.916,0l0.003,25.798l3.122,0l0,-12.745l-0.006,-0.165c0.006,-4.753 1.352,-10.434 7.767,-10.434l0.975,0.046l0.012,-0.101l0.156,-3.009l-0.363,-0.002c-4.333,0 -7.269,1.636 -8.75,4.844Z", 2, "fill", "#fff", "fill-rule", "nonzero"], ["d", "M134.06,20.521c-2.152,-0.71 -3.726,-1.121 -6.297,-1.121c-1.89,0 -4.145,0.664 -4.145,2.906c0,4.179 12.225,1.529 12.225,11.001c0,6.116 -5.614,8.562 -11.333,8.562c-2.68,0 -5.407,-0.457 -7.977,-1.119l0.419,-5.607c2.203,1.069 4.512,1.733 6.924,1.733c1.788,0 4.62,-0.664 4.62,-3.209c0,-5.146 -12.226,-1.632 -12.226,-11.107c0,-5.653 5.09,-8.153 10.599,-8.153c3.306,0 5.46,0.512 7.662,0.97l-0.471,5.144Z", 2, "fill", "#fff", "fill-rule", "nonzero"], ["x", "166.803", "y", "15.051", "width", "7.034", "height", "26.239", 2, "fill", "#fff", "fill-rule", "nonzero"], ["d", "M217.817,20.521c-2.151,-0.71 -3.725,-1.121 -6.296,-1.121c-1.892,0 -4.146,0.664 -4.146,2.906c0,4.179 12.225,1.529 12.225,11.001c0,6.116 -5.613,8.562 -11.333,8.562c-2.678,0 -5.405,-0.457 -7.977,-1.119l0.42,-5.607c2.203,1.069 4.513,1.733 6.926,1.733c1.785,0 4.619,-0.664 4.619,-3.209c0,-5.146 -12.227,-1.632 -12.227,-11.107c0,-5.653 5.09,-8.153 10.602,-8.153c3.305,0 5.454,0.512 7.659,0.97l-0.472,5.144Z", 2, "fill", "#fff", "fill-rule", "nonzero"], ["d", "M153.067,26.813l9.962,-11.762l-8.292,0l-8.394,10.497l-0.106,0l0,-24.614l-7.032,2.147l0,38.209l7.032,0l0,-12.737l0.106,0l9.027,12.737l8.919,0l-11.222,-14.477Z", 2, "fill", "#fff", "fill-rule", "nonzero"], ["d", "M101.041,39.334c-7.234,0 -8.017,-7.652 -8.017,-10.942c0,-3.292 0.783,-10.943 8.017,-10.943c5.537,0 8.017,5.495 8.017,10.943c0,5.447 -2.48,10.942 -8.017,10.942Zm11.012,-36.961l-2.995,0.917l0,15.951c-0.652,-1.091 -3.088,-4.428 -8.543,-4.362c-9.031,0.115 -10.927,7.409 -10.927,13.513c0,8.332 4.187,13.512 10.929,13.512c4.014,0 6.73,-1.48 8.541,-4.615l0,4.001l3.121,0l0,-38.956l-0.126,0.039Z", 2, "fill", "#fff", "fill-rule", "nonzero"], ["d", "M85.984,2.376l-2.997,0.912l0,38.003l3.123,0l0,-38.956l-0.126,0.041Z", 2, "fill", "#fff", "fill-rule", "nonzero"], ["d", "M178.373,3.081l0,38.209l7.031,0l0,-40.357l-7.031,2.148Z", 2, "fill", "#fff", "fill-rule", "nonzero"], ["d", "M189.455,3.081l-0.004,0l0,38.209l7.034,0l0,-40.357l-7.03,2.148Z", 2, "fill", "#fff", "fill-rule", "nonzero"], ["d", "M174.384,5.257c0,-2.165 -1.756,-3.917 -3.917,-3.917c-2.161,0 -3.915,1.752 -3.915,3.917c0,2.163 1.754,3.917 3.915,3.917c2.161,0 3.917,-1.754 3.917,-3.917Z", 2, "fill", "#fff", "fill-rule", "nonzero"], ["d", "M3.352,15.492l-3.352,0l0.042,0.128c0.16,0.487 8.402,25.375 8.48,25.603l0.022,0.067l3.856,0c0,0 7.249,-22.333 7.292,-22.468l0.239,0c0.045,0.135 7.294,22.468 7.294,22.468l3.858,0l8.753,-25.798l-3.113,0c0,0 -7.354,22.333 -7.4,22.466l-0.238,0c-0.042,-0.133 -7.082,-22.466 -7.082,-22.466l-3.857,0c0,0 -7.407,22.333 -7.453,22.466l-0.237,0c-0.042,-0.136 -7.032,-22.466 -7.032,-22.466l-0.072,0Z", 2, "fill", "#fff", "fill-rule", "nonzero"]], template: function WordmarkComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(0, "svg", 0);
        ɵngcc0.ɵɵelementStart(1, "g");
        ɵngcc0.ɵɵelement(2, "path", 1);
        ɵngcc0.ɵɵelement(3, "path", 2);
        ɵngcc0.ɵɵelement(4, "path", 3);
        ɵngcc0.ɵɵelement(5, "rect", 4);
        ɵngcc0.ɵɵelement(6, "path", 5);
        ɵngcc0.ɵɵelement(7, "path", 6);
        ɵngcc0.ɵɵelement(8, "path", 7);
        ɵngcc0.ɵɵelement(9, "path", 8);
        ɵngcc0.ɵɵelement(10, "path", 9);
        ɵngcc0.ɵɵelement(11, "path", 10);
        ɵngcc0.ɵɵelement(12, "path", 11);
        ɵngcc0.ɵɵelement(13, "path", 12);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [""] });
WordmarkComponent.ctorParameters = () => [];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(WordmarkComponent, [{
        type: Component,
        args: [{
                selector: 'ws-wordmark',
                template: "<svg width=\"115px\" height=\"22px\" viewBox=\"0 0 220 42\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xml:space=\"preserve\" xmlns:serif=\"http://www.serif.com/\" style=\"fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:1.41421;\" class=\"d-inline-block align-baseline\" aria-label=\"WorldSkills\">\n  <g>\n      <path d=\"M52.271,39.434c-5.36,0 -8.958,-4.397 -8.958,-10.943c0,-6.546 3.598,-10.945 8.958,-10.945c5.358,0 8.959,4.399 8.959,10.945c0,6.546 -3.601,10.943 -8.959,10.943Zm0,-24.453c-9.152,0 -12.397,7.275 -12.397,13.51c0,6.233 3.245,13.509 12.397,13.509c9.151,0 12.398,-7.276 12.398,-13.509c0,-6.235 -3.247,-13.51 -12.398,-13.51Z\" style=\"fill:#fff;fill-rule:nonzero;\"></path>\n      <path d=\"M70.618,19.724l0,-4.232l-2.916,0l0.003,25.798l3.122,0l0,-12.745l-0.006,-0.165c0.006,-4.753 1.352,-10.434 7.767,-10.434l0.975,0.046l0.012,-0.101l0.156,-3.009l-0.363,-0.002c-4.333,0 -7.269,1.636 -8.75,4.844Z\" style=\"fill:#fff;fill-rule:nonzero;\"></path>\n      <path d=\"M134.06,20.521c-2.152,-0.71 -3.726,-1.121 -6.297,-1.121c-1.89,0 -4.145,0.664 -4.145,2.906c0,4.179 12.225,1.529 12.225,11.001c0,6.116 -5.614,8.562 -11.333,8.562c-2.68,0 -5.407,-0.457 -7.977,-1.119l0.419,-5.607c2.203,1.069 4.512,1.733 6.924,1.733c1.788,0 4.62,-0.664 4.62,-3.209c0,-5.146 -12.226,-1.632 -12.226,-11.107c0,-5.653 5.09,-8.153 10.599,-8.153c3.306,0 5.46,0.512 7.662,0.97l-0.471,5.144Z\" style=\"fill:#fff;fill-rule:nonzero;\"></path>\n      <rect x=\"166.803\" y=\"15.051\" width=\"7.034\" height=\"26.239\" style=\"fill:#fff;fill-rule:nonzero;\"></rect>\n      <path d=\"M217.817,20.521c-2.151,-0.71 -3.725,-1.121 -6.296,-1.121c-1.892,0 -4.146,0.664 -4.146,2.906c0,4.179 12.225,1.529 12.225,11.001c0,6.116 -5.613,8.562 -11.333,8.562c-2.678,0 -5.405,-0.457 -7.977,-1.119l0.42,-5.607c2.203,1.069 4.513,1.733 6.926,1.733c1.785,0 4.619,-0.664 4.619,-3.209c0,-5.146 -12.227,-1.632 -12.227,-11.107c0,-5.653 5.09,-8.153 10.602,-8.153c3.305,0 5.454,0.512 7.659,0.97l-0.472,5.144Z\" style=\"fill:#fff;fill-rule:nonzero;\"></path>\n      <path d=\"M153.067,26.813l9.962,-11.762l-8.292,0l-8.394,10.497l-0.106,0l0,-24.614l-7.032,2.147l0,38.209l7.032,0l0,-12.737l0.106,0l9.027,12.737l8.919,0l-11.222,-14.477Z\" style=\"fill:#fff;fill-rule:nonzero;\"></path>\n      <path d=\"M101.041,39.334c-7.234,0 -8.017,-7.652 -8.017,-10.942c0,-3.292 0.783,-10.943 8.017,-10.943c5.537,0 8.017,5.495 8.017,10.943c0,5.447 -2.48,10.942 -8.017,10.942Zm11.012,-36.961l-2.995,0.917l0,15.951c-0.652,-1.091 -3.088,-4.428 -8.543,-4.362c-9.031,0.115 -10.927,7.409 -10.927,13.513c0,8.332 4.187,13.512 10.929,13.512c4.014,0 6.73,-1.48 8.541,-4.615l0,4.001l3.121,0l0,-38.956l-0.126,0.039Z\" style=\"fill:#fff;fill-rule:nonzero;\"></path>\n      <path d=\"M85.984,2.376l-2.997,0.912l0,38.003l3.123,0l0,-38.956l-0.126,0.041Z\" style=\"fill:#fff;fill-rule:nonzero;\"></path>\n      <path d=\"M178.373,3.081l0,38.209l7.031,0l0,-40.357l-7.031,2.148Z\" style=\"fill:#fff;fill-rule:nonzero;\"></path>\n      <path d=\"M189.455,3.081l-0.004,0l0,38.209l7.034,0l0,-40.357l-7.03,2.148Z\" style=\"fill:#fff;fill-rule:nonzero;\"></path>\n      <path d=\"M174.384,5.257c0,-2.165 -1.756,-3.917 -3.917,-3.917c-2.161,0 -3.915,1.752 -3.915,3.917c0,2.163 1.754,3.917 3.915,3.917c2.161,0 3.917,-1.754 3.917,-3.917Z\" style=\"fill:#fff;fill-rule:nonzero;\"></path>\n      <path d=\"M3.352,15.492l-3.352,0l0.042,0.128c0.16,0.487 8.402,25.375 8.48,25.603l0.022,0.067l3.856,0c0,0 7.249,-22.333 7.292,-22.468l0.239,0c0.045,0.135 7.294,22.468 7.294,22.468l3.858,0l8.753,-25.798l-3.113,0c0,0 -7.354,22.333 -7.4,22.466l-0.238,0c-0.042,-0.133 -7.082,-22.466 -7.082,-22.466l-3.857,0c0,0 -7.407,22.333 -7.453,22.466l-0.237,0c-0.042,-0.136 -7.032,-22.466 -7.032,-22.466l-0.072,0Z\" style=\"fill:#fff;fill-rule:nonzero;\"></path>\n  </g>\n</svg>\n",
                styles: [""]
            }]
    }], function () { return []; }, null); })();

class MenuAccessPipe {
    transform(items, isLoggedIn, roles) {
        if (items === null || items === undefined) {
            return [];
        }
        return items.filter(item => {
            // item doesn't exist, don't display it
            if (item === undefined || item === null) {
                return false;
            }
            // item is meant to be hidden
            if (item.hidden) {
                return false;
            }
            // item requires a logged in user
            if (item.requireLogin && !isLoggedIn) {
                return false;
            }
            // item doesn not require role permissions
            if (item.requiredRoles.length === 0) {
                return true;
            }
            // item requires role permissions
            let show = false;
            for (const roleName of item.requiredRoles) {
                show = roles.findIndex(userRoleName => userRoleName === roleName) !== -1;
                if (show) {
                    break;
                }
            }
            return show;
        });
    }
}
MenuAccessPipe.ɵfac = function MenuAccessPipe_Factory(t) { return new (t || MenuAccessPipe)(); };
MenuAccessPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "wsMenuAccessFilter", type: MenuAccessPipe, pure: true });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MenuAccessPipe, [{
        type: Pipe,
        args: [{
                name: 'wsMenuAccessFilter'
            }]
    }], null, null); })();

const MISSING_LANGUAGE_MESSAGE = (email) => `Please email us at WorldSkills (${email}) if you are able to help us translate our interface into your language.`;

class LangUtil {
    static getDefaultLanguages() {
        return [
            { code: 'ar_AE', name: 'Arabic' },
            { code: 'pt_BR', name: 'Brazilian' },
            { code: 'zh_CN', name: 'Chinese' },
            { code: 'en', name: 'English' },
            { code: 'de', name: 'German' },
            { code: 'fr', name: 'French' },
            { code: 'fi', name: 'Finnish' },
            { code: 'de', name: 'German' },
            { code: 'ru_RU', name: 'Russian' },
            { code: 'tt_RU', name: 'Tatar' },
        ];
    }
    static getDefaultLanguage() {
        return { code: 'en', name: 'English' };
    }
}

// tslint:disable-next-line:variable-name
const ar_AE = {};

const en = {
    auth: {
        login: 'Login',
        logout: 'Logout'
    },
    dialogue: {
        close: 'Close'
    },
    footer: {
        copyright: {
            contact: 'Contact',
            privacy: 'Privacy',
            terms: 'Terms',
            wsi: 'WorldSkills Internationa'
        },
        links: {
            forums: 'Forums',
            glossary: 'Glossary',
            'infrastructure.lists': 'Infrastructure Lists',
            'my.worldskills': 'myWorldSkills',
            registrations: 'Registrations',
            'skill.management': 'Skill Management',
            wiw: 'Who-is-Who'
        },
        translation: {
            language: 'Language',
            missing: 'Missing Translation ?'
        }
    },
    polls: {
        buttons: {
            abstain: 'Abstain',
            delete: 'Delete',
            edit: 'Edit',
            'export.results': 'Export Results',
            extend: 'Extend',
            'clear.vote': 'Clear Vote',
            reset: 'Reset',
            'view.choices': 'View Choices',
            'view.results': 'View Results',
            vote: 'vote'
        },
        'created.by': 'Created By',
        messages: {
            abstained: 'You have chosen to abstain from voting.',
            anon: 'his vote is anonymous.',
            choices: 'Your Choice(s):',
            voted: 'You have already voted!'
        },
        points: 'points',
        status: 'Status',
        selection: 'selection',
        to: 'to',
        votes: 'votes'
    },
    dates: {
        just_now: 'Just now',
        minute_ago: 'a minute ago',
        minutes_ago: 'minutes ago',
        hour_ago: 'an hour ago',
        hours_ago: 'hours ago',
        yesterday: 'Yesterday',
        days_ago: 'days ago',
        week_ago: 'a week ago',
        weeks_ago: 'weeks ago',
        soon: 'Soon',
        in_a_minute: 'in a minute',
        in_n_minutes: 'in {{ number }} minutes',
        in_an_hour: 'in an hour',
        in_n_hours: 'in {{ number }} hours',
        tomorrow: 'Tomorrow',
        in_n_days: 'in {{ number }} days',
        in_a_week: 'in a week',
        in_n_weeks: 'in {{ number }} weeks'
    },
    modals: {
        cancel: 'Cancel',
        no: 'no',
        ok: 'Ok',
        yes: 'Yes'
    }
};

const fr = {};

// tslint:disable-next-line:variable-name
const pt_BR = {};

// tslint:disable-next-line:variable-name
const ru_RU = {};

// tslint:disable-next-line:variable-name
const tt_RU = {};

// tslint:disable-next-line:variable-name
const zh_CN = {};

const fi = {
    auth: {
        login: 'Kirjaudu sisään',
        logout: 'Kirjaudu ulos'
    },
    dialogue: {
        close: 'Sulje'
    },
    footer: {
        copyright: {
            contact: 'Yhteystiedot',
            terms: 'Käyttöehdot',
            wsi: 'WorldSkills International',
            privacy: 'Tietosuojakäytäntö'
        },
        links: {
            forums: 'Foorumi',
            glossary: 'Sanasto',
            'infrastructure.lists': 'Infralistat',
            'my.worldskills': 'Oma profiili',
            registrations: 'Rekisteröinti',
            'skill.management': 'WorldSkills-tehtäväpankki',
            wiw: 'Henkilöhakemisto'
        },
        translation: {
            language: 'Kieli',
            missing: 'Puuttuuko käännös?'
        }
    },
    polls: {
        buttons: {
            abstain: 'Pidättäydyn äänestämästä',
            delete: 'Poista',
            edit: 'Muokkaa',
            'export.results': 'Vie tulokset',
            extend: 'Laajenna',
            'clear.vote': 'Nollaa ääni',
            reset: 'Nollaa',
            'view.choices': 'Katso vaihtoehdot',
            'view.results': 'Katso tulokset',
            vote: 'Äänestä'
        },
        'created.by': 'Luonut',
        messages: {
            anon: 'Anonyymi ääni.',
            choices: 'Valintasi:',
            voted: 'Olet jo äänestänyt!',
            abstained: 'Olet pidättäytynyt äänestämästä.'
        },
        points: 'pisteet',
        selection: 'valinta',
        status: 'Tila',
        to: '>',
        votes: 'äänet'
    },
    dates: {
        minutes_ago: 'minuuttia sitten',
        minute_ago: 'Hetki sitten',
        hour_ago: 'Tunti sitten',
        hours_ago: 'tuntia sitten',
        yesterday: 'Eilen',
        week_ago: 'Viikko sitten',
        weeks_ago: 'viikkoa sitten',
        soon: 'Pian',
        in_a_minute: 'Hetken päästä',
        in_n_minutes: '{{ number }} minuutin päästä',
        in_an_hour: 'Tunnin päästä',
        tomorrow: 'Huomenna',
        in_n_days: '{{ number }} päivän päästä',
        in_a_week: 'viikon päästä',
        in_n_weeks: '{{ number }} viikon päästä',
        just_now: 'Nyt',
        days_ago: 'päivää sitten',
        in_n_hours: '{{ number }} tunnin päästä'
    }
};

const de = {
    auth: {
        login: 'Login',
        logout: 'Logout'
    },
    dialogue: {
        close: 'Schliessen'
    },
    footer: {
        copyright: {
            contact: 'Kontakt',
            privacy: 'Datenschutz',
            terms: 'Bestimmungen',
            wsi: 'WorldSkills International'
        },
        links: {
            forums: 'Foren',
            glossary: 'Glossar',
            'infrastructure.lists': 'Infrastruktur-Listen',
            'my.worldskills': 'myWorldSkills',
            registrations: 'Registrierungen'
        },
        translation: {
            language: 'Sprache',
            missing: 'Fehlende Übersetzung?'
        }
    },
    polls: {
        buttons: {
            abstain: 'Enthaltung',
            edit: 'Bearbeiten',
            delete: 'Löschen',
            reset: 'Zurücksetzen'
        }
    }
};

class WsiTranslateService {
    constructor(translator) {
        this.translator = translator;
        this.availableLanguages = { ar_AE, en, de, fr, fi, pt_BR, ru_RU, tt_RU, zh_CN };
        this.onLangChanged = new Subject();
        const code = this.getCurrentOrDefaultCode();
        this.translator.setDefaultLang(LangUtil.getDefaultLanguage().code);
        this.translator.use(code).subscribe(() => {
            this.init(code);
        });
        // update language on changes
        this.translator.onLangChange.subscribe(newCode => {
            sessionStorage.setItem('lang', newCode.lang);
        });
    }
    /*
      Initialize a specific lang code
    */
    init(code) {
        const current = this.getCurrentOrDefaultCode();
        sessionStorage.setItem('lang', code);
        let lang = this.availableLanguages[code];
        if (code !== 'en') {
            lang = this.mergeMissingKeys(lang, en);
        }
        this.translator.setTranslation(code, lang, true);
        if (current !== code) {
            this.onLangChanged.next(this.getSelectedLanguage());
        }
    }
    mergeMissingKeys(obj, context) {
        Object.keys(context).forEach(key => {
            const actual = Object.keys(obj).find(x => x === key);
            if (!actual) {
                // replace missing keys or objects
                obj[key] = context[key];
            }
            else {
                // loop through nested objects that were not replace
                if (typeof actual === 'object') {
                    obj[key] = this.mergeMissingKeys(obj[key], context[key]);
                }
            }
        });
        return obj;
    }
    /*
      Set user preffered language from a user object
    */
    setUserLanguage(user) {
        if (user && user.preferred_lang) {
            this.init(user.preferred_lang);
        }
    }
    /*
      Get the sselected language code
    */
    getCurrentOrDefaultCode() {
        let code = sessionStorage.getItem('lang');
        if (GenericUtil.isNullOrUndefined(code)) {
            code = LangUtil.getDefaultLanguage().code;
        }
        return code;
    }
    /*
      Get the current selected language
    */
    getSelectedLanguage() {
        const code = this.getCurrentOrDefaultCode();
        return LangUtil.getDefaultLanguages().find(x => x.code === code);
    }
}
WsiTranslateService.ɵfac = function WsiTranslateService_Factory(t) { return new (t || WsiTranslateService)(ɵngcc0.ɵɵinject(ɵngcc2.TranslateService)); };
WsiTranslateService.ɵprov = ɵɵdefineInjectable({ factory: function WsiTranslateService_Factory() { return new WsiTranslateService(ɵɵinject(TranslateService)); }, token: WsiTranslateService, providedIn: "root" });
WsiTranslateService.ctorParameters = () => [
    { type: TranslateService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(WsiTranslateService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc2.TranslateService }]; }, null); })();

class FooterComponent {
    constructor(wsi, translator) {
        this.wsi = wsi;
        this.translator = translator;
        this.logoutClick = new EventEmitter();
        this.loginClick = new EventEmitter();
        this.wsi.appConfigSubject.subscribe(appConfig => {
            this.supportEmail = appConfig.supportEmailAddress;
        });
    }
    // tslint:disable-next-line:typedef
    ngOnInit() {
        this.date = new Date();
        this.languages = LangUtil.getDefaultLanguages();
        this.selectedLanguage = this.translator.getSelectedLanguage();
    }
    login() {
        this.loginClick.emit();
    }
    logout() {
        this.logoutClick.emit();
    }
    changeLanguage(model) {
        this.selectedLanguage = model;
        this.translator.init(model.code);
    }
    isLanguageSelected(model) {
        if (GenericUtil.isNullOrUndefined(this.selectedLanguage)) {
            return model.code === LangUtil.getDefaultLanguage().code;
        }
        return model.code === this.selectedLanguage.code;
    }
    languagePrompt() {
        alert(MISSING_LANGUAGE_MESSAGE(this.supportEmail || this.wsi.defaultSupportEmailAddress));
    }
    // get list of languages - backward compatible for apps that still want to define their own language
    getLanguages() {
        if (GenericUtil.isNullOrUndefined(this.languages) || this.languages.length === 0) {
            return LangUtil.getDefaultLanguages();
        }
        return this.languages;
    }
}
FooterComponent.ɵfac = function FooterComponent_Factory(t) { return new (t || FooterComponent)(ɵngcc0.ɵɵdirectiveInject(WorldskillsAngularLibService), ɵngcc0.ɵɵdirectiveInject(WsiTranslateService)); };
FooterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FooterComponent, selectors: [["ws-footer"]], viewQuery: function FooterComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c3, true);
        ɵngcc0.ɵɵviewQuery(_c4, true);
        ɵngcc0.ɵɵviewQuery(_c5, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.col1DefaultTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.col6DefaultTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.colDefaultTemplate = _t.first);
    } }, inputs: { isLoggedIn: "isLoggedIn", currentUser: "currentUser", col1Template: "col1Template", col2Template: "col2Template", col3Template: "col3Template", col4Template: "col4Template", col5Template: "col5Template", col6Template: "col6Template" }, outputs: { logoutClick: "logoutClick", loginClick: "loginClick" }, decls: 42, vars: 23, consts: [["col1DefaultTemplate", ""], ["col6DefaultTemplate", ""], ["colDefaultTemplate", ""], [1, "ws-page-footer"], [1, "container"], [1, "ws-page-footer-row"], [1, "ws-page-footer-col-sm"], [4, "ngTemplateOutlet"], [1, "ws-page-footer-row", "pb-3"], [1, "ws-page-footer-col-lg"], [1, "list-inline", "mt-2"], [1, "list-inline-item"], ["href", "https://worldskills.org/site/privacy/", "target", "_blank"], ["href", "https://worldskills.org/site/terms/", "target", "_blank"], ["href", "https://worldskills.org/site/contact/", "target", "_blank"], ["class", "btn-toolbar justify-content-end", 4, "ngIf"], ["href", "https://worldskills.org/internal/", "target", "_blank"], ["href", "https://worldskills.org/internal/wiw/", "target", "_blank"], ["href", "https://glossary.worldskills.org/", "target", "_blank"], ["href", "https://registrations.worldskills.org/", "target", "_blank"], ["href", "https://forums.worldskills.org/", "target", "_blank"], ["href", "https://il.worldskills.org/", "target", "_blank"], ["href", "https://skill-management.worldskills.org/", "target", "_blank"], [1, "text-right", "mt-5"], ["href", "https://worldskills.org/", "target", "_blank"], ["mode", "default"], [1, "btn-toolbar", "justify-content-end"], [1, "btn-group", "btn-group-sm", "dropup"], ["type", "button", "data-toggle", "dropdown", "aria-haspopup", "true", "aria-expanded", "false", 1, "btn", "btn-outline-light", "dropdown-toggle"], [1, "dropdown-menu", "dropdown-menu-right"], ["class", "dropdown-item", "href", "#", 3, "active", "click", 4, "ngFor", "ngForOf"], [1, "dropdown-divider"], ["href", "#", 1, "dropdown-item", 3, "click"]], template: function FooterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, FooterComponent_ng_template_0_Template, 29, 21, "ng-template", null, 0, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(2, FooterComponent_ng_template_2_Template, 3, 0, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(4, FooterComponent_ng_template_4_Template, 0, 0, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementStart(6, "footer", 3);
        ɵngcc0.ɵɵelementStart(7, "div", 4);
        ɵngcc0.ɵɵelementStart(8, "div", 5);
        ɵngcc0.ɵɵelementStart(9, "aside", 6);
        ɵngcc0.ɵɵtemplate(10, FooterComponent_ng_container_10_Template, 1, 0, "ng-container", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "aside", 6);
        ɵngcc0.ɵɵtemplate(12, FooterComponent_ng_container_12_Template, 1, 0, "ng-container", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "aside", 6);
        ɵngcc0.ɵɵtemplate(14, FooterComponent_ng_container_14_Template, 1, 0, "ng-container", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "aside", 6);
        ɵngcc0.ɵɵtemplate(16, FooterComponent_ng_container_16_Template, 1, 0, "ng-container", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(17, "aside", 6);
        ɵngcc0.ɵɵtemplate(18, FooterComponent_ng_container_18_Template, 1, 0, "ng-container", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(19, "aside", 6);
        ɵngcc0.ɵɵtemplate(20, FooterComponent_ng_container_20_Template, 1, 0, "ng-container", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(21, "div", 8);
        ɵngcc0.ɵɵelementStart(22, "div", 9);
        ɵngcc0.ɵɵelementStart(23, "ul", 10);
        ɵngcc0.ɵɵelementStart(24, "li", 11);
        ɵngcc0.ɵɵtext(25);
        ɵngcc0.ɵɵpipe(26, "date");
        ɵngcc0.ɵɵpipe(27, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(28, "li", 11);
        ɵngcc0.ɵɵelementStart(29, "a", 12);
        ɵngcc0.ɵɵtext(30);
        ɵngcc0.ɵɵpipe(31, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(32, "li", 11);
        ɵngcc0.ɵɵelementStart(33, "a", 13);
        ɵngcc0.ɵɵtext(34);
        ɵngcc0.ɵɵpipe(35, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(36, "li", 11);
        ɵngcc0.ɵɵelementStart(37, "a", 14);
        ɵngcc0.ɵɵtext(38);
        ɵngcc0.ɵɵpipe(39, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(40, "div", 9);
        ɵngcc0.ɵɵtemplate(41, FooterComponent_div_41_Template, 11, 7, "div", 15);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(1);
        const _r2 = ɵngcc0.ɵɵreference(3);
        const _r4 = ɵngcc0.ɵɵreference(5);
        ɵngcc0.ɵɵadvance(10);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.col1Template ? ctx.col1Template : _r0);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.col2Template ? ctx.col2Template : _r4);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.col3Template ? ctx.col3Template : _r4);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.col4Template ? ctx.col4Template : _r4);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.col5Template ? ctx.col5Template : _r4);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.col6Template ? ctx.col6Template : _r2);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate2("\u00A9 ", ɵngcc0.ɵɵpipeBind2(26, 12, ctx.date, "yyyy"), " ", ɵngcc0.ɵɵpipeBind1(27, 15, "footer.copyright.wsi"), "");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(31, 17, "footer.copyright.privacy"));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(35, 19, "footer.copyright.terms"));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(39, 21, "footer.copyright.contact"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.getLanguages());
    } }, directives: [ɵngcc1.NgTemplateOutlet, ɵngcc1.NgIf, LogoComponent, ɵngcc1.NgForOf], pipes: [ɵngcc1.DatePipe, ɵngcc2.TranslatePipe], styles: [""] });
FooterComponent.ctorParameters = () => [
    { type: WorldskillsAngularLibService },
    { type: WsiTranslateService }
];
FooterComponent.propDecorators = {
    isLoggedIn: [{ type: Input }],
    currentUser: [{ type: Input }],
    col1Template: [{ type: Input }],
    col2Template: [{ type: Input }],
    col3Template: [{ type: Input }],
    col4Template: [{ type: Input }],
    col5Template: [{ type: Input }],
    col6Template: [{ type: Input }],
    logoutClick: [{ type: Output }],
    loginClick: [{ type: Output }],
    col1DefaultTemplate: [{ type: ViewChild, args: ['#col1DefaultTemplate',] }],
    col6DefaultTemplate: [{ type: ViewChild, args: ['#col6DefaultTemplate',] }],
    colDefaultTemplate: [{ type: ViewChild, args: ['#colDefaultTemplate',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FooterComponent, [{
        type: Component,
        args: [{
                selector: 'ws-footer',
                template: "<ng-template #col1DefaultTemplate>\n  <h1><a href=\"https://worldskills.org/internal/\" target=\"_blank\">{{ 'footer.links.my.worldskills' | translate }}</a>\n  </h1>\n  <ul>\n    <li><a href=\"https://worldskills.org/internal/wiw/\" target=\"_blank\">{{ 'footer.links.wiw' | translate }}</a></li>\n    <li><a href=\"https://glossary.worldskills.org/\" target=\"_blank\">{{ 'footer.links.glossary' | translate }}</a></li>\n    <li><a href=\"https://registrations.worldskills.org/\"\n        target=\"_blank\">{{ 'footer.links.registrations' | translate }}</a></li>\n    <li><a href=\"https://forums.worldskills.org/\" target=\"_blank\">{{ 'footer.links.forums' | translate }}</a></li>\n    <li><a href=\"https://il.worldskills.org/\" target=\"_blank\">{{ 'footer.links.infrastructure.lists' | translate }}</a>\n    </li>\n    <li><a href=\"https://skill-management.worldskills.org/\"\n        target=\"_blank\">{{ 'footer.links.skill.management' | translate }}</a></li>\n  </ul>\n</ng-template>\n<ng-template #col6DefaultTemplate>\n  <div class=\"text-right mt-5\">\n    <a href=\"https://worldskills.org/\" target=\"_blank\">\n      <ws-logo mode=\"default\"></ws-logo>\n    </a>\n  </div>\n</ng-template>\n\n<ng-template #colDefaultTemplate>\n</ng-template>\n\n<footer class=\"ws-page-footer\">\n  <div class=\"container\">\n    <div class=\"ws-page-footer-row\">\n      <aside class=\"ws-page-footer-col-sm\">\n        <ng-container *ngTemplateOutlet=\"col1Template ? col1Template : col1DefaultTemplate\"></ng-container>\n      </aside>\n      <aside class=\"ws-page-footer-col-sm\">\n        <ng-container *ngTemplateOutlet=\"col2Template ? col2Template : colDefaultTemplate\"></ng-container>\n      </aside>\n      <aside class=\"ws-page-footer-col-sm\">\n        <ng-container *ngTemplateOutlet=\"col3Template? col3Template : colDefaultTemplate\"></ng-container>\n      </aside>\n      <aside class=\"ws-page-footer-col-sm\">\n        <ng-container *ngTemplateOutlet=\"col4Template? col4Template : colDefaultTemplate\"></ng-container>\n      </aside>\n      <aside class=\"ws-page-footer-col-sm\">\n        <ng-container *ngTemplateOutlet=\"col5Template? col5Template : colDefaultTemplate\"></ng-container>\n      </aside>\n      <aside class=\"ws-page-footer-col-sm\">\n        <ng-container *ngTemplateOutlet=\"col6Template? col6Template : col6DefaultTemplate\"></ng-container>\n      </aside>\n    </div>\n    <div class=\"ws-page-footer-row pb-3\">\n      <div class=\"ws-page-footer-col-lg\">\n        <ul class=\"list-inline mt-2\">\n          <li class=\"list-inline-item\">\u00A9 {{date | date:'yyyy'}} {{ 'footer.copyright.wsi' | translate }}</li>\n          <li class=\"list-inline-item\"><a href=\"https://worldskills.org/site/privacy/\"\n              target=\"_blank\">{{ 'footer.copyright.privacy' | translate }}</a></li>\n          <li class=\"list-inline-item\"><a href=\"https://worldskills.org/site/terms/\"\n              target=\"_blank\">{{ 'footer.copyright.terms' | translate }}</a></li>\n          <li class=\"list-inline-item\"><a href=\"https://worldskills.org/site/contact/\"\n              target=\"_blank\">{{ 'footer.copyright.contact' | translate }}</a></li>\n        </ul>\n      </div>\n      <div class=\"ws-page-footer-col-lg\">\n        <div class=\"btn-toolbar justify-content-end\" *ngIf=\"getLanguages()\">\n          <div class=\"btn-group btn-group-sm dropup\">\n            <button type=\"button\" class=\"btn btn-outline-light dropdown-toggle\" data-toggle=\"dropdown\"\n              aria-haspopup=\"true\" aria-expanded=\"false\">\n              {{ 'footer.translation.language' | translate }}\n            </button>\n            <div class=\"dropdown-menu dropdown-menu-right\">\n              <a *ngFor=\"let language of getLanguages()\" (click)=\"changeLanguage(language); false;\"\n                [class.active]=\"isLanguageSelected(language)\" class=\"dropdown-item\" href=\"#\">\n                {{ language.name }}\n              </a>\n              <div class=\"dropdown-divider\"></div>\n              <a (click)=\"$event.preventDefault(); languagePrompt();\" class=\"dropdown-item\" href=\"#\">\n                {{ 'footer.translation.missing' | translate }}\n              </a>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</footer>",
                styles: [""]
            }]
    }], function () { return [{ type: WorldskillsAngularLibService }, { type: WsiTranslateService }]; }, { logoutClick: [{
            type: Output
        }], loginClick: [{
            type: Output
        }], isLoggedIn: [{
            type: Input
        }], currentUser: [{
            type: Input
        }], col1Template: [{
            type: Input
        }], col2Template: [{
            type: Input
        }], col3Template: [{
            type: Input
        }], col4Template: [{
            type: Input
        }], col5Template: [{
            type: Input
        }], col6Template: [{
            type: Input
        }], col1DefaultTemplate: [{
            type: ViewChild,
            args: ['#col1DefaultTemplate']
        }], col6DefaultTemplate: [{
            type: ViewChild,
            args: ['#col6DefaultTemplate']
        }], colDefaultTemplate: [{
            type: ViewChild,
            args: ['#colDefaultTemplate']
        }] }); })();

/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
const ISO8601_DATE_REGEX = /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;
//    1        2       3         4          5          6          7          8  9     10      11
const NAMED_FORMATS = {};
const DATE_FORMATS_SPLIT = 
// tslint:disable-next-line:max-line-length
/((?:[^GyMLwWdEabBhHmsSzZO']+)|(?:'(?:[^']|'')*')|(?:G{1,5}|y{1,4}|M{1,5}|L{1,5}|w{1,2}|W{1}|d{1,2}|E{1,6}|a{1,5}|b{1,5}|B{1,5}|h{1,2}|H{1,2}|m{1,2}|s{1,2}|S{1,3}|z{1,4}|Z{1,5}|O{1,4}))([\s\S]*)/;
var ZoneWidth;
(function (ZoneWidth) {
    ZoneWidth[ZoneWidth["Short"] = 0] = "Short";
    ZoneWidth[ZoneWidth["ShortGMT"] = 1] = "ShortGMT";
    ZoneWidth[ZoneWidth["Long"] = 2] = "Long";
    ZoneWidth[ZoneWidth["Extended"] = 3] = "Extended";
})(ZoneWidth || (ZoneWidth = {}));
var DateType;
(function (DateType) {
    DateType[DateType["FullYear"] = 0] = "FullYear";
    DateType[DateType["Month"] = 1] = "Month";
    DateType[DateType["Date"] = 2] = "Date";
    DateType[DateType["Hours"] = 3] = "Hours";
    DateType[DateType["Minutes"] = 4] = "Minutes";
    DateType[DateType["Seconds"] = 5] = "Seconds";
    DateType[DateType["FractionalSeconds"] = 6] = "FractionalSeconds";
    DateType[DateType["Day"] = 7] = "Day";
})(DateType || (DateType = {}));
var TranslationType;
(function (TranslationType) {
    TranslationType[TranslationType["DayPeriods"] = 0] = "DayPeriods";
    TranslationType[TranslationType["Days"] = 1] = "Days";
    TranslationType[TranslationType["Months"] = 2] = "Months";
    TranslationType[TranslationType["Eras"] = 3] = "Eras";
})(TranslationType || (TranslationType = {}));
/**
 * @ngModule CommonModule
 * @description
 *
 * Formats a date according to locale rules.
 *
 * @param value The date to format, as a Date, or a number (milliseconds since UTC epoch)
 * or an [ISO date-time string](https://www.w3.org/TR/NOTE-datetime).
 * @param format The date-time components to include. See `DatePipe` for details.
 * @param locale A locale code for the locale format rules to use.
 * @param timezone The time zone. A time zone offset from GMT (such as `'+0430'`),
 * or a standard UTC/GMT or continental US time zone abbreviation.
 * If not specified, uses host system settings.
 *
 * @returns The formatted date string.
 *
 * @see `DatePipe`
 * @see [Internationalization (i18n) Guide](https://angular.io/guide/i18n)
 *
 * @publicApi
 */
function formatDate(value, format, locale, timezone) {
    let date = toDate(value);
    const namedFormat = getNamedFormat(locale, format);
    format = namedFormat || format;
    let parts = [];
    let match;
    while (format) {
        match = DATE_FORMATS_SPLIT.exec(format);
        if (match) {
            parts = parts.concat(match.slice(1));
            const part = parts.pop();
            if (!part) {
                break;
            }
            format = part;
        }
        else {
            parts.push(format);
            break;
        }
    }
    let dateTimezoneOffset = date.getTimezoneOffset();
    if (timezone) {
        dateTimezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
        date = convertTimezoneToLocal(date, timezone, true);
    }
    let text = '';
    // tslint:disable-next-line:no-shadowed-variable
    parts.forEach(value => {
        const dateFormatter = getDateFormatter(value);
        text += dateFormatter ?
            dateFormatter(date, locale, dateTimezoneOffset) :
            value === '\'\'' ? '\'' : value.replace(/(^'|'$)/g, '').replace(/''/g, '\'');
    });
    return text;
}
function getNamedFormat(locale, format) {
    const localeId = getLocaleId(locale);
    NAMED_FORMATS[localeId] = NAMED_FORMATS[localeId] || {};
    if (NAMED_FORMATS[localeId][format]) {
        return NAMED_FORMATS[localeId][format];
    }
    let formatValue = '';
    switch (format) {
        case 'shortDate':
            formatValue = getLocaleDateFormat(locale, FormatWidth.Short);
            break;
        case 'mediumDate':
            formatValue = getLocaleDateFormat(locale, FormatWidth.Medium);
            break;
        case 'longDate':
            formatValue = getLocaleDateFormat(locale, FormatWidth.Long);
            break;
        case 'fullDate':
            formatValue = getLocaleDateFormat(locale, FormatWidth.Full);
            break;
        case 'shortTime':
            formatValue = getLocaleTimeFormat(locale, FormatWidth.Short);
            break;
        case 'mediumTime':
            formatValue = getLocaleTimeFormat(locale, FormatWidth.Medium);
            break;
        case 'longTime':
            formatValue = getLocaleTimeFormat(locale, FormatWidth.Long);
            break;
        case 'fullTime':
            formatValue = getLocaleTimeFormat(locale, FormatWidth.Full);
            break;
        case 'short':
            const shortTime = getNamedFormat(locale, 'shortTime');
            const shortDate = getNamedFormat(locale, 'shortDate');
            formatValue = formatDateTime(getLocaleDateTimeFormat(locale, FormatWidth.Short), [shortTime, shortDate]);
            break;
        case 'medium':
            const mediumTime = getNamedFormat(locale, 'mediumTime');
            const mediumDate = getNamedFormat(locale, 'mediumDate');
            formatValue = formatDateTime(getLocaleDateTimeFormat(locale, FormatWidth.Medium), [mediumTime, mediumDate]);
            break;
        case 'long':
            const longTime = getNamedFormat(locale, 'longTime');
            const longDate = getNamedFormat(locale, 'longDate');
            formatValue =
                formatDateTime(getLocaleDateTimeFormat(locale, FormatWidth.Long), [longTime, longDate]);
            break;
        case 'full':
            const fullTime = getNamedFormat(locale, 'fullTime');
            const fullDate = getNamedFormat(locale, 'fullDate');
            formatValue =
                formatDateTime(getLocaleDateTimeFormat(locale, FormatWidth.Full), [fullTime, fullDate]);
            break;
    }
    if (formatValue) {
        NAMED_FORMATS[localeId][format] = formatValue;
    }
    return formatValue;
}
// tslint:disable-next-line:variable-name
function formatDateTime(str, opt_values) {
    if (opt_values) {
        // tslint:disable-next-line:only-arrow-functions
        str = str.replace(/\{([^}]+)}/g, function (match, key) {
            return (opt_values != null && key in opt_values) ? opt_values[key] : match;
        });
    }
    return str;
}
function padNumber(num, digits, minusSign = '-', trim, negWrap) {
    let neg = '';
    if (num < 0 || (negWrap && num <= 0)) {
        if (negWrap) {
            num = -num + 1;
        }
        else {
            num = -num;
            neg = minusSign;
        }
    }
    let strNum = String(num);
    while (strNum.length < digits) {
        strNum = '0' + strNum;
    }
    if (trim) {
        strNum = strNum.substr(strNum.length - digits);
    }
    return neg + strNum;
}
function formatFractionalSeconds(milliseconds, digits) {
    const strMs = padNumber(milliseconds, 3);
    return strMs.substr(0, digits);
}
/**
 * Returns a date formatter that transforms a date into its locale digit representation
 */
function dateGetter(name, size, offset = 0, trim = false, negWrap = false) {
    // tslint:disable-next-line:only-arrow-functions
    return function (date, locale) {
        let part = getDatePart(name, date);
        if (offset > 0 || part > -offset) {
            part += offset;
        }
        if (name === DateType.Hours) {
            if (part === 0 && offset === -12) {
                part = 12;
            }
        }
        else if (name === DateType.FractionalSeconds) {
            return formatFractionalSeconds(part, size);
        }
        const localeMinus = getLocaleNumberSymbol(locale, NumberSymbol.MinusSign);
        return padNumber(part, size, localeMinus, trim, negWrap);
    };
}
function getDatePart(part, date) {
    switch (part) {
        case DateType.FullYear:
            return date.getFullYear();
        case DateType.Month:
            return date.getMonth();
        case DateType.Date:
            return date.getDate();
        case DateType.Hours:
            return date.getHours();
        case DateType.Minutes:
            return date.getMinutes();
        case DateType.Seconds:
            return date.getSeconds();
        case DateType.FractionalSeconds:
            return date.getMilliseconds();
        case DateType.Day:
            return date.getDay();
        default:
            throw new Error(`Unknown DateType value "${part}".`);
    }
}
/**
 * Returns a date formatter that transforms a date into its locale string representation
 */
function dateStrGetter(name, width, form = FormStyle.Format, extended = false) {
    // tslint:disable-next-line:only-arrow-functions
    return function (date, locale) {
        return getDateTranslation(date, locale, name, width, form, extended);
    };
}
/**
 * Returns the locale translation of a date for a given form, type and width
 */
// tslint:disable-next-line:typedef
function getDateTranslation(date, locale, name, width, form, extended) {
    switch (name) {
        case TranslationType.Months:
            return getLocaleMonthNames(locale, form, width)[date.getMonth()];
        case TranslationType.Days:
            return getLocaleDayNames(locale, form, width)[date.getDay()];
        case TranslationType.DayPeriods:
            const currentHours = date.getHours();
            const currentMinutes = date.getMinutes();
            if (extended) {
                const rules = getLocaleExtraDayPeriodRules(locale);
                const dayPeriods = getLocaleExtraDayPeriods(locale, form, width);
                const index = rules.findIndex(rule => {
                    if (Array.isArray(rule)) {
                        // morning, afternoon, evening, night
                        const [from, to] = rule;
                        const afterFrom = currentHours >= from.hours && currentMinutes >= from.minutes;
                        const beforeTo = (currentHours < to.hours ||
                            (currentHours === to.hours && currentMinutes < to.minutes));
                        // We must account for normal rules that span a period during the day (e.g. 6am-9am)
                        // where `from` is less (earlier) than `to`. But also rules that span midnight (e.g.
                        // 10pm - 5am) where `from` is greater (later!) than `to`.
                        //
                        // In the first case the current time must be BOTH after `from` AND before `to`
                        // (e.g. 8am is after 6am AND before 10am).
                        //
                        // In the second case the current time must be EITHER after `from` OR before `to`
                        // (e.g. 4am is before 5am but not after 10pm; and 11pm is not before 5am but it is
                        // after 10pm).
                        if (from.hours < to.hours) {
                            if (afterFrom && beforeTo) {
                                return true;
                            }
                        }
                        else if (afterFrom || beforeTo) {
                            return true;
                        }
                    }
                    else { // noon or midnight
                        if (rule.hours === currentHours && rule.minutes === currentMinutes) {
                            return true;
                        }
                    }
                    return false;
                });
                if (index !== -1) {
                    return dayPeriods[index];
                }
            }
            // if no rules for the day periods, we use am/pm by default
            // tslint:disable-next-line:no-angle-bracket-type-assertion
            return getLocaleDayPeriods(locale, form, width)[currentHours < 12 ? 0 : 1];
        case TranslationType.Eras:
            // tslint:disable-next-line:no-angle-bracket-type-assertion
            return getLocaleEraNames(locale, width)[date.getFullYear() <= 0 ? 0 : 1];
        default:
            // This default case is not needed by TypeScript compiler, as the switch is exhaustive.
            // However Closure Compiler does not understand that and reports an error in typed mode.
            // The `throw new Error` below works around the problem, and the unexpected: never variable
            // makes sure tsc still checks this code is unreachable.
            const unexpected = name;
            throw new Error(`unexpected translation type ${unexpected}`);
    }
}
/**
 * Returns a date formatter that transforms a date and an offset into a timezone with ISO8601 or
 * GMT format depending on the width (eg: short = +0430, short:GMT = GMT+4, long = GMT+04:30,
 * extended = +04:30)
 */
function timeZoneGetter(width) {
    // tslint:disable-next-line:only-arrow-functions typedef
    return function (date, locale, offset) {
        const zone = -1 * offset;
        const minusSign = getLocaleNumberSymbol(locale, NumberSymbol.MinusSign);
        const hours = zone > 0 ? Math.floor(zone / 60) : Math.ceil(zone / 60);
        switch (width) {
            case ZoneWidth.Short:
                return ((zone >= 0) ? '+' : '') + padNumber(hours, 2, minusSign) +
                    padNumber(Math.abs(zone % 60), 2, minusSign);
            case ZoneWidth.ShortGMT:
                return 'GMT' + ((zone >= 0) ? '+' : '') + padNumber(hours, 1, minusSign);
            case ZoneWidth.Long:
                return 'GMT' + ((zone >= 0) ? '+' : '') + padNumber(hours, 2, minusSign) + ':' +
                    padNumber(Math.abs(zone % 60), 2, minusSign);
            case ZoneWidth.Extended:
                if (offset === 0) {
                    return 'Z';
                }
                else {
                    return ((zone >= 0) ? '+' : '') + padNumber(hours, 2, minusSign) + ':' +
                        padNumber(Math.abs(zone % 60), 2, minusSign);
                }
            default:
                throw new Error(`Unknown zone width "${width}"`);
        }
    };
}
const JANUARY = 0;
const THURSDAY = 4;
function getFirstThursdayOfYear(year) {
    const firstDayOfYear = (new Date(year, JANUARY, 1)).getDay();
    return new Date(year, 0, 1 + ((firstDayOfYear <= THURSDAY) ? THURSDAY : THURSDAY + 7) - firstDayOfYear);
}
function getThursdayThisWeek(datetime) {
    return new Date(datetime.getFullYear(), datetime.getMonth(), datetime.getDate() + (THURSDAY - datetime.getDay()));
}
function weekGetter(size, monthBased = false) {
    // tslint:disable-next-line:only-arrow-functions typedef
    return function (date, locale) {
        let result;
        if (monthBased) {
            const nbDaysBefore1stDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1).getDay() - 1;
            const today = date.getDate();
            result = 1 + Math.floor((today + nbDaysBefore1stDayOfMonth) / 7);
        }
        else {
            const firstThurs = getFirstThursdayOfYear(date.getFullYear());
            const thisThurs = getThursdayThisWeek(date);
            const diff = thisThurs.getTime() - firstThurs.getTime();
            result = 1 + Math.round(diff / 6.048e8); // 6.048e8 ms per week
        }
        return padNumber(result, size, getLocaleNumberSymbol(locale, NumberSymbol.MinusSign));
    };
}
const DATE_FORMATS = {};
// Based on CLDR formats:
// See complete list: http://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
// See also explanations: http://cldr.unicode.org/translation/date-time
// TODO(ocombe): support all missing cldr formats: Y, U, Q, D, F, e, c, j, J, C, A, v, V, X, x
function getDateFormatter(format) {
    if (DATE_FORMATS[format]) {
        return DATE_FORMATS[format];
    }
    let formatter;
    switch (format) {
        // Era name (AD/BC)
        case 'G':
        case 'GG':
        case 'GGG':
            formatter = dateStrGetter(TranslationType.Eras, TranslationWidth.Abbreviated);
            break;
        case 'GGGG':
            formatter = dateStrGetter(TranslationType.Eras, TranslationWidth.Wide);
            break;
        case 'GGGGG':
            formatter = dateStrGetter(TranslationType.Eras, TranslationWidth.Narrow);
            break;
        // 1 digit representation of the year, e.g. (AD 1 => 1, AD 199 => 199)
        case 'y':
            formatter = dateGetter(DateType.FullYear, 1, 0, false, true);
            break;
        // 2 digit representation of the year, padded (00-99). (e.g. AD 2001 => 01, AD 2010 => 10)
        case 'yy':
            formatter = dateGetter(DateType.FullYear, 2, 0, true, true);
            break;
        // 3 digit representation of the year, padded (000-999). (e.g. AD 2001 => 01, AD 2010 => 10)
        case 'yyy':
            formatter = dateGetter(DateType.FullYear, 3, 0, false, true);
            break;
        // 4 digit representation of the year (e.g. AD 1 => 0001, AD 2010 => 2010)
        case 'yyyy':
            formatter = dateGetter(DateType.FullYear, 4, 0, false, true);
            break;
        // Month of the year (1-12), numeric
        case 'M':
        case 'L':
            formatter = dateGetter(DateType.Month, 1, 1);
            break;
        case 'MM':
        case 'LL':
            formatter = dateGetter(DateType.Month, 2, 1);
            break;
        // Month of the year (January, ...), string, format
        case 'MMM':
            formatter = dateStrGetter(TranslationType.Months, TranslationWidth.Abbreviated);
            break;
        case 'MMMM':
            formatter = dateStrGetter(TranslationType.Months, TranslationWidth.Wide);
            break;
        case 'MMMMM':
            formatter = dateStrGetter(TranslationType.Months, TranslationWidth.Narrow);
            break;
        // Month of the year (January, ...), string, standalone
        case 'LLL':
            formatter =
                dateStrGetter(TranslationType.Months, TranslationWidth.Abbreviated, FormStyle.Standalone);
            break;
        case 'LLLL':
            formatter =
                dateStrGetter(TranslationType.Months, TranslationWidth.Wide, FormStyle.Standalone);
            break;
        case 'LLLLL':
            formatter =
                dateStrGetter(TranslationType.Months, TranslationWidth.Narrow, FormStyle.Standalone);
            break;
        // Week of the year (1, ... 52)
        case 'w':
            formatter = weekGetter(1);
            break;
        case 'ww':
            formatter = weekGetter(2);
            break;
        // Week of the month (1, ...)
        case 'W':
            formatter = weekGetter(1, true);
            break;
        // Day of the month (1-31)
        case 'd':
            formatter = dateGetter(DateType.Date, 1);
            break;
        case 'dd':
            formatter = dateGetter(DateType.Date, 2);
            break;
        // Day of the Week
        case 'E':
        case 'EE':
        case 'EEE':
            formatter = dateStrGetter(TranslationType.Days, TranslationWidth.Abbreviated);
            break;
        case 'EEEE':
            formatter = dateStrGetter(TranslationType.Days, TranslationWidth.Wide);
            break;
        case 'EEEEE':
            formatter = dateStrGetter(TranslationType.Days, TranslationWidth.Narrow);
            break;
        case 'EEEEEE':
            formatter = dateStrGetter(TranslationType.Days, TranslationWidth.Short);
            break;
        // Generic period of the day (am-pm)
        case 'a':
        case 'aa':
        case 'aaa':
            formatter = dateStrGetter(TranslationType.DayPeriods, TranslationWidth.Abbreviated);
            break;
        case 'aaaa':
            formatter = dateStrGetter(TranslationType.DayPeriods, TranslationWidth.Wide);
            break;
        case 'aaaaa':
            formatter = dateStrGetter(TranslationType.DayPeriods, TranslationWidth.Narrow);
            break;
        // Extended period of the day (midnight, at night, ...), standalone
        case 'b':
        case 'bb':
        case 'bbb':
            formatter = dateStrGetter(TranslationType.DayPeriods, TranslationWidth.Abbreviated, FormStyle.Standalone, true);
            break;
        case 'bbbb':
            formatter = dateStrGetter(TranslationType.DayPeriods, TranslationWidth.Wide, FormStyle.Standalone, true);
            break;
        case 'bbbbb':
            formatter = dateStrGetter(TranslationType.DayPeriods, TranslationWidth.Narrow, FormStyle.Standalone, true);
            break;
        // Extended period of the day (midnight, night, ...), standalone
        case 'B':
        case 'BB':
        case 'BBB':
            formatter = dateStrGetter(TranslationType.DayPeriods, TranslationWidth.Abbreviated, FormStyle.Format, true);
            break;
        case 'BBBB':
            formatter =
                dateStrGetter(TranslationType.DayPeriods, TranslationWidth.Wide, FormStyle.Format, true);
            break;
        case 'BBBBB':
            formatter = dateStrGetter(TranslationType.DayPeriods, TranslationWidth.Narrow, FormStyle.Format, true);
            break;
        // Hour in AM/PM, (1-12)
        case 'h':
            formatter = dateGetter(DateType.Hours, 1, -12);
            break;
        case 'hh':
            formatter = dateGetter(DateType.Hours, 2, -12);
            break;
        // Hour of the day (0-23)
        case 'H':
            formatter = dateGetter(DateType.Hours, 1);
            break;
        // Hour in day, padded (00-23)
        case 'HH':
            formatter = dateGetter(DateType.Hours, 2);
            break;
        // Minute of the hour (0-59)
        case 'm':
            formatter = dateGetter(DateType.Minutes, 1);
            break;
        case 'mm':
            formatter = dateGetter(DateType.Minutes, 2);
            break;
        // Second of the minute (0-59)
        case 's':
            formatter = dateGetter(DateType.Seconds, 1);
            break;
        case 'ss':
            formatter = dateGetter(DateType.Seconds, 2);
            break;
        // Fractional second
        case 'S':
            formatter = dateGetter(DateType.FractionalSeconds, 1);
            break;
        case 'SS':
            formatter = dateGetter(DateType.FractionalSeconds, 2);
            break;
        case 'SSS':
            formatter = dateGetter(DateType.FractionalSeconds, 3);
            break;
        // Timezone ISO8601 short format (-0430)
        case 'Z':
        case 'ZZ':
        case 'ZZZ':
            formatter = timeZoneGetter(ZoneWidth.Short);
            break;
        // Timezone ISO8601 extended format (-04:30)
        case 'ZZZZZ':
            formatter = timeZoneGetter(ZoneWidth.Extended);
            break;
        // Timezone GMT short format (GMT+4)
        case 'O':
        case 'OO':
        case 'OOO':
        // Should be location, but fallback to format O instead because we don't have the data yet
        case 'z':
        case 'zz':
        case 'zzz':
            formatter = timeZoneGetter(ZoneWidth.ShortGMT);
            break;
        // Timezone GMT long format (GMT+0430)
        case 'OOOO':
        case 'ZZZZ':
        // Should be location, but fallback to format O instead because we don't have the data yet
        case 'zzzz':
            formatter = timeZoneGetter(ZoneWidth.Long);
            break;
        default:
            return null;
    }
    DATE_FORMATS[format] = formatter;
    return formatter;
}
function timezoneToOffset(timezone, fallback) {
    // Support: IE 9-11 only, Edge 13-15+
    // IE/Edge do not "understand" colon (`:`) in timezone
    timezone = timezone.replace(/:/g, '');
    const requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
    return isNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
}
function addDateMinutes(date, minutes) {
    date = new Date(date.getTime());
    date.setMinutes(date.getMinutes() + minutes);
    return date;
}
function convertTimezoneToLocal(date, timezone, reverse) {
    const reverseValue = reverse ? -1 : 1;
    const dateTimezoneOffset = date.getTimezoneOffset();
    const timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
    return addDateMinutes(date, reverseValue * (timezoneOffset - dateTimezoneOffset));
}
/**
 * Converts a value to date.
 *
 * Supported input formats:
 * - `Date`
 * - number: timestamp
 * - string: numeric (e.g. "1234"), ISO and date strings in a format supported by
 *   [Date.parse()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/parse).
 *   Note: ISO strings without time return a date without timeoffset.
 *
 * Throws if unable to convert to a date.
 */
function toDate(value) {
    if (isDate(value)) {
        return value;
    }
    if (typeof value === 'number' && !isNaN(value)) {
        return new Date(value);
    }
    if (typeof value === 'string') {
        value = value.trim();
        const parsedNb = parseFloat(value);
        // any string that only contains numbers, like "1234" but not like "1234hello"
        if (!isNaN(value - parsedNb)) {
            return new Date(parsedNb);
        }
        if (/^(\d{4}-\d{1,2}-\d{1,2})$/.test(value)) {
            /* For ISO Strings without time the day, month and year must be extracted from the ISO String
            before Date creation to avoid time offset and errors in the new Date.
            If we only replace '-' with ',' in the ISO String ("2015,01,01"), and try to create a new
            date, some browsers (e.g. IE 9) will throw an invalid Date error.
            If we leave the '-' ("2015-01-01") and try to create a new Date("2015-01-01") the timeoffset
            is applied.
            Note: ISO months are 0 for January, 1 for February, ... */
            const [y, m, d] = value.split('-').map((val) => +val);
            return new Date(y, m - 1, d);
        }
        let match;
        // tslint:disable-next-line:no-conditional-assignment
        if (match = value.match(ISO8601_DATE_REGEX)) {
            return isoStringToDate(match);
        }
    }
    const date = new Date(value);
    if (!isDate(date)) {
        throw new Error(`Unable to convert "${value}" into a date`);
    }
    return date;
}
/**
 * Converts a date in ISO8601 to a Date.
 * Used instead of `Date.parse` because of browser discrepancies.
 */
function isoStringToDate(match) {
    const date = new Date(0);
    let tzHour = 0;
    let tzMin = 0;
    // match[8] means that the string contains "Z" (UTC) or a timezone like "+01:00" or "+0100"
    const dateSetter = match[8] ? date.setUTCFullYear : date.setFullYear;
    const timeSetter = match[8] ? date.setUTCHours : date.setHours;
    // if there is a timezone defined like "+01:00" or "+0100"
    if (match[9]) {
        tzHour = Number(match[9] + match[10]);
        tzMin = Number(match[9] + match[11]);
    }
    dateSetter.call(date, Number(match[1]), Number(match[2]) - 1, Number(match[3]));
    const h = Number(match[4] || 0) - tzHour;
    const m = Number(match[5] || 0) - tzMin;
    const s = Number(match[6] || 0);
    const ms = Math.round(parseFloat('0.' + (match[7] || 0)) * 1000);
    timeSetter.call(date, h, m, s, ms);
    return date;
}
function isDate(value) {
    return value instanceof Date && !isNaN(value.valueOf());
}

class DateRangeComponent {
    constructor(calendar, formatter) {
        this.calendar = calendar;
        this.formatter = formatter;
        this.disabled = false;
        this.hoveredDate = null;
        // tslint:disable-next-line:no-output-native
        this.change = new EventEmitter();
        // Function to call when the range changes.
        this.onChange = (range) => { };
        // Function to call when the input is touched.
        this.onTouched = () => { };
    }
    get opacity() {
        return this.disabled ? 0.25 : 1;
    }
    onDateSelection(date) {
        if (!this.fromDate && !this.toDate) {
            this.fromDate = date;
        }
        else if (this.fromDate && !this.toDate && date && date.after(this.fromDate)) {
            this.toDate = date;
        }
        else {
            this.toDate = null;
            this.fromDate = date;
        }
        if (this.fromDate && this.toDate) {
            if (!this.value) {
                this.value = { start: new Date(), end: new Date() };
            }
            this.value.start = new Date(this.fromDate.year, this.fromDate.month - 1, this.fromDate.day);
            this.value.end = new Date(this.toDate.year, this.toDate.month - 1, this.toDate.day);
            this.writeValue(this.value);
        }
    }
    isHovered(date) {
        return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate);
    }
    isInside(date) {
        return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
    }
    isRange(date) {
        return date.equals(this.fromDate) || (this.toDate && date.equals(this.toDate)) || this.isInside(date) || this.isHovered(date);
    }
    validateInput(currentValue, input) {
        const parsed = this.formatter.parse(input);
        return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
    }
    writeValue(obj) {
        if (obj && !this.disabled) {
            this.fromDate = this.toNgbDate(obj.start);
            this.toDate = this.toNgbDate(obj.end);
            this.value = obj;
            this.onChange(obj);
            this.change.emit(obj);
        }
    }
    toNgbDate(date) {
        date = toDate(date);
        return new NgbDate(date.getFullYear(), date.getMonth() + 1, date.getDate());
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
}
DateRangeComponent.ɵfac = function DateRangeComponent_Factory(t) { return new (t || DateRangeComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc4.NgbCalendar), ɵngcc0.ɵɵdirectiveInject(ɵngcc4.NgbDateParserFormatter)); };
DateRangeComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DateRangeComponent, selectors: [["ws-date-range"]], hostVars: 2, hostBindings: function DateRangeComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("opacity", ctx.opacity);
    } }, inputs: { disabled: "disabled" }, outputs: { change: "change" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DateRangeComponent),
                multi: true
            }
        ])], decls: 21, vars: 10, consts: [[1, "form-inline"], [1, "form-group"], [1, "input-group", "hidden-group"], ["name", "datepicker", "ngbDatepicker", "", "outsideDays", "hidden", 1, "form-control", 3, "autoClose", "displayMonths", "dayTemplate", "startDate", "dateSelect"], ["datepicker", "ngbDatepicker"], ["t", ""], [1, "input-group"], ["placeholder", "yyyy-mm-dd", "name", "dpFromDate", 1, "form-control", 3, "value", "disabled", "input"], ["dpFromDate", ""], [1, "input-group-append"], ["type", "button", 1, "btn", "btn-outline-secondary", "calendar", 3, "disabled", "click"], ["aria-hidden", "true", 1, "fa", "fa-calendar"], [1, "form-group", "ml-2"], ["placeholder", "yyyy-mm-dd", "name", "dpToDate", 1, "form-control", 3, "value", "disabled", "input"], ["dpToDate", ""], [1, "custom-day", 3, "mouseenter", "mouseleave"]], template: function DateRangeComponent_Template(rf, ctx) { if (rf & 1) {
        const _r10 = ɵngcc0.ɵɵgetCurrentView();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "input", 3, 4);
        ɵngcc0.ɵɵlistener("dateSelect", function DateRangeComponent_Template_input_dateSelect_3_listener($event) { return ctx.onDateSelection($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, DateRangeComponent_ng_template_5_Template, 2, 7, "ng-template", null, 5, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 1);
        ɵngcc0.ɵɵelementStart(8, "div", 6);
        ɵngcc0.ɵɵelementStart(9, "input", 7, 8);
        ɵngcc0.ɵɵlistener("input", function DateRangeComponent_Template_input_input_9_listener() { ɵngcc0.ɵɵrestoreView(_r10); const _r3 = ɵngcc0.ɵɵreference(10); return ctx.fromDate = ctx.validateInput(ctx.fromDate, _r3.value); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 9);
        ɵngcc0.ɵɵelementStart(12, "button", 10);
        ɵngcc0.ɵɵlistener("click", function DateRangeComponent_Template_button_click_12_listener() { ɵngcc0.ɵɵrestoreView(_r10); const _r0 = ɵngcc0.ɵɵreference(4); return _r0.toggle(); });
        ɵngcc0.ɵɵelement(13, "i", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "div", 12);
        ɵngcc0.ɵɵelementStart(15, "div", 6);
        ɵngcc0.ɵɵelementStart(16, "input", 13, 14);
        ɵngcc0.ɵɵlistener("input", function DateRangeComponent_Template_input_input_16_listener() { ɵngcc0.ɵɵrestoreView(_r10); const _r4 = ɵngcc0.ɵɵreference(17); return ctx.toDate = ctx.validateInput(ctx.toDate, _r4.value); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "div", 9);
        ɵngcc0.ɵɵelementStart(19, "button", 10);
        ɵngcc0.ɵɵlistener("click", function DateRangeComponent_Template_button_click_19_listener() { ɵngcc0.ɵɵrestoreView(_r10); const _r0 = ɵngcc0.ɵɵreference(4); return _r0.toggle(); });
        ɵngcc0.ɵɵelement(20, "i", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(6);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("autoClose", "outside")("displayMonths", 2)("dayTemplate", _r1)("startDate", ctx.fromDate);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("value", ctx.formatter.format(ctx.fromDate))("disabled", ctx.disabled ? "disabled" : null);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("disabled", ctx.disabled ? "disabled" : null);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("value", ctx.formatter.format(ctx.toDate))("disabled", ctx.disabled ? "disabled" : null);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("disabled", ctx.disabled ? "disabled" : null);
    } }, directives: [ɵngcc4.NgbInputDatepicker], styles: [".custom-day[_ngcontent-%COMP%]{display:inline-block;height:2rem;padding:.185rem .25rem;text-align:center;width:2rem}.custom-day.focused[_ngcontent-%COMP%]{background-color:#e6e6e6}.custom-day.range[_ngcontent-%COMP%], .custom-day[_ngcontent-%COMP%]:hover{background-color:#0275d8;color:#fff}.custom-day.faded[_ngcontent-%COMP%]{background-color:rgba(2,117,216,.5)}.hidden-group[_ngcontent-%COMP%]{width:0}.hidden-group[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{visibility:hidden}"] });
DateRangeComponent.ctorParameters = () => [
    { type: NgbCalendar },
    { type: NgbDateParserFormatter }
];
DateRangeComponent.propDecorators = {
    disabled: [{ type: Input }],
    opacity: [{ type: HostBinding, args: ['style.opacity',] }],
    change: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DateRangeComponent, [{
        type: Component,
        args: [{
                selector: 'ws-date-range',
                template: "<div class=\"form-inline\">\n  <div class=\"form-group\">\n    <div class=\"input-group hidden-group\">\n      <input name=\"datepicker\" class=\"form-control\" ngbDatepicker #datepicker=\"ngbDatepicker\" [autoClose]=\"'outside'\"\n        (dateSelect)=\"onDateSelection($event)\" [displayMonths]=\"2\" [dayTemplate]=\"t\" outsideDays=\"hidden\"\n        [startDate]=\"fromDate!\">\n      <ng-template #t let-date let-focused=\"focused\">\n        <span class=\"custom-day\" [class.focused]=\"focused\" [class.range]=\"isRange(date)\"\n          [class.faded]=\"isHovered(date) || isInside(date)\" (mouseenter)=\"hoveredDate = date\"\n          (mouseleave)=\"hoveredDate = null\">\n          {{ date.day }}\n        </span>\n      </ng-template>\n    </div>\n  </div>\n  <div class=\"form-group\">\n    <div class=\"input-group\">\n      <input #dpFromDate class=\"form-control\" placeholder=\"yyyy-mm-dd\" name=\"dpFromDate\"\n        [value]=\"formatter.format(fromDate)\" (input)=\"fromDate = validateInput(fromDate, dpFromDate.value)\" [disabled]=\"disabled ? 'disabled' : null\">\n      <div class=\"input-group-append\">\n        <button class=\"btn btn-outline-secondary calendar\" (click)=\"datepicker.toggle()\" type=\"button\" [disabled]=\"disabled ? 'disabled' : null\">\n          <i class=\"fa fa-calendar\" aria-hidden=\"true\"></i>\n        </button>\n      </div>\n    </div>\n  </div>\n  <div class=\"form-group ml-2\">\n    <div class=\"input-group\">\n      <input #dpToDate class=\"form-control\" placeholder=\"yyyy-mm-dd\" name=\"dpToDate\" [value]=\"formatter.format(toDate)\"\n        (input)=\"toDate = validateInput(toDate, dpToDate.value)\" [disabled]=\"disabled ? 'disabled' : null\">\n      <div class=\"input-group-append\">\n        <button class=\"btn btn-outline-secondary calendar\" (click)=\"datepicker.toggle()\" type=\"button\" [disabled]=\"disabled ? 'disabled' : null\">\n          <i class=\"fa fa-calendar\" aria-hidden=\"true\"></i>\n        </button>\n      </div>\n    </div>\n  </div>\n</div>\n",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DateRangeComponent),
                        multi: true
                    }
                ],
                styles: [".custom-day{display:inline-block;height:2rem;padding:.185rem .25rem;text-align:center;width:2rem}.custom-day.focused{background-color:#e6e6e6}.custom-day.range,.custom-day:hover{background-color:#0275d8;color:#fff}.custom-day.faded{background-color:rgba(2,117,216,.5)}.hidden-group{width:0}.hidden-group input{visibility:hidden}"]
            }]
    }], function () { return [{ type: ɵngcc4.NgbCalendar }, { type: ɵngcc4.NgbDateParserFormatter }]; }, { disabled: [{
            type: Input
        }], change: [{
            type: Output
        }], opacity: [{
            type: HostBinding,
            args: ['style.opacity']
        }] }); })();

class Datetime {
    constructor(init) {
        Object.assign(this, init);
    }
    static asToday() {
        const date = new Date();
        return new Datetime({
            year: date.getFullYear(),
            month: date.getMonth() + 1,
            day: date.getDate(),
            hour: date.getHours(),
            minute: date.getMinutes(),
            second: date.getSeconds(),
            timeZoneOffset: date.getTimezoneOffset()
        });
    }
    static fromLocalString(dateString) {
        const date = moment(dateString).toDate();
        return new Datetime({
            year: date.getFullYear(),
            month: date.getMonth() + 1,
            day: date.getDate(),
            hour: date.getHours(),
            minute: date.getMinutes(),
            second: date.getSeconds(),
            timeZoneOffset: date.getTimezoneOffset()
        });
    }
    isInteger(value) {
        return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
    }
    toString() {
        if (this.isInteger(this.year) && this.isInteger(this.month) && this.isInteger(this.day)) {
            const year = this.year.toString().padStart(2, '0');
            const month = this.month.toString().padStart(2, '0');
            const day = this.day.toString().padStart(2, '0');
            if (!this.hour) {
                this.hour = 0;
            }
            if (!this.minute) {
                this.minute = 0;
            }
            if (!this.second) {
                this.second = 0;
            }
            if (!this.timeZoneOffset) {
                this.timeZoneOffset = new Date().getTimezoneOffset();
            }
            const hour = this.hour.toString().padStart(2, '0');
            const minute = this.minute.toString().padStart(2, '0');
            const second = this.second.toString().padStart(2, '0');
            const tzo = -this.timeZoneOffset;
            const dif = tzo >= 0 ? '+' : '-';
            const pad = (num) => {
                const norm = Math.floor(Math.abs(num));
                return (norm < 10 ? '0' : '') + norm;
            };
            // tslint:disable-next-line:max-line-length
            const isoString = `${pad(year)}-${pad(month)}-${pad(day)}T${pad(hour)}:${pad(minute)}:${pad(second)}${dif}${pad(tzo / 60)}:${pad(tzo % 60)}`;
            return isoString;
        }
        return null;
    }
}

class DatetimePickerComponent {
    constructor(config) {
        this.config = config;
        this.disabled = false;
        this.inputDatetimeFormat = 'dd/MM/yyyy HH:mm';
        this.hourStep = 1;
        this.minuteStep = 1;
        this.secondStep = 30;
        this.seconds = false;
        this.minDate = new NgbDate(1900, 1, 1);
        this.showTimePickerToggle = false;
        // tslint:disable-next-line:no-output-native
        this.change = new EventEmitter();
        // Function to call when the range changes.
        this.onChange = (value) => { };
        // Function to call when the input is touched.
        this.onTouched = () => { };
        config.autoClose = 'outside';
        config.placement = 'auto';
    }
    get opacity() {
        return this.disabled ? 0.25 : 1;
    }
    writeValue(obj) {
        // report value back to the model
        if (obj && !this.disabled) {
            this.model = this.toNgbDate(new Date(obj.toString()));
            this.value = obj;
            this.onChange(obj);
            this.change.emit(obj);
        }
        else {
            // when there's no input model registered
            this.value = Datetime.asToday();
            this.change.emit(obj);
        }
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    onInputChange($event) {
        const value = $event.target.value;
        const dt = Datetime.fromLocalString(value);
        if (dt) {
            this.writeValue(dt);
        }
        else if (value.trim() === '') {
            this.writeValue(new Datetime());
        }
    }
    toggleDateTimeState() {
        this.showTimePickerToggle = !this.showTimePickerToggle;
    }
    onDateChange(date) {
        if (!this.value) {
            this.value = new Datetime();
        }
        this.value.year = date.year;
        this.value.month = date.month;
        this.value.day = date.day;
        this.writeValue(this.value);
    }
    onTimeChange(event) {
        this.value.hour = event.hour;
        this.value.minute = event.minute;
        this.value.second = event.second;
        this.writeValue(this.value);
    }
    onAccept() {
        if (this.popover.isOpen()) {
            this.popover.close();
        }
    }
    inputBlur($event) {
        this.onTouched();
    }
    toNgbDate(date) {
        date = toDate(date);
        return new NgbDate(date.getFullYear(), date.getMonth() + 1, date.getDate());
    }
}
DatetimePickerComponent.ɵfac = function DatetimePickerComponent_Factory(t) { return new (t || DatetimePickerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc4.NgbPopoverConfig)); };
DatetimePickerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DatetimePickerComponent, selectors: [["ws-datetime-picker"]], viewQuery: function DatetimePickerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c6, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.popover = _t.first);
    } }, hostVars: 2, hostBindings: function DatetimePickerComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("opacity", ctx.opacity);
    } }, inputs: { disabled: "disabled", inputDatetimeFormat: "inputDatetimeFormat", hourStep: "hourStep", minuteStep: "minuteStep", secondStep: "secondStep", seconds: "seconds", minDate: "minDate", maxDate: "maxDate" }, outputs: { change: "change" }, features: [ɵngcc0.ɵɵProvidersFeature([
            DatePipe,
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DatetimePickerComponent),
                multi: true
            }
        ])], decls: 11, vars: 8, consts: [[1, "input-group", "mr-2"], [1, "form-control", "form-control-sm", 3, "ngModel", "disabled", "placeholder", "blur", "change"], [1, "input-group-append"], ["type", "button", 1, "btn", "btn-outline-secondary", "btn-sm", 3, "ngbPopover", "disabled"], ["popOver", "ngbPopover"], [1, "fa", "fa-calendar"], ["calendarContent", ""], ["timePickerContent", ""], [4, "ngIf"], ["name", "datepicker", 3, "ngModel", "minDate", "maxDate", "ngModelChange"], ["dp", ""], ["type", "button", 1, "btn", "btn-block", "btn-outline-secondary", 3, "disabled", "ngbPopover", "click"], [1, "fa", "fa-clock-o"], ["type", "button", 1, "btn", "btn-block", "btn-outline-secondary", 3, "click"], [1, "fa", "fa-check"], [1, "mt-auto"], ["name", "timepicker", 3, "ngModel", "seconds", "hourStep", "minuteStep", "secondStep", "ngModelChange"], ["tp", ""]], template: function DatetimePickerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "input", 1);
        ɵngcc0.ɵɵlistener("blur", function DatetimePickerComponent_Template_input_blur_1_listener($event) { return ctx.inputBlur($event); })("change", function DatetimePickerComponent_Template_input_change_1_listener($event) { return ctx.onInputChange($event); });
        ɵngcc0.ɵɵpipe(2, "date");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵelementStart(4, "button", 3, 4);
        ɵngcc0.ɵɵelement(6, "i", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(7, DatetimePickerComponent_ng_template_7_Template, 3, 2, "ng-template", null, 6, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(9, DatetimePickerComponent_ng_template_9_Template, 1, 0, "ng-template", null, 7, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(8);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngModel", ɵngcc0.ɵɵpipeBind2(2, 5, ctx.value ? ctx.value.toString() : "", ctx.inputDatetimeFormat))("disabled", ctx.disabled)("placeholder", ctx.inputDatetimeFormat);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngbPopover", _r1)("disabled", ctx.disabled);
    } }, directives: [ɵngcc5.DefaultValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.NgModel, ɵngcc4.NgbPopover, ɵngcc1.NgIf, ɵngcc4.NgbDatepicker, ɵngcc4.NgbTimepicker], pipes: [ɵngcc1.DatePipe], styles: [""] });
DatetimePickerComponent.ctorParameters = () => [
    { type: NgbPopoverConfig }
];
DatetimePickerComponent.propDecorators = {
    disabled: [{ type: Input }],
    opacity: [{ type: HostBinding, args: ['style.opacity',] }],
    inputDatetimeFormat: [{ type: Input }],
    hourStep: [{ type: Input }],
    minuteStep: [{ type: Input }],
    secondStep: [{ type: Input }],
    seconds: [{ type: Input }],
    maxDate: [{ type: Input }],
    minDate: [{ type: Input }],
    popover: [{ type: ViewChild, args: ['popOver',] }],
    change: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DatetimePickerComponent, [{
        type: Component,
        args: [{
                selector: 'ws-datetime-picker',
                template: "<div class=\"input-group mr-2\">\n  <input class=\"form-control form-control-sm\" (blur)=\"inputBlur($event)\"\n    [ngModel]=\"(value ? value.toString() : '') | date:inputDatetimeFormat\" (change)=\"onInputChange($event)\" [disabled]='disabled'\n    [placeholder]=\"inputDatetimeFormat\" />\n\n  <div class=\"input-group-append\">\n    <button class=\"btn btn-outline-secondary btn-sm\" [ngbPopover]=\"calendarContent\" #popOver=\"ngbPopover\" [disabled]='disabled' type=\"button\">\n      <i class=\"fa fa-calendar\"></i>\n    </button>\n  </div>\n</div>\n\n\n<ng-template #calendarContent>\n  <div>\n    <div *ngIf=\"!showTimePickerToggle\">\n      <ngb-datepicker #dp name=\"datepicker\" [ngModel]=\"value\" (ngModelChange)=\"onDateChange($event)\" [minDate]=\"minDate\" [maxDate]=\"maxDate\"></ngb-datepicker>\n      <button class=\"btn btn-block btn-outline-secondary\" [disabled]=\"!value?.day\" [ngbPopover]=\"timePickerContent\"\n        type=\"button\" (click)=\"toggleDateTimeState();\">\n        <i class=\"fa fa-clock-o\"></i>\n      </button>\n      <button class=\"btn btn-block btn-outline-secondary\" type=\"button\" (click)=\"onAccept()\">\n        <i class=\"fa fa-check\"></i>\n      </button>\n    </div>\n    <div *ngIf=\"showTimePickerToggle\">\n      <button class=\"btn btn-block btn-outline-secondary\" type=\"button\" (click)=\"toggleDateTimeState();\">\n        <i class=\"fa fa-calendar\"></i>\n      </button>\n      <button class=\"btn btn-block btn-outline-secondary\" type=\"button\" (click)=\"onAccept()\">\n        <i class=\"fa fa-check\"></i>\n      </button>\n      <div class=\"mt-auto\">\n        <ngb-timepicker #tp name=\"timepicker\" [ngModel]=\"value\" (ngModelChange)=\"onTimeChange($event)\"\n          [seconds]=\"seconds\" [hourStep]=\"hourStep\" [minuteStep]=\"minuteStep\" [secondStep]=\"secondStep\">\n        </ngb-timepicker>\n      </div>\n    </div>\n  </div>\n</ng-template>\n\n<ng-template #timePickerContent>\n  timepicker here!\n</ng-template>\n",
                providers: [
                    DatePipe,
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DatetimePickerComponent),
                        multi: true
                    }
                ],
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc4.NgbPopoverConfig }]; }, { disabled: [{
            type: Input
        }], inputDatetimeFormat: [{
            type: Input
        }], hourStep: [{
            type: Input
        }], minuteStep: [{
            type: Input
        }], secondStep: [{
            type: Input
        }], seconds: [{
            type: Input
        }], minDate: [{
            type: Input
        }], change: [{
            type: Output
        }], opacity: [{
            type: HostBinding,
            args: ['style.opacity']
        }], maxDate: [{
            type: Input
        }], popover: [{
            type: ViewChild,
            args: ['popOver']
        }] }); })();

class SortPipe {
    transform(items, direction, property) {
        // default direction ascending
        direction = direction === null || direction === undefined ? 'asc' : direction;
        return items.sort((a, b) => {
            // handle arrays or objects
            const left = property === null || property === undefined ? a : a[property];
            const right = property === null || property === undefined ? b : b[property];
            // if equal weighting is the same
            if (left === right) {
                return 0;
            }
            // handle ascending and descening sorts
            if (direction === 'desc') {
                return left < right ? 1 : -1;
            }
            else {
                return left < right ? -1 : 1;
            }
        });
    }
}
SortPipe.ɵfac = function SortPipe_Factory(t) { return new (t || SortPipe)(); };
SortPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "wsSort", type: SortPipe, pure: true });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SortPipe, [{
        type: Pipe,
        args: [{
                name: 'wsSort'
            }]
    }], null, null); })();

class OrdinalUtil {
    // standard suffix implementation
    static applyDefault(i) {
        const j = i % 10;
        const k = i % 100;
        if (i === 1 && k !== 11) {
            return i + 'st';
        }
        if (j === 2 && k !== 12) {
            return i + 'nd';
        }
        if (j === 3 && k !== 13) {
            return i + 'nd';
        }
        return i + 'th';
    }
}

class PollResultComponent {
    constructor() { }
    ngOnInit() {
        this.init();
    }
    // tslint:disable-next-line:use-lifecycle-interface typedef
    ngOnChanges() {
        this.init();
    }
    init() {
        this.max = this.results.map(x => x.points).reduce((acc, cur) => acc + cur, 0);
    }
    getPeople(option) {
        let records = [];
        // if anonymous, option id will be blank    this.max = this.tracks.map(x => x.weight).reduce((acc, cur) => acc + cur, 0);
        if (this.poll && this.tracks && !this.poll.anonymousVoting) {
            records = this.tracks.filter(t => t.option.id === option.id);
        }
        return records;
    }
    // displays within the voer tile
    getVoter(track) {
        if (!GenericUtil.isNullOrUndefined(track.relativePosition)) {
            if (!GenericUtil.isNullOrUndefined(track.relativePosition.memberCode)) {
                return track.relativePosition.memberCode;
            }
            else {
                return `${track.firstName} ${track.lastName}`;
            }
        }
        return `${track.firstName} ${track.lastName}`;
    }
    // displays when howvering over the voter tile
    getVoterHover(track) {
        if (!GenericUtil.isNullOrUndefined(track.relativePosition)) {
            if (!GenericUtil.isNullOrUndefined(track.relativePosition.memberCode)) {
                return `${track.firstName} ${track.lastName} - ${track.relativePosition.memberCode} ${track.relativePosition.name}`;
            }
            else {
                return `${track.firstName} ${track.lastName} - ${track.relativePosition.name}`;
            }
        }
        return `${track.firstName} ${track.lastName}`;
    }
    countVotes(option) {
        if (!this.poll || !this.results) {
            return 0;
        }
        if (this.max === 0) {
            return 0;
        }
        const result = this.results.find(x => x.option.id === option.id);
        return result ? result.count : 0;
    }
    countPoints(option) {
        if (!this.poll || !this.results) {
            return 0;
        }
        if (this.max === 0) {
            return 0;
        }
        const points = this.results.filter(x => x.option.id === option.id).map(x => x.points);
        return points.length > 0 ? points.reduce((acc, cur) => acc + cur, 0) : 0;
    }
    showVoteIndex() {
        if (!this.poll) {
            return false;
        }
        return this.poll.type === 'weighted' || this.poll.type === 'multiselect';
    }
    getVoteIndex(track) {
        return OrdinalUtil.applyDefault(track.voteIndex);
    }
}
PollResultComponent.ɵfac = function PollResultComponent_Factory(t) { return new (t || PollResultComponent)(); };
PollResultComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: PollResultComponent, selectors: [["ws-poll-result"]], inputs: { poll: "poll", results: "results", tracks: "tracks" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["class", "poll-result", 4, "ngIf"], [1, "poll-result"], [4, "ngFor", "ngForOf"], ["type", "success", "triggers", "mouseenter:mouseleave", 3, "showValue", "value", "max", "ngbPopover"], [1, "member-list", "row"], ["class", "member-block", 4, "ngFor", "ngForOf"], [1, "member-block"], ["triggers", "mouseenter:mouseleave", 1, "member", "bg-primary", 3, "ngbPopover"], [1, "text"], [4, "ngIf"], ["class", "badge badge-pill badge-dark", 4, "ngIf"], [1, "badge", "badge-pill", "badge-dark"]], template: function PollResultComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, PollResultComponent_div_0_Template, 3, 5, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.results);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgForOf, ɵngcc4.NgbProgressbar, ɵngcc4.NgbPopover], pipes: [SortPipe, ɵngcc2.TranslatePipe], styles: [".member-list[_ngcontent-%COMP%]{list-style-type:none;padding:0}.member-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{padding:5px}.member-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   .member[_ngcontent-%COMP%]{border:1px solid hsla(0,0%,80%,.8);padding:5px}.member-list[_ngcontent-%COMP%]   .bg-primary[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%]{color:#fff}.member-block[_ngcontent-%COMP%]{float:left}"] });
PollResultComponent.ctorParameters = () => [];
PollResultComponent.propDecorators = {
    poll: [{ type: Input }],
    results: [{ type: Input }],
    tracks: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PollResultComponent, [{
        type: Component,
        args: [{
                selector: 'ws-poll-result',
                template: "<div *ngIf=\"results\" class=\"poll-result\">\n  <p *ngFor=\"let option of poll.options | wsSort: 'asc': 'id'\">\n    <strong>{{ option.text.text }}</strong><br />\n    <ngb-progressbar [showValue]=\"false\" type=\"success\" [value]=\"countPoints(option)\" [max]=\"max\" ngbPopover=\"{{ countPoints(option) }} points, {{ countVotes(option) }} votes\"\n    triggers=\"mouseenter:mouseleave\">\n      {{ countPoints(option) }} {{ 'polls.points' | translate }}, {{ countVotes(option) }} {{ 'polls.votes' | translate }}</ngb-progressbar>\n      <span>\n\n      <ul class=\"member-list row\">\n          <li class=\"member-block\" *ngFor=\"let track of getPeople(option)\">\n              <div class=\"member bg-primary\"  ngbPopover=\"{{ getVoterHover(track) }}\"\n              triggers=\"mouseenter:mouseleave\">\n                  <span class=\"text\">{{ getVoter(track) }}</span>\n                  <span *ngIf=\"showVoteIndex\">&nbsp;</span>\n                  <span *ngIf=\"showVoteIndex\" class=\"badge badge-pill badge-dark\">{{ getVoteIndex(track) }}</span>\n              </div>\n          </li>\n      </ul>\n      </span>\n  </p>\n</div>\n",
                styles: [".member-list{list-style-type:none;padding:0}.member-list li{padding:5px}.member-list li .member{border:1px solid hsla(0,0%,80%,.8);padding:5px}.member-list .bg-primary .text{color:#fff}.member-block{float:left}"]
            }]
    }], function () { return []; }, { poll: [{
            type: Input
        }], results: [{
            type: Input
        }], tracks: [{
            type: Input
        }] }); })();

class StandardPollComponent {
    constructor() {
        this.optionSelected = new EventEmitter();
    }
    ngOnInit() {
        this.init();
    }
    // tslint:disable-next-line:use-lifecycle-interface typedef
    ngOnChanges() {
        this.init();
    }
    init() {
        if (this.initialSelection) {
            if (this.initialSelection.length > 0) {
                this.selection = this.initialSelection[0];
            }
            else {
                this.loadDefaultSelection();
            }
        }
        else {
            this.loadDefaultSelection();
        }
    }
    loadDefaultSelection() {
        this.selection = { rank: 1, optionId: null };
    }
    isSelected(option) {
        if (!this.selection) {
            return false;
        }
        return this.selection.optionId === option.id;
    }
    onOptionSelect(option) {
        let model = [this.selection.optionId];
        model = this.optionHandler.onOptionSelect(this.poll.type, model, option.id, 0);
        const entry = { rank: 1, optionId: model[0] };
        this.optionSelected.emit([entry]);
    }
}
StandardPollComponent.ɵfac = function StandardPollComponent_Factory(t) { return new (t || StandardPollComponent)(); };
StandardPollComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: StandardPollComponent, selectors: [["ws-standard-poll"]], inputs: { poll: "poll", voted: "voted", initialSelection: "initialSelection", optionHandler: "optionHandler" }, outputs: { optionSelected: "optionSelected" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 3, vars: 5, consts: [[1, "list-group"], ["class", "list-group-item", 3, "ngClass", 4, "ngFor", "ngForOf"], [1, "list-group-item", 3, "ngClass"], [1, "form-check"], [1, "form-check-label"], ["type", "radio", "name", "questions", 1, "form-check-input", 3, "disabled", "checked", "value", "ngModel", "ngModelChange", "click"]], template: function StandardPollComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "ul", 0);
        ɵngcc0.ɵɵtemplate(1, StandardPollComponent_li_1_Template, 5, 8, "li", 1);
        ɵngcc0.ɵɵpipe(2, "wsSort");
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind3(2, 1, ctx.poll.options, "asc", "id"));
    } }, directives: [ɵngcc1.NgForOf, ɵngcc1.NgClass, ɵngcc5.RadioControlValueAccessor, ɵngcc5.DefaultValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.NgModel], pipes: [SortPipe], styles: [""] });
StandardPollComponent.ctorParameters = () => [];
StandardPollComponent.propDecorators = {
    poll: [{ type: Input }],
    voted: [{ type: Input }],
    initialSelection: [{ type: Input }],
    optionSelected: [{ type: Output }],
    optionHandler: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(StandardPollComponent, [{
        type: Component,
        args: [{
                selector: 'ws-standard-poll',
                template: "<ul class=\"list-group\">\n  <li *ngFor=\"let option of poll.options | wsSort: 'asc': 'id'\" class=\"list-group-item\"\n    [ngClass]=\"{active: voted.hasVoted && isSelected(option)}\">\n    <div class=\"form-check\">\n      <label class=\"form-check-label\">\n        <input type=\"radio\" class=\"form-check-input\" name=\"questions\" [disabled]=\"voted.hasVoted\"\n          [checked]=\"isSelected(option)\" [value]=\"option.id\" [(ngModel)]=\"selection.optionId\"\n          (click)=\"onOptionSelect(option)\" />{{ option.text.text }}\n      </label>\n    </div>\n  </li>\n</ul>\n",
                styles: [""]
            }]
    }], function () { return []; }, { optionSelected: [{
            type: Output
        }], poll: [{
            type: Input
        }], voted: [{
            type: Input
        }], initialSelection: [{
            type: Input
        }], optionHandler: [{
            type: Input
        }] }); })();

class WeightedPollComponent {
    constructor() {
        this.optionSelected = new EventEmitter();
    }
    ngOnInit() {
        this.init();
    }
    init() {
        // this.selection = [];
        // ensure variables
        this.numSelections = [];
        this.models = [];
        // loop for number of select boxes to show
        this.numSelections = Array(this.poll.numberOfSelections).fill(0).map((x, i) => i);
        // ensure each select box has a model to bind to
        this.numSelections.forEach(num => {
            const selected = this.initialSelection.find(x => x.rank === num + 1);
            if (selected) {
                this.models.push(selected.optionId.toString()); // handle initial selection
            }
            else {
                this.models.push('0'); // ensure the selection text is displayed
            }
        });
    }
    change(event, index) {
        this.models = this.optionHandler.onOptionSelect(this.poll.type, this.models, event.target.value, index);
        if (event.target.value === '0') {
            this.optionSelected.emit([]);
        }
        else {
            // emit selection only if all options are selected
            if (this.hasMaxSelections()) {
                const output = [];
                this.models.forEach((id, i) => {
                    const entry = { rank: i + 1, optionId: id };
                    output.push(entry);
                });
                this.optionSelected.emit(output);
            }
        }
    }
    hasMaxSelections() {
        // if there are no unset options, we have max selection
        return this.models.filter(x => x === '0').length === 0;
    }
    // convert this to an algorithm if the design works out
    numberToWord(num) {
        if (num < 0) {
            return null;
        }
        // TODO: Convert this to an algo
        const word = ['zero', 'first', 'second', 'third', 'fourth', 'fifth', 'sixth', 'seventh', 'eight', 'ninth', 'tenth'];
        return word[num];
    }
    calcPointsForItem(num) {
        return this.poll.numberOfSelections - num;
    }
    isSelected(optionId) {
        return this.models.findIndex(x => x === String(optionId)) !== -1;
    }
}
WeightedPollComponent.ɵfac = function WeightedPollComponent_Factory(t) { return new (t || WeightedPollComponent)(); };
WeightedPollComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: WeightedPollComponent, selectors: [["ws-weighted-poll"]], inputs: { poll: "poll", voted: "voted", initialSelection: "initialSelection", optionHandler: "optionHandler" }, outputs: { optionSelected: "optionSelected" }, decls: 2, vars: 1, consts: [[1, "list-group"], ["class", "list-group-item", 4, "ngFor", "ngForOf"], [1, "list-group-item"], [1, "form-control", 3, "ngModel", "disabled", "ngModelChange", "change"], ["value", "0"], [3, "disabled", "value", 4, "ngFor", "ngForOf"], [3, "disabled", "value"]], template: function WeightedPollComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "ul", 0);
        ɵngcc0.ɵɵtemplate(1, WeightedPollComponent_li_1_Template, 8, 15, "li", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.numSelections);
    } }, directives: [ɵngcc1.NgForOf, ɵngcc5.SelectControlValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.NgModel, ɵngcc5.NgSelectOption, ɵngcc5.ɵangular_packages_forms_forms_x], pipes: [ɵngcc2.TranslatePipe, SortPipe], styles: [""] });
WeightedPollComponent.ctorParameters = () => [];
WeightedPollComponent.propDecorators = {
    poll: [{ type: Input }],
    voted: [{ type: Input }],
    initialSelection: [{ type: Input }],
    optionHandler: [{ type: Input }],
    optionSelected: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(WeightedPollComponent, [{
        type: Component,
        args: [{
                selector: 'ws-weighted-poll',
                template: "<ul class=\"list-group\">\n  <li class=\"list-group-item\" *ngFor=\"let num of numSelections\">\n    <select class=\"form-control\" [(ngModel)]=\"models[num]\" (change)=\"change($event, num)\" [disabled]=\"voted.hasVoted\">\n      <option value=\"0\">{{ numberToWord(num + 1) }} {{ 'polls.selection' | translate }} ({{ calcPointsForItem(num) }} {{ 'polls.points' | translate }})</option>\n      <option [disabled]=\"isSelected(option.id)\" *ngFor=\"let option of poll.options | wsSort: 'asc': id\" value=\"{{ option.id }}\">{{ option.text.text }}</option>\n    </select>\n  </li>\n</ul>\n",
                styles: [""]
            }]
    }], function () { return []; }, { optionSelected: [{
            type: Output
        }], poll: [{
            type: Input
        }], voted: [{
            type: Input
        }], initialSelection: [{
            type: Input
        }], optionHandler: [{
            type: Input
        }] }); })();

var WSIDateFormat;
(function (WSIDateFormat) {
    WSIDateFormat["default"] = "d MMMM yyyy";
    WSIDateFormat["defaultWithDay"] = "EEEE, d MMMM yyyy";
    WSIDateFormat["numeric"] = "dd.MM.yy";
})(WSIDateFormat || (WSIDateFormat = {}));

class VoteControlComponent {
    constructor() {
        // events
        this.edit = new EventEmitter();
        this.extend = new EventEmitter();
        // tslint:disable-next-line:no-output-native
        this.reset = new EventEmitter();
        this.delete = new EventEmitter();
        this.viewChange = new EventEmitter();
        this.voteSelected = new EventEmitter();
        this.abstainSelected = new EventEmitter();
        this.voteRemoved = new EventEmitter();
        this.exportClicked = new EventEmitter();
    }
    ngOnInit() {
        this.view = 'question';
        this.dateFormat = `${WSIDateFormat.default}`;
        this.init();
    }
    // tslint:disable-next-line:use-lifecycle-interface typedef
    ngOnChanges() {
        this.init();
    }
    init() {
        if (this.poll && this.results && this.voted) {
            this.selection = this.voted.votes;
            this.calculateState();
        }
    }
    calculateState() {
        this.state = 'running';
        const now = new Date();
        const start = toDate(this.poll.start);
        const expiry = toDate(this.poll.expiry);
        if (now < start) {
            this.state = 'Not yet started';
            this.view = 'result';
            return;
        }
        if (now > expiry) {
            this.state = 'expired';
            this.view = 'result';
            return;
        }
    }
    selected(model) {
        this.selection = model;
    }
    vote() {
        if (this.voted.hasVoted) {
            alert('You have already voted');
        }
        else {
            if (this.confirmBeforeVote) {
                const voteSelections = [];
                this.selection.forEach(selected => {
                    // tslint:disable-next-line:triple-equals
                    const option = this.poll.options.find(x => x.id == selected.optionId);
                    voteSelections.push(option.text.text);
                });
                if (confirm(`Are you sure you want to vote for (${voteSelections.join(',')})`)) {
                    this.voteSelected.emit(this.selection);
                }
            }
            else {
                this.voteSelected.emit(this.selection);
            }
        }
    }
    abstain() {
        if (this.voted.hasVoted) {
            alert('You have already voted');
        }
        else {
            if (this.confirmBeforeAbstain) {
                if (confirm(`Are you sure you wish to abstain from voting ?`)) {
                    this.abstainSelected.emit();
                }
            }
            else {
                this.abstainSelected.emit();
            }
        }
    }
    unvote() {
        this.voteRemoved.emit(this.selection);
    }
    changeView(view) {
        this.view = view;
        this.viewChange.emit(view);
    }
    viewResultsState() {
        if (this.view === 'result') {
            return false;
        }
        if (!this.poll) {
            return false;
        }
        if (this.poll.anonymousResults) {
            return false;
        }
        // allow the owner to view results at anytime
        if (this.isOwner) {
            return true;
        }
        const time = new Date().getTime();
        const end = toDate(this.poll.expiry).getTime();
        if (this.poll.showingResults || time > end) {
            return true;
        }
        return false;
    }
    hasVotesSelected() {
        if (GenericUtil.isNullOrUndefined(this.selection)) {
            return true;
        }
        return this.selection.length === 0;
    }
    editClick(poll) {
        this.edit.emit(poll);
    }
    extendClick(poll) {
        this.extend.emit(poll);
    }
    resetClick(poll) {
        this.reset.emit(poll);
    }
    deleteClick(poll) {
        this.delete.emit(poll);
    }
    getVoteText(entry) {
        // tslint:disable-next-line:triple-equals
        const option = this.poll.options.find(x => x.id == entry.optionId);
        if (option == null) {
            return '';
        }
        return option.text.text;
    }
    showVoteButton() {
        return this.voted && !this.voted.hasVoted && this.view === 'question' && this.state === 'running';
    }
    showAbstainButton() {
        return this.voted && !this.voted.hasVoted && this.poll.allowingAbstain && this.view === 'question' && this.state === 'running';
    }
    showClearVoteButton() {
        return this.poll && this.voted && this.voted.hasVoted && this.view === 'question' && this.poll.allowingReVote
            && this.state === 'running';
    }
    showManageButton() {
        return this.showDeleteButton || this.showEditButton || this.showExtendButton
            || this.showResetButton || (this.view === 'result' && this.showExportButton);
    }
    export() {
        this.exportClicked.emit(new Date());
    }
    useDateRange() {
        if (GenericUtil.isNullOrUndefined(this.poll)) {
            return false;
        }
        const sameMonth = this.poll.start.getMonth() === this.poll.expiry.getMonth();
        const sameYear = this.poll.start.getFullYear() === this.poll.expiry.getFullYear();
        return sameMonth && sameYear;
    }
}
VoteControlComponent.ɵfac = function VoteControlComponent_Factory(t) { return new (t || VoteControlComponent)(); };
VoteControlComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VoteControlComponent, selectors: [["ws-vote-control"]], inputs: { showEditButton: "showEditButton", showExtendButton: "showExtendButton", showResetButton: "showResetButton", showDeleteButton: "showDeleteButton", showExportButton: "showExportButton", poll: "poll", results: "results", voted: "voted", tracks: "tracks", confirmBeforeVote: "confirmBeforeVote", confirmBeforeAbstain: "confirmBeforeAbstain", optionHandler: "optionHandler", isOwner: "isOwner", beforeOptionsTemplate: "beforeOptionsTemplate", optionsDefaultTemplate: "optionsDefaultTemplate", optionsTemplate: "optionsTemplate", afterOptionsTemplate: "afterOptionsTemplate", beforeResultTemplate: "beforeResultTemplate", resultDefaultTemplate: "resultDefaultTemplate", resultTemplate: "resultTemplate", afterResultTemplate: "afterResultTemplate", controlBarLeftTemplate: "controlBarLeftTemplate", controlBarRightTemplate: "controlBarRightTemplate", titleTemplate: "titleTemplate", footerTemplate: "footerTemplate", questionTemplate: "questionTemplate" }, outputs: { edit: "edit", extend: "extend", reset: "reset", delete: "delete", viewChange: "viewChange", voteSelected: "voteSelected", abstainSelected: "abstainSelected", voteRemoved: "voteRemoved", exportClicked: "exportClicked" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 17, vars: 1, consts: [["voteControlEmptyTemplate", ""], ["voteControlDefaultTitleTemplate", ""], ["voteControlDefaultFooterTemplate", ""], ["voteControlDefaultQuestionTemplate", ""], ["optionsDefaultTemplate", ""], ["resultDefaultTemplate", ""], ["controlBarLeftDefaultTemplate", ""], ["controlBarRightDefaultTemplate", ""], ["class", "card", 4, "ngIf"], [1, "text-muted"], [4, "ngIf"], ["triggers", "mouseenter:mouseleave", 3, "ngbPopover", 4, "ngIf"], ["triggers", "mouseenter:mouseleave", 3, "ngbPopover"], [4, "ngFor", "ngForOf"], [3, "poll", "voted", "initialSelection", "optionHandler", "optionSelected", 4, "ngIf"], [3, "poll", "voted", "initialSelection", "optionHandler", "optionSelected"], [3, "poll", "results", "tracks", 4, "ngIf"], [3, "poll", "results", "tracks"], ["class", "btn btn-success", "href", "#", 3, "disabled", "click", 4, "ngIf"], ["class", "btn btn-warning", "href", "#", 3, "click", 4, "ngIf"], ["class", "btn btn-primary", "href", "#", 3, "click", 4, "ngIf"], ["href", "#", 1, "btn", "btn-success", 3, "disabled", "click"], [1, "fa", "fa-check"], ["href", "#", 1, "btn", "btn-warning", 3, "click"], [1, "fa", "fa-ban"], [1, "fa", "fa-close"], ["href", "#", 1, "btn", "btn-primary", 3, "click"], [1, "fa", "fa-area-chart"], [1, "fa", "fa-question-circle"], [1, "btn-group"], ["type", "button", "data-toggle", "dropdown", "aria-haspopup", "true", "aria-expanded", "false", 1, "btn", "btn-primary", "dropdown-toggle"], [1, "dropdown-menu"], ["class", "dropdown-item", "href", "#", 3, "click", 4, "ngIf"], ["href", "#", 1, "dropdown-item", 3, "click"], [1, "fa", "fa-download"], [1, "fa", "fa-refresh"], [1, "fa", "fa-arrows-h"], [1, "fa", "fa-edit"], [1, "fa", "fa-trash"], [1, "card"], [1, "card-header"], [4, "ngTemplateOutlet"], [1, "card-body"], [1, "card-title"], ["class", "card-text", 4, "ngIf"], [1, "pull-left"], [1, "pull-right"], [1, "card-footer", "text-muted"], [1, "card-text"]], template: function VoteControlComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, VoteControlComponent_ng_template_0_Template, 0, 0, "ng-template", null, 0, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(2, VoteControlComponent_ng_template_2_Template, 5, 6, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(4, VoteControlComponent_ng_template_4_Template, 8, 6, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(6, VoteControlComponent_ng_template_6_Template, 1, 1, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(8, VoteControlComponent_ng_template_8_Template, 2, 2, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(10, VoteControlComponent_ng_template_10_Template, 1, 1, "ng-template", null, 5, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(12, VoteControlComponent_ng_template_12_Template, 10, 5, "ng-template", null, 6, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(14, VoteControlComponent_ng_template_14_Template, 9, 5, "ng-template", null, 7, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(16, VoteControlComponent_div_16_Template, 15, 7, "div", 8);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(16);
        ɵngcc0.ɵɵproperty("ngIf", ctx.poll);
    } }, directives: function () { return [ɵngcc1.NgIf, ɵngcc4.NgbPopover, ɵngcc1.NgForOf, StandardPollComponent, WeightedPollComponent, MultiselectPollComponent, PollResultComponent, ɵngcc1.NgTemplateOutlet]; }, pipes: function () { return [ɵngcc2.TranslatePipe, ɵngcc1.DatePipe]; }, styles: [""] });
VoteControlComponent.ctorParameters = () => [];
VoteControlComponent.propDecorators = {
    showEditButton: [{ type: Input }],
    showExtendButton: [{ type: Input }],
    showResetButton: [{ type: Input }],
    showDeleteButton: [{ type: Input }],
    showExportButton: [{ type: Input }],
    poll: [{ type: Input }],
    results: [{ type: Input }],
    voted: [{ type: Input }],
    tracks: [{ type: Input }],
    confirmBeforeVote: [{ type: Input }],
    confirmBeforeAbstain: [{ type: Input }],
    optionHandler: [{ type: Input }],
    isOwner: [{ type: Input }],
    beforeOptionsTemplate: [{ type: Input }],
    optionsDefaultTemplate: [{ type: Input }],
    optionsTemplate: [{ type: Input }],
    afterOptionsTemplate: [{ type: Input }],
    beforeResultTemplate: [{ type: Input }],
    resultDefaultTemplate: [{ type: Input }],
    resultTemplate: [{ type: Input }],
    afterResultTemplate: [{ type: Input }],
    controlBarLeftTemplate: [{ type: Input }],
    controlBarRightTemplate: [{ type: Input }],
    titleTemplate: [{ type: Input }],
    footerTemplate: [{ type: Input }],
    questionTemplate: [{ type: Input }],
    edit: [{ type: Output }],
    extend: [{ type: Output }],
    reset: [{ type: Output }],
    delete: [{ type: Output }],
    viewChange: [{ type: Output }],
    voteSelected: [{ type: Output }],
    abstainSelected: [{ type: Output }],
    voteRemoved: [{ type: Output }],
    exportClicked: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VoteControlComponent, [{
        type: Component,
        args: [{
                selector: 'ws-vote-control',
                template: "<ng-template #voteControlEmptyTemplate>\n</ng-template>\n<ng-template #voteControlDefaultTitleTemplate>\n  {{ poll.title.text }}\n  <br />\n  <small class=\"text-muted\">{{ 'polls.created.by' | translate }}: {{ poll.createdBy.firstName }} {{ poll.createdBy.lastName }}</small>\n</ng-template>\n<ng-template #voteControlDefaultFooterTemplate>\n  <small class=\"text-muted\"><strong>{{ 'polls.status' | translate }}:</strong> {{ state }} </small>&nbsp;|&nbsp;\n  <span *ngIf=\"!useDateRange()\">\n    <span *ngIf=\"poll.start\">\n      {{ poll.start | date: dateFormat }} {{ 'polls.to' | translate }} {{ poll.expiry | date: dateFormat }}\n    </span>\n  </span>\n  <span *ngIf=\"useDateRange()\">\n    <span *ngIf=\"poll.start\" ngbPopover=\"{{ poll.start | date: dateFormat }} to {{ poll.expiry | date: dateFormat }}\" triggers=\"mouseenter:mouseleave\">\n      {{ poll.start | date: 'd' }}-{{ poll.expiry | date: dateFormat }}\n    </span>\n  </span>\n</ng-template>\n<ng-template #voteControlDefaultQuestionTemplate>\n  {{ poll.question.text }}\n</ng-template>\n<ng-template #optionsDefaultTemplate>\n  <div *ngIf=\"voted.hasVoted\">\n    <em>{{ 'polls.messages.voted' | translate }}</em>\n    <div *ngIf=\"voted.abstained\">\n      <strong>{{ 'polls.messages.abstained' | translate }}</strong>\n    </div>\n    <div *ngIf=\"voted.anonymous\">\n      <strong>{{ 'polls.messages.anon' | translate }}</strong>\n    </div>\n    <div *ngIf=\"!voted.abstained && !voted.anonymous\">\n      <strong>{{ 'polls.messages.choices' | translate }}</strong>\n      <ol>\n        <li *ngFor=\"let entry of voted.votes\">\n          {{ getVoteText(entry) }}\n        </li>\n      </ol>\n    </div>\n  </div>\n  <div *ngIf=\"!voted.hasVoted\">\n    <ws-standard-poll *ngIf=\"poll.type === 'standard'\" [poll]=\"poll\" [voted]=\"voted\" [initialSelection]=\"selection\"\n      [optionHandler]=\"optionHandler\" (optionSelected)=\"selected($event)\">\n    </ws-standard-poll>\n    <ws-weighted-poll *ngIf=\"poll.type === 'weighted'\" [poll]=\"poll\" [voted]=\"voted\" [initialSelection]=\"selection\"\n      [optionHandler]=\"optionHandler\" (optionSelected)=\"selected($event)\">\n    </ws-weighted-poll>\n    <ws-multiselect-poll *ngIf=\"poll.type === 'multiselect'\" [poll]=\"poll\" [voted]=\"voted\"\n      [initialSelection]=\"selection\" [optionHandler]=\"optionHandler\" (optionSelected)=\"selected($event)\">\n    </ws-multiselect-poll>\n  </div>\n</ng-template>\n<ng-template #resultDefaultTemplate>\n  <ws-poll-result *ngIf=\"results\" [poll]=\"poll\" [results]=\"results\" [tracks]=\"tracks\"></ws-poll-result>\n</ng-template>\n\n<ng-template #controlBarLeftDefaultTemplate>\n  <button [disabled]=\"hasVotesSelected()\" *ngIf=\"showVoteButton()\" class=\"btn btn-success\" href=\"#\"\n    (click)=\"vote(); false;\"><i class=\"fa fa-check\"></i>&nbsp; {{ 'polls.buttons.vote' | translate }}</button>&nbsp;\n  <button *ngIf=\"showAbstainButton()\" class=\"btn btn-warning\" href=\"#\" (click)=\"abstain(); false;\"><i\n      class=\"fa fa-ban\"></i>&nbsp; {{ 'polls.buttons.abstain' | translate }}</button>&nbsp;\n  <button *ngIf=\"showClearVoteButton()\" class=\"btn btn-warning\" href=\"#\" (click)=\"unvote(); false;\"><i\n      class=\"fa fa-close\"></i>&nbsp; {{ 'polls.buttons.clear.vote' | translate }}</button>&nbsp;\n  <button *ngIf=\"viewResultsState() && state === 'running'\" class=\"btn btn-primary\" href=\"#\"\n    (click)=\"changeView('result'); false;\"><i class=\"fa fa-area-chart\"></i>&nbsp; {{ 'polls.buttons.view.results' | translate }}</button>&nbsp;\n  <button *ngIf=\"view === 'result' && state === 'running'\" class=\"btn btn-primary\" href=\"#\"\n    (click)=\"changeView('question'); false;\"><i class=\"fa fa-question-circle\"></i>&nbsp; {{ 'polls.buttons.view.choices' | translate }}</button>&nbsp;\n</ng-template>\n\n<ng-template #controlBarRightDefaultTemplate>\n  <!-- Example single danger button -->\n  <div class=\"btn-group\">\n    <button type=\"button\" class=\"btn btn-primary dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\"\n      aria-expanded=\"false\">\n      Manage\n    </button>\n    <div class=\"dropdown-menu\">\n      <a *ngIf=\"view === 'result' && showExportButton\" (click)=\"export(); false;\" class=\"dropdown-item\" href=\"#\">\n        <i class=\"fa fa-download\"></i>&nbsp;{{ 'polls.buttons.export.results' | translate }}\n      </a>\n      <a *ngIf=\"showResetButton\" (click)=\"resetClick(poll); false;\" class=\"dropdown-item\" href=\"#\">\n        <i class=\"fa fa-refresh\"></i>&nbsp;{{ 'polls.buttons.reset' | translate }}\n      </a>\n      <a *ngIf=\"showExtendButton\" (click)=\"extendClick(poll); false;\" class=\"dropdown-item\" href=\"#\">\n        <i class=\"fa fa-arrows-h\"></i>&nbsp;{{ 'polls.buttons.extend' | translate }}\n      </a>\n      <a *ngIf=\"showEditButton\" (click)=\"editClick(poll); false;\" class=\"dropdown-item\" href=\"#\">\n        <i class=\"fa fa-edit\"></i>&nbsp;{{ 'polls.buttons.edit' | translate }}\n      </a>\n      <a *ngIf=\"showDeleteButton\" (click)=\"deleteClick(poll); false;\" class=\"dropdown-item\" href=\"#\">\n        <i class=\"fa fa-trash\"></i>&nbsp;{{ 'polls.buttons.delete' | translate }}\n      </a>\n    </div>\n  </div>\n</ng-template>\n\n<div class=\"card\" *ngIf=\"poll\">\n  <div class=\"card-header\">\n    <ng-container *ngTemplateOutlet=\"titleTemplate ? titleTemplate : voteControlDefaultTitleTemplate\"></ng-container>\n  </div>\n  <div class=\"card-body\">\n    <div class=\"card-title\">\n      <ng-container *ngTemplateOutlet=\"questionTemplate ? questionTemplate : voteControlDefaultQuestionTemplate\">\n      </ng-container>\n    </div>\n    <div class=\"card-text\" *ngIf=\"view === 'question'\">\n      <ng-container *ngTemplateOutlet=\"beforeOptionsTemplate ? beforeOptionsTemplate : voteControlEmptyTemplate\">\n      </ng-container>\n      <ng-container *ngTemplateOutlet=\"optionsTemplate ? optionsTemplate : optionsDefaultTemplate\"></ng-container>\n      <ng-container *ngTemplateOutlet=\"afterOptionsTemplate ? afterOptionsTemplate : voteControlEmptyTemplate\">\n      </ng-container>\n    </div>\n    <div class=\"card-text\" *ngIf=\"view === 'result'\">\n      <ng-container *ngTemplateOutlet=\"beforeResultTemplate ? beforeResultTemplate : voteControlEmptyTemplate\">\n      </ng-container>\n      <ng-container *ngTemplateOutlet=\"resultTemplate ? resultTemplate : resultDefaultTemplate\"></ng-container>\n      <ng-container *ngTemplateOutlet=\"afterResultTemplate ? afterResultTemplate : voteControlEmptyTemplate\">\n      </ng-container>\n    </div>\n    <hr />\n\n    <div class=\"pull-left\">\n      <ng-container *ngTemplateOutlet=\"controlBarLeftTemplate ? controlBarLeftTemplate : controlBarLeftDefaultTemplate\">\n      </ng-container>\n    </div>\n    <div class=\"pull-right\">\n      <ng-container\n        *ngTemplateOutlet=\"controlBarRightTemplate ? controlBarRightTemplate : controlBarRightDefaultTemplate\">\n      </ng-container>\n    </div>\n  </div>\n  <div class=\"card-footer text-muted\">\n    <ng-container *ngTemplateOutlet=\"footerTemplate ? footerTemplate : voteControlDefaultFooterTemplate\"></ng-container>\n  </div>\n</div>",
                styles: [""]
            }]
    }], function () { return []; }, { edit: [{
            type: Output
        }], extend: [{
            type: Output
        }], reset: [{
            type: Output
        }], delete: [{
            type: Output
        }], viewChange: [{
            type: Output
        }], voteSelected: [{
            type: Output
        }], abstainSelected: [{
            type: Output
        }], voteRemoved: [{
            type: Output
        }], exportClicked: [{
            type: Output
        }], showEditButton: [{
            type: Input
        }], showExtendButton: [{
            type: Input
        }], showResetButton: [{
            type: Input
        }], showDeleteButton: [{
            type: Input
        }], showExportButton: [{
            type: Input
        }], poll: [{
            type: Input
        }], results: [{
            type: Input
        }], voted: [{
            type: Input
        }], tracks: [{
            type: Input
        }], confirmBeforeVote: [{
            type: Input
        }], confirmBeforeAbstain: [{
            type: Input
        }], optionHandler: [{
            type: Input
        }], isOwner: [{
            type: Input
        }], beforeOptionsTemplate: [{
            type: Input
        }], optionsDefaultTemplate: [{
            type: Input
        }], optionsTemplate: [{
            type: Input
        }], afterOptionsTemplate: [{
            type: Input
        }], beforeResultTemplate: [{
            type: Input
        }], resultDefaultTemplate: [{
            type: Input
        }], resultTemplate: [{
            type: Input
        }], afterResultTemplate: [{
            type: Input
        }], controlBarLeftTemplate: [{
            type: Input
        }], controlBarRightTemplate: [{
            type: Input
        }], titleTemplate: [{
            type: Input
        }], footerTemplate: [{
            type: Input
        }], questionTemplate: [{
            type: Input
        }] }); })();

class DefaultRelativeDateProccessor {
    /**
     * @deprecated The method should not be used. use tthe relative-date component instead
     */
    handlePastDate(date) {
        const now = new Date();
        const diff = ((now.getTime() - date.getTime()) / 1000);
        const daydiff = Math.floor(diff / 86400);
        if (isNaN(daydiff) || daydiff < 0 || daydiff >= 31) {
            return '';
        }
        return daydiff === 0 && (diff < 60 && 'Just now' ||
            diff < 120 && '1 minute ago' ||
            diff < 3600 && Math.floor(diff / 60) + ' minutes ago' ||
            diff < 7200 && '1 hour ago' ||
            diff < 86400 && Math.floor(diff / 3600) + ' hours ago') ||
            daydiff === 1 && 'Yesterday' ||
            daydiff < 7 && daydiff + ' days ago' ||
            daydiff === 7 && '1 week ago' ||
            daydiff < 31 && Math.ceil(daydiff / 7) + ' weeks ago';
    }
    /**
     * @deprecated The method should not be used. use tthe relative-date component instead
     */
    handleFutureDate(date) {
        const now = new Date();
        const diff = ((date.getTime() - now.getTime()) / 1000);
        const daydiff = Math.floor(diff / 86400);
        if (isNaN(daydiff) || daydiff < 0 || daydiff >= 31) {
            return '';
        }
        return daydiff === 0 && (diff < 60 && 'Soon' ||
            diff < 120 && '1 minute from now' ||
            diff < 3600 && Math.floor(diff / 60) + ' minutes from now' ||
            diff < 7200 && '1 hour from now' ||
            diff < 86400 && Math.floor(diff / 3600) + ' hours from now') ||
            daydiff === 1 && 'Tomorrow' ||
            daydiff < 7 && daydiff + ' days from now' ||
            daydiff === 7 && '1 week from now' ||
            daydiff < 31 && Math.ceil(daydiff / 7) + ' weeks from now';
    }
}

// based of: http://www.angulartutorial.net/2017/10/how-to-show-date-is-today-or-yesterday.html
class RelativeDatePipe {
    /**
     * @deprecated The method should not be used. use tthe relative-date component instead
     */
    transform(value, format, locale, processor) {
        processor = processor || new DefaultRelativeDateProccessor();
        const dt = new Date(value);
        const isDateValid = dt.toString() !== 'Invalid Date';
        if (!isDateValid) {
            return formatDate$1(value, format, locale);
        }
        format = format || 'MMM-dd-yyyy';
        locale = locale || 'en';
        const v = Number(value);
        const dif = Math.floor(((Date.now() - v) / 1000) / 86400);
        if (dif < 30) {
            const now = new Date();
            return value.getTime() < now.getTime() ? processor.handlePastDate(value) : processor.handleFutureDate(value);
        }
        else {
            return formatDate$1(value, format, locale);
        }
    }
}
RelativeDatePipe.ɵfac = function RelativeDatePipe_Factory(t) { return new (t || RelativeDatePipe)(); };
RelativeDatePipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "relativeDate", type: RelativeDatePipe, pure: true });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(RelativeDatePipe, [{
        type: Pipe,
        args: [{
                name: 'relativeDate'
            }]
    }], null, null); })();

class MultiselectPollComponent {
    constructor() {
        this.optionSelected = new EventEmitter();
    }
    ngOnInit() {
        this.init();
    }
    init() {
        // this.selection = [];
        // ensure variables
        this.numSelections = [];
        this.models = [];
        // loop for number of select boxes to show
        this.numSelections = Array(this.poll.numberOfSelections).fill(0).map((x, i) => i);
        // ensure each select box has a model to bind to
        this.numSelections.forEach(num => {
            const selected = this.initialSelection.find(x => x.rank === num + 1);
            if (selected) {
                this.models.push(selected.optionId.toString()); // handle initial selection
            }
            else {
                this.models.push('0'); // ensure the selection text is displayed
            }
        });
    }
    change(event, index) {
        // ensure we are not dealing with an unset action
        this.models = this.optionHandler.onOptionSelect(this.poll.type, this.models, event.target.value, index);
        if (event.target.value === '0') {
            this.optionSelected.emit([]);
        }
        else {
            // emit selection only if all options are selected
            if (this.hasMaxSelections()) {
                const output = [];
                this.models.forEach((id, i) => {
                    const entry = { rank: i + 1, optionId: id };
                    output.push(entry);
                });
                this.optionSelected.emit(output);
            }
        }
    }
    hasMaxSelections() {
        // if there are no unset options, we have max selection
        return this.models.filter(x => x === '0').length === 0;
    }
    // convert this to an algorithm if the design works out
    numberToWord(num) {
        if (num < 0) {
            return null;
        }
        // TODO: Convert this to an algo
        const word = ['zero', 'first', 'second', 'third', 'fourth', 'fifth', 'sixth', 'seventh', 'eight', 'ninth', 'tenth'];
        return word[num];
    }
    isSelected(optionId) {
        return this.models.findIndex(x => x === String(optionId)) !== -1;
    }
}
MultiselectPollComponent.ɵfac = function MultiselectPollComponent_Factory(t) { return new (t || MultiselectPollComponent)(); };
MultiselectPollComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MultiselectPollComponent, selectors: [["ws-multiselect-poll"]], inputs: { poll: "poll", voted: "voted", initialSelection: "initialSelection", optionHandler: "optionHandler" }, outputs: { optionSelected: "optionSelected" }, decls: 2, vars: 1, consts: [[1, "list-group"], ["class", "list-group-item", 4, "ngFor", "ngForOf"], [1, "list-group-item"], [1, "form-control", 3, "ngModel", "disabled", "ngModelChange", "change"], ["value", "0"], [3, "disabled", "value", 4, "ngFor", "ngForOf"], [3, "disabled", "value"]], template: function MultiselectPollComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "ul", 0);
        ɵngcc0.ɵɵtemplate(1, MultiselectPollComponent_li_1_Template, 6, 8, "li", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.numSelections);
    } }, directives: [ɵngcc1.NgForOf, ɵngcc5.SelectControlValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.NgModel, ɵngcc5.NgSelectOption, ɵngcc5.ɵangular_packages_forms_forms_x], pipes: [SortPipe], styles: [""] });
MultiselectPollComponent.ctorParameters = () => [];
MultiselectPollComponent.propDecorators = {
    poll: [{ type: Input }],
    voted: [{ type: Input }],
    initialSelection: [{ type: Input }],
    optionSelected: [{ type: Output }],
    optionHandler: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MultiselectPollComponent, [{
        type: Component,
        args: [{
                selector: 'ws-multiselect-poll',
                template: "<ul class=\"list-group\">\n    <li class=\"list-group-item\" *ngFor=\"let num of numSelections\">\n      <select class=\"form-control\" [(ngModel)]=\"models[num]\" (change)=\"change($event, num)\" [disabled]=\"voted.hasVoted\">\n        <option value=\"0\">{{ numberToWord(num + 1) }} selection (1 point)</option>\n        <option [disabled]=\"isSelected(option.id)\" *ngFor=\"let option of poll.options | wsSort: 'asc': id\" value=\"{{ option.id }}\">\n          {{ option.text.text }}\n        </option>\n      </select>\n    </li>\n  </ul>\n  ",
                styles: [""]
            }]
    }], function () { return []; }, { optionSelected: [{
            type: Output
        }], poll: [{
            type: Input
        }], voted: [{
            type: Input
        }], initialSelection: [{
            type: Input
        }], optionHandler: [{
            type: Input
        }] }); })();

class EntityTreeService {
    constructor(wsi, http) {
        this.wsi = wsi;
        this.http = http;
        this.subjects = [];
        this.subject = new BehaviorSubject(null);
        this.wsi.serviceConfigSubject.subscribe(next => {
            this.endpoint = next.apiEndpoint + '/auth/ws_entities';
        });
    }
    static equals(a, b) {
        return (a.limit === b.limit &&
            a.offset === b.offset &&
            a.depth === b.depth &&
            a.member_of === b.member_of &&
            a.name === b.name &&
            a.role === b.role &&
            a.roleApp === b.roleApp &&
            a.sort === b.sort);
    }
    clearCache(params = null) {
        if (params === null) {
            this.subjects = [];
        }
        else {
            const cacheEntryIndex = this.subjects.findIndex(cE => EntityTreeService.equals(cE.params, params));
            if (cacheEntryIndex >= 0) {
                this.subjects.splice(cacheEntryIndex, 1);
            }
        }
    }
    getCachedSubject(params = {}, fetchOnCreate = true) {
        const cacheEntry = this.subjects.find(cE => EntityTreeService.equals(cE.params, params));
        if (cacheEntry) {
            return cacheEntry.subject;
        }
        else {
            const newCacheEntry = {
                params,
                subject: new BehaviorSubject(null),
            };
            this.subjects.push(newCacheEntry);
            if (fetchOnCreate) {
                this.list(params);
            }
            return newCacheEntry.subject;
        }
    }
    list(params = {}) {
        let httpParams = new HttpParams();
        if (params.limit !== undefined) {
            httpParams = httpParams.set('limit', params.limit.toString());
        }
        if (params.offset !== undefined) {
            httpParams = httpParams.set('offset', params.offset.toString());
        }
        if (params.depth !== undefined) {
            httpParams = httpParams.set('depth', params.depth.toString());
        }
        if (params.member_of !== undefined) {
            httpParams = httpParams.set('member_of', params.member_of.toString());
        }
        if (params.name !== undefined) {
            httpParams = httpParams.set('name', params.name.toString());
        }
        if (params.role !== undefined) {
            httpParams = httpParams.set('role', params.role.toString());
        }
        if (params.roleApp !== undefined) {
            httpParams = httpParams.set('roleApp', params.roleApp.toString());
        }
        if (params.sort !== undefined) {
            httpParams = httpParams.set('sort', params.sort.toString());
        }
        const observable = this.http.get(this.endpoint, { params: httpParams }).pipe(share());
        const cacheEntry = this.subjects.find(cE => EntityTreeService.equals(cE.params, params));
        if (cacheEntry) {
            observable.subscribe(value => cacheEntry.subject.next(value));
        }
        observable.subscribe(value => this.subject.next(value));
        return observable;
    }
}
EntityTreeService.ɵfac = function EntityTreeService_Factory(t) { return new (t || EntityTreeService)(ɵngcc0.ɵɵinject(WorldskillsAngularLibService), ɵngcc0.ɵɵinject(ɵngcc6.HttpClient)); };
EntityTreeService.ɵprov = ɵɵdefineInjectable({ factory: function EntityTreeService_Factory() { return new EntityTreeService(ɵɵinject(WorldskillsAngularLibService), ɵɵinject(HttpClient)); }, token: EntityTreeService, providedIn: "root" });
EntityTreeService.ctorParameters = () => [
    { type: WorldskillsAngularLibService },
    { type: HttpClient }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EntityTreeService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: WorldskillsAngularLibService }, { type: ɵngcc6.HttpClient }]; }, null); })();

const DEFAULT_LABELS = {
    clearAllText: 'Clear all',
    loadingText: 'Loading entities...',
    notFoundText: 'No entities found',
    typeToSearchText: 'Type to search',
    placeholder: 'Select entity'
};

function isTreeEntity(obj) {
    return obj && typeof obj === 'object' && 'type' in obj && obj.type === 'treeEntity';
}
class EntityTreeSelectComponent {
    constructor(entityTreeService) {
        this.entityTreeService = entityTreeService;
        /** labels for ng-select */
        this.labels = {};
        /** control templates for the toolbar buttons */
        this.controls = {};
        /** entities input array */
        this.entities = null;
        /** force disable the following entities */
        this.disableEntities = null;
        /** always make children selectable of passed entities */
        this.selectableChildren = true;
        /** show unselectable parents */
        this.showUnselectableParents = true;
        /** whether or not to show the full path for selected entities */
        this.showFullPath = true;
        /** whether or not to show the header controls */
        this.showControls = true;
        /** whether to use api caching or not, caching is done per query request object, see EntityTreeService for more details */
        this.cache = true;
        /** if the tree is expanded by default */
        this.defaultExpand = false;
        this.expandedSearch = [];
        this.flattenedEntities = [];
        this.flattenedTreeEntities = [];
        this.lastTerm = ' ';
        this.refreshing = false;
        this.update = new Subject();
        this.fetchedTreeEntities = [];
        this.cachedWriteValueSubject = new Subject();
        this.treeEntitiesSubject = new Subject();
        this.hasFocus = false;
        this.loading = true;
        this.treeEntities = [];
        this.expanded = [];
        /** ng-select input */
        this.appendTo = null;
        /** ng-select input */
        this.closeOnSelect = true;
        /** ng-select input */
        this.clearable = true;
        /** ng-select input */
        this.clearOnBackspace = true;
        /** ng-select input */
        this.dropdownPosition = 'auto';
        /** ng-select input */
        this.markFirst = true;
        /** ng-select input */
        this.isOpen = undefined;
        /** ng-select input */
        this.maxSelectedItems = undefined;
        /** ng-select input */
        this.hideSelected = false;
        /** ng-select input */
        this.multiple = false;
        /** ng-select input */
        this.searchable = true;
        /** ng-select input */
        this.readonly = false;
        /** ng-select input */
        this.searchWhileComposing = true;
        /** ng-select input */
        this.selectOnTab = false;
        /** ng-select input */
        this.openOnEnter = true;
        /** ng-select input */
        this.virtualScroll = false;
        /** ng-select input */
        this.inputAttrs = undefined;
        /** ng-select input */
        this.tabIndex = undefined;
        /** ng-select output */
        // tslint:disable-next-line:no-output-native
        this.blur = new EventEmitter();
        /** ng-select output */
        // tslint:disable-next-line:no-output-native
        this.focus = new EventEmitter();
        /** ng-select output */
        // tslint:disable-next-line:no-output-native
        this.change = new EventEmitter();
        /** ng-select output */
        // tslint:disable-next-line:no-output-native
        this.open = new EventEmitter();
        /** ng-select output */
        // tslint:disable-next-line:no-output-native
        this.close = new EventEmitter();
        /** ng-select output */
        this.search = new EventEmitter();
        /** ng-select output */
        this.clear = new EventEmitter();
        /** ng-select output */
        this.add = new EventEmitter();
        /** ng-select output */
        this.remove = new EventEmitter();
        /** ng-select output */
        // tslint:disable-next-line:no-output-native
        this.scroll = new EventEmitter();
        /** ng-select output */
        this.scrollToEnd = new EventEmitter();
        /** the id callback function for the Input entities */
        this.entityIdCallback = (entity) => entity ? entity.id : undefined;
        this.htmlId = v4();
        this.compareWith = this.compareWith || ((a, b) => {
            const aId = this.toId(a);
            const bId = this.toId(b);
            return aId && bId && aId === bId;
        });
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onClick = this.onClick.bind(this);
        this.searchFn = this.searchFn.bind(this);
    }
    get currentMarkedEntity() {
        return (this.ngSelectComponent.itemsList.markedItem ? this.ngSelectComponent.itemsList.markedItem.value : null);
    }
    get filtered() {
        return this.getFiltered(this.treeEntities);
    }
    get total() {
        return this.ngSelectComponent.itemsList.items.length;
    }
    get queryParams() {
        return Object.assign({ limit: 9999, depth: 10 }, this.query);
    }
    ngOnChanges(changes) {
        if ('entities' in changes) {
            this.createTreeEntities();
        }
    }
    ngOnInit() {
        this.labels = Object.assign(Object.assign({}, DEFAULT_LABELS), this.labels);
        this.controls = Object.assign({ wrapper: this.wrapperControl, expand: this.expandControl, expandAll: this.expandAllControl, collapse: this.collapseControl, collapseAll: this.collapseAllControl, separator: this.separatorControl, showing: this.showingControl }, this.controls);
        let observable;
        if (this.cache === false) {
            observable = this.entityTreeService.list(this.queryParams);
        }
        else {
            observable = this.entityTreeService.getCachedSubject(this.queryParams);
        }
        this.writeValueSubscription = combineLatest([
            this.cachedWriteValueSubject,
            this.treeEntitiesSubject,
        ]).subscribe(([value]) => this.ngSelectComponent.writeValue(this.multiple ?
            (value || []).map(o => this.toTreeEntity(o)).filter(o => !!o) :
            this.toTreeEntity(value)));
        observable.subscribe(entities => {
            if (!!entities) {
                this.fetchedTreeEntities = entities.ws_entity_list.map(entity => this.deepCopyEntity(entity));
                this.createTreeEntities();
                this.loading = false;
                this.treeEntitiesSubject.next();
            }
        });
        this.update.subscribe(() => {
            this.refreshing = true;
            this.ngSelectComponent.filter(this.lastTerm);
            this.refreshing = false;
        });
        this.ngSelectComponentRef.nativeElement.addEventListener('click', this.onClick, true);
        this.ngSelectComponentRef.nativeElement.addEventListener('keydown', this.onKeyDown, true);
    }
    createTreeEntities() {
        this.treeEntities = this.fetchedTreeEntities.map(e => this.deepCopyEntity(e));
        this.flattenedEntities = this.flatten(this.entities || []);
        this.setSelectable(this.treeEntities, this.entities === null ? true : this.flattenedEntities.map(this.toId), this.disableEntities === null ? false : this.flatten(this.disableEntities).map(this.toId));
        if (this.selectableChildren) {
            this.setSelectableForChildren(this.treeEntities);
        }
        this.clearUnselectableTrees(this.treeEntities);
        this.setParentsForEntities(this.treeEntities);
        this.setPathNamesAndTypes(this.treeEntities);
        if (!this.showUnselectableParents) {
            this.treeEntities = this.flattenUnselectableParents(this.treeEntities);
        }
        this.flattenedTreeEntities = this.flatten(this.treeEntities);
        if (this.defaultExpand) {
            this.expandAll(this.treeEntities, false);
        }
        if (this.hasFocus) {
            setTimeout(() => this.update.next(null));
        }
    }
    deepCopyEntity(entity) {
        return Object.assign(Object.assign({}, entity), { children: entity.children ? entity.children.map(e => this.deepCopyEntity(e)) : [] });
    }
    ngOnDestroy() {
        this.writeValueSubscription.unsubscribe();
        this.ngSelectComponentRef.nativeElement.removeEventListener('click', this.onClick, true);
        this.ngSelectComponentRef.nativeElement.removeEventListener('keydown', this.onKeyDown, true);
    }
    isDomIdentifier(name) {
        return name.startsWith(`_${this.htmlId}`);
    }
    getDomIdentifier(name) {
        return `_${this.htmlId}-${name}`;
    }
    stripDomIdentifier(name) {
        return name.replace(`_${this.htmlId}-`, '');
    }
    flatten(entities) {
        return entities.reduce((acc, entity) => entity.children ?
            [...acc, entity, ...this.flatten(entity.children)] : [...acc, entity], []);
    }
    setParentsForEntities(entities) {
        entities.forEach(e => {
            e.children.forEach(c => {
                c.parent = e;
            });
            this.setParentsForEntities(e.children);
        });
    }
    setPathNamesAndTypes(entities) {
        entities.forEach(e => {
            const paths = [];
            let p = e;
            while (p) {
                paths.push(p.name.text);
                p = p.parent;
            }
            e.allPaths = paths.reverse();
            e.fullPathName = e.allPaths.join(' > ');
            e.allPaths = e.allPaths.map(n => n.toLowerCase());
            e.paths = [...e.allPaths];
            e.paths.pop();
            e.type = 'treeEntity';
            this.setPathNamesAndTypes(e.children);
        });
    }
    setSelectable(entities, selectables, ignoreables) {
        entities.forEach(e => {
            e.filtered = true;
            e.selectable = selectables === true ? true : selectables.includes(e.id);
            e.selectable = ignoreables === false ? e.selectable : (ignoreables.includes(e.id) ? false : e.selectable);
            this.setSelectable(e.children, selectables, ignoreables);
        });
    }
    setSelectableForChildren(entities) {
        entities.forEach(e => {
            if (e.selectable) {
                e.children.forEach(c => {
                    c.selectable = true;
                });
            }
            this.setSelectableForChildren(e.children);
        });
    }
    clearSafeChildren(entity) {
        return entity.children.every(e => !e.selectable && this.clearSafeChildren(e));
    }
    clearUnselectableTrees(entities) {
        let clear = true;
        while (clear) {
            clear = false;
            for (let i = 0; i < entities.length; i++) {
                this.clearUnselectableTrees(entities[i].children);
                if (!entities[i].selectable && this.clearSafeChildren(entities[i])) {
                    entities.splice(i, 1);
                    clear = true;
                    break;
                }
            }
        }
    }
    clearUnselectableTree(entity) {
        if (entity.children.length === 0 || entity.children.every(c => !c.selectable)) {
            return false;
        }
        else {
            this.clearUnselectableTrees(entity.children);
            return true;
        }
    }
    flattenUnselectableParents(entities) {
        entities = [...entities];
        let modified = true;
        while (modified) {
            modified = false;
            for (let i = 0; i < entities.length; i++) {
                if (!entities[i].selectable) {
                    const children = [...entities[i].children];
                    children.forEach(c => {
                        c.parent = entities[i].parent;
                    });
                    entities.splice(i, 1, ...children);
                    modified = true;
                    break;
                }
            }
        }
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < entities.length; i++) {
            entities[i].children = this.flattenUnselectableParents(entities[i].children);
        }
        return entities;
    }
    isExpandable(entity) {
        return entity.children.length > 0;
    }
    expandFn(entity) {
        return () => entity && this.expand(entity);
    }
    expand(entity) {
        if (!this.expanded.includes(entity.id)) {
            this.expanded.push(entity.id);
        }
        this.update.next(entity);
    }
    expandAllFn() {
        return () => this.expandAll(this.treeEntities);
    }
    expandAll(entities, update = true) {
        entities.forEach(entity => {
            if (this.isExpandable(entity) && !this.expanded.includes(entity.id)) {
                this.expanded.push(entity.id);
            }
            this.expandAll(entity.children, false);
        });
        if (update) {
            this.update.next(null);
        }
    }
    expandArray(entities) {
        entities.forEach(entity => {
            if (!this.expanded.includes(entity.id)) {
                this.expanded.push(entity.id);
            }
        });
        this.update.next(null);
    }
    expandTree(entity) {
        let currentEntity = entity;
        while (currentEntity) {
            if (!this.expanded.includes(currentEntity.id)) {
                this.expanded.push(currentEntity.id);
            }
            currentEntity = currentEntity.parent;
        }
        this.update.next(null);
    }
    expandTrees(entities) {
        entities.forEach(entity => {
            let currentEntity = entity;
            while (currentEntity) {
                if (!this.expanded.includes(currentEntity.id)) {
                    this.expanded.push(currentEntity.id);
                }
                currentEntity = currentEntity.parent;
            }
        });
        this.update.next(null);
    }
    collapseFn(entity) {
        return () => entity && this.collapse(entity);
    }
    collapse(entity) {
        if (this.expanded.includes(entity.id)) {
            this.expanded.splice(this.expanded.findIndex(e => e === entity.id), 1);
        }
        this.update.next(entity);
    }
    collapseAllFn() {
        return () => this.collapseAll(this.treeEntities);
    }
    collapseAll(entities, update = true) {
        entities.forEach(entity => {
            if (this.isExpandable(entity) && this.expanded.includes(entity.id)) {
                this.expanded.splice(this.expanded.findIndex(e => e === entity.id), 1);
            }
            this.collapseAll(entity.children, false);
        });
        if (update) {
            this.update.next(null);
        }
    }
    toggleExpanded(entity) {
        if (this.expanded.includes(entity.id)) {
            this.expanded.splice(this.expanded.findIndex(e => e === entity.id), 1);
        }
        else {
            this.expanded.push(entity.id);
        }
        this.update.next(entity);
    }
    toggleExpandedById(id) {
        if (this.expanded.includes(id)) {
            this.expanded.splice(this.expanded.findIndex(e => e === id), 1);
        }
        else {
            this.expanded.push(id);
        }
        this.update.next(null);
    }
    isTreeExpanded(entity) {
        let currentEntity = entity;
        while (currentEntity) {
            if (!this.isExpanded(currentEntity)) {
                return false;
            }
            else {
                currentEntity = currentEntity.parent;
            }
        }
        return true;
    }
    isExpanded(entity) {
        return this.expanded.includes(entity.id);
    }
    isCollapsed(entity) {
        return !this.expanded.includes(entity.id);
    }
    isVisible(entity) {
        return !entity.parent || this.isTreeExpanded(entity.parent);
    }
    trackByFn(entity) {
        return entity.id;
    }
    onClear(event) {
        this.lastTerm = ' ';
        this.update.next(null);
        this.clear.emit(event);
    }
    onOpen(event) {
        setTimeout(() => {
            this.update.next(null);
        });
        this.open.emit(event);
    }
    onSearch(event) {
        if (!this.refreshing) {
            if (!!event.term.trim() && !this.lastSearch.trim()) {
                this.expandedSearch = [...this.expanded];
            }
            else if (!event.term.trim() && !!this.lastSearch.trim()) {
                this.expanded = [...this.expandedSearch];
                this.update.next(null);
            }
            if (!!event.term.trim()) {
                this.expandTrees(event.items);
            }
        }
        if (event.term === '') {
            this.lastTerm = ' ';
            this.update.next(null);
        }
        this.lastSearch = event.term;
        this.search.emit(event);
    }
    searchFn(term, entity) {
        if (!GenericUtil.isNullOrUndefined(term)) {
            term = term.toLowerCase();
        }
        this.lastTerm = term;
        const terms = !!term.trim() ? term.split(/\s*>\s*/) : [];
        const visible = this.entityContainsSearchTerm(terms, entity);
        entity.filtered = visible;
        return visible && this.isVisible(entity);
    }
    entityContainsSearchTerm(terms, entity) {
        if (terms.length > 0) {
            const copyOfTerms = [...terms];
            const actualTerm = copyOfTerms.pop().trim();
            if (entity.name.text.toLowerCase().includes(actualTerm) &&
                copyOfTerms.every(term => entity.paths.some(path => path.includes(term.trim())))) {
                return true;
            }
            else {
                return this.childrenContainSearchTerm(terms, entity.children);
            }
        }
        else {
            return true;
        }
    }
    childrenContainSearchTerm(terms, entities) {
        return entities.some(e => this.entityContainsSearchTerm(terms, e));
    }
    onChange(entity) {
        this.change.emit(this.multiple ? entity.map(o => this.toId(o)) : this.toId(entity));
    }
    onClick(event) {
        const target = event.target;
        if (target.dataset && target.dataset.entityExpanderId && this.isDomIdentifier(target.dataset.entityExpanderId)) {
            const entityId = parseInt(this.stripDomIdentifier(target.dataset.entityExpanderId), 0);
            this.toggleExpandedById(entityId);
            event.preventDefault();
            event.stopImmediatePropagation();
        }
    }
    onKeyDown(event) {
        if (this.hasFocus) {
            const itemsList = this.ngSelectComponent.itemsList;
            const entity = itemsList.markedItem ? itemsList.markedItem.value : null;
            if (entity) {
                if (event.metaKey) {
                    let prevent = false;
                    let scrollAndUpdate = false;
                    if (event.key === 'ArrowLeft') {
                        if (this.isExpandable(entity) && this.isExpanded(entity)) {
                            this.collapse(entity);
                        }
                        else if (entity.parent) {
                            const option = itemsList.filteredItems.find(item => item.value.id === entity.parent.id);
                            if (option) {
                                itemsList.markItem(option);
                                scrollAndUpdate = true;
                            }
                        }
                        else {
                            itemsList.markPreviousItem();
                            scrollAndUpdate = true;
                        }
                        prevent = true;
                    }
                    if (event.key === 'ArrowRight') {
                        if (this.isExpandable(entity) && this.isCollapsed(entity)) {
                            this.expand(entity);
                        }
                        else if (this.isExpandable(entity) && this.isExpanded(entity)) {
                            const option = itemsList.filteredItems.find(item => item.value.parent_id && item.value.parent_id === entity.id);
                            if (option) {
                                itemsList.markItem(option);
                                scrollAndUpdate = true;
                            }
                        }
                        else {
                            itemsList.markNextItem();
                            scrollAndUpdate = true;
                        }
                        prevent = true;
                    }
                    if (scrollAndUpdate) {
                        const dom = document.getElementById(itemsList.markedItem.htmlId);
                        if (dom) {
                            dom.scrollIntoView();
                        }
                        this.update.next(null);
                    }
                    if (prevent) {
                        event.preventDefault();
                        event.stopImmediatePropagation();
                    }
                }
            }
        }
    }
    getFiltered(entities) {
        return entities.reduce((acc, e) => (e.filtered ? acc + 1 : acc) + this.getFiltered(e.children), 0);
    }
    registerOnChange(fn) {
        this.ngSelectComponent.registerOnChange(obj => fn(this.multiple ? obj.map(o => this.toId(o)) : this.toId(obj)));
    }
    registerOnTouched(fn) {
        this.ngSelectComponent.registerOnTouched(fn);
    }
    setDisabledState(isDisabled) {
        this.ngSelectComponent.setDisabledState(isDisabled);
    }
    writeValue(obj) {
        this.cachedWriteValueSubject.next(obj);
    }
    toId(obj) {
        if (isTreeEntity(obj)) {
            return obj.id;
        }
        else if (typeof obj === 'number') {
            return obj;
        }
        else if (typeof obj === 'object') {
            return this.entityIdCallback(obj);
        }
        else {
            return null;
        }
    }
    toTreeEntity(obj) {
        if (isTreeEntity(obj)) {
            return this.flattenedTreeEntities.find(e => e.id === obj.id);
        }
        else if (typeof obj === 'number') {
            return this.flattenedTreeEntities.find(e => e.id === obj);
        }
        else if (typeof obj === 'object') {
            return this.flattenedTreeEntities.find(e => e.id === this.entityIdCallback(obj));
        }
        else {
            return null;
        }
    }
    toEntity(obj) {
        if (isTreeEntity(obj)) {
            return this.flattenedEntities.find(e => this.entityIdCallback(e) === obj.id);
        }
        else if (typeof obj === 'number') {
            return this.flattenedEntities.find(e => this.entityIdCallback(e) === obj);
        }
        else if (typeof obj === 'object') {
            return this.flattenedEntities.find(e => this.entityIdCallback(e) === this.entityIdCallback(obj));
        }
        else {
            return null;
        }
    }
}
EntityTreeSelectComponent.ɵfac = function EntityTreeSelectComponent_Factory(t) { return new (t || EntityTreeSelectComponent)(ɵngcc0.ɵɵdirectiveInject(EntityTreeService)); };
EntityTreeSelectComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: EntityTreeSelectComponent, selectors: [["ws-entity-tree-select"]], viewQuery: function EntityTreeSelectComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c8, true);
        ɵngcc0.ɵɵstaticViewQuery(_c8, true, ElementRef);
        ɵngcc0.ɵɵstaticViewQuery(_c9, true);
        ɵngcc0.ɵɵstaticViewQuery(_c10, true);
        ɵngcc0.ɵɵstaticViewQuery(_c11, true);
        ɵngcc0.ɵɵstaticViewQuery(_c12, true);
        ɵngcc0.ɵɵstaticViewQuery(_c13, true);
        ɵngcc0.ɵɵstaticViewQuery(_c14, true);
        ɵngcc0.ɵɵstaticViewQuery(_c15, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.ngSelectComponent = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.ngSelectComponentRef = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.wrapperControl = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.expandControl = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.expandAllControl = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.collapseControl = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.collapseAllControl = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.separatorControl = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.showingControl = _t.first);
    } }, inputs: { labels: "labels", controls: "controls", entities: "entities", disableEntities: "disableEntities", selectableChildren: "selectableChildren", showUnselectableParents: "showUnselectableParents", showFullPath: "showFullPath", showControls: "showControls", cache: "cache", defaultExpand: "defaultExpand", appendTo: "appendTo", closeOnSelect: "closeOnSelect", clearable: "clearable", clearOnBackspace: "clearOnBackspace", dropdownPosition: "dropdownPosition", markFirst: "markFirst", isOpen: "isOpen", maxSelectedItems: "maxSelectedItems", hideSelected: "hideSelected", multiple: "multiple", searchable: "searchable", readonly: "readonly", searchWhileComposing: "searchWhileComposing", selectOnTab: "selectOnTab", openOnEnter: "openOnEnter", virtualScroll: "virtualScroll", inputAttrs: "inputAttrs", tabIndex: "tabIndex", entityIdCallback: "entityIdCallback", compareWith: "compareWith", query: "query" }, outputs: { blur: "blur", focus: "focus", change: "change", open: "open", close: "close", search: "search", clear: "clear", add: "add", remove: "remove", scroll: "scroll", scrollToEnd: "scrollToEnd" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => EntityTreeSelectComponent),
                multi: true
            }
        ]), ɵngcc0.ɵɵNgOnChangesFeature], decls: 21, vars: 28, consts: [["wrapperControl", ""], ["expandControl", ""], ["expandAllControl", ""], ["collapseControl", ""], ["collapseAllControl", ""], ["separatorControl", ""], ["showingControl", ""], ["controlsWrapper", ""], [3, "appendTo", "closeOnSelect", "clearAllText", "clearable", "clearOnBackspace", "compareWith", "dropdownPosition", "loadingText", "markFirst", "isOpen", "maxSelectedItems", "hideSelected", "multiple", "notFoundText", "searchable", "readonly", "searchFn", "searchWhileComposing", "selectOnTab", "openOnEnter", "typeToSearchText", "placeholder", "virtualScroll", "inputAttrs", "loading", "tabIndex", "trackByFn", "blur", "focus", "change", "open", "close", "search", "clear", "add", "remove", "scroll", "scrollToEnd"], ["ngSelectComponent", ""], ["entityOption", ""], [4, "ngFor", "ngForOf"], ["role", "group", 1, "btn-group", "btn-group-sm"], [3, "ngTemplateOutlet"], [1, "btn", "btn-primary", 3, "disabled", "click"], [1, "btn", "btn-primary", 3, "click"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [4, "ngIf"], ["ng-label-tmp", ""], [3, "value", "disabled"], [3, "id", "ngClass"], [1, "expander"], [1, "arrow"], [1, "item"], ["ng-header-tmp", ""], [1, "d-flex", "flex-row", "justify-content-between", "align-items-center"], [1, "font-weight-bold", "px-2", "border-left", 2, "cursor", "pointer", 3, "click"]], template: function EntityTreeSelectComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, EntityTreeSelectComponent_ng_template_0_Template, 2, 1, "ng-template", null, 0, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(2, EntityTreeSelectComponent_ng_template_2_Template, 2, 1, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(4, EntityTreeSelectComponent_ng_template_4_Template, 2, 0, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(6, EntityTreeSelectComponent_ng_template_6_Template, 2, 1, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(8, EntityTreeSelectComponent_ng_template_8_Template, 2, 0, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(10, EntityTreeSelectComponent_ng_template_10_Template, 0, 0, "ng-template", null, 5, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(12, EntityTreeSelectComponent_ng_template_12_Template, 1, 2, "ng-template", null, 6, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(14, EntityTreeSelectComponent_ng_template_14_Template, 7, 21, "ng-template", null, 7, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementStart(16, "ng-select", 8, 9);
        ɵngcc0.ɵɵlistener("blur", function EntityTreeSelectComponent_Template_ng_select_blur_16_listener($event) { ctx.hasFocus = false; return ctx.blur.emit($event); })("focus", function EntityTreeSelectComponent_Template_ng_select_focus_16_listener($event) { ctx.hasFocus = true; return ctx.focus.emit($event); })("change", function EntityTreeSelectComponent_Template_ng_select_change_16_listener($event) { return ctx.onChange($event); })("open", function EntityTreeSelectComponent_Template_ng_select_open_16_listener($event) { return ctx.onOpen($event); })("close", function EntityTreeSelectComponent_Template_ng_select_close_16_listener($event) { return ctx.close.emit($event); })("search", function EntityTreeSelectComponent_Template_ng_select_search_16_listener($event) { return ctx.onSearch($event); })("clear", function EntityTreeSelectComponent_Template_ng_select_clear_16_listener($event) { return ctx.onClear($event); })("add", function EntityTreeSelectComponent_Template_ng_select_add_16_listener($event) { return ctx.add.emit($event); })("remove", function EntityTreeSelectComponent_Template_ng_select_remove_16_listener($event) { return ctx.remove.emit($event); })("scroll", function EntityTreeSelectComponent_Template_ng_select_scroll_16_listener($event) { return ctx.scroll.emit($event); })("scrollToEnd", function EntityTreeSelectComponent_Template_ng_select_scrollToEnd_16_listener($event) { return ctx.scrollToEnd.emit($event); });
        ɵngcc0.ɵɵtemplate(18, EntityTreeSelectComponent_ng_template_18_Template, 10, 19, "ng-template", null, 10, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(20, EntityTreeSelectComponent_ng_container_20_Template, 2, 4, "ng-container", 11);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(16);
        ɵngcc0.ɵɵproperty("appendTo", ctx.appendTo)("closeOnSelect", ctx.closeOnSelect)("clearAllText", ctx.labels.clearAllText)("clearable", ctx.clearable)("clearOnBackspace", ctx.clearOnBackspace)("compareWith", ctx.compareWith)("dropdownPosition", ctx.dropdownPosition)("loadingText", ctx.labels.loadingText)("markFirst", ctx.markFirst)("isOpen", ctx.isOpen)("maxSelectedItems", ctx.maxSelectedItems)("hideSelected", ctx.hideSelected)("multiple", ctx.multiple)("notFoundText", ctx.labels.notFoundText)("searchable", ctx.searchable)("readonly", ctx.readonly)("searchFn", ctx.searchFn)("searchWhileComposing", ctx.searchWhileComposing)("selectOnTab", ctx.selectOnTab)("openOnEnter", ctx.openOnEnter)("typeToSearchText", ctx.labels.typeToSearchText)("placeholder", ctx.labels.placeholder)("virtualScroll", ctx.virtualScroll)("inputAttrs", ctx.inputAttrs)("loading", ctx.loading)("tabIndex", ctx.tabIndex)("trackByFn", ctx.trackByFn);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.treeEntities);
    } }, directives: [ɵngcc7.NgSelectComponent, ɵngcc1.NgForOf, ɵngcc1.NgTemplateOutlet, ɵngcc1.NgIf, ɵngcc7.ɵh, ɵngcc7.ɵr, ɵngcc1.NgClass, ɵngcc7.ɵj], styles: [".level-0[_ngcontent-%COMP%]{margin-left:0}.level-1[_ngcontent-%COMP%]{margin-left:20px}.level-2[_ngcontent-%COMP%]{margin-left:40px}.level-3[_ngcontent-%COMP%]{margin-left:60px}.level-4[_ngcontent-%COMP%]{margin-left:80px}.level-5[_ngcontent-%COMP%]{margin-left:100px}.level-6[_ngcontent-%COMP%]{margin-left:120px}.item-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.item[_ngcontent-%COMP%]{flex:1}.expander[_ngcontent-%COMP%]{align-items:center;display:flex;justify-content:center;text-align:center;width:20px}.arrow[_ngcontent-%COMP%]{border:5px solid transparent;font-size:0;height:0;visibility:hidden;width:0}.item-wrapper.collapsed[_ngcontent-%COMP%]   .arrow[_ngcontent-%COMP%]{border-left-color:#000;margin:0 0 0 3px;visibility:visible}.item-wrapper.expanded[_ngcontent-%COMP%]   .arrow[_ngcontent-%COMP%]{border-top-color:#000;margin:3px 0 0;visibility:visible}"] });
EntityTreeSelectComponent.ctorParameters = () => [
    { type: EntityTreeService }
];
EntityTreeSelectComponent.propDecorators = {
    labels: [{ type: Input }],
    controls: [{ type: Input }],
    query: [{ type: Input }],
    entities: [{ type: Input }],
    disableEntities: [{ type: Input }],
    selectableChildren: [{ type: Input }],
    showUnselectableParents: [{ type: Input }],
    showFullPath: [{ type: Input }],
    showControls: [{ type: Input }],
    cache: [{ type: Input }],
    defaultExpand: [{ type: Input }],
    appendTo: [{ type: Input }],
    closeOnSelect: [{ type: Input }],
    clearable: [{ type: Input }],
    clearOnBackspace: [{ type: Input }],
    dropdownPosition: [{ type: Input }],
    markFirst: [{ type: Input }],
    isOpen: [{ type: Input }],
    maxSelectedItems: [{ type: Input }],
    hideSelected: [{ type: Input }],
    multiple: [{ type: Input }],
    searchable: [{ type: Input }],
    readonly: [{ type: Input }],
    searchWhileComposing: [{ type: Input }],
    selectOnTab: [{ type: Input }],
    openOnEnter: [{ type: Input }],
    virtualScroll: [{ type: Input }],
    inputAttrs: [{ type: Input }],
    tabIndex: [{ type: Input }],
    blur: [{ type: Output }],
    focus: [{ type: Output }],
    change: [{ type: Output }],
    open: [{ type: Output }],
    close: [{ type: Output }],
    search: [{ type: Output }],
    clear: [{ type: Output }],
    add: [{ type: Output }],
    remove: [{ type: Output }],
    scroll: [{ type: Output }],
    scrollToEnd: [{ type: Output }],
    ngSelectComponent: [{ type: ViewChild, args: ['ngSelectComponent', { static: true },] }],
    ngSelectComponentRef: [{ type: ViewChild, args: ['ngSelectComponent', { static: true, read: ElementRef },] }],
    wrapperControl: [{ type: ViewChild, args: ['wrapperControl', { static: true },] }],
    expandControl: [{ type: ViewChild, args: ['expandControl', { static: true },] }],
    expandAllControl: [{ type: ViewChild, args: ['expandAllControl', { static: true },] }],
    collapseControl: [{ type: ViewChild, args: ['collapseControl', { static: true },] }],
    collapseAllControl: [{ type: ViewChild, args: ['collapseAllControl', { static: true },] }],
    separatorControl: [{ type: ViewChild, args: ['separatorControl', { static: true },] }],
    showingControl: [{ type: ViewChild, args: ['showingControl', { static: true },] }],
    compareWith: [{ type: Input }],
    entityIdCallback: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EntityTreeSelectComponent, [{
        type: Component,
        args: [{
                selector: 'ws-entity-tree-select',
                template: "<ng-template #wrapperControl let-template>\n  <div class=\"btn-group btn-group-sm\" role=\"group\">\n    <ng-template [ngTemplateOutlet]=\"template\"></ng-template>\n  </div>\n</ng-template>\n<ng-template #expandControl let-enabled=\"enabled\" let-click=\"click\">\n  <button [disabled]=\"!enabled\" class=\"btn btn-primary\" (click)=\"$event.preventDefault(); click()\">Expand</button>\n</ng-template>\n<ng-template #expandAllControl let-click=\"click\">\n  <button class=\"btn btn-primary\" (click)=\"click()\">Expand all</button>\n</ng-template>\n<ng-template #collapseControl let-enabled=\"enabled\" let-click=\"click\">\n  <button [disabled]=\"!enabled\" class=\"btn btn-primary\" (click)=\"click()\">Collapse</button>\n</ng-template>\n<ng-template #collapseAllControl let-click=\"click\">\n  <button class=\"btn btn-primary\" (click)=\"$event.preventDefault(); click()\">Collapse all</button>\n</ng-template>\n<ng-template #separatorControl></ng-template>\n<ng-template #showingControl let-showing=\"showing\" let-total=\"total\">\n  Showing {{showing}} of {{total}}\n</ng-template>\n\n<ng-template #controlsWrapper>\n  <ng-template [ngTemplateOutlet]=\"controls.collapse\"\n               [ngTemplateOutletContext]=\"{enabled: currentMarkedEntity && isExpandable(currentMarkedEntity) && isExpanded(currentMarkedEntity), click: collapseFn(currentMarkedEntity)}\"></ng-template>\n  <ng-template [ngTemplateOutlet]=\"controls.separator\"></ng-template>\n  <ng-template [ngTemplateOutlet]=\"controls.expand\"\n               [ngTemplateOutletContext]=\"{enabled: currentMarkedEntity && isExpandable(currentMarkedEntity) && isCollapsed(currentMarkedEntity), click: expandFn(currentMarkedEntity)}\"></ng-template>\n  <ng-template [ngTemplateOutlet]=\"controls.separator\"></ng-template>\n  <ng-template [ngTemplateOutlet]=\"controls.collapseAll\"\n               [ngTemplateOutletContext]=\"{click: collapseAllFn()}\"></ng-template>\n  <ng-template [ngTemplateOutlet]=\"controls.separator\"></ng-template>\n  <ng-template [ngTemplateOutlet]=\"controls.expandAll\"\n               [ngTemplateOutletContext]=\"{click: expandAllFn()}\"></ng-template>\n</ng-template>\n\n<ng-select\n\t#ngSelectComponent\n    [appendTo]=\"appendTo\"\n    [closeOnSelect]=\"closeOnSelect\"\n    [clearAllText]=\"labels.clearAllText\"\n    [clearable]=\"clearable\"\n    [clearOnBackspace]=\"clearOnBackspace\"\n    [compareWith]=\"compareWith\"\n    [dropdownPosition]=\"dropdownPosition\"\n    [loadingText]=\"labels.loadingText\"\n    [markFirst]=\"markFirst\"\n    [isOpen]=\"isOpen\"\n    [maxSelectedItems]=\"maxSelectedItems\"\n    [hideSelected]=\"hideSelected\"\n    [multiple]=\"multiple\"\n    [notFoundText]=\"labels.notFoundText\"\n    [searchable]=\"searchable\"\n    [readonly]=\"readonly\"\n    [searchFn]=\"searchFn\"\n    [searchWhileComposing]=\"searchWhileComposing\"\n    [selectOnTab]=\"selectOnTab\"\n    [openOnEnter]=\"openOnEnter\"\n    [typeToSearchText]=\"labels.typeToSearchText\"\n    [placeholder]=\"labels.placeholder\"\n    [virtualScroll]=\"virtualScroll\"\n    [inputAttrs]=\"inputAttrs\"\n    [loading]=\"loading\"\n    [tabIndex]=\"tabIndex\"\n    (blur)=\"hasFocus = false; blur.emit($event)\"\n    (focus)=\"hasFocus = true; focus.emit($event)\"\n    (change)=\"onChange($event)\"\n    (open)=\"onOpen($event)\"\n    (close)=\"close.emit($event)\"\n    (search)=\"onSearch($event)\"\n    (clear)=\"onClear($event)\"\n    (add)=\"add.emit($event)\"\n    (remove)=\"remove.emit($event)\"\n    (scroll)=\"scroll.emit($event)\"\n    (scrollToEnd)=\"scrollToEnd.emit($event)\"\n    [trackByFn]=\"trackByFn\"\n>\n  <ng-template #entityOption let-entity let-depth=\"depth\" let-visible=\"visible\">\n    <ng-container *ngIf=\"showControls && !!treeEntities\">\n      <ng-template ng-header-tmp>\n        <div class=\"d-flex flex-row justify-content-between align-items-center\">\n          <div>\n            <ng-template\n              [ngTemplateOutlet]=\"controls.showing\"\n              [ngTemplateOutletContext]=\"{showing: filtered, total: total}\"></ng-template>\n          </div>\n          <div>\n            <ng-template\n              [ngTemplateOutlet]=\"controls.wrapper\"\n              [ngTemplateOutletContext]=\"{$implicit: controlsWrapper}\"></ng-template>\n          </div>\n        </div>\n      </ng-template>\n    </ng-container>\n    <ng-template ng-label-tmp let-entity=\"item\" let-clear=\"clear\">\n      <span class=\"{{multiple ? 'px-2' : ''}}\">{{showFullPath ? entity.fullPathName : entity.name.text}}</span>\n      <ng-container *ngIf=\"multiple\">\n        <span style=\"cursor: pointer\" class=\"font-weight-bold px-2 border-left\" (click)=\"clear(entity)\">\u00D7</span>\n      </ng-container>\n    </ng-template>\n    <ng-option [value]=\"entity\" [disabled]=\"!entity.selectable\">\n      <div\n        [id]=\"getDomIdentifier('entity-' + entity.id)\"\n        [ngClass]=\"{'item-wrapper': true, 'level-0': depth === 0, 'level-1': depth === 1, 'level-2': depth === 2, 'level-3': depth === 3, 'level-4': depth === 4, 'level-5': depth === 5, 'level-6': depth === 6, 'expanded': isExpandable(entity) && isExpanded(entity), 'collapsed': isExpandable(entity) && isCollapsed(entity)}\">\n        <div class=\"expander\">\n          <div class=\"arrow\" [attr.data-entity-expander-id]=\"getDomIdentifier(entity.id)\">\n            {{isExpandable(entity) && isExpanded(entity) ? 'expanded' : (isExpandable(entity) && isCollapsed(entity) ? 'collapsed' : '')}}\n          </div>\n        </div>\n        <div class=\"item\">{{entity.name.text}}</div>\n      </div>\n    </ng-option>\n    <ng-container *ngFor=\"let child of entity.children\">\n      <ng-template\n        [ngTemplateOutlet]=\"entityOption\"\n        [ngTemplateOutletContext]=\"{$implicit: child, depth: depth + 1}\">\n      </ng-template>\n    </ng-container>\n  </ng-template>\n  <ng-container *ngFor=\"let entity of treeEntities\">\n    <ng-template\n      [ngTemplateOutlet]=\"entityOption\"\n      [ngTemplateOutletContext]=\"{$implicit: entity, depth: 0}\">\n    </ng-template>\n  </ng-container>\n</ng-select>\n",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => EntityTreeSelectComponent),
                        multi: true
                    }
                ],
                styles: [".level-0{margin-left:0}.level-1{margin-left:20px}.level-2{margin-left:40px}.level-3{margin-left:60px}.level-4{margin-left:80px}.level-5{margin-left:100px}.level-6{margin-left:120px}.item-wrapper{display:flex;flex-direction:row}.item{flex:1}.expander{align-items:center;display:flex;justify-content:center;text-align:center;width:20px}.arrow{border:5px solid transparent;font-size:0;height:0;visibility:hidden;width:0}.item-wrapper.collapsed .arrow{border-left-color:#000;margin:0 0 0 3px;visibility:visible}.item-wrapper.expanded .arrow{border-top-color:#000;margin:3px 0 0;visibility:visible}"]
            }]
    }], function () { return [{ type: EntityTreeService }]; }, { labels: [{
            type: Input
        }], controls: [{
            type: Input
        }], entities: [{
            type: Input
        }], disableEntities: [{
            type: Input
        }], selectableChildren: [{
            type: Input
        }], showUnselectableParents: [{
            type: Input
        }], showFullPath: [{
            type: Input
        }], showControls: [{
            type: Input
        }], cache: [{
            type: Input
        }], defaultExpand: [{
            type: Input
        }], appendTo: [{
            type: Input
        }], closeOnSelect: [{
            type: Input
        }], clearable: [{
            type: Input
        }], clearOnBackspace: [{
            type: Input
        }], dropdownPosition: [{
            type: Input
        }], markFirst: [{
            type: Input
        }], isOpen: [{
            type: Input
        }], maxSelectedItems: [{
            type: Input
        }], hideSelected: [{
            type: Input
        }], multiple: [{
            type: Input
        }], searchable: [{
            type: Input
        }], readonly: [{
            type: Input
        }], searchWhileComposing: [{
            type: Input
        }], selectOnTab: [{
            type: Input
        }], openOnEnter: [{
            type: Input
        }], virtualScroll: [{
            type: Input
        }], inputAttrs: [{
            type: Input
        }], tabIndex: [{
            type: Input
        }], blur: [{
            type: Output
        }], focus: [{
            type: Output
        }], change: [{
            type: Output
        }], open: [{
            type: Output
        }], close: [{
            type: Output
        }], search: [{
            type: Output
        }], clear: [{
            type: Output
        }], add: [{
            type: Output
        }], remove: [{
            type: Output
        }], scroll: [{
            type: Output
        }], scrollToEnd: [{
            type: Output
        }], entityIdCallback: [{
            type: Input
        }], compareWith: [{
            type: Input
        }], query: [{
            type: Input
        }], ngSelectComponent: [{
            type: ViewChild,
            args: ['ngSelectComponent', { static: true }]
        }], ngSelectComponentRef: [{
            type: ViewChild,
            args: ['ngSelectComponent', { static: true, read: ElementRef }]
        }], wrapperControl: [{
            type: ViewChild,
            args: ['wrapperControl', { static: true }]
        }], expandControl: [{
            type: ViewChild,
            args: ['expandControl', { static: true }]
        }], expandAllControl: [{
            type: ViewChild,
            args: ['expandAllControl', { static: true }]
        }], collapseControl: [{
            type: ViewChild,
            args: ['collapseControl', { static: true }]
        }], collapseAllControl: [{
            type: ViewChild,
            args: ['collapseAllControl', { static: true }]
        }], separatorControl: [{
            type: ViewChild,
            args: ['separatorControl', { static: true }]
        }], showingControl: [{
            type: ViewChild,
            args: ['showingControl', { static: true }]
        }] }); })();

class SelectAsyncHeaderComponent {
    constructor() {
        this.content = '';
    }
    get isString() {
        return typeof this.content === 'string';
    }
}
SelectAsyncHeaderComponent.ɵfac = function SelectAsyncHeaderComponent_Factory(t) { return new (t || SelectAsyncHeaderComponent)(); };
SelectAsyncHeaderComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SelectAsyncHeaderComponent, selectors: [["ws-select-async-header"]], viewQuery: function SelectAsyncHeaderComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c23, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.templateRef = _t.first);
    } }, inputs: { content: "content" }, decls: 2, vars: 0, consts: [["templateRef", ""], [4, "ngIf"], [3, "ngTemplateOutlet"]], template: function SelectAsyncHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, SelectAsyncHeaderComponent_ng_template_0_Template, 2, 2, "ng-template", null, 0, ɵngcc0.ɵɵtemplateRefExtractor);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet], encapsulation: 2 });
SelectAsyncHeaderComponent.propDecorators = {
    content: [{ type: Input }],
    templateRef: [{ type: ViewChild, args: ['templateRef', { static: true },] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SelectAsyncHeaderComponent, [{
        type: Component,
        args: [{
                selector: 'ws-select-async-header',
                template: '<ng-template #templateRef><ng-container *ngIf="isString">{{content}}</ng-container><ng-container *ngIf="!isString"><ng-template [ngTemplateOutlet]="content"></ng-template></ng-container></ng-template>'
            }]
    }], function () { return []; }, { content: [{
            type: Input
        }], templateRef: [{
            type: ViewChild,
            args: ['templateRef', { static: true }]
        }] }); })();

const DEFAULT_DEBOUNCE_TIME = 200;
const DEFAULT_MIN_CHARACTERS = 3;
class SelectAsyncHandler {
    constructor(ngSelectComponent, changeDetectorRef, settings) {
        this.ngSelectComponent = ngSelectComponent;
        this.changeDetectorRef = changeDetectorRef;
        this.settings = settings;
    }
    initialize() {
        if (this.debounceSubscription) {
            this.debounceSubscription.unsubscribe();
        }
        let theDebounceTime = DEFAULT_DEBOUNCE_TIME;
        let subscription;
        if (typeof this.settings === 'object' && 'debounceTime' in this.settings) {
            theDebounceTime = this.settings.debounceTime;
        }
        if (typeof this.settings === 'object' && 'observer' in this.settings) {
            subscription = this.settings.observer;
        }
        else {
            subscription = this.settings;
        }
        this.debounceSubject = new Subject();
        this.debounceSubscription = this.debounceSubject.pipe(debounceTime(theDebounceTime)).subscribe(value => {
            if (typeof subscription === 'function') {
                const observable = subscription(value);
                if (observable) {
                    observable.subscribe(() => {
                        this.ngSelectComponent.loading = false;
                        this.changeDetectorRef.detectChanges();
                    });
                    this.ngSelectComponent.loading = true;
                    this.changeDetectorRef.detectChanges();
                }
            }
            else {
                subscription.next(value);
            }
        });
    }
    setupSearchListener() {
        this.ngSelectComponent.searchEvent.subscribe(value => {
            const minCharacters = (typeof this.settings === 'object' && 'minCharacters' in this.settings)
                ? this.settings.minCharacters : DEFAULT_MIN_CHARACTERS;
            if (value.term && value.term.length >= minCharacters) {
                this.hideHeader();
                if (typeof this.settings === 'object' && 'onValid' in this.settings) {
                    this.settings.onValid(true);
                }
                this.debounceSubject.next(value.term);
            }
            else {
                this.showHeader();
                if (typeof this.settings === 'object' && 'onValid' in this.settings) {
                    this.settings.onValid(false);
                }
            }
        });
    }
    showHeader() {
        if (this.template) {
            this.ngSelectComponent.headerTemplate = this.template;
            this.changeDetectorRef.detectChanges();
        }
    }
    hideHeader() {
        if (this.template) {
            this.ngSelectComponent.headerTemplate = null;
            this.changeDetectorRef.detectChanges();
        }
    }
    destroy() {
        if (this.debounceSubscription) {
            this.debounceSubscription.unsubscribe();
        }
    }
}

class SelectDirective {
    constructor(ngSelectComponent, changeDetectorRef, viewContainerRef, componentFactoryResolver) {
        this.ngSelectComponent = ngSelectComponent;
        this.changeDetectorRef = changeDetectorRef;
        this.viewContainerRef = viewContainerRef;
        this.componentFactoryResolver = componentFactoryResolver;
        this.wsChange = new EventEmitter();
    }
    ngAfterViewInit() {
        if (this.asyncHandler && !this.ngSelectComponent.headerTemplate) {
            this.viewContainerRef.clear();
            const factory = this.componentFactoryResolver.resolveComponentFactory(SelectAsyncHeaderComponent);
            const instance = this.viewContainerRef.createComponent(factory).instance;
            if (typeof this.asyncSearch === 'object' && 'message' in this.asyncSearch) {
                instance.content = this.asyncSearch.message;
            }
            else {
                const chars = (typeof this.asyncSearch === 'object' && 'minCharacters' in this.asyncSearch)
                    ? this.asyncSearch.minCharacters : DEFAULT_MIN_CHARACTERS;
                instance.content = `Type at least ${chars} characters to start searching...`;
            }
            this.asyncHandler.template = instance.templateRef;
            this.asyncHandler.showHeader();
        }
    }
    ngOnChanges(changes) {
        if (this.ngSelectComponent) {
            if (changes.items) {
                this.updateItems(changes.items.currentValue, changes.items.isFirstChange());
            }
            if (changes.asyncSearch && changes.asyncSearch.currentValue) {
                if (this.asyncHandler) {
                    this.asyncHandler.destroy();
                }
                this.asyncHandler
                    = new SelectAsyncHandler(this.ngSelectComponent, this.changeDetectorRef, changes.asyncSearch.currentValue);
                this.asyncHandler.initialize();
            }
        }
    }
    ngOnInit() {
        if (this.ngSelectComponent) {
            let labelReaderFromMainSelector;
            let valueReaderFromMainSelector;
            let groupReaderFromMainSelector;
            if (this.entryReader) {
                if (Array.isArray(this.entryReader)) {
                    const [valueReaderFromMainArray, labelReaderFromMainArray, groupReaderFromMainArray] = this.entryReader;
                    labelReaderFromMainSelector = labelReaderFromMainArray;
                    valueReaderFromMainSelector = valueReaderFromMainArray;
                    groupReaderFromMainSelector = groupReaderFromMainArray;
                }
                else {
                    const { labelReader: labelReaderFromMainObject, valueReader: valueReaderFromMainObject, groupReader: groupReaderFromMainObject } = this.entryReader;
                    labelReaderFromMainSelector = labelReaderFromMainObject;
                    valueReaderFromMainSelector = valueReaderFromMainObject;
                    groupReaderFromMainSelector = groupReaderFromMainObject;
                }
                if (!this.labelReader) {
                    this.labelReader = labelReaderFromMainSelector;
                }
                if (!this.valueReader) {
                    this.valueReader = valueReaderFromMainSelector;
                }
                if (!this.groupReader) {
                    this.groupReader = groupReaderFromMainSelector;
                }
            }
            if (!this.labelReader || !this.valueReader) {
                throw new Error('Provide both a means to read the label and the value');
            }
            if (typeof this.labelReader === 'string') {
                this.labelReader = this.labelReader.split('.');
            }
            if (typeof this.valueReader === 'string') {
                this.valueReader = this.valueReader.split('.');
            }
            this.ngSelectComponent.bindLabel = 'label';
            this.ngSelectComponent.bindValue = 'value';
            if (this.groupReader) {
                this.ngSelectComponent.groupBy = 'group';
            }
            if (this.wsChange) {
                const currentChangeEvent = this.ngSelectComponent.changeEvent;
                const newEventEmitter = new EventEmitter();
                newEventEmitter.subscribe(original => {
                    if (original) {
                        this.wsChange.emit({
                            item: this.originalItems.find(i => this.readObjectValue(i) === original.value),
                            original,
                            value: original.value
                        });
                    }
                    else {
                        this.wsChange.emit(null);
                    }
                });
                if (currentChangeEvent) {
                    const overrideEventEmitter = new EventEmitter();
                    overrideEventEmitter.subscribe(obj => {
                        currentChangeEvent.emit(obj);
                        newEventEmitter.emit(obj);
                    });
                    this.ngSelectComponent.changeEvent = overrideEventEmitter;
                }
                else {
                    this.ngSelectComponent.changeEvent = newEventEmitter;
                }
            }
            if (this.asyncHandler) {
                this.asyncHandler.setupSearchListener();
            }
            this.updateItems(this.items);
        }
    }
    ngOnDestroy() {
        if (this.asyncHandler) {
            this.asyncHandler.destroy();
        }
    }
    updateItems(items, firstChange = false) {
        if (items) {
            this.originalItems = [...items];
            this.ngSelectComponent.items = items.map(obj => ({
                label: this.readObjectLabel(obj),
                value: this.readObjectValue(obj),
                group: this.groupReader ? this.readObjectGroup(obj) : undefined
            }));
            this.ngSelectComponent.ngOnChanges({ items: new SimpleChange(null, this.ngSelectComponent.items, firstChange) });
        }
    }
    readObjectLabel(obj) {
        let label;
        if (Array.isArray(this.labelReader)) {
            if (this.labelReader.length === 1) {
                label = obj[this.labelReader[0]];
            }
            else {
                label = obj;
                for (const entry of this.labelReader) {
                    label = label[entry];
                    if (label === undefined) {
                        break;
                    }
                }
            }
        }
        else if (typeof this.labelReader === 'function') {
            label = this.labelReader(obj);
        }
        return label;
    }
    readObjectValue(obj) {
        let value;
        if (Array.isArray(this.valueReader)) {
            if (this.valueReader.length === 1) {
                value = obj[this.valueReader[0]];
            }
            else {
                value = obj;
                for (const entry of this.valueReader) {
                    value = value[entry];
                    if (value === undefined) {
                        break;
                    }
                }
            }
        }
        else if (typeof this.valueReader === 'function') {
            value = this.valueReader(obj);
        }
        return value;
    }
    readObjectGroup(obj) {
        let group;
        if (Array.isArray(this.groupReader)) {
            if (this.groupReader.length === 1) {
                group = obj[this.groupReader[0]];
            }
            else {
                group = obj;
                for (const entry of this.groupReader) {
                    group = group[entry];
                    if (group === undefined) {
                        break;
                    }
                }
            }
        }
        else if (typeof this.groupReader === 'function') {
            group = this.groupReader(obj);
        }
        return group;
    }
}
SelectDirective.ɵfac = function SelectDirective_Factory(t) { return new (t || SelectDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc7.NgSelectComponent, 11), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver)); };
SelectDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: SelectDirective, selectors: [["", "wsSelect", ""]], inputs: { labelReader: "labelReader", valueReader: "valueReader", groupReader: "groupReader", entryReader: ["wsSelect", "entryReader"], items: "items", asyncSearch: "asyncSearch" }, outputs: { wsChange: "wsChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
SelectDirective.ctorParameters = () => [
    { type: NgSelectComponent, decorators: [{ type: Host }, { type: Optional }, { type: Self }] },
    { type: ChangeDetectorRef },
    { type: ViewContainerRef },
    { type: ComponentFactoryResolver }
];
SelectDirective.propDecorators = {
    entryReader: [{ type: Input, args: ['wsSelect',] }],
    items: [{ type: Input }],
    wsChange: [{ type: Output }],
    labelReader: [{ type: Input }],
    valueReader: [{ type: Input }],
    groupReader: [{ type: Input }],
    asyncSearch: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SelectDirective, [{
        type: Directive,
        args: [{
                selector: '[wsSelect]'
            }]
    }], function () { return [{ type: ɵngcc7.NgSelectComponent, decorators: [{
                type: Host
            }, {
                type: Optional
            }, {
                type: Self
            }] }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.ComponentFactoryResolver }]; }, { wsChange: [{
            type: Output
        }], labelReader: [{
            type: Input
        }], valueReader: [{
            type: Input
        }], groupReader: [{
            type: Input
        }], entryReader: [{
            type: Input,
            args: ['wsSelect']
        }], items: [{
            type: Input
        }], asyncSearch: [{
            type: Input
        }] }); })();

class UserRoleUtil {
    static userHasRoles(user, appId, ...roles) {
        const userRoles = user && user.roles ? user.roles
            .filter(role => role.role_application.application_code === appId)
            .map(role => role.name) : [];
        return roles.some(r1 => userRoles.some(r2 => r1 === r2));
    }
    static userHasRolesOfEntity(user, appId, entityId, ...roles) {
        const userRoles = user && user.roles ? user.roles
            .filter(role => role.role_application.application_code === appId)
            .filter(role => !role.apply_per_entity || (role.ws_entity && role.ws_entity.id === entityId))
            .map(role => role.name) : [];
        return roles.some(r1 => userRoles.some(r2 => r1 === r2));
    }
    static userHasAllRoles(user, appId, ...roles) {
        const userRoles = user && user.roles ? user.roles
            .filter(role => role.role_application.application_code === appId)
            .map(role => role.name) : [];
        return roles.every(r1 => userRoles.some(r2 => r1 === r2));
    }
    static userHasAllRolesOfEntity(user, appId, entityId, ...roles) {
        const userRoles = user && user.roles ? user.roles
            .filter(role => role.role_application.application_code === appId)
            .filter(role => !role.apply_per_entity || (role.ws_entity && role.ws_entity.id === entityId))
            .map(role => role.name) : [];
        return roles.every(r1 => userRoles.some(r2 => r1 === r2));
    }
    static userHasRolesOfAnyApp(user, ...roles) {
        const userRoles = user && user.roles ? user.roles
            .map(role => role.name) : [];
        return roles.some(r1 => userRoles.some(r2 => r1 === r2));
    }
    static userHasRolesOfEntityOfAnyApp(user, entityId, ...roles) {
        const userRoles = user && user.roles ? user.roles
            .filter(role => !role.apply_per_entity || (role.ws_entity && role.ws_entity.id === entityId))
            .map(role => role.name) : [];
        return roles.some(r1 => userRoles.some(r2 => r1 === r2));
    }
    static userHasAllRolesOfAnyApp(user, ...roles) {
        const userRoles = user && user.roles ? user.roles
            .map(role => role.name) : [];
        return roles.every(r1 => userRoles.some(r2 => r1 === r2));
    }
    static userHasAllRolesOfEntityOfAnyApp(user, entityId, ...roles) {
        const userRoles = user && user.roles ? user.roles
            .filter(role => !role.apply_per_entity || (role.ws_entity && role.ws_entity.id === entityId))
            .map(role => role.name) : [];
        return roles.every(r1 => userRoles.some(r2 => r1 === r2));
    }
}

class HttpUtil {
    /*
     * Convert any class to an HTTP Params object
    */
    static objectToParams(obj) {
        let params = new HttpParams();
        Object.getOwnPropertyNames(obj).forEach((propName, propIndex) => {
            const prop = obj[propName];
            if (ArrayUtil.isArray(prop)) {
                prop.filter(item => !GenericUtil.isNullOrUndefined(item)).forEach((item, valueIndex) => {
                    if (valueIndex === 0) {
                        params = params.set(propName, item);
                    }
                    else {
                        params = params.append(propName, item);
                    }
                });
            }
            else if (!GenericUtil.isNullOrUndefined(prop)) {
                params = params.set(propName, prop);
            }
        });
        return params;
    }
    /*
    * Determine if the current user is actually logged out from an http error
    *
    * @param err - The Http Error Response
    * @param notLoggedInCode - application specific WSI code that identifies as not logged in
    * @returns true if the user is not logged in. false if the user is logged in
    */
    static isNotLoggedIn(err, notLoggedInCode) {
        if (err.error) {
            const apiError = err.error;
            if (apiError.code === notLoggedInCode) {
                return true;
            }
        }
        return false;
    }
    /*
    * Determine if the current user token is stale
    *
    * @param err - The Http Error Response
    * @param authorizationMissingCode - the WSI code that identifies as authorization missing. usually 100-100
    * @returns true if the user token is stale. false if the user token is valid
    */
    static hasStaleToken(err, authorizationMissingCode = '100-100') {
        if (err.error) {
            const apiError = err.error;
            if (apiError.code === authorizationMissingCode) {
                return true;
            }
        }
        if (err.error) {
            const matches = JSON.stringify(err.error).match('Authorization token is invalid');
            return GenericUtil.isNullOrUndefined(matches) ? false : matches.length > 0;
        }
        return false;
    }
}

class AuthService {
    constructor(wsi, http) {
        this.wsi = wsi;
        this.http = http;
        this.wsi.serviceConfigSubject.subscribe(next => {
            this.appCode = next.appCode;
            this.endpoint = next.apiEndpoint + '/auth';
        });
    }
    getLoggedInUser(showChildRoles = false) {
        let params = new HttpParams();
        params = params.set('show_child_roles', String(showChildRoles));
        this.appCode.forEach(code => {
            if (params.has('app_code')) {
                params = params.append('app_code', String(code));
            }
            else {
                params = params.set('app_code', String(code));
            }
        });
        const url = `${this.endpoint}/users/loggedIn`;
        return this.http.get(url, { params }).pipe(share());
    }
    logout() {
        const authUrl = `${this.endpoint}/sessions/logout`;
        return this.http.post(authUrl, {});
    }
    ping() {
        const url = `${this.endpoint}/ping`;
        return this.http.get(url, {});
    }
    /*
      User
    */
    listUsers(filter) {
        const params = HttpUtil.objectToParams(filter);
        const url = `${this.endpoint}/users`;
        return this.http.get(url, { params });
    }
    getUser(id) {
        const url = `${this.endpoint}/users/${id}`;
        return this.http.get(url);
    }
    getUserByPerson(id) {
        const url = `${this.endpoint}/users/person/${id}`;
        return this.http.get(url);
    }
    /*
      User Roles
    */
    addRole(userId, roleId) {
        const url = `${this.endpoint}/users/${userId}/roles`;
        const data = { role_id: roleId };
        return this.http.post(url, data);
    }
    addRoleWithEntity(userId, roleId, entityId) {
        const url = `${this.endpoint}/users/${userId}/roles`;
        const data = { role_id: roleId, ws_entity_id: entityId };
        return this.http.post(url, data);
    }
    deleteRole(userId, roleId) {
        const url = `${this.endpoint}/users/${userId}/roles/${roleId}`;
        return this.http.delete(url);
    }
    deleteRoleWithEntity(userId, roleId, entityId) {
        const url = `${this.endpoint}/users/${userId}/roles/${roleId}?ws_entity_id=${entityId}`;
        return this.http.delete(url);
    }
}
AuthService.ɵfac = function AuthService_Factory(t) { return new (t || AuthService)(ɵngcc0.ɵɵinject(WorldskillsAngularLibService), ɵngcc0.ɵɵinject(ɵngcc6.HttpClient)); };
AuthService.ɵprov = ɵɵdefineInjectable({ factory: function AuthService_Factory() { return new AuthService(ɵɵinject(WorldskillsAngularLibService), ɵɵinject(HttpClient)); }, token: AuthService, providedIn: "root" });
AuthService.ctorParameters = () => [
    { type: WorldskillsAngularLibService },
    { type: HttpClient }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: WorldskillsAngularLibService }, { type: ɵngcc6.HttpClient }]; }, null); })();

const RETURN_URL_KEY = 'returnUrl';
const USER_CURRENT_KEY = 'user.current';

// TODO: This class can be cleanup up and optimized
// TODO: Generate auth state
class NgAuthService {
    constructor(wsi, oAuthService, authService) {
        this.wsi = wsi;
        this.oAuthService = oAuthService;
        this.authService = authService;
        this.currentUser = new BehaviorSubject(null);
        combineLatest([
            this.wsi.authConfigSubject,
            this.wsi.serviceConfigSubject
        ])
            .subscribe(([next]) => {
            this.oAuthService.configure(next);
            const user = JSON.parse(sessionStorage.getItem(USER_CURRENT_KEY));
            this.currentUser.next(user);
            this.oAuthService.setStorage(sessionStorage);
            this.oAuthService.tryLogin();
        });
    }
    keepAlive() {
        const observable = this.authService.ping().pipe(share());
        observable.subscribe(error => {
            console.log(error);
            this.logout();
        });
        return observable;
    }
    isLoggedIn() {
        return this.oAuthService.hasValidAccessToken();
    }
    getLoggedInUser(showChildRoles = false) {
        const observable = this.authService.getLoggedInUser(showChildRoles).pipe(share());
        observable.subscribe(next => {
            if (next != null) {
                sessionStorage.setItem(USER_CURRENT_KEY, JSON.stringify(next));
                this.currentUser.next(next);
            }
        }, () => {
            this.currentUser.next(null);
        });
        return observable;
    }
    login() {
        this.oAuthService.initImplicitFlow();
    }
    logout() {
        const observable = this.authService.logout().pipe(share());
        observable.subscribe(() => this.clearSession(), () => this.clearSession(), () => { });
        return observable;
    }
    clearSession() {
        sessionStorage.removeItem('nonce');
        sessionStorage.removeItem(USER_CURRENT_KEY);
        sessionStorage.removeItem('access_token_stored_at');
        sessionStorage.removeItem('access_token');
        sessionStorage.removeItem('token');
        this.oAuthService.logOut();
        this.currentUser.next(null);
    }
}
NgAuthService.ɵfac = function NgAuthService_Factory(t) { return new (t || NgAuthService)(ɵngcc0.ɵɵinject(WorldskillsAngularLibService), ɵngcc0.ɵɵinject(ɵngcc8.OAuthService), ɵngcc0.ɵɵinject(AuthService)); };
NgAuthService.ɵprov = ɵɵdefineInjectable({ factory: function NgAuthService_Factory() { return new NgAuthService(ɵɵinject(WorldskillsAngularLibService), ɵɵinject(OAuthService), ɵɵinject(AuthService)); }, token: NgAuthService, providedIn: "root" });
NgAuthService.ctorParameters = () => [
    { type: WorldskillsAngularLibService },
    { type: OAuthService },
    { type: AuthService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NgAuthService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: WorldskillsAngularLibService }, { type: ɵngcc8.OAuthService }, { type: AuthService }]; }, null); })();

class UserRoleDirective {
    constructor(templateRef, viewContainerRef, ngAuthService) {
        this.templateRef = templateRef;
        this.viewContainerRef = viewContainerRef;
        this.ngAuthService = ngAuthService;
        this.wsUserRole = [];
        this.wsUserRoleUser = true;
        this.wsUserRoleAll = false;
        this.wsUserRoleNegate = false;
    }
    ngOnInit() {
        if (this.wsUserRoleUser === true) {
            this.ngAuthService.currentUser.subscribe(user => this.renderIfValid(user));
        }
        else {
            this.renderIfValid(this.wsUserRoleUser);
        }
    }
    renderIfValid(user) {
        let valid = true;
        const roles = typeof this.wsUserRole === 'string' ? [this.wsUserRole] : this.wsUserRole;
        const all = this.wsUserRoleAll;
        const entityId = typeof this.wsUserRoleEntity === 'object' ? this.wsUserRoleEntity.id : this.wsUserRoleEntity;
        const appId = this.wsUserRoleAppId;
        if (user) {
            if (appId) {
                if (all) {
                    if (entityId) {
                        valid = UserRoleUtil.userHasAllRolesOfEntity(user, appId, entityId, ...roles);
                    }
                    else {
                        valid = UserRoleUtil.userHasAllRoles(user, appId, ...roles);
                    }
                }
                else {
                    if (entityId) {
                        valid = UserRoleUtil.userHasRolesOfEntity(user, appId, entityId, ...roles);
                    }
                    else {
                        valid = UserRoleUtil.userHasRoles(user, appId, ...roles);
                    }
                }
            }
            else {
                if (all) {
                    if (entityId) {
                        valid = UserRoleUtil.userHasAllRolesOfEntityOfAnyApp(user, entityId, ...roles);
                    }
                    else {
                        valid = UserRoleUtil.userHasAllRolesOfAnyApp(user, ...roles);
                    }
                }
                else {
                    if (entityId) {
                        valid = UserRoleUtil.userHasRolesOfEntityOfAnyApp(user, entityId, ...roles);
                    }
                    else {
                        valid = UserRoleUtil.userHasRolesOfAnyApp(user, ...roles);
                    }
                }
            }
        }
        else {
            valid = false;
        }
        if (this.wsUserRoleNegate) {
            valid = !valid;
        }
        if (valid) {
            this.viewContainerRef.clear();
            this.viewContainerRef.createEmbeddedView(this.templateRef);
        }
    }
}
UserRoleDirective.ɵfac = function UserRoleDirective_Factory(t) { return new (t || UserRoleDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(NgAuthService)); };
UserRoleDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: UserRoleDirective, selectors: [["", "wsUserRole", ""]], inputs: { wsUserRole: "wsUserRole", wsUserRoleUser: "wsUserRoleUser", wsUserRoleAll: "wsUserRoleAll", wsUserRoleNegate: "wsUserRoleNegate", wsUserRoleEntity: "wsUserRoleEntity", wsUserRoleAppId: "wsUserRoleAppId" } });
UserRoleDirective.ctorParameters = () => [
    { type: TemplateRef },
    { type: ViewContainerRef },
    { type: NgAuthService }
];
UserRoleDirective.propDecorators = {
    wsUserRole: [{ type: Input }],
    wsUserRoleUser: [{ type: Input }],
    wsUserRoleAll: [{ type: Input }],
    wsUserRoleEntity: [{ type: Input }],
    wsUserRoleAppId: [{ type: Input }],
    wsUserRoleNegate: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(UserRoleDirective, [{
        type: Directive,
        args: [{
                selector: '[wsUserRole]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }, { type: ɵngcc0.ViewContainerRef }, { type: NgAuthService }]; }, { wsUserRole: [{
            type: Input
        }], wsUserRoleUser: [{
            type: Input
        }], wsUserRoleAll: [{
            type: Input
        }], wsUserRoleNegate: [{
            type: Input
        }], wsUserRoleEntity: [{
            type: Input
        }], wsUserRoleAppId: [{
            type: Input
        }] }); })();

class AuthHeaderComponent {
    constructor(router, ngAuthService) {
        this.router = router;
        this.ngAuthService = ngAuthService;
        this.appName = 'Application';
        this.menuItems = [];
        // tslint:disable-next-line:no-output-on-prefix
        this.onLogin = new EventEmitter();
        // tslint:disable-next-line:no-output-on-prefix
        this.onLogout = new EventEmitter();
        this.autoLoginOnLogout = false;
    }
    ngOnInit() {
        this.ngAuthService.currentUser.subscribe(user => (this.currentUser = user));
    }
    isRouteActive(route) {
        return route === this.router.url;
    }
    login() {
        this.ngAuthService.login();
        if (this.onLogin) {
            this.onLogin.emit();
        }
    }
    logout() {
        this.ngAuthService.logout().subscribe(() => {
            if (this.onLogout) {
                this.onLogout.emit();
            }
            if (this.autoLoginOnLogout) {
                this.login();
            }
        });
    }
    get userRoles() {
        return this.currentUser && this.currentUser.roles ? this.currentUser.roles.map(item => item.name) : [];
    }
    get initials() {
        let s = '';
        if (this.currentUser) {
            if (this.currentUser.first_name) {
                s = this.currentUser.first_name.substr(0, 1);
            }
            if (this.currentUser.last_name) {
                s += this.currentUser.last_name.substr(0, 1);
            }
        }
        return s.toUpperCase();
    }
}
AuthHeaderComponent.ɵfac = function AuthHeaderComponent_Factory(t) { return new (t || AuthHeaderComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.Router), ɵngcc0.ɵɵdirectiveInject(NgAuthService)); };
AuthHeaderComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AuthHeaderComponent, selectors: [["ws-auth-header"]], inputs: { appName: "appName", menuItems: "menuItems", autoLoginOnLogout: "autoLoginOnLogout", appNameTemplate: "appNameTemplate", menuTemplate: "menuTemplate" }, outputs: { onLogin: "onLogin", onLogout: "onLogout" }, decls: 8, vars: 2, consts: [["appNameDefaultTemplate", ""], ["menuDefaultTemplate", ""], [1, "navbar", "navbar-expand-md", "ws-navbar-main", "ws-navbar-stripe", "wsmember-navbar-main", "wsmember-bg-pink"], [1, "container"], [4, "ngTemplateOutlet"], ["href", "#", 1, "navbar-brand"], [1, "ml-1", "text-white"], ["type", "button", "data-toggle", "collapse", "data-target", "#navbarSupportedContent", "aria-controls", "navbarSupportedContent", "aria-expanded", "false", "aria-label", "Toggle navigation", 1, "navbar-toggler", "collapsed"], ["id", "navbarSupportedContent", 1, "collapse", "navbar-collapse"], [1, "navbar-nav", "ml-auto"], [3, "class", 4, "ngFor", "ngForOf"], ["class", "dropdown ml-2", 4, "ngIf"], ["class", "btn btn-light btn-sm ml-2 wsi-login", 3, "click", 4, "ngIf"], [1, "nav-link", 3, "routerLink"], [1, "dropdown", "ml-2"], ["type", "button", "data-toggle", "dropdown", 1, "btn", "btn-white", "rounded-pill"], [1, "dropdown-menu", "dropdown-menu-right"], ["href", "#", "tabindex", "-1", 1, "dropdown-item", "disabled"], [1, "dropdown-divider"], ["href", "#", 1, "dropdown-item", 3, "click"], [1, "btn", "btn-light", "btn-sm", "ml-2", "wsi-login", 3, "click"]], template: function AuthHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, AuthHeaderComponent_ng_template_0_Template, 4, 1, "ng-template", null, 0, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(2, AuthHeaderComponent_ng_template_2_Template, 8, 7, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementStart(4, "nav", 2);
        ɵngcc0.ɵɵelementStart(5, "div", 3);
        ɵngcc0.ɵɵtemplate(6, AuthHeaderComponent_ng_container_6_Template, 1, 0, "ng-container", 4);
        ɵngcc0.ɵɵtemplate(7, AuthHeaderComponent_ng_container_7_Template, 1, 0, "ng-container", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(1);
        const _r2 = ɵngcc0.ɵɵreference(3);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.appNameTemplate ? ctx.appNameTemplate : _r0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.menuTemplate ? ctx.menuTemplate : _r2);
    } }, directives: [ɵngcc4.NgbNavbar, ɵngcc1.NgTemplateOutlet, WordmarkComponent, ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc3.RouterLinkWithHref], pipes: [MenuAccessPipe, ɵngcc2.TranslatePipe], styles: [""] });
AuthHeaderComponent.ctorParameters = () => [
    { type: Router },
    { type: NgAuthService }
];
AuthHeaderComponent.propDecorators = {
    appName: [{ type: Input }],
    menuItems: [{ type: Input }],
    onLogin: [{ type: Output }],
    onLogout: [{ type: Output }],
    appNameTemplate: [{ type: Input }],
    menuTemplate: [{ type: Input }],
    autoLoginOnLogout: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthHeaderComponent, [{
        type: Component,
        args: [{
                selector: 'ws-auth-header',
                template: "<ng-template #appNameDefaultTemplate>\n    <a class=\"navbar-brand\" href=\"#\">\n        <ws-wordmark></ws-wordmark>\n        <span class=\"ml-1 text-white\">{{ appName }}</span>\n    </a>\n</ng-template>\n<ng-template #menuDefaultTemplate>\n    <button class=\"navbar-toggler collapsed\" type=\"button\" data-toggle=\"collapse\" data-target=\"#navbarSupportedContent\"\n        aria-controls=\"navbarSupportedContent\" aria-expanded=\"false\" aria-label=\"Toggle navigation\">\n        Menu\n    </button>\n    <div class=\"collapse navbar-collapse\" id=\"navbarSupportedContent\">\n        <ul class=\"navbar-nav ml-auto\">\n            <li class=\"nav-item {{ isRouteActive(item.url) ? 'active' : '' }}\"\n                *ngFor=\"let item of menuItems | wsMenuAccessFilter : !!currentUser : userRoles\">\n                <a class=\"nav-link\" [routerLink]=\"item.params ? [item.url, item.params] : [item.url]\">\n                    {{ item.label }}\n                </a>\n            </li>\n        </ul>\n        <div class=\"dropdown ml-2\" *ngIf=\"currentUser\">\n            <button class=\"btn btn-white rounded-pill\" type=\"button\" data-toggle=\"dropdown\">\n                {{ initials }}\n            </button>\n            <div class=\"dropdown-menu dropdown-menu-right\">\n                <a class=\"dropdown-item disabled\" href=\"#\" tabindex=\"-1\">{{ currentUser.first_name }}\n                    {{ currentUser.last_name }}</a>\n                <div class=\"dropdown-divider\"></div>\n                <a class=\"dropdown-item\" href=\"#\" (click)=\"$event.preventDefault(); logout()\">{{ 'auth.logout' | translate }}</a>\n            </div>\n        </div>\n        <a class=\"btn btn-light btn-sm ml-2 wsi-login\" (click)=\"$event.preventDefault(); login()\"\n            *ngIf=\"!currentUser\">{{ 'auth.login' | translate }}</a>\n    </div>\n</ng-template>\n<nav class=\"navbar navbar-expand-md ws-navbar-main ws-navbar-stripe wsmember-navbar-main wsmember-bg-pink\">\n    <div class=\"container\">\n        <ng-container *ngTemplateOutlet=\"appNameTemplate ? appNameTemplate : appNameDefaultTemplate\"></ng-container>\n        <ng-container *ngTemplateOutlet=\"menuTemplate ? menuTemplate : menuDefaultTemplate\"></ng-container>\n    </div>\n</nav>",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc3.Router }, { type: NgAuthService }]; }, { appName: [{
            type: Input
        }], menuItems: [{
            type: Input
        }], onLogin: [{
            type: Output
        }], onLogout: [{
            type: Output
        }], autoLoginOnLogout: [{
            type: Input
        }], appNameTemplate: [{
            type: Input
        }], menuTemplate: [{
            type: Input
        }] }); })();

class AuthFooterComponent {
    constructor(ngAuthService, wsi, translator) {
        this.ngAuthService = ngAuthService;
        this.wsi = wsi;
        this.translator = translator;
        // tslint:disable-next-line:no-output-on-prefix
        this.onLogin = new EventEmitter();
        // tslint:disable-next-line:no-output-on-prefix
        this.onLogout = new EventEmitter();
        this.loginLabel = 'Log in';
        this.logoutLabel = 'Log out';
        this.languageChange = new EventEmitter();
        this.autoLoginOnLogout = false;
    }
    ngOnInit() {
        this.date = new Date();
        this.ngAuthService.currentUser.subscribe(user => (this.currentUser = user));
        this.wsi.appConfigSubject.subscribe(appConfig => {
            this.supportEmail = appConfig.supportEmailAddress;
        });
        this.languages = LangUtil.getDefaultLanguages();
        this.selectedLanguage = this.translator.getSelectedLanguage();
    }
    login() {
        this.ngAuthService.login();
        if (this.onLogin) {
            this.onLogin.emit();
        }
    }
    logout() {
        this.ngAuthService.logout().subscribe(() => {
            if (this.onLogout) {
                this.onLogout.emit();
            }
            if (this.autoLoginOnLogout) {
                this.login();
            }
        });
    }
    changeLanguage(model) {
        this.selectedLanguage = model;
        this.translator.init(model.code);
    }
    isLanguageSelected(model) {
        if (GenericUtil.isNullOrUndefined(this.selectedLanguage)) {
            return model.code === LangUtil.getDefaultLanguage().code;
        }
        return model.code === this.selectedLanguage.code;
    }
    languagePrompt() {
        alert(MISSING_LANGUAGE_MESSAGE(this.supportEmail || this.wsi.defaultSupportEmailAddress));
    }
    // get list of languages - backward compatible for apps that still want to define their own language
    getLanguages() {
        if (GenericUtil.isNullOrUndefined(this.languages) || this.languages.length === 0) {
            return LangUtil.getDefaultLanguages();
        }
        return this.languages;
    }
}
AuthFooterComponent.ɵfac = function AuthFooterComponent_Factory(t) { return new (t || AuthFooterComponent)(ɵngcc0.ɵɵdirectiveInject(NgAuthService), ɵngcc0.ɵɵdirectiveInject(WorldskillsAngularLibService), ɵngcc0.ɵɵdirectiveInject(WsiTranslateService)); };
AuthFooterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AuthFooterComponent, selectors: [["ws-auth-footer"]], viewQuery: function AuthFooterComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c3, true);
        ɵngcc0.ɵɵviewQuery(_c4, true);
        ɵngcc0.ɵɵviewQuery(_c5, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.col1DefaultTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.col6DefaultTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.colDefaultTemplate = _t.first);
    } }, inputs: { loginLabel: "loginLabel", logoutLabel: "logoutLabel", autoLoginOnLogout: "autoLoginOnLogout", col1Template: "col1Template", col2Template: "col2Template", col3Template: "col3Template", col4Template: "col4Template", col5Template: "col5Template", col6Template: "col6Template" }, outputs: { onLogin: "onLogin", onLogout: "onLogout", languageChange: "languageChange" }, decls: 44, vars: 25, consts: [["col1DefaultTemplate", ""], ["col6DefaultTemplate", ""], ["colDefaultTemplate", ""], [1, "ws-page-footer"], [1, "container"], [1, "ws-page-footer-row"], [1, "ws-page-footer-col-sm"], [4, "ngTemplateOutlet"], [1, "ws-page-footer-row", "pb-3"], [1, "ws-page-footer-col-lg"], [1, "list-inline", "mt-2"], [1, "list-inline-item"], ["href", "https://worldskills.org/site/privacy/", "target", "_blank"], ["href", "https://worldskills.org/site/terms/", "target", "_blank"], ["href", "https://worldskills.org/site/contact/", "target", "_blank"], ["class", "list-inline-item", 4, "ngIf"], ["class", "btn-toolbar justify-content-end", 4, "ngIf"], ["href", "https://worldskills.org/internal/", "target", "_blank"], ["href", "https://worldskills.org/internal/wiw/", "target", "_blank"], ["href", "https://glossary.worldskills.org/", "target", "_blank"], ["href", "https://registrations.worldskills.org/", "target", "_blank"], ["href", "https://forums.worldskills.org/", "target", "_blank"], ["href", "https://il.worldskills.org/", "target", "_blank"], ["href", "https://skill-management.worldskills.org/", "target", "_blank"], [1, "text-right", "mt-5"], ["href", "https://worldskills.org/", "target", "_blank"], ["mode", "default"], ["href", "#", 3, "click"], [1, "btn-toolbar", "justify-content-end"], [1, "btn-group", "btn-group-sm", "dropup"], ["type", "button", "data-toggle", "dropdown", "aria-haspopup", "true", "aria-expanded", "false", 1, "btn", "btn-outline-light", "dropdown-toggle"], [1, "dropdown-menu", "dropdown-menu-right"], ["class", "dropdown-item", "href", "#", 3, "active", "click", 4, "ngFor", "ngForOf"], [1, "dropdown-divider"], ["href", "#", 1, "dropdown-item", 3, "click"]], template: function AuthFooterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, AuthFooterComponent_ng_template_0_Template, 29, 21, "ng-template", null, 0, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(2, AuthFooterComponent_ng_template_2_Template, 3, 0, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(4, AuthFooterComponent_ng_template_4_Template, 0, 0, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementStart(6, "footer", 3);
        ɵngcc0.ɵɵelementStart(7, "div", 4);
        ɵngcc0.ɵɵelementStart(8, "div", 5);
        ɵngcc0.ɵɵelementStart(9, "aside", 6);
        ɵngcc0.ɵɵtemplate(10, AuthFooterComponent_ng_container_10_Template, 1, 0, "ng-container", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "aside", 6);
        ɵngcc0.ɵɵtemplate(12, AuthFooterComponent_ng_container_12_Template, 1, 0, "ng-container", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "aside", 6);
        ɵngcc0.ɵɵtemplate(14, AuthFooterComponent_ng_container_14_Template, 1, 0, "ng-container", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "aside", 6);
        ɵngcc0.ɵɵtemplate(16, AuthFooterComponent_ng_container_16_Template, 1, 0, "ng-container", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(17, "aside", 6);
        ɵngcc0.ɵɵtemplate(18, AuthFooterComponent_ng_container_18_Template, 1, 0, "ng-container", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(19, "aside", 6);
        ɵngcc0.ɵɵtemplate(20, AuthFooterComponent_ng_container_20_Template, 1, 0, "ng-container", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(21, "div", 8);
        ɵngcc0.ɵɵelementStart(22, "div", 9);
        ɵngcc0.ɵɵelementStart(23, "ul", 10);
        ɵngcc0.ɵɵelementStart(24, "li", 11);
        ɵngcc0.ɵɵtext(25);
        ɵngcc0.ɵɵpipe(26, "date");
        ɵngcc0.ɵɵpipe(27, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(28, "li", 11);
        ɵngcc0.ɵɵelementStart(29, "a", 12);
        ɵngcc0.ɵɵtext(30);
        ɵngcc0.ɵɵpipe(31, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(32, "li", 11);
        ɵngcc0.ɵɵelementStart(33, "a", 13);
        ɵngcc0.ɵɵtext(34);
        ɵngcc0.ɵɵpipe(35, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(36, "li", 11);
        ɵngcc0.ɵɵelementStart(37, "a", 14);
        ɵngcc0.ɵɵtext(38);
        ɵngcc0.ɵɵpipe(39, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(40, AuthFooterComponent_li_40_Template, 4, 3, "li", 15);
        ɵngcc0.ɵɵtemplate(41, AuthFooterComponent_li_41_Template, 3, 0, "li", 15);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(42, "div", 9);
        ɵngcc0.ɵɵtemplate(43, AuthFooterComponent_div_43_Template, 11, 7, "div", 16);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(1);
        const _r2 = ɵngcc0.ɵɵreference(3);
        const _r4 = ɵngcc0.ɵɵreference(5);
        ɵngcc0.ɵɵadvance(10);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.col1Template ? ctx.col1Template : _r0);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.col2Template ? ctx.col2Template : _r4);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.col3Template ? ctx.col3Template : _r4);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.col4Template ? ctx.col4Template : _r4);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.col5Template ? ctx.col5Template : _r4);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.col6Template ? ctx.col6Template : _r2);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate2("\u00A9 ", ɵngcc0.ɵɵpipeBind2(26, 14, ctx.date, "yyyy"), " ", ɵngcc0.ɵɵpipeBind1(27, 17, "footer.copyright.wsi"), "");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(31, 19, "footer.copyright.privacy"));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(35, 21, "footer.copyright.terms"));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(39, 23, "footer.copyright.contact"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.currentUser);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !!ctx.currentUser);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.getLanguages());
    } }, directives: [ɵngcc1.NgTemplateOutlet, ɵngcc1.NgIf, LogoComponent, ɵngcc1.NgForOf], pipes: [ɵngcc1.DatePipe, ɵngcc2.TranslatePipe], styles: [""] });
AuthFooterComponent.ctorParameters = () => [
    { type: NgAuthService },
    { type: WorldskillsAngularLibService },
    { type: WsiTranslateService }
];
AuthFooterComponent.propDecorators = {
    col1Template: [{ type: Input }],
    col2Template: [{ type: Input }],
    col3Template: [{ type: Input }],
    col4Template: [{ type: Input }],
    col5Template: [{ type: Input }],
    col6Template: [{ type: Input }],
    onLogin: [{ type: Output }],
    onLogout: [{ type: Output }],
    loginLabel: [{ type: Input }],
    logoutLabel: [{ type: Input }],
    languageChange: [{ type: Output }],
    autoLoginOnLogout: [{ type: Input }],
    col1DefaultTemplate: [{ type: ViewChild, args: ['#col1DefaultTemplate',] }],
    col6DefaultTemplate: [{ type: ViewChild, args: ['#col6DefaultTemplate',] }],
    colDefaultTemplate: [{ type: ViewChild, args: ['#colDefaultTemplate',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthFooterComponent, [{
        type: Component,
        args: [{
                selector: 'ws-auth-footer',
                template: "<ng-template #col1DefaultTemplate>\n    <h1><a href=\"https://worldskills.org/internal/\" target=\"_blank\">{{ 'footer.links.my.worldskills' | translate }}</a>\n    </h1>\n    <ul>\n        <li><a href=\"https://worldskills.org/internal/wiw/\" target=\"_blank\">{{ 'footer.links.wiw' | translate }}</a>\n        </li>\n        <li><a href=\"https://glossary.worldskills.org/\" target=\"_blank\">{{ 'footer.links.glossary' | translate }}</a>\n        </li>\n        <li><a href=\"https://registrations.worldskills.org/\"\n                target=\"_blank\">{{ 'footer.links.registrations' | translate }}</a></li>\n        <li><a href=\"https://forums.worldskills.org/\" target=\"_blank\">{{ 'footer.links.forums' | translate }}</a></li>\n        <li><a href=\"https://il.worldskills.org/\"\n                target=\"_blank\">{{ 'footer.links.infrastructure.lists' | translate }}</a></li>\n        <li><a href=\"https://skill-management.worldskills.org/\"\n                target=\"_blank\">{{ 'footer.links.skill.management' | translate }}</a></li>\n    </ul>\n</ng-template>\n<ng-template #col6DefaultTemplate>\n    <div class=\"text-right mt-5\">\n        <a href=\"https://worldskills.org/\" target=\"_blank\">\n            <ws-logo mode=\"default\"></ws-logo>\n        </a>\n    </div>\n</ng-template>\n\n<ng-template #colDefaultTemplate>\n</ng-template>\n\n<footer class=\"ws-page-footer\">\n    <div class=\"container\">\n        <div class=\"ws-page-footer-row\">\n            <aside class=\"ws-page-footer-col-sm\">\n                <ng-container *ngTemplateOutlet=\"col1Template ? col1Template : col1DefaultTemplate\"></ng-container>\n            </aside>\n            <aside class=\"ws-page-footer-col-sm\">\n                <ng-container *ngTemplateOutlet=\"col2Template ? col2Template : colDefaultTemplate\"></ng-container>\n            </aside>\n            <aside class=\"ws-page-footer-col-sm\">\n                <ng-container *ngTemplateOutlet=\"col3Template? col3Template : colDefaultTemplate\"></ng-container>\n            </aside>\n            <aside class=\"ws-page-footer-col-sm\">\n                <ng-container *ngTemplateOutlet=\"col4Template? col4Template : colDefaultTemplate\"></ng-container>\n            </aside>\n            <aside class=\"ws-page-footer-col-sm\">\n                <ng-container *ngTemplateOutlet=\"col5Template? col5Template : colDefaultTemplate\"></ng-container>\n            </aside>\n            <aside class=\"ws-page-footer-col-sm\">\n                <ng-container *ngTemplateOutlet=\"col6Template? col6Template : col6DefaultTemplate\"></ng-container>\n            </aside>\n        </div>\n        <div class=\"ws-page-footer-row pb-3\">\n            <div class=\"ws-page-footer-col-lg\">\n                <ul class=\"list-inline mt-2\">\n                    <li class=\"list-inline-item\">\u00A9 {{date | date:'yyyy'}} {{ 'footer.copyright.wsi' | translate }}</li>\n                    <li class=\"list-inline-item\"><a href=\"https://worldskills.org/site/privacy/\"\n                            target=\"_blank\">{{ 'footer.copyright.privacy' | translate }}</a></li>\n                    <li class=\"list-inline-item\"><a href=\"https://worldskills.org/site/terms/\"\n                            target=\"_blank\">{{ 'footer.copyright.terms' | translate }}</a>\n                    </li>\n                    <li class=\"list-inline-item\"><a href=\"https://worldskills.org/site/contact/\"\n                            target=\"_blank\">{{ 'footer.copyright.contact' | translate }}</a></li>\n                    <li *ngIf=\"!currentUser\" class=\"list-inline-item\">\n                        <a href=\"#\" (click)=\"$event.preventDefault(); login()\">{{ 'auth.login' | translate }}</a>\n                    </li>\n                    <li *ngIf=\"!!currentUser\" class=\"list-inline-item\">\n                        <a href=\"#\" (click)=\"$event.preventDefault(); logout()\">'auth.logout'</a>\n                    </li>\n                </ul>\n            </div>\n            <div class=\"ws-page-footer-col-lg\">\n                <div class=\"btn-toolbar justify-content-end\" *ngIf=\"getLanguages()\">\n                    <div class=\"btn-group btn-group-sm dropup\">\n                        <button type=\"button\" class=\"btn btn-outline-light dropdown-toggle\" data-toggle=\"dropdown\"\n                            aria-haspopup=\"true\" aria-expanded=\"false\">\n                            {{ 'footer.translation.language' | translate }}\n                        </button>\n                        <div class=\"dropdown-menu dropdown-menu-right\">\n                            <a *ngFor=\"let language of getLanguages()\"\n                                (click)=\"$event.preventDefault(); changeLanguage(language);\"\n                                [class.active]=\"isLanguageSelected(language)\" class=\"dropdown-item\" href=\"#\">\n                                {{ language.name }}\n                            </a>\n                            <div class=\"dropdown-divider\"></div>\n                            <a (click)=\"$event.preventDefault(); languagePrompt();\" class=\"dropdown-item\" href=\"#\">\n                                {{ 'footer.translation.missing' | translate }}\n                            </a>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</footer>",
                styles: [""]
            }]
    }], function () { return [{ type: NgAuthService }, { type: WorldskillsAngularLibService }, { type: WsiTranslateService }]; }, { onLogin: [{
            type: Output
        }], onLogout: [{
            type: Output
        }], loginLabel: [{
            type: Input
        }], logoutLabel: [{
            type: Input
        }], languageChange: [{
            type: Output
        }], autoLoginOnLogout: [{
            type: Input
        }], col1Template: [{
            type: Input
        }], col2Template: [{
            type: Input
        }], col3Template: [{
            type: Input
        }], col4Template: [{
            type: Input
        }], col5Template: [{
            type: Input
        }], col6Template: [{
            type: Input
        }], col1DefaultTemplate: [{
            type: ViewChild,
            args: ['#col1DefaultTemplate']
        }], col6DefaultTemplate: [{
            type: ViewChild,
            args: ['#col6DefaultTemplate']
        }], colDefaultTemplate: [{
            type: ViewChild,
            args: ['#colDefaultTemplate']
        }] }); })();

var WSIMediaType;
(function (WSIMediaType) {
    WSIMediaType["XML"] = "application/xml";
    WSIMediaType["JSON"] = "application/json";
    WSIMediaType["PDF"] = "application/pdf";
    WSIMediaType["VCF"] = "text/vcard";
    WSIMediaType["XLSX"] = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    WSIMediaType["ZIP"] = "application/zip";
})(WSIMediaType || (WSIMediaType = {}));
function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) {
        return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}
function getFilenameExtension(filename) {
    return filename.substr(filename.lastIndexOf('.') + 1);
}

class ResourceThumbnailComponent {
    constructor() {
        this.showDetailInfo = false;
    }
    get resourceThumbnail() {
        return this._resourceThumbnail;
    }
    set resourceThumbnail(view) {
        this._resourceThumbnail = view;
        if (!this._resourceThumbnail.thumbnailLink) {
            this._resourceThumbnail.thumbnailLink = 'assets/images/default-thumbnail.png';
        }
    }
    ngOnInit() {
    }
    isNumber(value) {
        return typeof value === 'number';
    }
    showDownload() {
        return this._resourceThumbnail && !!this._resourceThumbnail.downloadLink;
    }
    getFileTypeIcon() {
        let defaultIcon;
        const ext = getFilenameExtension(this._resourceThumbnail.filename).toLowerCase();
        switch (ext) {
            case 'pdf':
                defaultIcon = 'file-pdf-o';
                break;
            case 'jpg':
            case 'png':
            case 'jpeg':
            case 'bmp':
                defaultIcon = 'file-image-o';
                break;
            default:
                defaultIcon = 'file';
                break;
        }
        return `fa-${defaultIcon}`;
    }
}
ResourceThumbnailComponent.ɵfac = function ResourceThumbnailComponent_Factory(t) { return new (t || ResourceThumbnailComponent)(); };
ResourceThumbnailComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ResourceThumbnailComponent, selectors: [["ws-resource-thumbnail"]], inputs: { resourceThumbnail: "resourceThumbnail" }, decls: 9, vars: 7, consts: [[1, "ws-thumbnail", "card", "shadow", 2, "max-width", "160px", "width", "auto", "height", "auto"], ["alt", "Resource thumbnail image", 1, "card-img-top", 2, "display", "block", "max-width", "160px", "max-height", "160px", "width", "auto", "height", "auto", 3, "src"], [1, "card-footer", "bg-white", "text-center", "small"], [1, "title-overflow", "font-weight-bolder", 3, "title"], [1, "text-muted"], [4, "ngIf"], [3, "href"]], template: function ResourceThumbnailComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "img", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵpipe(7, "fileSize");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(8, ResourceThumbnailComponent_div_8_Template, 3, 1, "div", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("src", ctx.resourceThumbnail.thumbnailLink, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("title", ctx.resourceThumbnail.filename);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.resourceThumbnail.filename);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.isNumber(ctx.resourceThumbnail.fileSize) ? ɵngcc0.ɵɵpipeBind1(7, 5, ctx.resourceThumbnail.fileSize) : ctx.resourceThumbnail.fileSize);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showDownload());
    } }, directives: function () { return [ɵngcc1.NgIf]; }, pipes: function () { return [FileSizePipe]; }, styles: [".ws-thumbnail[_ngcontent-%COMP%]{opacity:1;transition:.5s ease}.card-footer[_ngcontent-%COMP%], .ws-thumbnail[_ngcontent-%COMP%]:hover   .card-img-top[_ngcontent-%COMP%]{opacity:.7}.file-extension-icon[_ngcontent-%COMP%]{width:20%}.title-overflow[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:100%}"] });
ResourceThumbnailComponent.ctorParameters = () => [];
ResourceThumbnailComponent.propDecorators = {
    resourceThumbnail: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ResourceThumbnailComponent, [{
        type: Component,
        args: [{
                selector: 'ws-resource-thumbnail',
                template: "<div class=\"ws-thumbnail card shadow\" style=\"max-width: 160px;width: auto; height: auto\">\n    <img class=\"card-img-top\" [src]=\"resourceThumbnail.thumbnailLink\" alt=\"Resource thumbnail image\"\n         style=\"display: block; max-width: 160px;max-height: 160px; width: auto; height: auto\">\n\n    <div class=\"card-footer bg-white text-center small\">\n        <div class=\"title-overflow font-weight-bolder \"\n             [title]=\"resourceThumbnail.filename\">{{resourceThumbnail.filename}}</div>\n        <div class=\"text-muted \">{{isNumber(resourceThumbnail.fileSize) ? (resourceThumbnail.fileSize | fileSize) : resourceThumbnail.fileSize}}</div>\n        <div *ngIf=\"showDownload()\"><a [href]=\"resourceThumbnail.downloadLink\">Download</a></div>\n    </div>\n</div>\n",
                styles: [".ws-thumbnail{opacity:1;transition:.5s ease}.card-footer,.ws-thumbnail:hover .card-img-top{opacity:.7}.file-extension-icon{width:20%}.title-overflow{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:100%}"]
            }]
    }], function () { return []; }, { resourceThumbnail: [{
            type: Input
        }] }); })();

class FileSizePipe {
    transform(size, ...args) {
        return size ? formatBytes(size) : '';
    }
}
FileSizePipe.ɵfac = function FileSizePipe_Factory(t) { return new (t || FileSizePipe)(); };
FileSizePipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "fileSize", type: FileSizePipe, pure: true });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FileSizePipe, [{
        type: Pipe,
        args: [{
                name: 'fileSize'
            }]
    }], null, null); })();

class UploadService {
    constructor(http) {
        this.http = http;
    }
    prepareUpload(url, data, params, method = 'POST') {
        const options = {
            params,
            reportProgress: true,
        };
        return new HttpRequest(method, url, data, options);
    }
    // Full list of events: https://angular.io/api/common/http/HttpEventType
    // event specific classes: https://angular.io/api/common/http/HttpEvent#description
    listen(request, progress, complete) {
        this.http.request(request).subscribe((event) => {
            switch (event.type) {
                case HttpEventType.UploadProgress:
                    progress(event);
                    break;
                case HttpEventType.Response:
                    complete(event);
                    break;
            }
        });
    }
}
UploadService.ɵfac = function UploadService_Factory(t) { return new (t || UploadService)(ɵngcc0.ɵɵinject(ɵngcc6.HttpClient)); };
UploadService.ɵprov = ɵɵdefineInjectable({ factory: function UploadService_Factory() { return new UploadService(ɵɵinject(HttpClient)); }, token: UploadService, providedIn: "root" });
UploadService.ctorParameters = () => [
    { type: HttpClient }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(UploadService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc6.HttpClient }]; }, null); })();

function isMulticastOptions(object) {
    return object && ('subject' in object || 'loader' in object || 'subscription' in object || 'onError' in object);
}
// Fetch params can be empty and probably is most of the time, so hard to check this in a signature
function isFetchParams(object) {
    return object && ('limit' in object || 'offset' in object || 'sort' in object || 'l' in object);
}
function isRequestOptions(object) {
    return object && ('url' in object);
}
const FULL = {
    subject: true,
    loader: true,
    subscription: true
};
const LOADER_ONLY = {
    loader: true
};
const NO_SUBJECT = {
    loader: true,
    subscription: true
};
class WsService {
    constructor() {
        this.loaders = new BehaviorSubject(0);
        this.subscription = null;
        this.subject = new ReplaySubject(1);
        this.loading = new ReplaySubject(1);
        this.loaders.subscribe(numLoaders => this.loading.next(numLoaders !== 0));
    }
    resolveArgs(p1, p2, p3, defaultMulticastOptions, defaultFetchParams) {
        let fetchParams;
        let multicastOptions;
        let requestOptions;
        if (isRequestOptions(p3)) {
            fetchParams = p1;
            multicastOptions = p2;
            requestOptions = p3;
        }
        else if (isRequestOptions(p2)) {
            requestOptions = p2;
            if (isMulticastOptions(p1)) {
                multicastOptions = p1;
            }
            else if (!isMulticastOptions(p1)) {
                fetchParams = p1;
            }
        }
        else if (isRequestOptions(p1)) {
            requestOptions = p1;
        }
        else {
            if (isMulticastOptions(p2) && !isMulticastOptions(p1)) {
                fetchParams = p1;
                multicastOptions = p2;
            }
            else {
                if (isMulticastOptions(p1)) {
                    multicastOptions = p1;
                }
                else if (!isMulticastOptions(p1)) {
                    fetchParams = p1;
                }
            }
        }
        if (fetchParams === undefined) {
            fetchParams = defaultFetchParams;
        }
        if (multicastOptions === undefined) {
            multicastOptions = defaultMulticastOptions;
        }
        if (requestOptions === undefined) {
            requestOptions = {};
        }
        return {
            fetchParams,
            multicastOptions,
            requestOptions
        };
    }
    incrementLoader() {
        this.loaders.pipe(take(1)).subscribe(v => {
            this.loaders.next(++v);
        });
    }
    decrementLoader() {
        this.loaders.pipe(take(1)).subscribe(v => {
            const loaders = Math.max(0, v - 1);
            this.loaders.next(loaders);
        });
    }
    multicast(observable, options = FULL) {
        const { loader, subject, subscription, onError } = options;
        if (loader) {
            this.incrementLoader();
        }
        if (subscription && this.subscription) {
            if (loader && !this.subscription.closed) {
                this.decrementLoader();
                this.subscription.unsubscribe();
            }
        }
        const s = observable.subscribe(value => {
            if (loader) {
                this.decrementLoader();
            }
            if (subject) {
                this.subject.next(value);
            }
        }, error => {
            if (loader) {
                this.decrementLoader();
            }
            if (onError) {
                onError(error);
            }
        });
        if (subscription) {
            this.subscription = s;
        }
    }
    request(observable, options = FULL) {
        this.multicast(observable, options);
        return observable;
    }
    requestMany(observables, options = NO_SUBJECT) {
        const forkJoined = forkJoin(observables);
        this.multicast(forkJoined, options);
        return forkJoined;
    }
}

class ResourceService extends WsService {
    constructor(wsi, http, uploader) {
        super();
        this.wsi = wsi;
        this.http = http;
        this.uploader = uploader;
        this.wsi.serviceConfigSubject.subscribe(next => {
            this.url = next.apiEndpoint + '/resources';
        });
    }
    /*
      ResourceResource
    */
    // allow a client to user submit an object directly or use a managed object
    search(filter) {
        const params = HttpUtil.objectToParams(filter);
        return this.http.get(this.url, { params });
    }
    get(id) {
        const url = `${this.url}/${id}`;
        return this.http.get(url);
    }
    delete(id) {
        const url = `${this.url}/${id}`;
        return this.http.delete(url);
    }
    update(id, model) {
        const url = `${this.url}/${id}`;
        return this.http.put(url, model);
    }
    // this more or less saves the resource to the api
    // the client has control over weather it's a POST or a PUT
    upload(data, file, method = 'POST', id = 0) {
        const url = method === 'POST' ? this.url : `${this.url}/${id}`;
        const formData = new FormData();
        formData.append('key', 'value');
        formData.append('requestData', JSON.stringify(data));
        formData.append('file', file);
        return this.uploader.prepareUpload(url, formData, new HttpParams(), method);
    }
    /* /types
      ResourceTypeResource
    */
    listTypes() {
        const url = `${this.url}/types`;
        return this.http.get(url);
    }
    getType(id) {
        const url = `${this.url}/types/${id}`;
        return this.http.get(url);
    }
    /* /metadata
      MetadataResource
    */
    listMetadata() {
        const url = `${this.url}/metadata`;
        return this.http.get(url);
    }
    getMetadata(id) {
        const url = `${this.url}/metadata/${id}`;
        return this.http.get(url);
    }
    createMetadata(model) {
        const url = `${this.url}/metadata`;
        return this.http.post(url, model);
    }
    updateMetadata(id, model) {
        const url = `${this.url}/metadata/${id}`;
        return this.http.put(url, model);
    }
    deleteMetadata(id) {
        const url = `${this.url}/metadata/${id}`;
        return this.http.delete(url);
    }
    downloadResources(resourceIds) {
        const uniqueResourceIds = new Set(resourceIds);
        let params = new HttpParams();
        for (const id of uniqueResourceIds) {
            params = params.append('resource_ids', id.toString());
        }
        const observable = this.http.get(`${this.url}/download/resources`, {
            params,
            responseType: 'arraybuffer'
        }).pipe(share());
        return this.request(observable);
    }
}
ResourceService.ɵfac = function ResourceService_Factory(t) { return new (t || ResourceService)(ɵngcc0.ɵɵinject(WorldskillsAngularLibService), ɵngcc0.ɵɵinject(ɵngcc6.HttpClient), ɵngcc0.ɵɵinject(UploadService)); };
ResourceService.ɵprov = ɵɵdefineInjectable({ factory: function ResourceService_Factory() { return new ResourceService(ɵɵinject(WorldskillsAngularLibService), ɵɵinject(HttpClient), ɵɵinject(UploadService)); }, token: ResourceService, providedIn: "root" });
ResourceService.ctorParameters = () => [
    { type: WorldskillsAngularLibService },
    { type: HttpClient },
    { type: UploadService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ResourceService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: WorldskillsAngularLibService }, { type: ɵngcc6.HttpClient }, { type: UploadService }]; }, null); })();

var AlertType;
(function (AlertType) {
    AlertType["error"] = "alert-danger";
    AlertType["info"] = "alert-info";
    AlertType["success"] = "alert-success";
    AlertType["warning"] = "alert-warning";
})(AlertType || (AlertType = {}));

class ErrorUtil {
    /*
    * Returns the user message from an instance of a WSI API Error
    *
    * @param error - The error object extracted from an Http message
    * @param defaultErrorMessage - The default message if an error message cannot be extracted
    * @returns The error message or a default error
    */
    static getErrorMsg(error, defaultErrorMessage) {
        return ErrorUtil.hasApiError(error) ? defaultErrorMessage : error.error.user_msg;
    }
    /*
    * Returns if an error is an instance of a WSI API error
    *
    * @param error - The error object extracted from an Http message
    * @returns true if this is an instance of a WSI API error
    */
    static hasApiError(error) {
        if (GenericUtil.isNullOrUndefined(error)) {
            return false;
        }
        return error.error && error.error.user_msg;
    }
    static arrayBufferToJSON(error) {
        const decodedString = String.fromCharCode.apply(null, new Uint8Array(error.error));
        return JSON.parse(decodedString);
    }
}

// tslint:disable-next-line:directive-class-suffix
class WsComponent {
    constructor() {
        this.subscriptions = new Subscription();
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    // tslint:disable-next-line:typedef
    subscribe(...teardowns) {
        teardowns.forEach(teardown => this.subscriptions.add(teardown));
    }
}
WsComponent.ɵfac = function WsComponent_Factory(t) { return new (t || WsComponent)(); };
WsComponent.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: WsComponent });
WsComponent.ctorParameters = () => [];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(WsComponent, [{
        type: Directive
    }], function () { return []; }, null); })();

class ResourceThumbnailContainerComponent extends WsComponent {
    constructor(resourceService, datePipe, alertService) {
        super();
        this.resourceService = resourceService;
        this.datePipe = datePipe;
        this.alertService = alertService;
        this.isZippingFiles = false;
    }
    get getDownloadAllBtnText() {
        return this.isZippingFiles ? 'Zipping files...' : 'Download all';
    }
    ngOnInit() {
    }
    showDownloadAll() {
        return this.resourceThumbnailList && this.resourceThumbnailList.filter(r => !!r.downloadLink).length > 0;
    }
    downloadAllResourcesAsZipFile() {
        this.isZippingFiles = true;
        this.resourceService.downloadResources(this.resourceThumbnailList.map(rt => rt.resource_id)).subscribe(res => {
            this.createDownloadLink(res);
            this.isZippingFiles = false;
        }, error => {
            this.isZippingFiles = false;
            this.alertService.setAlert('new-alert', AlertType.error, null, ErrorUtil.arrayBufferToJSON(error).user_msg, true);
        });
    }
    createDownloadLink(res) {
        const blob = new Blob([res], { type: WSIMediaType.ZIP });
        const url = window.URL.createObjectURL(blob);
        const downloadLink = document.createElement('a');
        downloadLink.href = url;
        const now = new Date();
        const date = this.datePipe.transform(now, 'yyyyMMddHHmmss');
        downloadLink.setAttribute('download', `Resources${date}.zip`);
        document.body.appendChild(downloadLink);
        downloadLink.click();
    }
}
ResourceThumbnailContainerComponent.ɵfac = function ResourceThumbnailContainerComponent_Factory(t) { return new (t || ResourceThumbnailContainerComponent)(ɵngcc0.ɵɵdirectiveInject(ResourceService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DatePipe), ɵngcc0.ɵɵdirectiveInject(AlertService)); };
ResourceThumbnailContainerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ResourceThumbnailContainerComponent, selectors: [["ws-resource-thumbnail-container"]], inputs: { title: "title", resourceThumbnailList: "resourceThumbnailList" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 9, vars: 3, consts: [[1, "card"], [1, "card-header"], [1, "row"], [1, "col-md-6"], ["class", "btn btn-link float-right", 3, "disabled", "click", 4, "ngIf"], [1, "card-body", "d-flex", "flex-row", "flex-wrap", 2, "max-height", "250px", "overflow-y", "scroll"], ["class", "mr-3 mb-3", 3, "resourceThumbnail", 4, "ngFor", "ngForOf"], [1, "btn", "btn-link", "float-right", 3, "disabled", "click"], [1, "mr-3", "mb-3", 3, "resourceThumbnail"]], template: function ResourceThumbnailContainerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 3);
        ɵngcc0.ɵɵtemplate(6, ResourceThumbnailContainerComponent_button_6_Template, 2, 2, "button", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 5);
        ɵngcc0.ɵɵtemplate(8, ResourceThumbnailContainerComponent_ws_resource_thumbnail_8_Template, 1, 1, "ws-resource-thumbnail", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ctx.title);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showDownloadAll());
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.resourceThumbnailList);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgForOf, ResourceThumbnailComponent], styles: [""] });
ResourceThumbnailContainerComponent.ctorParameters = () => [
    { type: ResourceService },
    { type: DatePipe },
    { type: AlertService }
];
ResourceThumbnailContainerComponent.propDecorators = {
    title: [{ type: Input }],
    resourceThumbnailList: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ResourceThumbnailContainerComponent, [{
        type: Component,
        args: [{
                selector: 'ws-resource-thumbnail-container',
                template: "<div class=\"card\">\n    <div class=\"card-header\">\n        <div class=\"row\">\n            <div class=\"col-md-6\">{{title}}</div>\n            <div class=\"col-md-6\">\n                <button\n                        class=\"btn btn-link float-right\"\n                        [disabled]=\"isZippingFiles\"\n                        (click)=\"downloadAllResourcesAsZipFile()\"\n                        *ngIf=\"showDownloadAll()\">\n                    {{getDownloadAllBtnText}}\n                </button>\n            </div>\n        </div>\n    </div>\n    <div class=\"card-body d-flex flex-row flex-wrap\" style=\"max-height: 250px;overflow-y: scroll\">\n        <ws-resource-thumbnail\n                class=\"mr-3 mb-3\"\n                [resourceThumbnail]=\"thumbnail\"\n                *ngFor=\"let thumbnail of resourceThumbnailList\"></ws-resource-thumbnail>\n    </div>\n</div>\n",
                styles: [""]
            }]
    }], function () { return [{ type: ResourceService }, { type: ɵngcc1.DatePipe }, { type: AlertService }]; }, { title: [{
            type: Input
        }], resourceThumbnailList: [{
            type: Input
        }] }); })();

class I18nTextboxComponent {
    constructor() {
        // we can directly repace the "text" array of an object we need to save
        this.valueChanged = new EventEmitter();
        this.show = false;
        // ability to disable the dropdown
        this.disaableLangChange = false;
    }
    ngOnInit() {
        this.defaultLanguage = LangUtil.getDefaultLanguage();
        this.allowedLanguages = LangUtil.getDefaultLanguages();
        // setup default languages - can be overriden with a change
        if (GenericUtil.isNullOrUndefined(this.value)) {
            this.value = this.getValues();
        }
        // get current selected language to determine the focused innpiut
        let current = sessionStorage.getItem('lang');
        if (GenericUtil.isNullOrUndefined(current)) {
            current = this.defaultLanguage.code;
        }
        this.currentCode = current;
    }
    // tslint:disable-next-line:use-lifecycle-interface
    ngOnChanges() {
        // if therre are no inputs provided, generate them until they are provided
        if (GenericUtil.isNullOrUndefined(this.value)) {
            this.value = this.getValues();
        }
    }
    // useed for looping to cater for missing languages
    getValues() {
        if (GenericUtil.isNullOrUndefined(this.allowedLanguages)) {
            this.allowedLanguages = LangUtil.getDefaultLanguages();
        }
        if (GenericUtil.isNullOrUndefined(this.value)) {
            this.value = this.allowedLanguages.map(X => {
                return { lang_code: X.code, text: null };
            });
        }
        return this.value;
    }
    textChanged(text) {
        const index = this.value.findIndex(x => x.lang_code === this.currentCode);
        this.value[index].text = text;
        this.valueChanged.emit(this.value);
    }
    selectLang(lang) {
        this.currentCode = lang.lang_code;
        this.loadText();
        this.show = false;
    }
    loadText() {
        const index = this.value.findIndex(x => x.lang_code === this.currentCode);
        if (index !== -1) {
            this.text = this.value[index].text;
        }
        else {
            this.text = null;
        }
    }
    getLang(code) {
        const lang = LangUtil.getDefaultLanguages().find(x => x.code === code);
        return GenericUtil.isNullOrUndefined(lang) ? '' : lang.name;
    }
}
I18nTextboxComponent.ɵfac = function I18nTextboxComponent_Factory(t) { return new (t || I18nTextboxComponent)(); };
I18nTextboxComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: I18nTextboxComponent, selectors: [["ws-i18n-textbox"]], inputs: { disaableLangChange: "disaableLangChange", value: "value" }, outputs: { valueChanged: "valueChanged" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 1, consts: [[2, "position", "relative"], ["class", "input-group", 4, "ngIf"], [1, "input-group"], ["type", "text", 1, "form-control", 3, "ngModel", "input", "ngModelChange"], [1, "input-group-append"], ["type", "button", 1, "btn", "btn-outline-secondary", "dropdown-toggle", 3, "disabled", "click"], [2, "position", "absolute", "top", "36px", "left", "0", "width", "100%"], [1, "dropdown-menu", 2, "width", "100%", 3, "ngClass"], ["class", "dropdown-item", "triggers", "mouseenter:mouseleave", "placement", "left", 3, "ngClass", "ngbPopover", "click", 4, "ngFor", "ngForOf"], ["triggers", "mouseenter:mouseleave", "placement", "left", 1, "dropdown-item", 3, "ngClass", "ngbPopover", "click"], [1, "row"], [1, "col-sm-10"], [4, "ngIf"], ["class", "text-muted", 4, "ngIf"], [1, "col-sm-2"], [1, "pull-right"], [1, "text-muted"]], template: function I18nTextboxComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, I18nTextboxComponent_div_1_Template, 8, 7, "div", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.currentCode);
    } }, directives: [ɵngcc1.NgIf, ɵngcc5.DefaultValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.NgModel, ɵngcc1.NgClass, ɵngcc1.NgForOf, ɵngcc4.NgbPopover], styles: [""] });
I18nTextboxComponent.ctorParameters = () => [];
I18nTextboxComponent.propDecorators = {
    valueChanged: [{ type: Output }],
    value: [{ type: Input }],
    disaableLangChange: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(I18nTextboxComponent, [{
        type: Component,
        args: [{
                selector: 'ws-i18n-textbox',
                template: "<div style=\"position:relative\">\n  <div class=\"input-group\" *ngIf=\"currentCode\">\n    <input type=\"text\" class=\"form-control\" (input)=\"textChanged($event.target.value)\" [(ngModel)]=\"text\">\n    <div class=\"input-group-append\">\n      <button [disabled]=\"disaableLangChange\" (click)=\"show = !show\" class=\"btn btn-outline-secondary dropdown-toggle\" type=\"button\" >{{ getLang(currentCode) }}</button>\n    </div>\n    <div style=\"position: absolute; top:36px; left: 0; width: 100%;\">\n      <div class=\"dropdown-menu\" style=\"width: 100%;\" [ngClass]=\"{show: show}\">\n        <div class=\"dropdown-item\" (click)=\"selectLang(lang)\"  *ngFor=\"let lang of value\" [ngClass]=\"{active: lang.lang_code === currentCode }\" ngbPopover=\"{{ lang.text }}\" triggers=\"mouseenter:mouseleave\" placement=\"left\">\n          <div class=\"row\">\n            <div class=\"col-sm-10\">\n              <span *ngIf=\"lang.text\">{{ lang.text }}</span>\n              <span *ngIf=\"!lang.text\" class=\"text-muted\">\n                <em>(Empty)</em>\n              </span>\n            </div>\n            <div class=\"col-sm-2\">\n              <div class=\"pull-right\">\n                {{ getLang(lang.lang_code) }}\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n  ",
                styles: [""]
            }]
    }], function () { return []; }, { valueChanged: [{
            type: Output
        }], disaableLangChange: [{
            type: Input
        }], value: [{
            type: Input
        }] }); })();

class I18nTextareaComponent {
    constructor() {
        // we can directly repace the "text" array of an object we need to save
        this.valueChanged = new EventEmitter();
        this.show = false;
        // ability to disable the dropdown
        this.disaableLangChange = false;
    }
    ngOnInit() {
        this.defaultLanguage = LangUtil.getDefaultLanguage();
        this.allowedLanguages = LangUtil.getDefaultLanguages();
        // setup default languages - can be overriden with a change
        if (GenericUtil.isNullOrUndefined(this.value)) {
            this.value = this.getValues();
        }
        // get current selected language to determine the focused innpiut
        let current = sessionStorage.getItem('lang');
        if (GenericUtil.isNullOrUndefined(current)) {
            current = this.defaultLanguage.code;
        }
        this.currentCode = current;
    }
    // tslint:disable-next-line:use-lifecycle-interface
    ngOnChanges() {
        // if therre are no inputs provided, generate them until they are provided
        if (GenericUtil.isNullOrUndefined(this.value)) {
            this.value = this.getValues();
        }
    }
    // useed for looping to cater for missing languages
    getValues() {
        if (GenericUtil.isNullOrUndefined(this.allowedLanguages)) {
            this.allowedLanguages = LangUtil.getDefaultLanguages();
        }
        if (GenericUtil.isNullOrUndefined(this.value)) {
            this.value = this.allowedLanguages.map(X => {
                return { lang_code: X.code, text: null };
            });
        }
        return this.value;
    }
    textChanged(text) {
        const index = this.value.findIndex(x => x.lang_code === this.currentCode);
        this.value[index].text = text;
        this.valueChanged.emit(this.value);
    }
    selectLang(lang) {
        this.currentCode = lang.lang_code;
        this.loadText();
        this.show = false;
    }
    loadText() {
        const index = this.value.findIndex(x => x.lang_code === this.currentCode);
        if (index !== -1) {
            this.text = this.value[index].text;
        }
        else {
            this.text = null;
        }
    }
    getLang(code) {
        const lang = LangUtil.getDefaultLanguages().find(x => x.code === code);
        return GenericUtil.isNullOrUndefined(lang) ? '' : lang.name;
    }
}
I18nTextareaComponent.ɵfac = function I18nTextareaComponent_Factory(t) { return new (t || I18nTextareaComponent)(); };
I18nTextareaComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: I18nTextareaComponent, selectors: [["ws-i18n-textarea"]], inputs: { disaableLangChange: "disaableLangChange", value: "value" }, outputs: { valueChanged: "valueChanged" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 1, consts: [[2, "position", "relative"], ["class", "input-group", 4, "ngIf"], [1, "input-group"], [1, "form-control", 3, "ngModel", "input", "ngModelChange"], [1, "input-group-append"], ["type", "button", 1, "btn", "btn-outline-secondary", "dropdown-toggle", 3, "disabled", "click"], [2, "position", "absolute", "top", "36px", "left", "0", "width", "100%"], [1, "dropdown-menu", 2, "width", "100%", 3, "ngClass"], ["class", "dropdown-item", "triggers", "mouseenter:mouseleave", "placement", "left", 3, "ngClass", "ngbPopover", "click", 4, "ngFor", "ngForOf"], ["triggers", "mouseenter:mouseleave", "placement", "left", 1, "dropdown-item", 3, "ngClass", "ngbPopover", "click"], [1, "row"], [1, "col-sm-10"], [4, "ngIf"], ["class", "text-muted", 4, "ngIf"], [1, "col-sm-2"], [1, "pull-right"], [1, "text-muted"]], template: function I18nTextareaComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, I18nTextareaComponent_div_1_Template, 8, 7, "div", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.currentCode);
    } }, directives: [ɵngcc1.NgIf, ɵngcc5.DefaultValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.NgModel, ɵngcc1.NgClass, ɵngcc1.NgForOf, ɵngcc4.NgbPopover], styles: [""] });
I18nTextareaComponent.ctorParameters = () => [];
I18nTextareaComponent.propDecorators = {
    valueChanged: [{ type: Output }],
    value: [{ type: Input }],
    disaableLangChange: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(I18nTextareaComponent, [{
        type: Component,
        args: [{
                selector: 'ws-i18n-textarea',
                template: "<div style=\"position:relative\">\n    <div class=\"input-group\" *ngIf=\"currentCode\">\n      <textarea class=\"form-control\" (input)=\"textChanged($event.target.value)\" [(ngModel)]=\"text\"></textarea>\n      <div class=\"input-group-append\">\n        <button [disabled]=\"disaableLangChange\" (click)=\"show = !show\" class=\"btn btn-outline-secondary dropdown-toggle\" type=\"button\" >{{ getLang(currentCode) }}</button>\n      </div>\n      <div style=\"position: absolute; top:36px; left: 0; width: 100%;\">\n        <div class=\"dropdown-menu\" style=\"width: 100%;\" [ngClass]=\"{show: show}\">\n          <div class=\"dropdown-item\" (click)=\"selectLang(lang)\"  *ngFor=\"let lang of value\" [ngClass]=\"{active: lang.lang_code === currentCode }\" ngbPopover=\"{{ lang.text }}\" triggers=\"mouseenter:mouseleave\" placement=\"left\">\n            <div class=\"row\">\n              <div class=\"col-sm-10\">\n                <span *ngIf=\"lang.text\">{{ lang.text }}</span>\n                <span *ngIf=\"!lang.text\" class=\"text-muted\">\n                  <em>(Empty)</em>\n                </span>\n              </div>\n              <div class=\"col-sm-2\">\n                <div class=\"pull-right\">\n                  {{ getLang(lang.lang_code) }}\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n    ",
                styles: [""]
            }]
    }], function () { return []; }, { valueChanged: [{
            type: Output
        }], disaableLangChange: [{
            type: Input
        }], value: [{
            type: Input
        }] }); })();

class RelativeDateComponent {
    constructor() {
        // number of daays relative proessing is calculated for
        this.tresholdInDays = 30;
        this.calculateDelta = (now, date) => Math.round(Math.abs(now - date) / 1000);
    }
    ngOnInit() {
    }
    // tslint:disable-next-line:use-lifecycle-interface
    ngOnChanges() {
        this.calcRelativeDate();
    }
    calcRelativeDate() {
        const dt = new Date(this.date);
        const isDateValid = dt.toString() !== 'Invalid Date';
        if (!isDateValid) {
            this.output = formatDate(this.date, this.format, this.locale);
            return;
        }
        else {
            this.date = dt;
        }
        this.format = this.format || 'MMM-dd-yyyy';
        this.locale = this.locale || 'en';
        const v = Number(this.date);
        const dif = Math.floor(((Date.now() - v) / 1000) / 86400);
        if (dif < this.tresholdInDays) {
            this.isRelative = true;
            const now = new Date();
            this.isPastDate = this.date.getTime() <= now.getTime();
            if (this.isPastDate) {
                this.diff = ((now.getTime() - this.date.getTime()) / 1000);
            }
            else {
                this.diff = ((this.date.getTime() - now.getTime()) / 1000);
            }
            this.daydiff = Math.floor(this.diff / 86400);
        }
        else {
            this.isRelative = false;
            this.output = formatDate(this.date, this.format, this.locale);
        }
    }
    isNotValid() {
        return isNaN(this.daydiff) || this.daydiff < 0 || this.daydiff >= 31;
    }
    ceil(value) {
        return Math.ceil(value);
    }
    floor(value) {
        return Math.floor(value);
    }
}
RelativeDateComponent.ɵfac = function RelativeDateComponent_Factory(t) { return new (t || RelativeDateComponent)(); };
RelativeDateComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: RelativeDateComponent, selectors: [["ws-relative-date"]], inputs: { tresholdInDays: "tresholdInDays", date: "date", format: "format", locale: "locale" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 4, vars: 4, consts: [[4, "ngIf"]], template: function RelativeDateComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, RelativeDateComponent_span_0_Template, 2, 1, "span", 0);
        ɵngcc0.ɵɵtemplate(1, RelativeDateComponent_span_1_Template, 1, 0, "span", 0);
        ɵngcc0.ɵɵtemplate(2, RelativeDateComponent_span_2_Template, 10, 9, "span", 0);
        ɵngcc0.ɵɵtemplate(3, RelativeDateComponent_span_3_Template, 10, 9, "span", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isRelative);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isRelative && ctx.isNotValid());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isRelative && ctx.isPastDate);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isRelative && !ctx.isPastDate);
    } }, directives: [ɵngcc1.NgIf], pipes: [ɵngcc2.TranslatePipe], styles: [""] });
RelativeDateComponent.ctorParameters = () => [];
RelativeDateComponent.propDecorators = {
    date: [{ type: Input }],
    format: [{ type: Input }],
    locale: [{ type: Input }],
    tresholdInDays: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(RelativeDateComponent, [{
        type: Component,
        args: [{
                selector: 'ws-relative-date',
                template: "<span *ngIf=\"!isRelative\">{{ output }}</span>\n<span *ngIf=\"isRelative && isNotValid()\"></span>\n<span *ngIf=\"isRelative && isPastDate\">\n    <span *ngIf=\"diff < 60\">{{ 'dates.just_now' | translate }}</span>\n    <span *ngIf=\"diff > 60 && diff < 120\">{{ 'dates.minute_ago' | translate }}</span>\n    <span *ngIf=\"diff > 120 && diff < 3600\">{{ floor(diff / 60) }} {{ 'dates.minutes_ago' | translate }}</span>\n    <span *ngIf=\"diff > 3600 && diff < 7200\">{{ 'dates.hour_ago' | translate }}</span>\n    <span *ngIf=\"diff > 7200 && diff < 86400\">{{ floor(diff / 3600) }} {{ 'dates.hours_ago' | translate }}</span>\n    <span *ngIf=\"diff >= 86400 && daydiff === 1 \">{{ 'dates.yesterday' | translate }}</span>\n    <span *ngIf=\"diff > 86400 && daydiff > 1 && daydiff < 7\">{{ daydiff }} {{ 'dates.days_ago' | translate }}</span>\n    <span *ngIf=\"diff > 86400 && daydiff === 7\">{{ 'dates.week_ago' | translate }}</span>\n    <span *ngIf=\"diff > 86400 && daydiff > 7 && daydiff < 31\">{{ ceil(daydiff / 7) }} {{ 'dates.weeks_ago' | translate }}</span>\n</span>\n<span *ngIf=\"isRelative && !isPastDate\">\n    <span *ngIf=\"diff < 60\">{{ 'dates.soon' | translate }}</span>\n    <span *ngIf=\"diff > 60 && diff < 120\">{{ 'dates.in_a_minute' | translate }}</span>\n    <span *ngIf=\"diff > 120 && diff < 3600\">{{ 'dates.in_n_minutes' | translate: {number: floor(diff / 60)} }}</span>\n    <span *ngIf=\"diff > 3600 && diff < 7200\">{{ 'dates.in_an_hour' | translate }}</span>\n    <span *ngIf=\"diff > 7200 && diff < 86400\">{{ 'dates.in_n_hours' | translate: {number: floor(diff / 3600)} }}</span>\n    <span *ngIf=\"diff >= 86400 && daydiff === 1 \">{{ 'dates.tomorrow' | translate }}</span>\n    <span *ngIf=\"diff > 86400 && daydiff > 1 && daydiff < 7\">{{ 'dates.in_n_days' | translate: {number: daydiff} }}</span>\n    <span *ngIf=\"diff > 86400 && daydiff === 7\">{{ 'dates.in_a_week' | translate }}</span>\n    <span *ngIf=\"diff > 86400 && daydiff > 7 && daydiff < 31\">{{ 'dates.in_n_weeks' | translate: {number: ceil(daydiff / 7)} }}</span>\n</span>\n",
                styles: [""]
            }]
    }], function () { return []; }, { tresholdInDays: [{
            type: Input
        }], date: [{
            type: Input
        }], format: [{
            type: Input
        }], locale: [{
            type: Input
        }] }); })();

class WsiToastService {
    constructor() {
        this.toasts = [];
    }
    // Push new Toasts to array with content and options
    show(textOrTpl, options = {}) {
        this.toasts.push(Object.assign({ textOrTpl }, options));
    }
    // Callback method to remove Toast DOM element from view
    remove(toast) {
        this.toasts = this.toasts.filter(t => t !== toast);
    }
}
WsiToastService.ɵfac = function WsiToastService_Factory(t) { return new (t || WsiToastService)(); };
WsiToastService.ɵprov = ɵɵdefineInjectable({ factory: function WsiToastService_Factory() { return new WsiToastService(); }, token: WsiToastService, providedIn: "root" });
WsiToastService.ctorParameters = () => [];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(WsiToastService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class ToastComponent {
    constructor(service) {
        this.service = service;
    }
    ngOnInit() {
    }
    isTemplate(toast) {
        return toast.textOrTpl instanceof TemplateRef;
    }
}
ToastComponent.ɵfac = function ToastComponent_Factory(t) { return new (t || ToastComponent)(ɵngcc0.ɵɵdirectiveInject(WsiToastService)); };
ToastComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ToastComponent, selectors: [["ws-toast"]], decls: 2, vars: 1, consts: [[1, "ws-toast-container"], [3, "header", "class", "autohide", "delay", "hide", 4, "ngFor", "ngForOf"], [3, "header", "autohide", "delay", "hide"], [3, "ngIf", "ngIfElse"], ["text", ""], [3, "ngTemplateOutlet"]], template: function ToastComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, ToastComponent_ngb_toast_1_Template, 4, 7, "ngb-toast", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.service.toasts);
    } }, directives: [ɵngcc1.NgForOf, ɵngcc4.NgbToast, ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet], styles: [".ws-toast-container[_ngcontent-%COMP%]{position:absolute;right:0;top:0}"] });
ToastComponent.ctorParameters = () => [
    { type: WsiToastService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ToastComponent, [{
        type: Component,
        args: [{
                selector: 'ws-toast',
                template: "<div class=\"ws-toast-container\">\n    <ngb-toast *ngFor=\"let toast of service.toasts\" [header]=\"toast.headertext\" [class]=\"toast.classname\"\n    [autohide]=\"toast.autohide\" [delay]=\"toast.delay || 5000\" (hide)=\"service.remove(toast)\">\n    <ng-template [ngIf]=\"isTemplate(toast)\" [ngIfElse]=\"text\">\n        <ng-template [ngTemplateOutlet]=\"toast.textOrTpl\"></ng-template>\n    </ng-template>\n\n    <ng-template #text>{{ toast.textOrTpl }}</ng-template>\n</ngb-toast>\n</div>",
                styles: [".ws-toast-container{position:absolute;right:0;top:0}"]
            }]
    }], function () { return [{ type: WsiToastService }]; }, null); })();

/*
  This servicec actts as a wrapper to the NgModal service and provides extended functionality for common modals.
  this can also be extended to include custsom app modals.
*/
class WsiModalService {
    constructor(modal) {
        this.modal = modal;
        this.onModalUpdate = new Subject();
        this.modals = [];
        this.openModals = [];
    }
    /*
      Update tracking properties on modal close
    */
    closeModal(item) {
        const idx = this.openModals.findIndex(x => x.name === item.name);
        if (idx !== -1) {
            this.updateModal(item.name, item); // update last reason or last result
            this.openModals.splice(idx, 1);
        }
    }
    /*
      Listen ffor modal close event
    */
    listenModal(item) {
        item.ref.result.then((result) => {
            item.lastResult = result;
            this.closeModal(item);
        }, (reason) => {
            item.lastReason = this.getDismissReason(reason);
            this.closeModal(item);
        });
    }
    /*
      Open a specific registered modal
    */
    open(item) {
        item.options = item.options || this.getDefaultOptions();
        item.ref = this.modal.open(item.content, item.options);
        this.updateModal(item.name, item); // update modal ref
        this.listenModal(item); // listen for close event
        return item;
    }
    /*
      Get default modal optioons
    */
    getDefaultOptions() {
        return {
            centered: true
        };
    }
    /*
      Extract modal dismiss reason
    */
    getDismissReason(reason) {
        if (reason === ModalDismissReasons.ESC) {
            return 'ESC';
        }
        else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'BACKDROP';
        }
        else {
            return reason;
        }
    }
    /*
      Get a registered modal
    */
    getModal(name) {
        return this.modals.find(x => x.name === name);
    }
    /*
      Update a regitered modal
    */
    updateModal(name, item) {
        const idx = this.modals.findIndex(x => x.name === name);
        if (idx === -1) {
            return false;
        }
        this.modals[idx] = item;
        this.onModalUpdate.next(item);
        return true;
    }
    /*
      Determine if a specific modal is open
    */
    isModalOpen(item) {
        return this.openModals.filter(x => x.name === item.name).length > 0;
    }
}
WsiModalService.ɵfac = function WsiModalService_Factory(t) { return new (t || WsiModalService)(ɵngcc0.ɵɵinject(ɵngcc4.NgbModal)); };
WsiModalService.ɵprov = ɵɵdefineInjectable({ factory: function WsiModalService_Factory() { return new WsiModalService(ɵɵinject(NgbModal)); }, token: WsiModalService, providedIn: "root" });
WsiModalService.ctorParameters = () => [
    { type: NgbModal }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(WsiModalService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc4.NgbModal }]; }, null); })();

/*
  If required thesse modals caan be exended to include angular template
*/
class ModalsComponent {
    constructor(service) {
        this.service = service;
    }
    ngOnInit() {
    }
    // content is only available after view init
    // tslint:disable-next-line:use-lifecycle-interface
    ngAfterViewInit() {
        // listen for modal updates
        this.okModalItem = {
            name: 'ok',
            content: this.okContent,
            title: '',
            body: ''
        };
        this.okCancelModalItem = {
            name: 'okcancel',
            content: this.okCancelContent,
            title: '',
            body: ''
        };
        this.yesModalItem = {
            name: 'yes',
            content: this.yesContent,
            title: '',
            body: ''
        };
        this.yesNoModalItem = {
            name: 'yesno',
            content: this.yesContent,
            title: '',
            body: ''
        };
        // register Modals
        this.service.modals.push(this.okModalItem, this.okCancelModalItem, this.yesModalItem, this.yesNoModalItem);
        // listen for modal changes
        this.service.onModalUpdate.subscribe(item => {
            if (item) {
                switch (item.name) {
                    default:
                        break;
                    case 'ok':
                        this.okModalItem = item;
                        break;
                    case 'okcancel':
                        this.okCancelModalItem = item;
                        break;
                    case 'yes':
                        this.yesModalItem = item;
                        break;
                    case 'yesno':
                        this.yesNoModalItem = item;
                        break;
                }
            }
        });
    }
}
ModalsComponent.ɵfac = function ModalsComponent_Factory(t) { return new (t || ModalsComponent)(ɵngcc0.ɵɵdirectiveInject(WsiModalService)); };
ModalsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ModalsComponent, selectors: [["ws-modals"]], viewQuery: function ModalsComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c26, true);
        ɵngcc0.ɵɵviewQuery(_c27, true);
        ɵngcc0.ɵɵviewQuery(_c28, true);
        ɵngcc0.ɵɵviewQuery(_c29, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.okContent = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.okCancelContent = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.yesContent = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.yesNoContent = _t.first);
    } }, decls: 8, vars: 0, consts: [["okmodal", ""], ["okcancelmodal", ""], ["yesmodal", ""], ["yesnomodal", ""], [1, "modal-header"], ["id", "modal-basic-title", 1, "modal-title"], ["type", "button", "aria-label", "Close", 1, "close", 3, "click"], ["aria-hidden", "true"], [1, "modal-body"], [1, "modal-footer"], ["type", "button", 1, "btn", "btn-outline-dark", 3, "click"]], template: function ModalsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, ModalsComponent_ng_template_0_Template, 12, 5, "ng-template", null, 0, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(2, ModalsComponent_ng_template_2_Template, 15, 8, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(4, ModalsComponent_ng_template_4_Template, 12, 5, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(6, ModalsComponent_ng_template_6_Template, 15, 8, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
    } }, pipes: [ɵngcc2.TranslatePipe], styles: [""] });
ModalsComponent.ctorParameters = () => [
    { type: WsiModalService }
];
ModalsComponent.propDecorators = {
    okContent: [{ type: ViewChild, args: ['okmodal',] }],
    okCancelContent: [{ type: ViewChild, args: ['okcancelmodal',] }],
    yesContent: [{ type: ViewChild, args: ['yesmodal',] }],
    yesNoContent: [{ type: ViewChild, args: ['yesnomodal',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ModalsComponent, [{
        type: Component,
        args: [{
                selector: 'ws-modals',
                template: "<ng-template #okmodal let-modal>\n    <div class=\"modal-header\">\n      <h4 class=\"modal-title\" id=\"modal-basic-title\">{{ okModalItem.title }}</h4>\n      <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"modal.dismiss('close')\">\n        <span aria-hidden=\"true\">&times;</span>\n      </button>\n    </div>\n    <div class=\"modal-body\">\n        {{ okModalItem.body }}\n    </div>\n    <div class=\"modal-footer\">\n      <button type=\"button\" class=\"btn btn-outline-dark\" (click)=\"modal.close('ok')\">{{ 'modals.ok' | translate }}</button>\n    </div>\n  </ng-template>\n\n  <ng-template #okcancelmodal let-modal>\n    <div class=\"modal-header\">\n      <h4 class=\"modal-title\" id=\"modal-basic-title\">{{ okCancelModalItem.title }}</h4>\n      <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"modal.dismiss('close')\">\n        <span aria-hidden=\"true\">&times;</span>\n      </button>\n    </div>\n    <div class=\"modal-body\">\n        {{ okCancelModalItem.body }}\n    </div>\n    <div class=\"modal-footer\">\n      <button type=\"button\" class=\"btn btn-outline-dark\" (click)=\"modal.close('cancel')\">{{ 'modals.cancel' | translate }}</button>\n      <button type=\"button\" class=\"btn btn-outline-dark\" (click)=\"modal.close('ok')\">{{ 'modals.ok' | translate }}</button>\n    </div>\n  </ng-template>\n\n  <ng-template #yesmodal let-modal>\n    <div class=\"modal-header\">\n      <h4 class=\"modal-title\" id=\"modal-basic-title\">{{ yesModalItem.title }}</h4>\n      <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"modal.dismiss('close')\">\n        <span aria-hidden=\"true\">&times;</span>\n      </button>\n    </div>\n    <div class=\"modal-body\">\n        {{ yesModalItem.body }}\n    </div>\n    <div class=\"modal-footer\">\n      <button type=\"button\" class=\"btn btn-outline-dark\" (click)=\"modal.close('yes')\">{{ 'modals.yes' | translate }}</button>\n    </div>\n  </ng-template>\n\n\n  <ng-template #yesnomodal let-modal>\n    <div class=\"modal-header\">\n      <h4 class=\"modal-title\" id=\"modal-basic-title\">{{ yesModalItem.title }}</h4>\n      <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"modal.dismiss('close')\">\n        <span aria-hidden=\"true\">&times;</span>\n      </button>\n    </div>\n    <div class=\"modal-body\">\n        {{ yesModalItem.body }}\n    </div>\n    <div class=\"modal-footer\">\n      <button type=\"button\" class=\"btn btn-outline-dark\" (click)=\"modal.close('yes')\">{{ 'modals.no' | translate }}</button>\n      <button type=\"button\" class=\"btn btn-outline-dark\" (click)=\"modal.close('yes')\">{{ 'modals.yes' | translate }}</button>\n    </div>\n  </ng-template>",
                styles: [""]
            }]
    }], function () { return [{ type: WsiModalService }]; }, { okContent: [{
            type: ViewChild,
            args: ['okmodal']
        }], okCancelContent: [{
            type: ViewChild,
            args: ['okcancelmodal']
        }], yesContent: [{
            type: ViewChild,
            args: ['yesmodal']
        }], yesNoContent: [{
            type: ViewChild,
            args: ['yesnomodal']
        }] }); })();

function HttpLoaderFactory(http) {
    return new TranslateHttpLoader(http, '/assets/i18n/lazy-loaded/', '.json');
}
const translateConfig = TranslateModule.forChild({
    loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
    },
    isolate: true
});
class WorldskillsAngularLibModule {
}
WorldskillsAngularLibModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: WorldskillsAngularLibModule });
WorldskillsAngularLibModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function WorldskillsAngularLibModule_Factory(t) { return new (t || WorldskillsAngularLibModule)(); }, providers: [], imports: [[
            BrowserModule,
            FormsModule,
            HttpClientModule,
            RouterModule,
            NgbModule,
            NgSelectModule,
            translateConfig
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(WorldskillsAngularLibModule, { declarations: function () { return [WorldskillsAngularLibComponent, AlertComponent, AlertsComponent, BreadcrumbsComponent, DateRangeComponent, DatetimePickerComponent, EntityTreeSelectComponent, FooterComponent, HeaderComponent, LogoComponent, MenuAccessPipe, PollResultComponent, PuppeteerBannerComponent, RelativeDatePipe, SelectDirective, SelectAsyncHeaderComponent, SortPipe, StagingBannerComponent, StandardPollComponent, VoteControlComponent, WordmarkComponent, WeightedPollComponent, MultiselectPollComponent, UserRoleDirective, AuthHeaderComponent, AuthFooterComponent, ResourceThumbnailComponent, FileSizePipe, ResourceThumbnailContainerComponent, I18nTextboxComponent, I18nTextareaComponent, RelativeDateComponent, ToastComponent, ModalsComponent]; }, imports: function () { return [BrowserModule,
        FormsModule,
        HttpClientModule,
        RouterModule,
        NgbModule,
        NgSelectModule, ɵngcc2.TranslateModule]; }, exports: function () { return [WorldskillsAngularLibComponent, AlertComponent, AlertsComponent, BreadcrumbsComponent, DateRangeComponent, DatetimePickerComponent, EntityTreeSelectComponent, FooterComponent, HeaderComponent, AuthHeaderComponent, AuthFooterComponent, LogoComponent, MenuAccessPipe, PollResultComponent, PuppeteerBannerComponent, RelativeDatePipe, SelectDirective, SelectAsyncHeaderComponent, SortPipe, StagingBannerComponent, StandardPollComponent, MultiselectPollComponent, VoteControlComponent, WordmarkComponent, WeightedPollComponent, UserRoleDirective, ResourceThumbnailComponent, ResourceThumbnailContainerComponent, I18nTextboxComponent, I18nTextareaComponent, RelativeDateComponent, ToastComponent, ModalsComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(WorldskillsAngularLibModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    WorldskillsAngularLibComponent,
                    AlertComponent,
                    AlertsComponent,
                    BreadcrumbsComponent,
                    DateRangeComponent,
                    DatetimePickerComponent,
                    EntityTreeSelectComponent,
                    FooterComponent,
                    HeaderComponent,
                    LogoComponent,
                    MenuAccessPipe,
                    PollResultComponent,
                    PuppeteerBannerComponent,
                    RelativeDatePipe,
                    SelectDirective,
                    SelectAsyncHeaderComponent,
                    SortPipe,
                    StagingBannerComponent,
                    StandardPollComponent,
                    VoteControlComponent,
                    WordmarkComponent,
                    WeightedPollComponent,
                    MultiselectPollComponent,
                    UserRoleDirective,
                    AuthHeaderComponent,
                    AuthFooterComponent,
                    ResourceThumbnailComponent,
                    FileSizePipe,
                    ResourceThumbnailContainerComponent,
                    I18nTextboxComponent,
                    I18nTextareaComponent,
                    RelativeDateComponent,
                    ToastComponent,
                    ModalsComponent,
                ],
                imports: [
                    BrowserModule,
                    FormsModule,
                    HttpClientModule,
                    RouterModule,
                    NgbModule,
                    NgSelectModule,
                    translateConfig
                ],
                exports: [
                    WorldskillsAngularLibComponent,
                    AlertComponent,
                    AlertsComponent,
                    BreadcrumbsComponent,
                    DateRangeComponent,
                    DatetimePickerComponent,
                    EntityTreeSelectComponent,
                    FooterComponent,
                    HeaderComponent,
                    AuthHeaderComponent,
                    AuthFooterComponent,
                    LogoComponent,
                    MenuAccessPipe,
                    PollResultComponent,
                    PuppeteerBannerComponent,
                    RelativeDatePipe,
                    SelectDirective,
                    SelectAsyncHeaderComponent,
                    SortPipe,
                    StagingBannerComponent,
                    StandardPollComponent,
                    MultiselectPollComponent,
                    VoteControlComponent,
                    WordmarkComponent,
                    WeightedPollComponent,
                    UserRoleDirective,
                    ResourceThumbnailComponent,
                    ResourceThumbnailContainerComponent,
                    I18nTextboxComponent,
                    I18nTextareaComponent,
                    RelativeDateComponent,
                    ToastComponent,
                    ModalsComponent,
                ],
                providers: []
            }]
    }], null, null); })();

var WSITimeFormat;
(function (WSITimeFormat) {
    WSITimeFormat["TwentyFourHour"] = "HH:mm";
    WSITimeFormat["TwentyFourHourGMT"] = "HH:mm (O)";
    WSITimeFormat["TwelveHour"] = "hh.mm aa.";
    WSITimeFormat["TwelveHourGMT"] = "hh.mm aa. (O)";
})(WSITimeFormat || (WSITimeFormat = {}));

class DateUtil {
    // example: '2019-04-25T16:10:25+0200'
    static toJavaDateString(date, locale) {
        return formatDate$1(date, 'yyyy-MM-ddTHH:mm:ssZ', locale);
    }
}

class HtmlUtil {
    static txt(html) {
        const result = String(html).replace(/<[^>]+>/gm, '');
        return result;
    }
}

class I18nUtil {
    static instanceOfI18nModel(object) {
        return object !== null && typeof object === 'object' && object.hasOwnProperty('lang_code') && object.hasOwnProperty('text');
    }
    static setObjectI18n(object, langCode) {
        if (typeof object === 'object') {
            if (Array.isArray(object)) {
                for (let i = 0; i < object.length; i++) {
                    if (I18nUtil.instanceOfI18nModel(object[i])) {
                        object[i].lang_code = langCode;
                    }
                    else {
                        object[i] = I18nUtil.setObjectI18n(object[i], langCode);
                    }
                }
            }
            else {
                for (const key in object) {
                    if (object.hasOwnProperty(key)) {
                        if (I18nUtil.instanceOfI18nModel(object[key])) {
                            object[key].lang_code = langCode;
                        }
                        else {
                            object[key] = I18nUtil.setObjectI18n(object[key], langCode);
                        }
                    }
                }
            }
        }
        return object;
    }
}

class ObjectUtil {
    static stripUndefined(obj, deep = false) {
        if (Array.isArray(obj)) {
            if (deep) {
                // tslint:disable-next-line:forin
                for (const k in obj) {
                    obj[k] = ObjectUtil.stripUndefined(obj[k], true);
                }
            }
        }
        else if (obj && typeof obj === 'object') {
            Object.keys(obj).forEach(key => obj[key] === undefined && delete obj[key]);
        }
        return obj;
    }
    static stripNullOrUndefined(obj, deep = false) {
        if (Array.isArray(obj)) {
            if (deep) {
                // tslint:disable-next-line:forin
                for (const k in obj) {
                    obj[k] = ObjectUtil.stripNullOrUndefined(obj[k], true);
                }
            }
        }
        else if (obj && typeof obj === 'object') {
            Object.keys(obj).forEach(key => (obj[key] === undefined || obj[key] === null) && delete obj[key]);
        }
        return obj;
    }
}

class RouterUtil {
    static lastNavigationEventWithOrInitialObservable(router, name = null) {
        const result = router.events.pipe(filter(event => event instanceof NavigationEnd), startWith(true), map(v => name !== null ? name : v));
        return result;
    }
    static getResolvedUrl(route) {
        const result = route.pathFromRoot
            .map(v => v.url.map(segment => segment.toString()).join('/'))
            .join('/');
        return result;
    }
    static getConfiguredUrl(route) {
        const result = '/' + route.pathFromRoot
            .filter(v => v.routeConfig)
            .map(v => v.routeConfig.path)
            .join('/');
        return result;
    }
}

class RxjsUtil {
    static loaderSubscriber(...subscribables) {
        const sources = subscribables
            .map((s) => s instanceof WsService ? s.loading : s);
        return combineLatest(sources).pipe(map(ls => !ls.every(l => !l)));
    }
}

class RedirectHandler {
    constructor(ngAuthService, router) {
        this.ngAuthService = ngAuthService;
        this.router = router;
    }
    redirectOrReturn(redirectOptions) {
        const observable = new Observable(subscriber => {
            if (!this.ngAuthService.isLoggedIn()) {
                this.ngAuthService.login();
                subscriber.next();
                subscriber.complete();
            }
            else {
                if (this.hasReturnUrl()) {
                    this.handleReturnUrl(!!redirectOptions.showChildRoles).subscribe(() => subscriber.next(), error => subscriber.error(error), () => subscriber.complete());
                }
                else {
                    this.ngAuthService.getLoggedInUser(!!redirectOptions.showChildRoles).subscribe(next => {
                        sessionStorage.removeItem(RETURN_URL_KEY);
                        if (redirectOptions.url) {
                            if (!redirectOptions.onlyIfExact ||
                                RouterUtil.getResolvedUrl(redirectOptions.onlyIfExact instanceof ActivatedRoute
                                    ? redirectOptions.onlyIfExact.snapshot
                                    : redirectOptions.onlyIfExact) === this.router.routerState.snapshot.url) {
                                this.redirectUserToRoute(next, redirectOptions.url);
                            }
                        }
                        subscriber.next();
                    }, error => {
                        this.ngAuthService.clearSession();
                        subscriber.error(error);
                    }, () => subscriber.complete());
                }
            }
        });
        return observable;
    }
    hasReturnUrl() {
        const returnUrl = sessionStorage.getItem(RETURN_URL_KEY);
        return returnUrl !== null && returnUrl !== undefined && returnUrl !== 'undefined';
    }
    handleReturnUrl(showChildRoles = false) {
        const observable = new Observable(subscriber => {
            const returnUrl = sessionStorage.getItem(RETURN_URL_KEY);
            sessionStorage.removeItem(RETURN_URL_KEY);
            this.ngAuthService.getLoggedInUser(showChildRoles).subscribe(next => {
                this.redirectUserToUrl(next, returnUrl);
                subscriber.next();
            }, error => subscriber.error(error), () => subscriber.complete());
        });
        return observable;
    }
    // override this method to catch a user being redirected to a specific returnUrl (when a user pastes a link in the browser)
    redirectUserToUrl(user, returnUrl) {
        this.router.navigateByUrl(returnUrl);
    }
    // override this method to catch a user being redirected to the homepage route. useful if you need to load the homepage from the DB
    redirectUserToRoute(user, route) {
        this.router.navigate(route);
    }
}
RedirectHandler.ɵfac = function RedirectHandler_Factory(t) { return new (t || RedirectHandler)(ɵngcc0.ɵɵinject(NgAuthService), ɵngcc0.ɵɵinject(ɵngcc3.Router)); };
RedirectHandler.ɵprov = ɵɵdefineInjectable({ factory: function RedirectHandler_Factory() { return new RedirectHandler(ɵɵinject(NgAuthService), ɵɵinject(Router)); }, token: RedirectHandler, providedIn: "root" });
RedirectHandler.ctorParameters = () => [
    { type: NgAuthService },
    { type: Router }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(RedirectHandler, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: NgAuthService }, { type: ɵngcc3.Router }]; }, null); })();

/*
    A lighter verssion of the URL redirect that places more power in the calling application
*/
class RedirectEventHandler {
    constructor(ngAuthService, router) {
        this.ngAuthService = ngAuthService;
        this.router = router;
    }
    getReturnUrl() {
        return sessionStorage.getItem(RETURN_URL_KEY);
    }
    getUser(showRoles) {
        return this.ngAuthService.getLoggedInUser(showRoles);
    }
    redirectUserToUrl(returnUrl) {
        this.router.navigateByUrl(returnUrl);
    }
    listen() {
        const observable = new Observable(subscriber => {
            if (!this.ngAuthService.isLoggedIn()) {
                this.ngAuthService.login();
                subscriber.next('logging-in');
                subscriber.complete();
            }
            else {
                const returnUrl = this.getReturnUrl();
                if (returnUrl !== null && returnUrl !== undefined && returnUrl !== 'undefined') {
                    sessionStorage.removeItem(RETURN_URL_KEY);
                    subscriber.next(returnUrl);
                    subscriber.complete();
                }
                else {
                    subscriber.next(null);
                    subscriber.complete();
                }
            }
        });
        return observable;
    }
}
RedirectEventHandler.ɵfac = function RedirectEventHandler_Factory(t) { return new (t || RedirectEventHandler)(ɵngcc0.ɵɵinject(NgAuthService), ɵngcc0.ɵɵinject(ɵngcc3.Router)); };
RedirectEventHandler.ɵprov = ɵɵdefineInjectable({ factory: function RedirectEventHandler_Factory() { return new RedirectEventHandler(ɵɵinject(NgAuthService), ɵɵinject(Router)); }, token: RedirectEventHandler, providedIn: "root" });
RedirectEventHandler.ctorParameters = () => [
    { type: NgAuthService },
    { type: Router }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(RedirectEventHandler, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: NgAuthService }, { type: ɵngcc3.Router }]; }, null); })();

class EntityTreeView {
    constructor(obj) {
        this.id = obj && obj.id || undefined;
        this.name = obj && obj.name || { lang_code: 'en', text: null };
        this.parent_id = obj && obj.parent_id || undefined;
        this.children = obj && obj.children || [];
    }
}

class GuardService {
    constructor(ngAuthService, wsi, router) {
        this.ngAuthService = ngAuthService;
        this.wsi = wsi;
        this.router = router;
        this.wsi.appConfigSubject.subscribe(config => (this.config = config));
    }
    canActivate(next, state) {
        const user = this.getCurrentUser();
        if (user == null) {
            return this.login(state);
        }
        const roles = next.data.roles;
        if (GenericUtil.isNullOrUndefined(roles)) {
            return false;
        }
        const userRoles = user.roles
            .filter(x => roles.findIndex(y => y.appCode === x.role_application.application_code && y.name === x.name) !== -1);
        const accessible = userRoles.length > 0;
        if (this.config && !accessible) {
            const error = {
                missingRole: !accessible,
                url: state.url
            };
            sessionStorage.setItem('error', JSON.stringify(error));
            this.router.navigate(this.config.notAuthorizedRoute, { replaceUrl: true });
        }
        return accessible;
    }
    getCurrentUser() {
        const user = sessionStorage.getItem(USER_CURRENT_KEY);
        if (GenericUtil.isNullOrUndefined(user)) {
            return null;
        }
        return JSON.parse(user);
    }
    login(state) {
        sessionStorage.setItem(RETURN_URL_KEY, state.url);
        this.ngAuthService.login();
        return false;
    }
}
GuardService.ɵfac = function GuardService_Factory(t) { return new (t || GuardService)(ɵngcc0.ɵɵinject(NgAuthService), ɵngcc0.ɵɵinject(WorldskillsAngularLibService), ɵngcc0.ɵɵinject(ɵngcc3.Router)); };
GuardService.ɵprov = ɵɵdefineInjectable({ factory: function GuardService_Factory() { return new GuardService(ɵɵinject(NgAuthService), ɵɵinject(WorldskillsAngularLibService), ɵɵinject(Router)); }, token: GuardService, providedIn: "root" });
GuardService.ctorParameters = () => [
    { type: NgAuthService },
    { type: WorldskillsAngularLibService },
    { type: Router }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(GuardService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: NgAuthService }, { type: WorldskillsAngularLibService }, { type: ɵngcc3.Router }]; }, null); })();

// this incoder handles reserved characters such as the '+' symbol for special cases
class WsHttpEncoder {
    encodeKey(key) {
        return encodeURIComponent(key);
    }
    encodeValue(value) {
        return encodeURIComponent(value);
    }
    decodeKey(key) {
        return decodeURIComponent(key);
    }
    decodeValue(value) {
        return decodeURIComponent(value);
    }
}

class WsHttpInterceptor {
    constructor(wsi, oAuthService) {
        this.wsi = wsi;
        this.oAuthService = oAuthService;
        this.wsi.httpConfigSubject.subscribe(config => (this.config = config));
    }
    intercept(req, next) {
        if (this.config) {
            const uriPatterns = GenericUtil.getValueOrDefault(this.config.authUriPatterns, []);
            const encoderPatterns = GenericUtil.getValueOrDefault(this.config.encoderUriPatterns, []);
            const includeLanguageParam = GenericUtil.getValueOrDefault(this.config.includeLanguageParam, false);
            const authorize = uriPatterns.filter(s => req.url.match(s)).length > 0;
            const rewrite = encoderPatterns.filter(s => req.url.match(s)).length > 0;
            // append auth header
            if (authorize) {
                req = req.clone({
                    headers: new HttpHeaders({
                        Authorization: this.oAuthService.authorizationHeader(),
                    })
                });
            }
            // appent language code
            if (includeLanguageParam) {
                // appendd language param to requests
                const lang = sessionStorage.getItem('lang');
                req = req.clone({
                    params: (req.params ? req.params : new HttpParams())
                        .set('l', lang),
                    headers: (req.headers ? req.headers : new HttpHeaders())
                        .set('Accept-Language', lang)
                });
            }
            // rewrite parameters with encoder
            if (rewrite) {
                const params = new HttpParams({ encoder: new WsHttpEncoder(), fromString: req.params.toString() });
                req = req.clone({ params });
            }
        }
        return next.handle(req);
    }
}
WsHttpInterceptor.ɵfac = function WsHttpInterceptor_Factory(t) { return new (t || WsHttpInterceptor)(ɵngcc0.ɵɵinject(WorldskillsAngularLibService), ɵngcc0.ɵɵinject(ɵngcc8.OAuthService)); };
WsHttpInterceptor.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: WsHttpInterceptor, factory: WsHttpInterceptor.ɵfac });
WsHttpInterceptor.ctorParameters = () => [
    { type: WorldskillsAngularLibService },
    { type: OAuthService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(WsHttpInterceptor, [{
        type: Injectable
    }], function () { return [{ type: WorldskillsAngularLibService }, { type: ɵngcc8.OAuthService }]; }, null); })();

class ResourceUpload {
    constructor(obj) {
        this.tags = []; // do not create tags
        this.name = obj && obj.name || { lang_code: 'en', text: null };
        this.ws_entity = obj && obj.ws_entity;
        this.types = obj && obj.types || [];
        this.version = obj && obj.version || { name: '1.0', };
        this.metadata = obj && obj.metadata || [];
    }
    static fromResource(resource) {
        const version = resource.versions[resource.versions.length - 1];
        const translation = version.translations[version.translations.length - 1];
        return new ResourceUpload({
            name: resource.name,
            ws_entity: resource.ws_entity.id,
            tags: resource.tags,
            types: resource.resource_types.map(x => x.id),
            metadata: resource.metadata.map(x => {
                return { metadata: x.metadata.id, value: x.value };
            }),
            version: {
                name: version.name,
                date: version.date,
                tags: version.tags,
                translation: {
                    version: version.id,
                    lang_code: translation.lang_code,
                    storage_data: translation.storage_data,
                    storage_type: translation.storage_type.id
                }
            }
        });
    }
}

/*
    We will start moving to a handler approach over time as we cusstomize and improve the controls
*/
class DefaultOptionHandler {
    onOptionSelect(pollType, currentSelection, newSelectedValue, selectionIndex) {
        if (pollType === 'standard') {
            return [newSelectedValue];
        }
        else {
            if (newSelectedValue !== '0') {
                currentSelection.forEach((model, idx) => {
                    if (idx === selectionIndex) {
                        currentSelection[idx] = newSelectedValue;
                    }
                    else {
                        if (model === newSelectedValue) {
                            currentSelection[idx] = '0';
                        }
                    }
                });
            }
            return currentSelection;
        }
    }
}

class PollListService {
    constructor(wsi, http) {
        this.wsi = wsi;
        this.http = http;
        this.wsi.serviceConfigSubject.subscribe(next => {
            this.endpoint = next.apiEndpoint + '/votes/list';
        });
    }
    list(params) {
        return this.http.get(this.endpoint, { params });
    }
    get(id) {
        const url = `${this.endpoint}/${id}`;
        return this.http.get(url);
    }
    getBySlug(slug) {
        const url = `${this.endpoint}/slug/${slug}`;
        return this.http.get(url);
    }
    create(model) {
        return this.http.post(this.endpoint, model);
    }
    update(id, model) {
        const url = `${this.endpoint}/${id}`;
        return this.http.put(url, model);
    }
    delete(id) {
        const url = `${this.endpoint}/${id}`;
        return this.http.delete(url);
    }
    undelete(id) {
        const url = `${this.endpoint}/${id}/undelete`;
        return this.http.put(url, {});
    }
}
PollListService.ɵfac = function PollListService_Factory(t) { return new (t || PollListService)(ɵngcc0.ɵɵinject(WorldskillsAngularLibService), ɵngcc0.ɵɵinject(ɵngcc6.HttpClient)); };
PollListService.ɵprov = ɵɵdefineInjectable({ factory: function PollListService_Factory() { return new PollListService(ɵɵinject(WorldskillsAngularLibService), ɵɵinject(HttpClient)); }, token: PollListService, providedIn: "root" });
PollListService.ctorParameters = () => [
    { type: WorldskillsAngularLibService },
    { type: HttpClient }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PollListService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: WorldskillsAngularLibService }, { type: ɵngcc6.HttpClient }]; }, null); })();

class PollService {
    constructor(wsi, http) {
        this.wsi = wsi;
        this.http = http;
        this.wsi.serviceConfigSubject.subscribe(next => {
            this.endpoint = next.apiEndpoint + '/votes';
        });
    }
    list(params) {
        return this.http.get(this.endpoint, { params });
    }
    select(params) {
        const url = `${this.endpoint}/select`;
        return this.http.get(url, { params });
    }
    get(id) {
        const url = `${this.endpoint}/${id}`;
        return this.http.get(url);
    }
    getAbstains(id) {
        const url = `${this.endpoint}/${id}/abstains`;
        return this.http.get(url);
    }
    getResults(id) {
        const url = `${this.endpoint}/${id}/results`;
        return this.http.get(url);
    }
    getTrackRecords(id) {
        const url = `${this.endpoint}/${id}/tracks`;
        return this.http.get(url);
    }
    hasVoted(id) {
        const url = `${this.endpoint}/${id}/has_voted`;
        return this.http.get(url);
    }
    create(model) {
        return this.http.post(this.endpoint, model);
    }
    update(id, model) {
        const url = `${this.endpoint}/${id}`;
        return this.http.put(url, model);
    }
    open(id, start, expiry) {
        const model = { start, expiry };
        const url = `${this.endpoint}/${id}/open`;
        return this.http.put(url, model);
    }
    close(id) {
        const url = `${this.endpoint}/${id}/close`;
        return this.http.put(url, {});
    }
    delete(id) {
        const url = `${this.endpoint}/${id}`;
        return this.http.delete(url);
    }
    undelete(id) {
        const url = `${this.endpoint}/${id}/undelete`;
        return this.http.put(url, {});
    }
    reset(id, start, expiry) {
        const model = { start, expiry };
        const url = `${this.endpoint}/${id}/reset`;
        return this.http.put(url, model);
    }
    extend(id, expiry) {
        const model = { expiry };
        const url = `${this.endpoint}/${id}/extend`;
        return this.http.put(url, model);
    }
    addVote(pollId, votes) {
        const model = { votes };
        const url = `${this.endpoint}/${pollId}/addVote`;
        return this.http.post(url, model);
    }
    addAbstain(pollId) {
        const url = `${this.endpoint}/${pollId}/addAbstain`;
        return this.http.post(url, {});
    }
    unvote(pollId) {
        const url = `${this.endpoint}/${pollId}/removeVote`;
        return this.http.delete(url);
    }
    unAbstain(pollId) {
        const url = `${this.endpoint}/${pollId}/removeAbstain`;
        return this.http.delete(url);
    }
    copy(pollId) {
        const url = `${this.endpoint}/${pollId}/copy`;
        return this.http.post(url, {});
    }
    export(id) {
        this.http.get(`${this.endpoint}/${id}/results_export`, { responseType: 'arraybuffer' })
            .subscribe(response => {
            const objectURL = window.URL.createObjectURL(new Blob([response], { type: 'application/octet-stream' }));
            const downloadLink = document.createElement('a');
            downloadLink.href = objectURL;
            downloadLink.setAttribute('download', `poll_results_${id}.xlsx`);
            document.body.appendChild(downloadLink);
            downloadLink.click();
        });
    }
}
PollService.ɵfac = function PollService_Factory(t) { return new (t || PollService)(ɵngcc0.ɵɵinject(WorldskillsAngularLibService), ɵngcc0.ɵɵinject(ɵngcc6.HttpClient)); };
PollService.ɵprov = ɵɵdefineInjectable({ factory: function PollService_Factory() { return new PollService(ɵɵinject(WorldskillsAngularLibService), ɵɵinject(HttpClient)); }, token: PollService, providedIn: "root" });
PollService.ctorParameters = () => [
    { type: WorldskillsAngularLibService },
    { type: HttpClient }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PollService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: WorldskillsAngularLibService }, { type: ɵngcc6.HttpClient }]; }, null); })();

/*
 * Public API Surface of worldskills-angular-lib
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AlertComponent, AlertService, AlertType, AlertsComponent, ArrayUtil, AuthFooterComponent, AuthHeaderComponent, AuthService, BreadcrumbsComponent, BreadcrumbsService, DEFAULT_LABELS, DateRangeComponent, DateUtil, Datetime, DatetimePickerComponent, DefaultOptionHandler, DefaultRelativeDateProccessor, EntityTreeSelectComponent, EntityTreeService, EntityTreeView, ErrorUtil, FULL, FooterComponent, GenericUtil, GuardService, HeaderComponent, HtmlUtil, HttpLoaderFactory, HttpUtil, I18nTextareaComponent, I18nTextboxComponent, I18nUtil, ISO8601_DATE_REGEX, LOADER_ONLY, LangUtil, LogoComponent, MISSING_LANGUAGE_MESSAGE, MenuAccessPipe, ModalsComponent, MultiselectPollComponent, NO_SUBJECT, NgAuthService, ObjectUtil, OrdinalUtil, PollListService, PollResultComponent, PollService, PuppeteerBannerComponent, RETURN_URL_KEY, RedirectEventHandler, RedirectHandler, RelativeDateComponent, RelativeDatePipe, ResourceService, ResourceThumbnailComponent, ResourceThumbnailContainerComponent, ResourceUpload, RouterUtil, RxjsUtil, SelectAsyncHeaderComponent, SelectDirective, SortPipe, StagingBannerComponent, StandardPollComponent, ToastComponent, USER_CURRENT_KEY, UploadService, UserRoleDirective, UserRoleUtil, VoteControlComponent, WSIDateFormat, WSITimeFormat, WeightedPollComponent, WordmarkComponent, WorldskillsAngularLibComponent, WorldskillsAngularLibModule, WorldskillsAngularLibService, WsComponent, WsHttpEncoder, WsHttpInterceptor, WsService, WsiModalService, WsiToastService, WsiTranslateService, formatDate, isDate, isFetchParams, isMulticastOptions, isRequestOptions, isoStringToDate, toDate, translateConfig, FileSizePipe as ɵa };

//# sourceMappingURL=worldskills-worldskills-angular-lib.js.map